export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A datetime string in `Y-m-d H:i:s` or ISO 8601 format. */
  DateTime: { input: any; output: any; }
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  JSON: { input: any; output: any; }
  /** Loose type that allows any value. */
  Mixed: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** Represents the academic calendar for a specific term within a session. */
export type AcademicCalendar = {
  created_at: Scalars['DateTime']['output'];
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  next_calender_starts_at?: Maybe<Scalars['DateTime']['output']>;
  school_id: Scalars['ID']['output'];
  session: Session;
  session_id: Scalars['ID']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  termStructure: TermStructure;
  term_structure_id: Scalars['ID']['output'];
  total_school_days?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type AddCourseOutstandingWaiverInput = {
  academic_calendar_id: Scalars['ID']['input'];
  course_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  student_id: Scalars['ID']['input'];
};

export type AddManualOutstandingCourseInput = {
  course_id: Scalars['ID']['input'];
  curriculum_level?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  student_id: Scalars['ID']['input'];
};

export type AddStudentCourseToExemptInput = {
  course_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};

export type AdjustWalletInput = {
  amount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
  student_id: Scalars['ID']['input'];
  type: WalletTransactionTypeEnum;
};

export type AdminGenerateTranscriptInput = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
  transcript_type_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminResetStudentPasswordInput = {
  student_id: Scalars['ID']['input'];
};

export type AdmissionLetterAssignmentTarget = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  template_id?: Maybe<Scalars['ID']['output']>;
};

export type AdmissionLetterAssignments = {
  forms: Array<AdmissionLetterAssignmentTarget>;
  programmes: Array<AdmissionLetterAssignmentTarget>;
};

export enum AdmissionLetterBulletStyle {
  Diamond = 'DIAMOND',
  Disc = 'DISC',
  Numbered = 'NUMBERED'
}

export type AdmissionLetterDesign = {
  accent_color?: Maybe<Scalars['String']['output']>;
  affiliation_text?: Maybe<Scalars['String']['output']>;
  bullet_style?: Maybe<AdmissionLetterBulletStyle>;
  conditions_heading?: Maybe<Scalars['String']['output']>;
  font_preset?: Maybe<AdmissionLetterFont>;
  /** Print the footer at the foot of every page instead of right after the signatures. */
  footer_pinned?: Maybe<Scalars['Boolean']['output']>;
  header_padding_mm?: Maybe<Scalars['Float']['output']>;
  heading_style?: Maybe<AdmissionLetterHeadingStyle>;
  letterhead_align?: Maybe<AdmissionLetterLetterheadAlign>;
  /** Up to four lines of contact details, usually from the {school_address}, {school_phone}, {school_email} and {school_website} placeholders. A line whose placeholders are all empty is left out. */
  letterhead_contact?: Maybe<Scalars['String']['output']>;
  /** Print the template's uploaded banner instead of the built letterhead. Without an upload the built letterhead still prints. */
  letterhead_image_mode?: Maybe<AdmissionLetterImageMode>;
  /** A line printed in italics under the school name. */
  letterhead_motto?: Maybe<Scalars['String']['output']>;
  letterhead_rule?: Maybe<AdmissionLetterRuleStyle>;
  margin_mm?: Maybe<Scalars['Float']['output']>;
  meta_style?: Maybe<AdmissionLetterMetaStyle>;
  page_decoration?: Maybe<AdmissionLetterPageDecoration>;
  reporting_instructions?: Maybe<Scalars['String']['output']>;
  secondary_color?: Maybe<Scalars['String']['output']>;
  show_affiliate?: Maybe<Scalars['Boolean']['output']>;
  title_second_line?: Maybe<Scalars['String']['output']>;
  title_style?: Maybe<AdmissionLetterTitleStyle>;
  /** Top and bottom page margin; null keeps them equal to margin_mm. */
  vertical_margin_mm?: Maybe<Scalars['Float']['output']>;
  watermark_font_size?: Maybe<Scalars['Int']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_text?: Maybe<Scalars['String']['output']>;
  watermark_type?: Maybe<AdmissionLetterWatermark>;
};

export type AdmissionLetterDesignInput = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  affiliation_text?: InputMaybe<Scalars['String']['input']>;
  bullet_style?: InputMaybe<AdmissionLetterBulletStyle>;
  conditions_heading?: InputMaybe<Scalars['String']['input']>;
  font_preset?: InputMaybe<AdmissionLetterFont>;
  /** Print the footer at the foot of every page instead of right after the signatures. */
  footer_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  header_padding_mm?: InputMaybe<Scalars['Float']['input']>;
  heading_style?: InputMaybe<AdmissionLetterHeadingStyle>;
  letterhead_align?: InputMaybe<AdmissionLetterLetterheadAlign>;
  /** Up to four lines of contact details, usually from the {school_address}, {school_phone}, {school_email} and {school_website} placeholders. A line whose placeholders are all empty is left out. */
  letterhead_contact?: InputMaybe<Scalars['String']['input']>;
  /** Print the template's uploaded banner instead of the built letterhead. Without an upload the built letterhead still prints. */
  letterhead_image_mode?: InputMaybe<AdmissionLetterImageMode>;
  /** A line printed in italics under the school name. */
  letterhead_motto?: InputMaybe<Scalars['String']['input']>;
  letterhead_rule?: InputMaybe<AdmissionLetterRuleStyle>;
  margin_mm?: InputMaybe<Scalars['Float']['input']>;
  meta_style?: InputMaybe<AdmissionLetterMetaStyle>;
  page_decoration?: InputMaybe<AdmissionLetterPageDecoration>;
  reporting_instructions?: InputMaybe<Scalars['String']['input']>;
  secondary_color?: InputMaybe<Scalars['String']['input']>;
  show_affiliate?: InputMaybe<Scalars['Boolean']['input']>;
  title_second_line?: InputMaybe<Scalars['String']['input']>;
  title_style?: InputMaybe<AdmissionLetterTitleStyle>;
  /** Top and bottom page margin; null keeps them equal to margin_mm. */
  vertical_margin_mm?: InputMaybe<Scalars['Float']['input']>;
  watermark_font_size?: InputMaybe<Scalars['Int']['input']>;
  watermark_opacity?: InputMaybe<Scalars['Float']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Float']['input']>;
  watermark_text?: InputMaybe<Scalars['String']['input']>;
  watermark_type?: InputMaybe<AdmissionLetterWatermark>;
};

/** One labelled value in the letter's highlighted details box. Both may carry placeholders. */
export type AdmissionLetterDetail = {
  /** Take a whole row of the box instead of half of one. */
  full_width: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdmissionLetterDetailInput = {
  full_width?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AdmissionLetterExportCandidate = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/** ELEGANT pairs a book serif with sans labels; CLEAN is sans throughout. Both embed fonts that cover Yoruba letters and the naira sign. */
export enum AdmissionLetterFont {
  Clean = 'CLEAN',
  Elegant = 'ELEGANT',
  Mono = 'MONO',
  Sans = 'SANS',
  Serif = 'SERIF'
}

/** STANDARD is the bold uppercase section heading; UNDERLINE is a coloured heading over a short rule. */
export enum AdmissionLetterHeadingStyle {
  Standard = 'STANDARD',
  Underline = 'UNDERLINE'
}

/** An uploaded letterhead banner printed instead of the built letterhead: BANNER across the text width, BANNER_FULL_WIDTH edge to edge from the top of the page. */
export enum AdmissionLetterImageMode {
  Banner = 'BANNER',
  BannerFullWidth = 'BANNER_FULL_WIDTH',
  None = 'NONE'
}

/** Stock layouts shipped with the platform. Picks the stylesheet only — the content is the school's. */
export enum AdmissionLetterLayout {
  Classic = 'CLASSIC',
  Modern = 'MODERN'
}

/** CENTER puts the crest above the school name, LEFT beside it, and SPLIT beside it with the contact lines on the right. */
export enum AdmissionLetterLetterheadAlign {
  Center = 'CENTER',
  Left = 'LEFT',
  Split = 'SPLIT'
}

/** STACKED prints the reference over the date; INLINE puts them on one row. */
export enum AdmissionLetterMetaStyle {
  Inline = 'INLINE',
  Stacked = 'STACKED'
}

/** A coloured band along the page edge, or a thin frame, printed on every page. */
export enum AdmissionLetterPageDecoration {
  Border = 'BORDER',
  None = 'NONE',
  SideBand = 'SIDE_BAND',
  TopBand = 'TOP_BAND'
}

export type AdmissionLetterPreset = {
  body: Scalars['String']['output'];
  conditions: Array<Scalars['String']['output']>;
  design: AdmissionLetterDesign;
  details: Array<AdmissionLetterDetail>;
  footer_text?: Maybe<Scalars['String']['output']>;
  header_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layout: AdmissionLetterLayout;
  letter_title: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sections?: Maybe<Array<AdmissionLetterSection>>;
  show_logo: Scalars['Boolean']['output'];
  show_qr_code: Scalars['Boolean']['output'];
  signatures: Array<AdmissionLetterSignature>;
};

export type AdmissionLetterPreviewInput = {
  body: Scalars['String']['input'];
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  design?: InputMaybe<AdmissionLetterDesignInput>;
  details?: InputMaybe<Array<AdmissionLetterDetailInput>>;
  footer_text?: InputMaybe<Scalars['String']['input']>;
  header_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  layout: AdmissionLetterLayout;
  letter_title?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resumption_date?: InputMaybe<Scalars['Date']['input']>;
  sections?: InputMaybe<Array<AdmissionLetterSectionInput>>;
  show_logo?: InputMaybe<Scalars['Boolean']['input']>;
  show_qr_code?: InputMaybe<Scalars['Boolean']['input']>;
  signatures?: InputMaybe<Array<AdmissionLetterSignatureInput>>;
};

/** The programme on an applicant's admission letter, next to the one they applied for and the one they were placed in. */
export type AdmissionLetterProgrammeCheck = {
  /** The programme the applicant applied for: the matched programme's name, or their answer when it names none. */
  applied_programme?: Maybe<Scalars['String']['output']>;
  /** The current letter names a different programme from the one a regenerated letter would. */
  letter_outdated: Scalars['Boolean']['output'];
  /** The programme the current letter names. Null when no letter is active, or it predates recorded values. */
  letter_programme?: Maybe<Scalars['String']['output']>;
  /** The student was placed in a different programme from the one they applied for. */
  placed_elsewhere: Scalars['Boolean']['output'];
  /** That programme was picked at conversion over the applicant's choice, after the convert dialog's warning: the difference was meant. */
  placed_on_purpose: Scalars['Boolean']['output'];
  /** The programme the converted student was first placed in. Null before conversion. */
  placed_programme?: Maybe<Scalars['String']['output']>;
  /** The programme a regenerated letter would name. Null when the school has no letter template for this applicant. */
  regenerated_programme?: Maybe<Scalars['String']['output']>;
};

/** Where the programme on an admission letter comes from. */
export enum AdmissionLetterProgrammeSource {
  /** The programme the applicant chose. */
  ApplicantChoice = 'APPLICANT_CHOICE',
  /** The form's default programme: no answer names one of the school's programmes. */
  FormDefault = 'FORM_DEFAULT',
  /** The programme the converted student was placed in. */
  Placement = 'PLACEMENT',
  /** The applicant's answer as written: it names none of the school's programmes. */
  UnmatchedAnswer = 'UNMATCHED_ANSWER'
}

export type AdmissionLetterRevision = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  revocation_reason?: Maybe<Scalars['String']['output']>;
  revoked_at?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** The line under the letterhead: STANDARD is the layout's own rule, DOUBLE a thick main-colour rule over a thin second-colour one. */
export enum AdmissionLetterRuleStyle {
  Double = 'DOUBLE',
  None = 'NONE',
  Standard = 'STANDARD'
}

export type AdmissionLetterSection = {
  /** TEXT only: an optional heading, in the template's heading style. */
  heading?: Maybe<Scalars['String']['output']>;
  /** SPACER only: the space it leaves, in millimetres. */
  height_mm?: Maybe<Scalars['Float']['output']>;
  /** TEXT only: paragraphs separated by a blank line. Placeholders, **bold** and *italic* work as in the body. */
  text?: Maybe<Scalars['String']['output']>;
  type: AdmissionLetterSectionType;
};

export type AdmissionLetterSectionInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  height_mm?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: AdmissionLetterSectionType;
};

/** A block of the letter between the title and the footer. BODY to SIGNATURES are the template's own content, each printed at most once; BODY and SIGNATURES must stay. TEXT, SPACER and PAGE_BREAK are extra blocks. */
export enum AdmissionLetterSectionType {
  Body = 'BODY',
  Conditions = 'CONDITIONS',
  Details = 'DETAILS',
  PageBreak = 'PAGE_BREAK',
  Reporting = 'REPORTING',
  Signatures = 'SIGNATURES',
  Spacer = 'SPACER',
  Text = 'TEXT'
}

export type AdmissionLetterSettings = {
  /** Whether matchAdmissionLetter can run: the school's AI assistant is on and AI is configured. */
  ai_match_available: Scalars['Boolean']['output'];
  auto_revoke: Scalars['Boolean']['output'];
  auto_send: Scalars['Boolean']['output'];
};

export type AdmissionLetterSignature = {
  /** An optional line printed after the title, such as a phone number. */
  detail?: Maybe<Scalars['String']['output']>;
  /** The signature printed above the line, from uploadAdmissionLetterSignature; null without one. The editor shows it with admissionLetterSignatureImages. */
  image_id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A signature prepared for a letter: a transparent PNG cropped to the ink. */
export type AdmissionLetterSignatureImage = {
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** The prepared PNG as a data URI, to show in the editor. */
  image?: Maybe<Scalars['String']['output']>;
  source: AdmissionLetterSignatureSource;
  width: Scalars['Int']['output'];
};

export type AdmissionLetterSignatureInput = {
  detail?: InputMaybe<Scalars['String']['input']>;
  /** A signature from uploadAdmissionLetterSignature, printed above the line. Leave it out for a plain line. */
  image_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** How a signature was made: DRAWN on screen or UPLOADED as a picture of one on paper. */
export enum AdmissionLetterSignatureSource {
  Drawn = 'DRAWN',
  Uploaded = 'UPLOADED'
}

export type AdmissionLetterTemplate = {
  body: Scalars['String']['output'];
  conditions?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['DateTime']['output'];
  design?: Maybe<AdmissionLetterDesign>;
  /** Rows of the highlighted details box. A body paragraph that is just {details} places the box; otherwise it follows the body. */
  details?: Maybe<Array<AdmissionLetterDetail>>;
  footer_text?: Maybe<Scalars['String']['output']>;
  has_custom_watermark: Scalars['Boolean']['output'];
  has_letterhead_image: Scalars['Boolean']['output'];
  header_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Exactly one template per school is the default — the one a final approval renders. */
  is_default: Scalars['Boolean']['output'];
  layout: AdmissionLetterLayout;
  letter_title: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resumption_date?: Maybe<Scalars['Date']['output']>;
  /** The letter's blocks in print order; null prints the standard order: body, details box, conditions, reporting instructions, signatures. */
  sections?: Maybe<Array<AdmissionLetterSection>>;
  show_logo: Scalars['Boolean']['output'];
  show_qr_code: Scalars['Boolean']['output'];
  signatures?: Maybe<Array<AdmissionLetterSignature>>;
  updated_at: Scalars['DateTime']['output'];
};

/** STANDARD is the bold uppercase title; DISPLAY is a large title whose optional second line prints in the secondary colour. */
export enum AdmissionLetterTitleStyle {
  Display = 'DISPLAY',
  Standard = 'STANDARD'
}

export enum AdmissionLetterWatermark {
  CustomImage = 'CUSTOM_IMAGE',
  None = 'NONE',
  SchoolLogo = 'SCHOOL_LOGO',
  Text = 'TEXT'
}

/** The server's own description of exactly what confirming will do. */
export type AiActionPreview = {
  /** Before/after diff lines (at most 100), when the action edits a structure. Empty for everything else. */
  changes: Array<AiPreviewChange>;
  /** The confirm button's text, e.g. 'Approve 35'. */
  confirmLabel: Scalars['String']['output'];
  /** True when the change is hard to undo; the card styles the button as dangerous. */
  destructive: Scalars['Boolean']['output'];
  /** Records that will actually change. */
  eligibleCount: Scalars['Int']['output'];
  fields: Array<AiPreviewField>;
  /** At most 20 rows, eligible first. */
  sample: Array<AiPreviewRow>;
  /** Records that will be skipped (already done, wrong state, ...). */
  skippedCount: Scalars['Int']['output'];
  /** Records the action was asked to cover (1 for a single action). */
  subjectCount: Scalars['Int']['output'];
  /** Bullet lines describing the effect, side effects included (emails sent, letters generated). */
  summary: Array<Scalars['String']['output']>;
  /** e.g. 'Approve 35 submissions' */
  title: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AiActionRun = {
  failed: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Failed and skipped rows, newest first. */
  problems: Array<AiActionRunItem>;
  skipped: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AiActionRunStatus;
  succeeded: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type AiActionRunProblemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AiActionRunItem = {
  label?: Maybe<Scalars['String']['output']>;
  /** Display-safe message; never a raw exception. */
  message?: Maybe<Scalars['String']['output']>;
  /** Stable machine code, e.g. ALREADY_CONVERTED, DUPLICATE_EMAIL, NOT_ELIGIBLE. */
  reasonCode?: Maybe<Scalars['String']['output']>;
  status: AiActionRunItemStatus;
  subjectId: Scalars['ID']['output'];
};

export enum AiActionRunItemStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export enum AiActionRunStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/**
 * AI workspace actions: what the assistant PROPOSES and a person CONFIRMS.
 *
 * The model never executes a change to someone else's records. It proposes one
 * through the `propose_action` MCP tool, which stores an AiPendingAction holding
 * the server's own preview; the chat shows it as an `action_confirmation` card,
 * and only the signed-in person pressing Confirm on that card (these mutations,
 * from the browser session) carries it out. Bulk actions run over a frozen
 * AiSelection and report per row through an AiActionRun.
 *
 * Everything here is owner-scoped: a pending action, selection or run that is
 * not this user's in this school resolves to null, exactly like one that does
 * not exist.
 */
export enum AiActionTier {
  /** Runs over a frozen selection of records. */
  Bulk = 'BULK',
  /** Changes one record that is not the user's own draft. */
  Single = 'SINGLE'
}

export type AiPendingAction = {
  /** Stable catalogue key, e.g. 'forms.submissions.approve'. */
  actionKey: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Human name of the action, e.g. 'Approve submissions'. */
  label: Scalars['String']['output'];
  preview: AiActionPreview;
  /** Set only once DONE, by actions that have something to open (null otherwise). */
  resultLink?: Maybe<AiResultLink>;
  /** Outcome sentence once DONE/FAILED/STALE, e.g. 'Approved Ada Obi's submission.' */
  resultMessage?: Maybe<Scalars['String']['output']>;
  /** The bulk run, once a BULK action is confirmed. */
  run?: Maybe<AiActionRun>;
  status: AiPendingActionStatus;
  tier: AiActionTier;
};

export enum AiPendingActionStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  /** A bulk action was confirmed and its run is queued or running. */
  Executing = 'EXECUTING',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  /** Waiting for the person to confirm or cancel. */
  Pending = 'PENDING',
  /** The records changed after the preview; nothing ran. Ask for a new preview. */
  Stale = 'STALE'
}

/** One line of a before/after diff on a preview, for actions that edit a structure (a form's fields, sections and settings). */
export type AiPreviewChange = {
  /** Property-level detail, e.g. 'Type: TEXT → DATE · Required: No → Yes'. */
  detail?: Maybe<Scalars['String']['output']>;
  kind: AiPreviewChangeKind;
  /** e.g. 'Date of birth' */
  label: Scalars['String']['output'];
  /** What changed: 'field', 'section' or 'setting'. */
  subject: Scalars['String']['output'];
};

export enum AiPreviewChangeKind {
  Added = 'ADDED',
  Changed = 'CHANGED',
  Moved = 'MOVED',
  Removed = 'REMOVED'
}

/** One labelled fact on a preview or a selection ('Form' → 'JSS1 Admission 2026'). */
export type AiPreviewField = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** One record in a preview sample or a selection sample. Labels are display-safe (masked where needed). */
export type AiPreviewRow = {
  detail?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Why the row would be skipped, when it is not eligible. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Where the card can take the person once the action is DONE, e.g. the form builder on the form a draft created. */
export type AiResultLink = {
  /** Button text, e.g. 'Open in form builder'. */
  label: Scalars['String']['output'];
  /** JSON object of route params, e.g. {"id": "12"}. */
  params: Scalars['JSON']['output'];
  /** Frontend route NAME, e.g. 'admin-forms-edit'. */
  routeName: Scalars['String']['output'];
};

/** A frozen set of records the assistant found; bulk actions run over exactly these ids. */
export type AiSelection = {
  breakdowns: Array<AiSelectionBreakdown>;
  count: Scalars['Int']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** The filters that produced it, human-readable. */
  filters: Array<AiPreviewField>;
  id: Scalars['ID']['output'];
  /** e.g. 'Submissions — JSS1 Admission 2026' */
  label: Scalars['String']['output'];
  /** JSON object of route params/query for openRoute. */
  openParams?: Maybe<Scalars['JSON']['output']>;
  /** Frontend route NAME that shows these records in the app's own screen, when one exists. */
  openRoute?: Maybe<Scalars['String']['output']>;
  /** At most 20 display-safe rows. */
  sample: Array<AiPreviewRow>;
  /** Catalogue key of the source, e.g. 'forms.submissions'. */
  sourceKey: Scalars['String']['output'];
};

export type AiSelectionBreakdown = {
  buckets: Array<AiSelectionBucket>;
  /** e.g. 'Status', 'Programme choice', 'Payment' */
  label: Scalars['String']['output'];
};

export type AiSelectionBucket = {
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type AllSemesterResults = {
  semesters: Array<SemesterResult>;
  student: Student;
};

export enum AllocationGroupBy {
  Level = 'LEVEL',
  None = 'NONE',
  Programme = 'PROGRAMME'
}

export type Announcement = {
  body: Scalars['String']['output'];
  cta_label?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  dismissible: Scalars['Boolean']['output'];
  display_from?: Maybe<Scalars['DateTime']['output']>;
  display_until?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  requires_ack: Scalars['Boolean']['output'];
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ApplicantBillDetailSummary = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
};

/** Bill data exposed publicly to verified applicants for payment routing — minimal fields only, no school internals. */
export type ApplicantBillSummary = {
  amount: Scalars['Float']['output'];
  /** Polymorphic ID of what's being billed (FormSubmission, Student, etc.) — needed by the payment processor. */
  billable_id: Scalars['ID']['output'];
  billable_type: Scalars['String']['output'];
  details: Array<ApplicantBillDetailSummary>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export enum ApplicantCategoryEnum {
  CurrentStudent = 'CURRENT_STUDENT',
  MatricRetrieved = 'MATRIC_RETRIEVED',
  UnverifiedApplicant = 'UNVERIFIED_APPLICANT'
}

/**
 * What the applicant should be told about their application fee.
 *
 * PROCESSING means a payment was started and has not been confirmed yet — it is
 * an explanation shown ALONGSIDE the pay action, never a replacement for it: the
 * pending row is written when a checkout is initiated, so an abandoned checkout
 * looks the same as a payment in flight and must not lock anyone out of paying.
 */
export enum ApplicantPaymentState {
  /** No bill was raised for this submission. */
  None = 'NONE',
  /** The bill is settled. */
  Paid = 'PAID',
  /** A payment was started recently and is awaiting confirmation. */
  Processing = 'PROCESSING',
  /** A bill is outstanding and nothing is in flight. */
  Unpaid = 'UNPAID',
  /** The fee was waived (a waiver code, or an admin waiver): nothing to pay. */
  Waived = 'WAIVED'
}

/** An applicant's programme answer, as conversion and the admission letter read it. */
export type ApplicantProgrammeChoice = {
  /** The answer: the matched programme's name, or the option the applicant picked when it matches none. */
  answer: Scalars['String']['output'];
  /** The programme the answer names; null when the applicant picked one from the form's list that matches no single programme of the school. */
  programme_id?: Maybe<Scalars['ID']['output']>;
};

/** Applicant-facing reference progress. */
export type ApplicantReferee = {
  /** Only present when the school's applicants_can_view_responses toggle is on and the reference is submitted. */
  answers?: Maybe<Array<ReferenceAnswer>>;
  /** The email the applicant typed for this referee — only while the nomination is still pending (not yet invited), so a resumed draft can show and edit it. Null once invited. */
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantReferenceRequirement = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  received: Scalars['Int']['output'];
  referees: Array<ApplicantReferee>;
  required: Scalars['Int']['output'];
};

export type ApplicantSession = {
  expires_at: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

/** Response for the public applicant status lookup */
export type ApplicantStatusResponse = {
  activities: Array<FormSubmissionActivity>;
  bill_amount?: Maybe<Scalars['Float']['output']>;
  bill_status?: Maybe<Scalars['String']['output']>;
  form_title: Scalars['String']['output'];
  form_type: Scalars['String']['output'];
  has_bill: Scalars['Boolean']['output'];
  /** Whether the fee is paid, still being confirmed, or outstanding. */
  payment_state: ApplicantPaymentState;
  review_note?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  status: FormSubmissionStatus;
  submitted_at: Scalars['DateTime']['output'];
  tracking_code: Scalars['String']['output'];
};

export type ApplicantSubmissionSummary = {
  activities: Array<FormSubmissionActivity>;
  /** A short-lived signed URL to download the admission letter (#376). Null until the school issues one. */
  admission_letter_url?: Maybe<Scalars['String']['output']>;
  /** Bill data scoped for the public payment checkout flow. Null when no bill exists. */
  bill?: Maybe<ApplicantBillSummary>;
  bill_amount?: Maybe<Scalars['Float']['output']>;
  bill_status?: Maybe<Scalars['String']['output']>;
  /** Which stage the applicant is currently on (1-indexed). With `status`, this lets the status page resume a draft at the right wizard step. */
  current_stage: Scalars['Int']['output'];
  /** The data the applicant originally submitted. Returned to the applicant for self-service field updates and audit context. */
  data: Scalars['JSON']['output'];
  /** Slug of the parent form — applicants can fetch the full form schema (fields + publicOptions) via the publicForm(slug) query. */
  form_slug: Scalars['String']['output'];
  form_title: Scalars['String']['output'];
  form_type: Scalars['String']['output'];
  has_action_required: Scalars['Boolean']['output'];
  has_bill: Scalars['Boolean']['output'];
  /** Whether the fee is paid, still being confirmed, or outstanding. */
  payment_state: ApplicantPaymentState;
  /** A short-lived signed URL to download this application as a branded PDF (#377). */
  pdf_url?: Maybe<Scalars['String']['output']>;
  /** Per-requirement reference progress with per-referee statuses. Response content only present when the school's toggle allows it. */
  references: Array<ApplicantReferenceRequirement>;
  review_note?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  status: FormSubmissionStatus;
  submitted_at: Scalars['DateTime']['output'];
  tracking_code: Scalars['String']['output'];
};

export type ApplyManualDiscountInput = {
  bill_detail_id: Scalars['ID']['input'];
  discount_type: DiscountTypeEnum;
  discount_value: Scalars['Float']['input'];
  /** Mandatory audit trail: why this line is being discounted by hand. */
  reason: Scalars['String']['input'];
};

export enum ApprovalActionEnum {
  Approve = 'APPROVE',
  Endorse = 'ENDORSE',
  Reject = 'REJECT',
  SenateApprove = 'SENATE_APPROVE'
}

/** What approving an application does with its admission letter. */
export type ApprovalLetterPreview = {
  /** The address the letter is emailed to. */
  email?: Maybe<Scalars['String']['output']>;
  /** The letter is emailed when it is issued: automatic sending is on and the applicant left an email address. */
  emails_letter: Scalars['Boolean']['output'];
  /** This approval decides the application. An earlier stage of a multi-stage form only moves the applicant on. */
  final_approval: Scalars['Boolean']['output'];
  /** Approving issues an admission letter: it is the final approval and the school has a template for it. */
  issues_letter: Scalars['Boolean']['output'];
  /** The programme the letter names. */
  programme?: Maybe<Scalars['String']['output']>;
  /** Where the letter's programme comes from. */
  programme_source?: Maybe<AdmissionLetterProgrammeSource>;
  /** The letter prints the matric number, which the applicant gets when converted to a student: it is issued then instead of on approval, so issues_letter is false. */
  waits_for_matric_no: Scalars['Boolean']['output'];
};

export type ApproveStudentRegistrationInput = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};

export type ApproverInfo = {
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type ArchivedStudentRow = {
  deleted_at: Scalars['DateTime']['output'];
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matric_no?: Maybe<Scalars['String']['output']>;
  other_name?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  school_name: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  surname: Scalars['String']['output'];
  transfer?: Maybe<ArchivedStudentTransferInfo>;
};

export type ArchivedStudentTransferInfo = {
  reason?: Maybe<Scalars['String']['output']>;
  target_matric_no?: Maybe<Scalars['String']['output']>;
  target_school_name: Scalars['String']['output'];
  transferred_at: Scalars['DateTime']['output'];
};

export type ArchivedStudentsResponse = {
  current_page: Scalars['Int']['output'];
  data: Array<ArchivedStudentRow>;
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssessmentStatistics = {
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  fail_count: Scalars['Int']['output'];
  highest: Scalars['Float']['output'];
  lowest: Scalars['Float']['output'];
  pass_count: Scalars['Int']['output'];
  pass_rate: Scalars['Float']['output'];
};

export type AssessmentTypeBulkResult = {
  created_assessments?: Maybe<Array<Maybe<SchoolAssessmentType>>>;
  error_count: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success_count: Scalars['Int']['output'];
};

export type AssessmentTypeCountResult = {
  count: Scalars['Int']['output'];
};

export type AssessmentTypeDeleteResult = {
  deleted_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AssessmentTypeExistsResult = {
  exists: Scalars['Boolean']['output'];
};

export type AssessmentTypeFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  is_ca?: InputMaybe<Scalars['Boolean']['input']>;
  is_exam?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssessmentTypeOrderInput = {
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

export type AssessmentTypeReorderResult = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AssignDiscountInput = {
  /** Pin the assignment to one term — it then applies only to bills of that calendar (wins over session/date window). */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  bill_id?: InputMaybe<Scalars['ID']['input']>;
  discount_category_id: Scalars['ID']['input'];
  effective_from?: InputMaybe<Scalars['Date']['input']>;
  effective_until?: InputMaybe<Scalars['Date']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Pin the assignment to one session — it then applies to all bills of that session (wins over the date window). */
  session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignFeeSplitProfileInput = {
  child_school_ids: Array<Scalars['ID']['input']>;
  fee_split_profile_id: Scalars['ID']['input'];
};

export type AssignPermissionGroupInput = {
  group_id: Scalars['ID']['input'];
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type AssignResultTemplateToProgrammesInput = {
  academic_calendar_ids: Array<Scalars['ID']['input']>;
  historical_source_map?: InputMaybe<Array<HistoricalSourceMapInput>>;
  /** Replace assignments that currently use a different template. Default false: conflicts are returned and nothing is written. */
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  programme_ids: Array<Scalars['ID']['input']>;
  result_template_id: Scalars['ID']['input'];
};

export type AssignStaffToChildSchoolsInput = {
  role?: InputMaybe<Scalars['String']['input']>;
  school_ids: Array<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type AttachLinkResourceToLessonNoteInput = {
  accessLevel?: InputMaybe<EducationalResourceAccessLevel>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalUrl: Scalars['String']['input'];
  lessonNoteId: Scalars['ID']['input'];
  resourceType?: InputMaybe<EducationalResourceType>;
  title: Scalars['String']['input'];
};

export type AttachResourceToLessonNoteInput = {
  accessLevel?: InputMaybe<EducationalResourceAccessLevel>;
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  lessonNoteId: Scalars['ID']['input'];
  resourceType?: InputMaybe<EducationalResourceType>;
  title: Scalars['String']['input'];
};

/**
 * A named thing attendance is taken for — a chapel service, an assembly, a club
 * meeting, or one weekly lecture slot of a course. The scope morph decides who
 * belongs on the register (null scope = the whole school).
 */
export type AttendanceEvent = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id: Scalars['ID']['output'];
  category: AttendanceEventCategory;
  /** The linked course, when the event is about one (auto-created lecture slots). */
  course?: Maybe<Course>;
  created_at: Scalars['DateTime']['output'];
  end_time?: Maybe<Scalars['String']['output']>;
  eventable_id?: Maybe<Scalars['ID']['output']>;
  eventable_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  lifecycle: AttendanceEventLifecycle;
  name: Scalars['String']['output'];
  /** Weekdays a RECURRING event holds on; empty means any day. */
  recurrence_days?: Maybe<Array<DayOfWeek>>;
  /** The single date of a ONE_TIME event. */
  scheduled_date?: Maybe<Scalars['Date']['output']>;
  scope_id?: Maybe<Scalars['ID']['output']>;
  scope_type?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** When the register opens (HH:MM:SS); marking today's register earlier is refused. */
  start_time?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** What kind of gathering an attendance event represents. */
export enum AttendanceEventCategory {
  Assembly = 'ASSEMBLY',
  Ceremony = 'CEREMONY',
  Chapel = 'CHAPEL',
  Club = 'CLUB',
  Excursion = 'EXCURSION',
  Lecture = 'LECTURE',
  Other = 'OTHER',
  Seminar = 'SEMINAR',
  Sports = 'SPORTS'
}

/** Whether an attendance event repeats weekly within its calendar or happens once. */
export enum AttendanceEventLifecycle {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export enum AttendanceEventType {
  Lecture = 'LECTURE',
  Other = 'OTHER',
  SchoolProgramme = 'SCHOOL_PROGRAMME'
}

export enum AttendanceStatus {
  Absent = 'ABSENT',
  Excused = 'EXCUSED',
  Late = 'LATE',
  Present = 'PRESENT'
}

export type AttendanceTrendDay = {
  absent: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  late: Scalars['Int']['output'];
  present: Scalars['Int']['output'];
};

export type AuditLog = {
  auditable_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Who or what the row is about, as a name: the user, "<user> · <role>" for a
   * permission grant, or the group name. Read from the label snapshot the
   * permission mutations store, else resolved from the row (deleted included).
   * Null when it can no longer be resolved.
   */
  auditable_label?: Maybe<Scalars['String']['output']>;
  auditable_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  /** The stored event name or code, e.g. "admission_letter.issued". Filter and match on this. */
  event?: Maybe<Scalars['String']['output']>;
  /** The event as a person reads it, e.g. "Admission Letter Issued". Show this, not `event`. */
  event_label?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  /** The after snapshot, as a JSON string. */
  new_values?: Maybe<Scalars['String']['output']>;
  /** The before snapshot, as a JSON string. Encoded from the model's array cast. */
  old_values?: Maybe<Scalars['String']['output']>;
  /** Comma-separated tags, e.g. "security,permissions,ai_assistant". */
  tags?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of AuditLog items. */
export type AuditLogPaginator = {
  /** A list of AuditLog items. */
  data: Array<AuditLog>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BatchApproveGraduationsResult = {
  approved_count: Scalars['Int']['output'];
  skipped_count: Scalars['Int']['output'];
};

export type BatchGenerateCertificatesInput = {
  academic_calendar_id: Scalars['ID']['input'];
  certificate_template_id: Scalars['ID']['input'];
  created_from?: InputMaybe<Scalars['Date']['input']>;
  created_to?: InputMaybe<Scalars['Date']['input']>;
  degree_classification?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum BatchJobStatusEnum {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type BatchRoleActionInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type Bill = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  aggregates?: Maybe<BillAggregates>;
  amount: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  billDetails: Array<BillDetail>;
  /** Student-context views receive only non-voided rows with staff internals (reason, appliedBy) hidden. */
  billDiscounts: Array<BillDiscount>;
  billable?: Maybe<BillableUnion>;
  billable_id: Scalars['ID']['output'];
  billable_type: Scalars['String']['output'];
  classroom?: Maybe<Classroom>;
  classroom_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  creator?: Maybe<User>;
  /** Student-context only: this student's derived adjustments (discounts + exemptions) on an indirect bill. Empty for staff views and direct bills. */
  derivedAdjustments: Array<StudentBillAdjustment>;
  discount_amount: Scalars['Float']['output'];
  due_date?: Maybe<Scalars['Date']['output']>;
  /** When set, overrides all line item settlement accounts — the entire bill pays into this one account. */
  gatewaySettlementAccount?: Maybe<GatewaySettlementAccount>;
  gateway_settlement_account_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  invoice_number?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  net_amount: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Who owes this bill. An application fee is owed by applicants, who have no
   * student record — the list must not call them students. Resolved from the
   * form, since a restrict_to_students form really is owed by students.
   */
  payer_type?: Maybe<FormFeePayerType>;
  paymentStatusDetails?: Maybe<PaymentStatusDetail>;
  school?: Maybe<School>;
  school_id: Scalars['ID']['output'];
  session?: Maybe<Session>;
  session_id?: Maybe<Scalars['ID']['output']>;
  status: BillStatusEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type BillAggregates = {
  student_count: Scalars['Int']['output'];
  /** Net of derived relief: total_billed - total_paid = total_outstanding. */
  total_billed: Scalars['Float']['output'];
  /** Class-bill discount relief derived for this bill's students. */
  total_discounted: Scalars['Float']['output'];
  /** Exemption relief derived for this bill's students. */
  total_exempted: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

export type BillDetail = {
  amount: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  bill: Bill;
  /** Student-context views receive only non-voided rows with staff internals (reason, appliedBy) hidden. */
  billDiscounts: Array<BillDiscount>;
  billItemCategory?: Maybe<BillItemCategory>;
  billItemTemplate?: Maybe<BillItemTemplate>;
  bill_id: Scalars['ID']['output'];
  bill_item_category_id?: Maybe<Scalars['ID']['output']>;
  bill_item_template_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  /** Student-context only: this student's derived adjustments (discounts + exemptions) on this line of an indirect bill. */
  derivedAdjustments: Array<StudentBillAdjustment>;
  discount_amount: Scalars['Float']['output'];
  /** The settlement account this line item pays into (copied from fee item at bill creation, overridable). */
  gatewaySettlementAccount?: Maybe<GatewaySettlementAccount>;
  gateway_settlement_account_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  item_description?: Maybe<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  net_amount: Scalars['Float']['output'];
  paymentAllocations: Array<PaymentAllocation>;
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillDiscount = {
  appliedBy?: Maybe<User>;
  applied_by?: Maybe<Scalars['ID']['output']>;
  bill_detail_id?: Maybe<Scalars['ID']['output']>;
  bill_id: Scalars['ID']['output'];
  calculated_amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  discountCategory?: Maybe<DiscountCategory>;
  discountRule?: Maybe<DiscountRule>;
  discount_category_id?: Maybe<Scalars['ID']['output']>;
  discount_rule_id?: Maybe<Scalars['ID']['output']>;
  discount_type: DiscountTypeEnum;
  discount_value: Scalars['Float']['output'];
  exemption_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  source: BillDiscountSourceEnum;
  voidedBy?: Maybe<User>;
  voided_at?: Maybe<Scalars['DateTime']['output']>;
  voided_by?: Maybe<Scalars['ID']['output']>;
};

/** Who owns a bill_discounts ledger row: engine-applied rule, staff manual adjustment, or an approved exemption. */
export enum BillDiscountSourceEnum {
  Exemption = 'EXEMPTION',
  Manual = 'MANUAL',
  Rule = 'RULE'
}

export enum BillDuplicateConfidenceEnum {
  Duplicate = 'DUPLICATE',
  Likely = 'LIKELY',
  Possible = 'POSSIBLE'
}

export type BillDuplicateExistingRef = {
  amount?: Maybe<Scalars['Float']['output']>;
  bill_id?: Maybe<Scalars['ID']['output']>;
  invoice_number?: Maybe<Scalars['Int']['output']>;
  item_name: Scalars['String']['output'];
  /** Where the clash was found: existing_bill or same_request. */
  source: Scalars['String']['output'];
};

export type BillDuplicateWarning = {
  amount?: Maybe<Scalars['Float']['output']>;
  billable_id: Scalars['ID']['output'];
  confidence: BillDuplicateConfidenceEnum;
  existing: Array<BillDuplicateExistingRef>;
  item_name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type BillItemCategory = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  normalized_name: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  templates_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BillItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Category for a custom item; ignored when bill_item_template_id is set (the template's category wins). */
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Override the settlement account for this line item. If omitted, uses the fee item template's default. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  item_description?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  /** Save this custom item as a reusable template (reused by normalized name if one already exists) and link the bill line to it. Requires the createBillItems ability. */
  save_as_template?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillItemTemplate = {
  billItemCategory?: Maybe<BillItemCategory>;
  bill_item_category_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  default_amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The default settlement account for this fee item. Copied to bill line items at bill creation. */
  gatewaySettlementAccount?: Maybe<GatewaySettlementAccount>;
  gateway_settlement_account_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  school?: Maybe<School>;
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillItemTemplateFilterInput = {
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum BillPaymentStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export enum BillStatusEnum {
  Draft = 'DRAFT',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Published = 'PUBLISHED',
  Void = 'VOID'
}

export type BillStudentStatus = {
  adjusted_amount: Scalars['Float']['output'];
  /** Itemized derived adjustment lines (discounts + exemptions) behind the amounts above. */
  adjustments: Array<StudentBillAdjustment>;
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  base_amount: Scalars['Float']['output'];
  /** This student's derived discount-category effect on their share of the bill. */
  discount_amount: Scalars['Float']['output'];
  enrolled_at?: Maybe<Scalars['DateTime']['output']>;
  entity_discounts: Array<EntityDiscount>;
  exemption_amount: Scalars['Float']['output'];
  exemptions: Array<Exemption>;
  payment_status: BillPaymentStatus;
  student: Student;
};

export type BillStudentsSummary = {
  /**
   * Students whose share ended fully covered WITH an exemption in the mix.
   * Discounts compose first and exemptions absorb the remainder, so this
   * counts every zero-balance student whose exemption closed that remainder —
   * including one relieved mostly by discount. Purely-discount-relieved
   * students count in paid_count only.
   */
  exempt_count: Scalars['Int']['output'];
  new_students_since_publish: Scalars['Int']['output'];
  paid_count: Scalars['Int']['output'];
  partially_paid_count: Scalars['Int']['output'];
  total_collected: Scalars['Float']['output'];
  total_discounted: Scalars['Float']['output'];
  total_exempted: Scalars['Float']['output'];
  total_expected: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_students: Scalars['Int']['output'];
  unpaid_count: Scalars['Int']['output'];
};

export type BillStudentsWithStatusResult = {
  page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  students: Array<BillStudentStatus>;
  summary: BillStudentsSummary;
  total: Scalars['Int']['output'];
};

/** Interface for entities that can be billed (Student, Classroom, ClassroomSection) */
export type Billable = {
  id: Scalars['ID']['output'];
};

/**
 * Entities that can be billed for fees or services. Application-fee bills raised
 * on admission submissions (payment gate) morph to FormSubmission; transcript-fee
 * bills raised on transcript requests morph to TranscriptRequest.
 */
export type BillableUnion = Classroom | ClassroomSection | FormSubmission | ProgrammeType | Student | TranscriptRequest;

export enum BillingIntervalEnum {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Termly = 'TERMLY'
}

export type BillingKpis = {
  bill_count: Scalars['Int']['output'];
  /** total_paid / total_billed — collectible, not gross. */
  collection_rate: Scalars['Float']['output'];
  /** total_discounted split per discount category (named scholarships included); amounts sum to total_discounted. */
  discount_breakdown: Array<DiscountCategoryTotal>;
  paid_bill_count: Scalars['Int']['output'];
  /**
   * Net of derived relief (built from per-bill allocation-aware summaries), so
   * total_billed - total_paid ≈ total_outstanding. The identity is exact when
   * every successful payment is fully allocated to a non-void bill in the
   * queried period and no student overpaid: total_paid sums raw Payment
   * amounts, so unallocated remainders widen the gap and per-student
   * overpayment is clamped out of total_outstanding.
   * Pre-relief gross = total_billed + total_discounted + total_exempted.
   */
  total_billed: Scalars['Float']['output'];
  /** Discount relief granted across the period: derived class-bill relief plus direct-bill ledger rows, the same sources as the Relief Granted report. */
  total_discounted: Scalars['Float']['output'];
  /** Exemption relief granted across the period, from the same two sources as total_discounted. */
  total_exempted: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_overdue: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

export type BillingReportResult = CategoryRevenueReport | DailyCollectionsReport | OutstandingReport | PaymentMethodReport | RefundsReport | ReliefGrantedReport | RevenueReport;

export type BillsFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  billable_id?: InputMaybe<Scalars['ID']['input']>;
  billable_type?: InputMaybe<Scalars['String']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BroadcastMessageInput = {
  body: Scalars['String']['input'];
  chat_channel_ids: Array<Scalars['ID']['input']>;
};

export type BroadcastWhatsappMessageInput = {
  guardianIds: Array<Scalars['ID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  templateName: Scalars['String']['input'];
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BroadsheetReport = {
  course_legend?: Maybe<Array<Maybe<Scalars['Mixed']['output']>>>;
  data: Array<Maybe<Scalars['Mixed']['output']>>;
  grade_legend?: Maybe<Array<Maybe<Scalars['Mixed']['output']>>>;
  headers: Array<Maybe<Scalars['Mixed']['output']>>;
  meta?: Maybe<BroadsheetReportMeta>;
  summary?: Maybe<Scalars['Mixed']['output']>;
};

export type BroadsheetReportMeta = {
  classroom_name?: Maybe<Scalars['String']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  faculty_name?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  program_name?: Maybe<Scalars['String']['output']>;
  semester?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
};

export type BroadsheetTemplate = {
  columns: Array<BroadsheetTemplateColumn>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade_group?: Maybe<GradeGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['Mixed']['output']>;
  school?: Maybe<School>;
  updated_at: Scalars['DateTime']['output'];
};

export type BroadsheetTemplateColumn = {
  broadsheet_template: BroadsheetTemplate;
  calculation_arguments?: Maybe<Scalars['Mixed']['output']>;
  calculation_function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_visible: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  school_assessment_type?: Maybe<SchoolAssessmentType>;
  sequence: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/** A paginated list of BroadsheetTemplate items. */
export type BroadsheetTemplatePaginator = {
  /** A list of BroadsheetTemplate items. */
  data: Array<BroadsheetTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BulkAddCourseOutstandingWaiverInput = {
  academic_calendar_id: Scalars['ID']['input'];
  course_ids: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  student_ids: Array<Scalars['ID']['input']>;
};

export type BulkCbtActionResult = {
  affected_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkCbtScoresPreview = {
  items: Array<BulkCbtScoresPreviewItem>;
  total_tests: Scalars['Int']['output'];
  unlinked_count: Scalars['Int']['output'];
};

export type BulkCbtScoresPreviewItem = {
  course_code?: Maybe<Scalars['String']['output']>;
  course_title?: Maybe<Scalars['String']['output']>;
  student_count: Scalars['Int']['output'];
  tests: Array<BulkCbtScoresPreviewTest>;
};

export type BulkCbtScoresPreviewTest = {
  session_count: Scalars['Int']['output'];
  test_title: Scalars['String']['output'];
};

export type BulkConvertResponse = {
  converted: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
};

export type BulkCourseDeleteResponse = {
  blocked_count: Scalars['Int']['output'];
  deleted_count: Scalars['Int']['output'];
  outcomes: Array<CourseDeleteOutcome>;
};

export type BulkCourseRegistrationActionInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  action: ApprovalActionEnum;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  registration_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  registration_level?: InputMaybe<Scalars['String']['input']>;
};

export type BulkExemptByStudentsInput = {
  course_ids: Array<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Int']['input']>;
  student_ids: Array<Scalars['ID']['input']>;
};

export type BulkExemptInput = {
  course_ids: Array<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Int']['input']>;
  levels: Array<Scalars['String']['input']>;
  scope_id: Scalars['ID']['input'];
  scope_type: ExemptionScopeType;
};

export type BulkInviteResult = {
  email: Scalars['String']['output'];
  invitation_id?: Maybe<Scalars['ID']['output']>;
  status: BulkInviteStatus;
};

export type BulkInviteStaffInput = {
  emails: Array<Scalars['String']['input']>;
  school_permission_group_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkInviteStaffResponse = {
  results: Array<BulkInviteResult>;
  summary: BulkInviteSummary;
};

export enum BulkInviteStatus {
  Sent = 'SENT',
  SkippedAlreadyInvited = 'SKIPPED_ALREADY_INVITED',
  SkippedAlreadyRegistered = 'SKIPPED_ALREADY_REGISTERED',
  SkippedDuplicateInBatch = 'SKIPPED_DUPLICATE_IN_BATCH',
  SkippedInvalidFormat = 'SKIPPED_INVALID_FORMAT'
}

export type BulkInviteSummary = {
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulkLinkingCodeResult = {
  generated: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulkManualOutstandingByScopeInput = {
  course_ids: Array<Scalars['ID']['input']>;
  curriculum_level?: InputMaybe<Scalars['String']['input']>;
  levels: Array<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scope_id: Scalars['ID']['input'];
  scope_type: ExemptionScopeType;
  status: Scalars['String']['input'];
};

export type BulkManualOutstandingByStudentsInput = {
  course_ids: Array<Scalars['ID']['input']>;
  curriculum_level?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};

/** A single student that could not be published during a bulk publish, with the reason. */
export type BulkPublishFailure = {
  reason: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  student_name: Scalars['String']['output'];
};

/**
 * Response for bulkPublishResults. Mirrors MutationResponse but additionally carries the
 * per-student failures so the admin can see exactly which students were skipped and why.
 * Partial success is intentional: valid students stay published even when others fail.
 */
export type BulkPublishResponse = Response & {
  code: Scalars['String']['output'];
  failures: Array<BulkPublishFailure>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkRegistrationActionResult = {
  affected_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  skipped_count: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkResetStudentPasswordsInput = {
  student_ids: Array<Scalars['ID']['input']>;
};

export type BulkResetStudentPasswordsResponse = Response & {
  code: Scalars['String']['output'];
  failed_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  reset_count: Scalars['Int']['output'];
  results: Array<StudentPasswordResetResult>;
  /** True only when every selected student was reset. */
  success: Scalars['Boolean']['output'];
};

export type BulkScoreSheetPreview = {
  has_template: Scalars['Boolean']['output'];
  items: Array<BulkScoreSheetPreviewItem>;
  total_courses: Scalars['Int']['output'];
};

export type BulkScoreSheetPreviewItem = {
  course_code?: Maybe<Scalars['String']['output']>;
  course_title?: Maybe<Scalars['String']['output']>;
  student_count: Scalars['Int']['output'];
};

export type BulkStaffAssignmentResult = {
  assigned_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  skipped_schools: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BulkTransferResult = {
  errors: Array<Scalars['String']['output']>;
  failed_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  transferred_count: Scalars['Int']['output'];
  transfers: Array<StudentTransferRecord>;
};

export type BulkTransferStudentsInput = {
  carry_over?: InputMaybe<Array<TransferCarryOver>>;
  custom_matric_no?: InputMaybe<Scalars['String']['input']>;
  matric_no_option?: InputMaybe<MatricNoOption>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source_school_id: Scalars['ID']['input'];
  student_ids: Array<Scalars['ID']['input']>;
  target_classroom_section_id: Scalars['ID']['input'];
  target_programme_id?: InputMaybe<Scalars['ID']['input']>;
  target_school_id: Scalars['ID']['input'];
};

export type BulkUpdateCbtTestsInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  ids: Array<Scalars['ID']['input']>;
  question_count?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BulkUpdateStudentCourseExemptionInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

/**
 * Input for bulk-updating student attributes such as programme, classroom section,
 * or campus across multiple students in a single academic calendar.
 */
export type BulkUpdateStudentsInput = {
  academic_calendar_id: Scalars['ID']['input'];
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  cascade_to_registrations?: InputMaybe<Scalars['Boolean']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  entry_level?: InputMaybe<Scalars['String']['input']>;
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  min_graduation_units?: InputMaybe<Scalars['Int']['input']>;
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_ids: Array<Scalars['ID']['input']>;
  update_scope?: InputMaybe<StudentUpdateScope>;
};

export type CbtProgressAnswer = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  question: Question;
  selectedOption: QuestionOption;
  testSession: CbtTestSession;
  updatedAt: Scalars['DateTime']['output'];
};

export type CbtTest = {
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  end_time?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  linkedAssessmentType?: Maybe<SchoolAssessmentType>;
  /**
   * Optional narrowing scope, only meaningful when questionable is Subject.
   * When set, only students in this classroom (in addition to being enrolled
   * in the subject) can see the test.
   */
  narrowClassroom?: Maybe<Classroom>;
  /**
   * Optional narrowing scope, only meaningful when questionable is Subject.
   * When set, only students in this classroom section (in addition to being
   * enrolled in the subject) can see the test.
   */
  narrowClassroomSection?: Maybe<ClassroomSection>;
  questionBanks: Array<QuestionBank>;
  question_count?: Maybe<Scalars['Int']['output']>;
  questionable?: Maybe<Questionable>;
  questions: Array<Question>;
  school: School;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Subject>;
  testSessions: Array<CbtTestSession>;
  title: Scalars['String']['output'];
  track_progress: Scalars['Boolean']['output'];
};

/** A paginated list of CBTTest items. */
export type CbtTestPaginator = {
  /** A list of CBTTest items. */
  data: Array<CbtTest>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CbtTestResult = {
  cbtSession?: Maybe<CbtTestSession>;
  maxScoreSetOnTest?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  student: Student;
};

/** A paginated list of CBTTestResult items. */
export type CbtTestResultPaginator = {
  /** A list of CBTTestResult items. */
  data: Array<CbtTestResult>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CbtTestSession = {
  cbtTest: CbtTest;
  createdAt: Scalars['DateTime']['output'];
  end_time?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Array<CbtProgressAnswer>>;
  school: School;
  score?: Maybe<Scalars['Int']['output']>;
  selected_question_ids?: Maybe<Array<Scalars['ID']['output']>>;
  start_time: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  student: Student;
  studentAnswers: Array<StudentAnswer>;
  theoryQuestionAnswers: Array<TheoryQuestionAnswer>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of CBTTestSession items. */
export type CbtTestSessionPaginator = {
  /** A list of CBTTestSession items. */
  data: Array<CbtTestSession>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CampusType = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  school_id: Scalars['Int']['output'];
  student_count: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of CampusType items. */
export type CampusTypePaginator = {
  /** A list of CampusType items. */
  data: Array<CampusType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CancelMode {
  Immediate = 'immediate',
  PeriodEnd = 'period_end'
}

export type CategoryRevenueReport = {
  record_count: Scalars['Int']['output'];
  records: Array<CategoryRevenueReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: CategoryRevenueReportSummary;
  type: Scalars['String']['output'];
};

export type CategoryRevenueReportRecord = {
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type CategoryRevenueReportSummary = {
  total_amount: Scalars['Float']['output'];
  total_count: Scalars['Int']['output'];
};

export type CbtMonitoringConsent = {
  accepted_at: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  student: Student;
  testSession: CbtTestSession;
};

export type CbtMonitoringEvent = {
  createdAt: Scalars['DateTime']['output'];
  event_type: CbtMonitoringEventTypeEnum;
  id: Scalars['ID']['output'];
  monitoringSession: CbtMonitoringSession;
  occurred_at: Scalars['DateTime']['output'];
  payload?: Maybe<Scalars['Mixed']['output']>;
  severity: CbtMonitoringEventSeverityEnum;
};

export enum CbtMonitoringEventSeverityEnum {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warn = 'WARN'
}

export enum CbtMonitoringEventTypeEnum {
  AudioVoiceDetected = 'AUDIO_VOICE_DETECTED',
  CopyAttempt = 'COPY_ATTEMPT',
  DevtoolsOpened = 'DEVTOOLS_OPENED',
  FocusLost = 'FOCUS_LOST',
  FocusRegained = 'FOCUS_REGAINED',
  FullscreenExit = 'FULLSCREEN_EXIT',
  KeyboardShortcutBlocked = 'KEYBOARD_SHORTCUT_BLOCKED',
  ManualFlag = 'MANUAL_FLAG',
  MultiDisplayDetected = 'MULTI_DISPLAY_DETECTED',
  MultiFaceDetected = 'MULTI_FACE_DETECTED',
  NetworkDisconnect = 'NETWORK_DISCONNECT',
  NetworkReconnect = 'NETWORK_RECONNECT',
  NoFaceDetected = 'NO_FACE_DETECTED',
  PasteAttempt = 'PASTE_ATTEMPT',
  PointerLeaveLong = 'POINTER_LEAVE_LONG',
  RightClickBlocked = 'RIGHT_CLICK_BLOCKED',
  ScreenShareChanged = 'SCREEN_SHARE_CHANGED',
  VirtualCameraDetected = 'VIRTUAL_CAMERA_DETECTED',
  VisibilityLost = 'VISIBILITY_LOST',
  VisibilityRegained = 'VISIBILITY_REGAINED'
}

export type CbtMonitoringSession = {
  createdAt: Scalars['DateTime']['output'];
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  events: Array<CbtMonitoringEvent>;
  flag_reason?: Maybe<Scalars['String']['output']>;
  flaggedBy?: Maybe<User>;
  flagged_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_flagged: Scalars['Boolean']['output'];
  last_heartbeat_at?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['Mixed']['output']>;
  recordings: Array<CbtRecording>;
  room_id: Scalars['String']['output'];
  school: School;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: CbtMonitoringSessionStatusEnum;
  student?: Maybe<Student>;
  testSession?: Maybe<CbtTestSession>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of CbtMonitoringSession items. */
export type CbtMonitoringSessionPaginator = {
  /** A list of CbtMonitoringSession items. */
  data: Array<CbtMonitoringSession>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CbtMonitoringSessionStatusEnum {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Errored = 'ERRORED',
  Pending = 'PENDING'
}

export enum CbtMonitoringSignalingRoleEnum {
  Consumer = 'CONSUMER',
  Producer = 'PRODUCER'
}

export type CbtMonitoringSignalingToken = {
  expires_at: Scalars['DateTime']['output'];
  role: CbtMonitoringSignalingRoleEnum;
  room_id: Scalars['String']['output'];
  token: Scalars['String']['output'];
  ws_url: Scalars['String']['output'];
};

export type CbtRecording = {
  compressed_at?: Maybe<Scalars['DateTime']['output']>;
  compressed_size_bytes?: Maybe<Scalars['Int']['output']>;
  compression_codec?: Maybe<Scalars['String']['output']>;
  compression_status: CbtRecordingCompressionStatusEnum;
  createdAt: Scalars['DateTime']['output'];
  duration_ms?: Maybe<Scalars['Int']['output']>;
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  finalized_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_segmented: Scalars['Boolean']['output'];
  kind: CbtRecordingKindEnum;
  metadata?: Maybe<Scalars['Mixed']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  monitoringSession: CbtMonitoringSession;
  segments: Array<CbtRecordingSegment>;
  size_bytes?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: CbtRecordingStatusEnum;
  storage_disk: Scalars['String']['output'];
  storage_path: Scalars['String']['output'];
  thumbnail_generated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum CbtRecordingCompressionStatusEnum {
  Compressed = 'COMPRESSED',
  Failed = 'FAILED',
  None = 'NONE',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type CbtRecordingDownload = {
  expires_at: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum CbtRecordingKindEnum {
  Screen = 'SCREEN',
  Webcam = 'WEBCAM'
}

export type CbtRecordingSegment = {
  createdAt: Scalars['DateTime']['output'];
  duration_ms?: Maybe<Scalars['Int']['output']>;
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  recording: CbtRecording;
  segment_index: Scalars['Int']['output'];
  size_bytes: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  storage_disk: Scalars['String']['output'];
  storage_path: Scalars['String']['output'];
};

export enum CbtRecordingStatusEnum {
  Errored = 'ERRORED',
  Finalized = 'FINALIZED',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export type CbtTestFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CbtTestStatus>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum CbtTestStatus {
  Ended = 'ENDED',
  Ongoing = 'ONGOING',
  Upcoming = 'UPCOMING'
}

export enum CertificateAuditActionEnum {
  Approved = 'APPROVED',
  Downloaded = 'DOWNLOADED',
  Emailed = 'EMAILED',
  Generated = 'GENERATED',
  Reissued = 'REISSUED',
  Rejected = 'REJECTED',
  Released = 'RELEASED',
  Revoked = 'REVOKED',
  SubmittedForReview = 'SUBMITTED_FOR_REVIEW'
}

export type CertificateAuditLog = {
  action: CertificateAuditActionEnum;
  certificate: GeneratedCertificate;
  created_at: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CertificateAuditLogFilterInput = {
  certificate_id: Scalars['ID']['input'];
};

export type CertificateBatchJob = {
  academicCalendar?: Maybe<AcademicCalendar>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  error_log?: Maybe<Scalars['JSON']['output']>;
  failed_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  initiator: User;
  max_retries: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  processed_count: Scalars['Int']['output'];
  programme?: Maybe<ProgrammeType>;
  retry_count: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: BatchJobStatusEnum;
  successful_count: Scalars['Int']['output'];
  template: CertificateTemplate;
  total_students: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of CertificateBatchJob items. */
export type CertificateBatchJobPaginator = {
  /** A list of CertificateBatchJob items. */
  data: Array<CertificateBatchJob>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CertificateDeliveryEnum {
  Download = 'DOWNLOAD',
  Email = 'EMAIL',
  Portal = 'PORTAL'
}

export enum CertificateDesignEnum {
  Classic = 'CLASSIC',
  Elegant = 'ELEGANT',
  Formal = 'FORMAL',
  Minimal = 'MINIMAL',
  Modern = 'MODERN'
}

export type CertificateDesignInfo = {
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum CertificateFieldTypeEnum {
  Barcode = 'BARCODE',
  CertificateNumber = 'CERTIFICATE_NUMBER',
  Custom = 'CUSTOM',
  DateOfBirth = 'DATE_OF_BIRTH',
  Degree = 'DEGREE',
  DegreeClassification = 'DEGREE_CLASSIFICATION',
  DepartmentName = 'DEPARTMENT_NAME',
  FacultyName = 'FACULTY_NAME',
  GraduationDate = 'GRADUATION_DATE',
  MatricNo = 'MATRIC_NO',
  ProgrammeName = 'PROGRAMME_NAME',
  QrCode = 'QR_CODE',
  SchoolLogo = 'SCHOOL_LOGO',
  SchoolName = 'SCHOOL_NAME',
  Signature = 'SIGNATURE',
  StaticText = 'STATIC_TEXT',
  StudentName = 'STUDENT_NAME',
  YearOfAdmission = 'YEAR_OF_ADMISSION',
  YearOfGraduation = 'YEAR_OF_GRADUATION'
}

export type CertificateFieldTypeInfo = {
  description: Scalars['String']['output'];
  is_dynamic: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum CertificateStatusEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Generated = 'GENERATED',
  Released = 'RELEASED',
  Revoked = 'REVOKED',
  UnderReview = 'UNDER_REVIEW'
}

export type CertificateTemplate = {
  background_image_path?: Maybe<Scalars['String']['output']>;
  color_scheme?: Maybe<Scalars['JSON']['output']>;
  created_at: Scalars['DateTime']['output'];
  custom_height_mm?: Maybe<Scalars['Int']['output']>;
  custom_width_mm?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  design?: Maybe<CertificateDesignEnum>;
  fields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orientation: Scalars['String']['output'];
  paper_size: Scalars['String']['output'];
  programmes: Array<ProgrammeType>;
  signatures?: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CertificateVerificationResult = {
  certificate_number?: Maybe<Scalars['String']['output']>;
  degree_classification?: Maybe<Scalars['String']['output']>;
  graduation_date?: Maybe<Scalars['String']['output']>;
  is_valid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  programme_name?: Maybe<Scalars['String']['output']>;
  school_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CertificateStatusEnum>;
  student_name?: Maybe<Scalars['String']['output']>;
};

export type ChangePasswordInput = {
  current_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};

export type ChatChannel = {
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_message?: Maybe<ChatMessageType>;
  members: Array<ChatChannelMemberType>;
  name?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  type: ChatChannelType;
  unread_count: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ChatChannelListResponse = {
  data: Array<ChatChannel>;
  total: Scalars['Int']['output'];
};

export type ChatChannelMemberType = {
  id: Scalars['ID']['output'];
  joined_at: Scalars['DateTime']['output'];
  role: Scalars['String']['output'];
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
};

export enum ChatChannelType {
  Direct = 'DIRECT',
  Group = 'GROUP',
  SchoolGeneral = 'SCHOOL_GENERAL'
}

export type ChatChannelUnread = {
  channel_id: Scalars['ID']['output'];
  channel_type: ChatChannelType;
  unread_count: Scalars['Int']['output'];
};

/**
 * A staff member the viewer may start a direct or group chat with — exactly the
 * set createDirectChannel/createGroupChannel accept as targets.
 */
export type ChatContact = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type ChatMessageConnection = {
  data: Array<ChatMessageType>;
  has_more: Scalars['Boolean']['output'];
  next_cursor?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageReadType = {
  chat_channel_id: Scalars['ID']['output'];
  last_read_message_id: Scalars['ID']['output'];
  read_at: Scalars['DateTime']['output'];
  user_id: Scalars['ID']['output'];
};

export type ChatMessageType = {
  body: Scalars['String']['output'];
  chat_channel_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sender_id: Scalars['ID']['output'];
  sender_name: Scalars['String']['output'];
};

/**
 * How much of a shared record the *viewing* user may see. Each viewer resolves a
 * share independently, so the same message renders differently per recipient.
 */
export enum ChatShareAccess {
  /** Viewer holds the record's view permission — full card. */
  Full = 'FULL',
  /** Same school but no view permission — name only, so the conversation still reads. */
  Restricted = 'RESTRICTED',
  /** Another school's record, or it no longer exists — nothing is revealed. */
  Unavailable = 'UNAVAILABLE'
}

/**
 * A shared record resolved for one viewer. Fields beyond `title` are populated
 * only at FULL access; `title` is also null when access is UNAVAILABLE.
 */
export type ChatShareCard = {
  access: ChatShareAccess;
  /** Class or section (FULL only). */
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Profile photo URL (FULL only). */
  image_url?: Maybe<Scalars['String']['output']>;
  /** Enrolment status in the active calendar (FULL only). */
  status?: Maybe<Scalars['String']['output']>;
  /** Matric number (FULL only). */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Student's full name. Null only when UNAVAILABLE. */
  title?: Maybe<Scalars['String']['output']>;
  type: ChatShareType;
};

export type ChatShareRefInput = {
  id: Scalars['ID']['input'];
  type: ChatShareType;
};

/** A kind of school record that can be attached to a chat message. */
export enum ChatShareType {
  Student = 'STUDENT'
}

export type ChatUnreadSummary = {
  channels: Array<ChatChannelUnread>;
  total_unread: Scalars['Int']['output'];
};

export type CheckBillDuplicatesInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  billable_ids: Array<Scalars['ID']['input']>;
  billable_type: Scalars['String']['input'];
  items: Array<BillItemInput>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CheckGraduationEligibilityInput = {
  academic_calendar_id: Scalars['ID']['input'];
  level: Scalars['String']['input'];
  programme_id: Scalars['ID']['input'];
  semester: Scalars['Int']['input'];
};

/**
 * A checkout group — a set of bill line items that share the same settlement
 * account and will be paid in a single gateway transaction.
 */
export type CheckoutGroup = {
  /** The bill detail IDs in this group. */
  details: Array<BillDetail>;
  settlement_account: GatewaySettlementAccount;
  /** Sum of net_amount for all details in this group. */
  subtotal: Scalars['Float']['output'];
};

/**
 * Preview of how a bill's items will be grouped at checkout. Used during bill
 * creation/editing to show the admin "Pays Into" information.
 */
export type CheckoutGroupPreview = {
  group_count: Scalars['Int']['output'];
  groups: Array<CheckoutGroupPreviewItem>;
  unresolved_count: Scalars['Int']['output'];
};

export type CheckoutGroupPreviewItem = {
  gateway_identifier?: Maybe<Scalars['String']['output']>;
  is_override: Scalars['Boolean']['output'];
  item_count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
};

/** What a public caller learns from applying a waiver code at checkout: nothing beyond what the page shows. */
export type CheckoutWaiverResult = {
  payment_waived_at: Scalars['DateTime']['output'];
  tracking_code: Scalars['String']['output'];
};

export type ChildSchoolAttendanceSummary = {
  absent: Scalars['Int']['output'];
  excused: Scalars['Int']['output'];
  late: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  present: Scalars['Int']['output'];
  school: School;
  total: Scalars['Int']['output'];
};

export type ChildSchoolBillItem = {
  category?: Maybe<Scalars['String']['output']>;
  default_amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ChildSchoolCalendarOption = {
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ChildSchoolClassroomBreakdown = {
  classroom_id: Scalars['ID']['output'];
  classroom_name: Scalars['String']['output'];
  enrolled: Scalars['Int']['output'];
  graduated: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  promoted: Scalars['Int']['output'];
  suspended: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  withdrawn: Scalars['Int']['output'];
};

export type ChildSchoolClassroomOption = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  school_name: Scalars['String']['output'];
};

export type ChildSchoolClassroomSection = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ChildSchoolEnrollmentRecord = {
  academic_calendar_name: Scalars['String']['output'];
  classroom_name?: Maybe<Scalars['String']['output']>;
  programme_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ChildSchoolFinancial = {
  campus_share: Scalars['Float']['output'];
  collection_rate: Scalars['Float']['output'];
  hq_share: Scalars['Float']['output'];
  school: School;
  total_billed: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

export type ChildSchoolFinancialTotals = {
  campus_share: Scalars['Float']['output'];
  collection_rate: Scalars['Float']['output'];
  hq_share: Scalars['Float']['output'];
  total_billed: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

export type ChildSchoolFinancialsResponse = {
  children: Array<ChildSchoolFinancial>;
  totals: ChildSchoolFinancialTotals;
};

export type ChildSchoolLevelBreakdown = {
  classroom_id: Scalars['ID']['output'];
  enrolled: Scalars['Int']['output'];
  graduated: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  other: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChildSchoolProgramme = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ChildSchoolProgrammeBreakdown = {
  department_name?: Maybe<Scalars['String']['output']>;
  enrolled: Scalars['Int']['output'];
  faculty_name?: Maybe<Scalars['String']['output']>;
  graduated: Scalars['Int']['output'];
  levels?: Maybe<Array<ChildSchoolLevelBreakdown>>;
  other: Scalars['Int']['output'];
  programme_id: Scalars['ID']['output'];
  programme_name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ChildSchoolProgrammeOption = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  school_name: Scalars['String']['output'];
};

export type ChildSchoolResultSummary = {
  school: School;
  total_not_published: Scalars['Int']['output'];
  total_published: Scalars['Int']['output'];
};

export type ChildSchoolResultsTotals = {
  total_not_published: Scalars['Int']['output'];
  total_published: Scalars['Int']['output'];
};

export type ChildSchoolSessionOption = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ChildSchoolSessionsAndTermsResponse = {
  sessions: Array<ChildSchoolSessionOption>;
  terms: Array<ChildSchoolTermOption>;
};

export type ChildSchoolStaffMember = {
  email?: Maybe<Scalars['String']['output']>;
  school: School;
  status?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
};

export type ChildSchoolStudentBreakdownResponse = {
  academic_calendar_name?: Maybe<Scalars['String']['output']>;
  classrooms?: Maybe<Array<ChildSchoolClassroomBreakdown>>;
  programmes?: Maybe<Array<ChildSchoolProgrammeBreakdown>>;
  school: School;
  school_type: Scalars['String']['output'];
  status_summary: ChildSchoolStudentStatusSummary;
};

export type ChildSchoolStudentGuardian = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationship_type?: Maybe<Scalars['String']['output']>;
};

export type ChildSchoolStudentProfile = {
  academic_calendar_name?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  classroom_name?: Maybe<Scalars['String']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollment_history: Array<ChildSchoolEnrollmentRecord>;
  faculty_name?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  guardians: Array<ChildSchoolStudentGuardian>;
  home_address?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  /** @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key. */
  lga?: Maybe<Scalars['String']['output']>;
  matric_no: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  other_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key. */
  permanent_address?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  programme_name?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key. */
  state_of_origin?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  student_id: Scalars['ID']['output'];
  surname: Scalars['String']['output'];
};

export type ChildSchoolStudentRecord = {
  classroom_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  matric_no: Scalars['String']['output'];
  other_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  programme_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  surname: Scalars['String']['output'];
};

export type ChildSchoolStudentStatusSummary = {
  enrolled: Scalars['Int']['output'];
  expelled: Scalars['Int']['output'];
  graduated: Scalars['Int']['output'];
  left: Scalars['Int']['output'];
  promoted: Scalars['Int']['output'];
  suspended: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  transferred: Scalars['Int']['output'];
  withdrawn: Scalars['Int']['output'];
};

export type ChildSchoolStudentsResponse = {
  current_page: Scalars['Int']['output'];
  data: Array<ChildSchoolStudentRecord>;
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChildSchoolSummary = {
  active_calendar?: Maybe<Scalars['String']['output']>;
  female_students: Scalars['Int']['output'];
  male_students: Scalars['Int']['output'];
  school: School;
  total_staff: Scalars['Int']['output'];
  total_students: Scalars['Int']['output'];
};

export type ChildSchoolTermOption = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
};

export type ChildSchoolsAttendanceResponse = {
  children: Array<ChildSchoolAttendanceSummary>;
  totals: ChildSchoolsAttendanceTotals;
};

export type ChildSchoolsAttendanceTotals = {
  absent: Scalars['Int']['output'];
  excused: Scalars['Int']['output'];
  late: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  present: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChildSchoolsResultsResponse = {
  children: Array<ChildSchoolResultSummary>;
  totals: ChildSchoolResultsTotals;
};

export type ChildSchoolsSummaryResponse = {
  children: Array<ChildSchoolSummary>;
  totals: ChildSchoolsTotals;
};

export type ChildSchoolsTotals = {
  total_schools: Scalars['Int']['output'];
  total_staff: Scalars['Int']['output'];
  total_students: Scalars['Int']['output'];
};

export type Classroom = Billable & {
  abbreviation?: Maybe<Scalars['String']['output']>;
  classroomSections?: Maybe<Array<Maybe<ClassroomSection>>>;
  created_at: Scalars['DateTime']['output'];
  /** Default result template used for any calendar without an explicit assignment. */
  default_result_template?: Maybe<ResultTemplate>;
  id: Scalars['ID']['output'];
  /** The name of the classroom. */
  name: Scalars['String']['output'];
  school_id?: Maybe<Scalars['ID']['output']>;
  sections?: Maybe<Array<Maybe<Section>>>;
  sequence?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ClassroomSection = Billable & {
  classroom: Classroom;
  classroom_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  school: School;
  school_id: Scalars['ID']['output'];
  section?: Maybe<Section>;
  section_id?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClassroomStudentAttendanceResult = {
  data: Array<StudentAttendancePeriodSummary>;
  paginatorInfo: PaginatorInfo;
};

export type CloneProgrammeModulesResult = {
  /** Modules created in the target. */
  created: Scalars['Int']['output'];
  modules: Array<ProgrammeModuleType>;
  /** Source modules skipped because the target already had a module with the same sequence. */
  skipped: Scalars['Int']['output'];
};

/** A freshly-minted CMS connection code. The plaintext is shown to the issuer exactly once. */
export type CmsConnectionCode = {
  code: Scalars['String']['output'];
  expires_at: Scalars['DateTime']['output'];
};

/** What the CMS receives after redeeming a code. */
export type CmsConnectionResult = {
  school_id: Scalars['ID']['output'];
  school_name: Scalars['String']['output'];
  school_slug: Scalars['String']['output'];
};

/** Whether compulsory course registration is enforced. */
export enum CompulsoryModeEnum {
  Enforced = 'ENFORCED',
  Flexible = 'FLEXIBLE'
}

export enum ConsolidatedExportFormat {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export type ConsolidatedExportInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  export_type: ConsolidatedExportType;
  format?: InputMaybe<ConsolidatedExportFormat>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  school_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ConsolidatedExportType {
  AttendanceSummary = 'ATTENDANCE_SUMMARY',
  FinancialSummary = 'FINANCIAL_SUMMARY',
  StudentList = 'STUDENT_LIST'
}

export type ConversionCampus = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ConversionClassroom = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Lightweight classroom section for cross-school conversion — no @belongsTo directives that would re-apply BelongsToSchool scope. */
export type ConversionClassroomSection = {
  classroom?: Maybe<ConversionClassroom>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  section?: Maybe<ConversionSection>;
};

/** Classroom sections, programmes and campuses available in a child school — used by the conversion dialog. */
export type ConversionOptions = {
  campuses: Array<ConversionCampus>;
  classroom_sections: Array<ConversionClassroomSection>;
  has_auto_matric: Scalars['Boolean']['output'];
  programmes: Array<ConversionProgramme>;
};

export type ConversionProgramme = {
  id: Scalars['ID']['output'];
  program_name?: Maybe<Scalars['String']['output']>;
};

export type ConversionSection = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CopyCbtScoresToAssessmentInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  cbt_test_id: Scalars['Int']['input'];
  classroom_id?: InputMaybe<Scalars['Int']['input']>;
  overwrite_existing?: InputMaybe<Scalars['Boolean']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
  target_assessment_type_id: Scalars['Int']['input'];
};

export type CopyCbtScoresToAssessmentResult = {
  copied_count: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message: Scalars['String']['output'];
  skipped_count: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  updated_count: Scalars['Int']['output'];
};

export type CopySchoolTemplatesInput = {
  source_school_id: Scalars['ID']['input'];
  target_school_id: Scalars['ID']['input'];
  templates: Array<CopyableTemplate>;
};

export type CopySchoolTemplatesResult = {
  copied: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum CopyableTemplate {
  FeeItems = 'FEE_ITEMS',
  Forms = 'FORMS',
  Settings = 'SETTINGS',
  Subjects = 'SUBJECTS'
}

export type Course = {
  course_code: Scalars['String']['output'];
  course_instance_id: Scalars['String']['output'];
  /** Four-digit year inside course_instance_id (CODE*0109YEAR*school_id). Null when the key is malformed. */
  course_instance_year?: Maybe<Scalars['Int']['output']>;
  course_title: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['String']['output']>;
  prerequisites: Array<CoursePrerequisiteType>;
  school_id: Scalars['ID']['output'];
  unit: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseApprovalInfo = {
  code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
};

export type CourseCreateInput = {
  course_code: Scalars['String']['input'];
  course_instance_year?: InputMaybe<Scalars['String']['input']>;
  course_title: Scalars['String']['input'];
  unit: Scalars['Int']['input'];
};

export type CourseDeleteOutcome = {
  course_code?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type CourseEquivalenceGroup = {
  courses: Array<Course>;
  equivalence_id: Scalars['Int']['output'];
};

export type CourseFilterInput = {
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_instance_id?: InputMaybe<Scalars['String']['input']>;
  course_title?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseLecturer = {
  academic_calendar_id?: Maybe<Scalars['Int']['output']>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approved_by_id?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<Course>;
  course_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  denied_at?: Maybe<Scalars['DateTime']['output']>;
  denied_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_approved?: Maybe<Scalars['Boolean']['output']>;
  school_id?: Maybe<Scalars['Int']['output']>;
  school_staff_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type CourseOutstandingExemptionFilterInput = {
  course_code?: InputMaybe<Scalars['String']['input']>;
  department_name?: InputMaybe<Scalars['String']['input']>;
  faculty_name?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  prog_code?: InputMaybe<Scalars['String']['input']>;
  program_name?: InputMaybe<Scalars['String']['input']>;
};

export type CourseOutstandingExemptionType = {
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseOutstandingWaiverPaginator = {
  data: Array<CourseOutstandingWaiverType>;
  paginatorInfo: PaginatorInfo;
};

export type CourseOutstandingWaiverType = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id: Scalars['ID']['output'];
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  created_by?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of Course items. */
export type CoursePaginator = {
  /** A list of Course items. */
  data: Array<Course>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CoursePrerequisiteType = {
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  prerequisiteCourse?: Maybe<Course>;
  prerequisite_course_id: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Payment progress against one pegged bill's percentage threshold. */
export type CourseRegClearancePeg = {
  /** Amount counted toward the threshold (payments, plus scholarship relief on the gross basis). */
  amount_counted: Scalars['Float']['output'];
  amount_required: Scalars['Float']['output'];
  bill_id: Scalars['ID']['output'];
  bill_label: Scalars['String']['output'];
  cleared: Scalars['Boolean']['output'];
  percentage_achieved: Scalars['Float']['output'];
  percentage_required: Scalars['Float']['output'];
};

export type CourseRegistered = {
  acceptedByUser?: Maybe<User>;
  acceptedForProgramme?: Maybe<ProgrammeType>;
  /** When the transfer was accepted */
  accepted_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who approved the transfer */
  accepted_by?: Maybe<Scalars['ID']['output']>;
  /** The programme this course was transferred/accepted to (if any) */
  accepted_for_programme_id?: Maybe<Scalars['ID']['output']>;
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  course_status: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether this course was transferred from another programme */
  is_transferred: Scalars['Boolean']['output'];
  module_name?: Maybe<Scalars['String']['output']>;
  module_sequence?: Maybe<Scalars['Int']['output']>;
  programmeModule?: Maybe<ProgrammeModuleType>;
  programme_module_id?: Maybe<Scalars['ID']['output']>;
  /** Raw recorded scores. Empty in the parent portal: guardians see published results only. */
  scores: Array<CourseRegisteredScore>;
  studentCourseRegistration?: Maybe<StudentCourseRegistration>;
  student_course_registration_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseRegisteredScore = {
  approval_status?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  course_registered_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  recordedByUser?: Maybe<User>;
  recorded_at?: Maybe<Scalars['DateTime']['output']>;
  recorded_by_user_id?: Maybe<Scalars['Int']['output']>;
  schoolAssessmentType?: Maybe<SchoolAssessmentType>;
  school_assessment_type_id: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CourseRegisteredUpdateFieldsInput = {
  accepted_for_programme_id?: InputMaybe<Scalars['ID']['input']>;
  course_status?: InputMaybe<Scalars['String']['input']>;
};

export type CourseRegistrationApprovalDetails = {
  approval_status: CourseRegistrationApprovalStatusEnum;
  can_print: Scalars['Boolean']['output'];
  courses: Array<CourseApprovalInfo>;
  hod?: Maybe<ApproverInfo>;
  level_adviser?: Maybe<ApproverInfo>;
  semester?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  student: StudentInfo;
  total_units: Scalars['Int']['output'];
};

export type CourseRegistrationApprovalFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  matric_number?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum CourseRegistrationApprovalStatusEnum {
  HodEndorsed = 'HOD_ENDORSED',
  LevelAdviserApproved = 'LEVEL_ADVISER_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Financial clearance for course registration, evaluated for the authenticated student. */
export type CourseRegistrationFinancialClearance = {
  /** Percentage basis for pegs: net (of post-scholarship obligation) or gross (scholarship counts as payment). */
  basis: Scalars['String']['output'];
  /** True when the student may submit (gate off, thresholds met, or nothing outstanding). */
  cleared: Scalars['Boolean']['output'];
  /** How the gate evaluated this student: off | full | pegged. */
  mode: Scalars['String']['output'];
  /** full mode: total outstanding on the student's bills; pegged mode: total shortfall against the thresholds. */
  outstanding_balance: Scalars['Float']['output'];
  /** Per-pegged-bill payment progress; empty unless mode is pegged. */
  pegs: Array<CourseRegClearancePeg>;
  /** Whether this school has the financial-clearance gate enabled. */
  required: Scalars['Boolean']['output'];
};

export type CourseRegistrationForApproval = {
  academic_calendar: AcademicCalendar;
  course_count: Scalars['Int']['output'];
  level?: Maybe<Scalars['String']['output']>;
  level_adviser?: Maybe<User>;
  level_adviser_approved_at?: Maybe<Scalars['DateTime']['output']>;
  programme: Scalars['String']['output'];
  registrations: Array<StudentCourseRegistration>;
  semester: Scalars['String']['output'];
  session: Scalars['String']['output'];
  student: Student;
  total_units: Scalars['Int']['output'];
};

export type CourseRegistrationForApprovalPaginator = {
  data: Array<CourseRegistrationForApproval>;
  paginatorInfo: PaginatorInfo;
};

export type CourseRegistrationLevelInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseScoreInput = {
  course_registered_id: Scalars['ID']['input'];
  scores: Array<ScoreInput>;
};

export type CourseScoreResponse = {
  course_registered_id: Scalars['ID']['output'];
  scores: Array<ScoreResponse>;
};

export type CourseUpdateInput = {
  acknowledgeImpact?: InputMaybe<Scalars['Boolean']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_instance_year?: InputMaybe<Scalars['String']['input']>;
  course_title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAcademicCalendarInput = {
  ended_at?: InputMaybe<Scalars['Date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  next_calender_starts_at?: InputMaybe<Scalars['Date']['input']>;
  session_id: Scalars['ID']['input'];
  started_at?: InputMaybe<Scalars['Date']['input']>;
  term_structure_id: Scalars['ID']['input'];
  total_school_days?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAssessmentTypeInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  cbt_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_id?: InputMaybe<Scalars['Int']['input']>;
  created_by?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_ca?: InputMaybe<Scalars['Boolean']['input']>;
  is_exam?: InputMaybe<Scalars['Boolean']['input']>;
  max_score: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAttendanceEventInput = {
  /** Defaults to the active academic calendar. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  category: AttendanceEventCategory;
  end_time?: InputMaybe<Scalars['String']['input']>;
  eventable_id?: InputMaybe<Scalars['ID']['input']>;
  /** Morph alias of the entity the event is about, e.g. 'Course'. */
  eventable_type?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycle: AttendanceEventLifecycle;
  name: Scalars['String']['input'];
  recurrence_days?: InputMaybe<Array<DayOfWeek>>;
  scheduled_date?: InputMaybe<Scalars['Date']['input']>;
  scope_id?: InputMaybe<Scalars['ID']['input']>;
  /** Morph alias narrowing who attends: 'ClassroomSection', 'Programme', 'Department', 'Course'. Omit for school-wide. */
  scope_type?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillItemCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBillItemTemplateInput = {
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  default_amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Default settlement account for this fee item (copied to bill line items at creation). */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBillsInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  /** Proceed even when items look like duplicates of the entity's existing charges (the caller has reviewed the warnings from checkBillDuplicates). */
  acknowledge_duplicates?: InputMaybe<Scalars['Boolean']['input']>;
  billable_ids: Array<Scalars['ID']['input']>;
  billable_type: Scalars['String']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  /** Bill-level settlement account override. When set, ALL line items on this bill will pay into this single account, regardless of individual item settings. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  items: Array<BillItemInput>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBroadsheetTemplateColumnInput = {
  calculation_arguments?: InputMaybe<Scalars['Mixed']['input']>;
  calculation_function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  school_assessment_type_id?: InputMaybe<Scalars['ID']['input']>;
  sequence: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type CreateBroadsheetTemplateInput = {
  columns?: InputMaybe<Array<CreateBroadsheetTemplateColumnInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['Mixed']['input']>;
};

export type CreateCbtTestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  linked_assessment_type_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional narrowing — only honored when questionable.type = Subject.
   * Restricts visibility to students whose current classroom matches.
   */
  narrow_classroom_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional narrowing — only honored when questionable.type = Subject.
   * Restricts visibility to students whose current classroom section matches.
   */
  narrow_classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  question_bank_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  question_count?: InputMaybe<Scalars['Int']['input']>;
  question_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionable: CreateQuestionableInput;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  track_progress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCertificateTemplateInput = {
  color_scheme?: InputMaybe<Scalars['JSON']['input']>;
  custom_height_mm?: InputMaybe<Scalars['Int']['input']>;
  custom_width_mm?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<CertificateDesignEnum>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orientation?: InputMaybe<Scalars['String']['input']>;
  paper_size?: InputMaybe<Scalars['String']['input']>;
  programme_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  signatures?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateChildSchoolInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin_user_id?: InputMaybe<Scalars['ID']['input']>;
  copy_data?: InputMaybe<Array<ParentDataCopyOption>>;
  copy_from_school_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  school_type: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChildSchoolResult = {
  copied?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  school?: Maybe<School>;
  success: Scalars['Boolean']['output'];
};

export type CreateClassroomInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateClassroomSectionInput = {
  classroom_id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCustomFieldInput = {
  /** NIGERIAN_LGAS only: key of a NIGERIAN_STATES field of the same record type that this field follows. */
  depends_on?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity: CustomFieldEntity;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional; derived from the label when omitted. Cannot change later. */
  key?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  /** SELECT only: take the choices from a built-in list instead of options. */
  options_source?: InputMaybe<CustomFieldOptionsSource>;
  /** Student fields only: whether students see the field on their profile and may fill it in. Defaults to HIDDEN. */
  student_access?: InputMaybe<CustomFieldStudentAccess>;
  type: CustomFieldType;
};

export type CreateDirectChannelInput = {
  user_id: Scalars['ID']['input'];
};

export type CreateDiscountCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  rules?: InputMaybe<Array<CreateDiscountRuleInput>>;
};

export type CreateDiscountRuleInput = {
  apply_to: DiscountApplyToEnum;
  discount_category_id?: InputMaybe<Scalars['ID']['input']>;
  discount_type: DiscountTypeEnum;
  discount_value: Scalars['Float']['input'];
  exclude_template_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  max_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  target_category_id?: InputMaybe<Scalars['ID']['input']>;
  target_template_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFeeSplitOverrideInput = {
  base_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_percentage?: InputMaybe<Scalars['Float']['input']>;
  campus_price?: InputMaybe<Scalars['Float']['input']>;
  fee_split_assignment_id: Scalars['ID']['input'];
  fee_split_rule_id: Scalars['ID']['input'];
  hq_amount?: InputMaybe<Scalars['Float']['input']>;
  hq_percentage?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateFeeSplitProfileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  split_mode: SplitModeEnum;
};

export type CreateFeeSplitRuleInput = {
  base_amount?: InputMaybe<Scalars['Float']['input']>;
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  billable_id?: InputMaybe<Scalars['ID']['input']>;
  billable_type?: InputMaybe<Scalars['String']['input']>;
  campus_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_percentage?: InputMaybe<Scalars['Float']['input']>;
  campus_price?: InputMaybe<Scalars['Float']['input']>;
  fee_split_profile_id: Scalars['ID']['input'];
  hq_amount?: InputMaybe<Scalars['Float']['input']>;
  hq_percentage?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFormInput = {
  admission_field_mapping?: InputMaybe<Scalars['JSON']['input']>;
  application_deadline?: InputMaybe<Scalars['DateTime']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  branding?: InputMaybe<FormBrandingInput>;
  declaration_text?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<FormFieldInput>;
  form_type?: InputMaybe<FormType>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  payment_gates_review?: InputMaybe<Scalars['Boolean']['input']>;
  reference_requirements?: InputMaybe<Array<FormReferenceRequirementInput>>;
  reference_settings?: InputMaybe<FormReferenceSettingsInput>;
  restrict_to_students?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<FormSectionInput>>;
  /** Optional ordered stages. Omit for a normal single-stage form. */
  stages?: InputMaybe<Array<FormStageInput>>;
  target_classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  target_programme_id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CreateGatewaySettlementAccountInput = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  gateway_identifier: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  payment_provider_id: Scalars['ID']['input'];
};

export type CreateGroupChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  member_user_ids: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGuardianInput = {
  altPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  /**
   * BCP-47 language tag for guardian communication preference.
   * Allowed values: en (English), fr (French), yo (Yoruba), ha (Hausa), ig (Igbo).
   */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  studentLinks?: InputMaybe<Array<GuardianStudentLinkInput>>;
  whatsappOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateLessonNoteInput = {
  body: Scalars['String']['input'];
  classroomId: Scalars['ID']['input'];
  schemeWeekId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LessonNoteStatus>;
  subjectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateQuestionBankInput = {
  name: Scalars['String']['input'];
};

export type CreateQuestionInput = {
  cbt_question_bank_id: Scalars['ID']['input'];
  correct_answer_guidelines?: InputMaybe<Scalars['String']['input']>;
  correct_answer_prose?: InputMaybe<Scalars['Mixed']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marks?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<CreateQuestionOptionInput>>;
  question: Scalars['String']['input'];
  question_type: QuestionTypeEnum;
};

export type CreateQuestionOptionInput = {
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  option: Scalars['String']['input'];
};

export type CreateQuestionableInput = {
  ids: Array<Scalars['ID']['input']>;
  type: QuestionableTypeEnum;
};

export type CreateQuestionsInput = {
  cbt_question_bank_id: Scalars['ID']['input'];
  questions: Array<QuestionInput>;
};

export type CreateResultTemplateColumnInput = {
  calculation_arguments?: InputMaybe<Scalars['Mixed']['input']>;
  calculation_function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  school_assessment_type_id?: InputMaybe<Scalars['ID']['input']>;
  sequence: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type CreateResultTemplateFeedbackInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to TEXT. */
  input_type?: InputMaybe<ResultFeedbackInputType>;
  label: Scalars['String']['input'];
  /** RATING only: one label per level, lowest first; omit for the defaults. */
  rating_labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** RATING only: 2-10, default 5. */
  rating_max?: InputMaybe<Scalars['Int']['input']>;
  sequence: Scalars['Int']['input'];
};

export type CreateResultTemplateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<CreateResultTemplateColumnInput>>;
  feedbacks?: InputMaybe<Array<CreateResultTemplateFeedbackInput>>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['Mixed']['input']>;
  style_code?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoomInput = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSchemeOfWorkInput = {
  classroomId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  initialWeeks?: InputMaybe<Array<SchemeWeekInput>>;
  subjectId: Scalars['ID']['input'];
  termStructureId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchoolAnnouncementInput = {
  audience_type?: InputMaybe<SchoolAnnouncementAudienceType>;
  /** Required when audience_type is CLASSROOMS or SECTIONS. */
  audiences?: InputMaybe<Array<SchoolAnnouncementAudienceInput>>;
  body: Scalars['String']['input'];
  expires_at?: InputMaybe<Scalars['DateTime']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to publish immediately. */
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  requires_acknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<SchoolAnnouncementSeverity>;
  title: Scalars['String']['input'];
};

export type CreateSchoolGradeBulkInput = {
  grade?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateSchoolInput = {
  attendance_type?: InputMaybe<Scalars['String']['input']>;
  schoolAddress?: InputMaybe<Scalars['String']['input']>;
  schoolEmail?: InputMaybe<Scalars['String']['input']>;
  schoolMobile?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  school_type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSectionInput = {
  classroom_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSessionInput = {
  ended_at?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  session_structure_id?: InputMaybe<Scalars['ID']['input']>;
  started_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateSessionStructureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSettlementAccountInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  bank_code: Scalars['String']['input'];
  bank_name: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  provider_name: Scalars['String']['input'];
  /**
   * Optional target school. Defaults to the current school; a parent school may
   * pass one of its own child schools here, so campus settlement accounts (the
   * rows split payouts resolve against) can be created from the parent
   * dashboard. Any other value reads as not found.
   */
  school_id?: InputMaybe<Scalars['ID']['input']>;
  sub_account_id: Scalars['String']['input'];
};

export type CreateStudentDataRequestInput = {
  audience: StudentDataRequestAudienceInput;
  /** Defaults to false. */
  blocks_portal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required. YYYY-MM-DD, today or later in the school's time zone (error key input.due_on). */
  due_on?: InputMaybe<Scalars['Date']['input']>;
  fields: Array<StudentDataRequestFieldInput>;
  /** Defaults to false. */
  include_late_joiners?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to true. */
  lock_on_close?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Required; nullable so a blank title comes back as a field error (input.title). */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStudentInput = {
  campus_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  entry_level?: InputMaybe<Scalars['String']['input']>;
  min_graduation_units?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  student?: InputMaybe<StudentInput>;
};

export type CreateStudentScoreInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  recorded_at?: InputMaybe<Scalars['DateTime']['input']>;
  school_assessment_type_id: Scalars['Int']['input'];
  score: Scalars['Float']['input'];
  student_subject_enrollment_id: Scalars['Int']['input'];
};

export type CreateSummaryTemplateColumnInput = {
  calculation_arguments?: InputMaybe<Scalars['Mixed']['input']>;
  calculation_function?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type CreateSummaryTemplateInput = {
  columns?: InputMaybe<Array<CreateSummaryTemplateColumnInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['Mixed']['input']>;
};

export type CreateTermStructureInput = {
  name: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  session_structure_id: Scalars['ID']['input'];
};

export type CreateTicketCategoryInput = {
  auto_response?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<TicketPriority>;
};

export type CreateTicketInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<TicketPriority>;
  subject: Scalars['String']['input'];
  ticket_category_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTimetableInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  timeable_id: Scalars['ID']['input'];
  timeable_type: Scalars['String']['input'];
  timetable_template_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTimetableTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTimetableTimeSlotInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  end_time: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order_index?: InputMaybe<Scalars['Int']['input']>;
  start_time: Scalars['String']['input'];
  timetable_template_id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateTranscriptTemplateInput = {
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  style_code?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTranscriptTypeInput = {
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  category: TranscriptTypeCategoryEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CurriculumType = {
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  course_registration_level: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['String']['output']>;
  moduleOfferings: Array<ProgrammeModuleType>;
  programme?: Maybe<ProgrammeType>;
  /** The module this entry is taught in (null for regular programmes). */
  programmeModule?: Maybe<ProgrammeModuleType>;
  programme_id: Scalars['ID']['output'];
  programme_module_id?: Maybe<Scalars['ID']['output']>;
  school_id: Scalars['ID']['output'];
  semester: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of CurriculumType items. */
export type CurriculumTypePaginator = {
  /** A list of CurriculumType items. */
  data: Array<CurriculumType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CustomField = {
  /** Key of the field this one follows: an LGA field follows the state-of-origin field and offers only that state's LGAs. */
  depends_on?: Maybe<Scalars['String']['output']>;
  /** Optional help text shown under the input. */
  description?: Maybe<Scalars['String']['output']>;
  entity: CustomFieldEntity;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_required: Scalars['Boolean']['output'];
  /** Stable identifier, fixed at creation. Admission forms map answers to it with maps_to "custom:<key>". */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Choices for a SELECT field; empty for every other type. */
  options: Array<CustomFieldOption>;
  /** Set when a SELECT takes its choices from a built-in list instead of options (options is then empty). */
  options_source?: Maybe<CustomFieldOptionsSource>;
  sequence: Scalars['Int']['output'];
  /** Whether the student sees this field on their own profile and may fill it in. Always HIDDEN for staff and guardian fields. */
  student_access: CustomFieldStudentAccess;
  type: CustomFieldType;
  /** How many records hold a value for this field — shown before a delete. */
  values_count: Scalars['Int']['output'];
};

export enum CustomFieldEntity {
  Guardian = 'GUARDIAN',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

/** A filter on one student custom field: its key and the value to match. */
export type CustomFieldFilterInput = {
  key: Scalars['String']['input'];
  /** Text fields: substring. Dropdown: option value. Yes/No: true or false. Date: YYYY-MM-DD. */
  value: Scalars['String']['input'];
};

export type CustomFieldOption = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomFieldOptionInput = {
  label: Scalars['String']['input'];
  /** Stored value; defaults to the label when omitted. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Where a SELECT field's choices come from when they are not the school's own
 * list. The lists are shared reference data: read them from Query.nigerianStates.
 */
export enum CustomFieldOptionsSource {
  /** Nigerian local government areas. With depends_on set, only the LGAs of the state chosen in that field. */
  NigerianLgas = 'NIGERIAN_LGAS',
  /** The 36 Nigerian states and the FCT. */
  NigerianStates = 'NIGERIAN_STATES'
}

/** What a student may do with a student custom field on their own profile. */
export enum CustomFieldStudentAccess {
  /** Shown on the student's profile, and the student may fill it in. */
  Edit = 'EDIT',
  /** Staff only: the student never sees the field. The default. */
  Hidden = 'HIDDEN',
  /** Shown on the student's profile, read-only. */
  View = 'VIEW'
}

/** A ready-made set of custom fields a school can add in one click, e.g. state of origin and LGA for Nigerian schools. */
export type CustomFieldTemplate = {
  /** True when every field of the template already exists and is active. */
  applied: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  entity: CustomFieldEntity;
  fields: Array<CustomFieldTemplateField>;
  /** Stable identifier passed to applyCustomFieldTemplate, e.g. "nigerian_origin". */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** One field a template adds. */
export type CustomFieldTemplateField = {
  depends_on?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** True when the school already has a field with this key (active or retired), so applying the template skips or reactivates it. */
  exists: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options_source?: Maybe<CustomFieldOptionsSource>;
  type: CustomFieldType;
};

export enum CustomFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

/** A custom field together with one record's value for it. value is null when nothing is saved; a CHECKBOX stores "1" or "0". */
export type CustomFieldValue = {
  field: CustomField;
  /** When the value was last changed. */
  filled_at?: Maybe<Scalars['DateTime']['output']>;
  /** Who last filled in the value; null when nothing is saved or it was saved before this was recorded. */
  filled_by?: Maybe<CustomFieldValueSource>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldValueInput = {
  field_id: Scalars['ID']['input'];
  /** Blank or null clears the value. CHECKBOX accepts true/false; DATE expects YYYY-MM-DD. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Who last filled in a custom field value. */
export enum CustomFieldValueSource {
  /** A staff member, on the record's page. */
  Staff = 'STAFF',
  /** The student, on their own profile. */
  Student = 'STUDENT',
  /** A system path: admission conversion, import or transfer. */
  System = 'SYSTEM'
}

export type CustomForm = {
  admission_field_mapping?: Maybe<Scalars['JSON']['output']>;
  application_deadline?: Maybe<Scalars['DateTime']['output']>;
  /** The bill item associated with this form (fee) */
  billItem?: Maybe<BillItemTemplate>;
  /** Per-form branding. Null for forms that use the school/default branding. */
  branding?: Maybe<FormBranding>;
  created_at: Scalars['DateTime']['output'];
  /** Optional applicant declaration shown above submit and printed on the application PDF (#377). Null = none. */
  declaration_text?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** HTML iframe code to embed this form */
  embed_code?: Maybe<Scalars['String']['output']>;
  fields: Array<FormField>;
  form_type: FormType;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  /** The caller's parked, unsubmitted draft of this form (student dashboard "Save & continue later"); null when there is none. */
  my_draft?: Maybe<FormSubmission>;
  /** When true, an application on this form cannot be approved or converted until its fee is paid or an admin waives it (#249). Opt-in per form; requires a fee (bill_item_template_id). */
  payment_gates_review: Scalars['Boolean']['output'];
  /** Options needed to render CLASSROOM_SELECT / PROGRAMME_SELECT fields on a public form. Returns only the data the form's fields actually need, scoped to the form's school. Safe to expose without auth — anyone with the public form slug can already see what school it belongs to. */
  publicOptions: PublicFormOptions;
  /** The public URL of the form */
  public_url?: Maybe<Scalars['String']['output']>;
  /** Referee slots this admission form requires. Null/empty = referencing not used. */
  reference_requirements?: Maybe<Array<FormReferenceRequirement>>;
  /** Referencing behaviour knobs (applicant visibility of responses, link expiry). */
  reference_settings?: Maybe<FormReferenceSettings>;
  restrict_to_students: Scalars['Boolean']['output'];
  school?: Maybe<School>;
  /** Ordered, titled sections. Null/empty for legacy forms (which render as one unnamed section). */
  sections?: Maybe<Array<FormSection>>;
  slug: Scalars['String']['output'];
  /** Ordered application stages. A single-stage form returns one synthesized stage covering all fields (the N=1 case). */
  stages: Array<FormStage>;
  /** Aggregate counts of submissions by status (admin view, school-scoped) */
  submissionCounts: SubmissionCounts;
  submissions: FormSubmissionPaginator;
  targetClassroomSection?: Maybe<ClassroomSection>;
  targetProgramme?: Maybe<ProgrammeType>;
  target_classroom_section_id?: Maybe<Scalars['ID']['output']>;
  target_programme_id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  /** Summary of waiver code counts for this form. */
  waiverCodeSummary?: Maybe<FormWaiverCodeSummary>;
};


export type CustomFormSubmissionsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of CustomForm items. */
export type CustomFormPaginator = {
  /** A list of CustomForm items. */
  data: Array<CustomForm>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DailyCollectionsReport = {
  record_count: Scalars['Int']['output'];
  records: Array<DailyCollectionsReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: DailyCollectionsReportSummary;
  type: Scalars['String']['output'];
};

export type DailyCollectionsReportRecord = {
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type DailyCollectionsReportSummary = {
  average_per_day: Scalars['Float']['output'];
  peak_amount: Scalars['Float']['output'];
  peak_date?: Maybe<Scalars['String']['output']>;
  total_amount: Scalars['Float']['output'];
  total_count: Scalars['Int']['output'];
};

/** Where today falls in the school's active academic calendar. */
export enum DashboardCalendarStatus {
  /** Past the active calendar's end date. currentWeek is its last week. */
  Ended = 'ENDED',
  InProgress = 'IN_PROGRESS',
  /** No active calendar, or it has no start date. */
  None = 'NONE',
  /** Before the active calendar's start date (currentWeek is 0). */
  NotStarted = 'NOT_STARTED'
}

export type DashboardStats = {
  activeCbtTests: Array<CbtTest>;
  attendanceToday: StudentAttendanceSummary;
  attendanceTrend: Array<AttendanceTrendDay>;
  auditLogs: Array<AuditLog>;
  calendarStatus: DashboardCalendarStatus;
  currentWeek: Scalars['Int']['output'];
  femaleStudentsCount: Scalars['Int']['output'];
  maleStudentsCount: Scalars['Int']['output'];
  newStaffCount: Scalars['Int']['output'];
  ticketing?: Maybe<TicketingSummary>;
  totalStaff: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
  upcomingCbtTests: Array<CbtTest>;
  weekEndsInDays: Scalars['Int']['output'];
};


export type DashboardStatsAuditLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Debtor = {
  outstanding_balance: Scalars['Float']['output'];
  student: Student;
  total_billed?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
};

export type DebtorPaginated = {
  data: Array<Debtor>;
  page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  total_outstanding: Scalars['Float']['output'];
};

/**
 * Input for de-enrolling students from a specific academic calendar.
 * Removes the student_academic_calendar record entirely.
 */
export type DeenrollStudentsInput = {
  academic_calendar_id: Scalars['ID']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};

export enum DeletableModelType {
  ClassroomSection = 'ClassroomSection',
  Student = 'Student'
}

/** How the visitor's country on a demo request was chosen. */
export enum DemoCountrySource {
  /** Browser timezone / locale fallback. */
  Browser = 'BROWSER',
  /** CDN geolocation of the visitor's IP. */
  Ip = 'IP',
  /** Picked by the visitor. */
  Manual = 'MANUAL'
}

export enum DemoInstitutionType {
  K12 = 'K12',
  Other = 'OTHER',
  Tertiary = 'TERTIARY'
}

export enum DemoRequestKind {
  Demo = 'DEMO',
  Sales = 'SALES'
}

export enum DemoStudentCount {
  From_201To_500 = 'FROM_201_TO_500',
  From_501To_1000 = 'FROM_501_TO_1000',
  From_1001To_5000 = 'FROM_1001_TO_5000',
  Over_5000 = 'OVER_5000',
  UpTo_200 = 'UP_TO_200'
}

export type DepartmentType = {
  createdAt: Scalars['DateTime']['output'];
  department_name: Scalars['String']['output'];
  faculty?: Maybe<FacultyType>;
  faculty_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['String']['output']>;
  programmes?: Maybe<Array<Maybe<ProgrammeType>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of DepartmentType items. */
export type DepartmentTypePaginator = {
  /** A list of DepartmentType items. */
  data: Array<DepartmentType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DepartmentUpdateInput = {
  department_name?: InputMaybe<Scalars['String']['input']>;
  faculty_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for disabling one or more students, optionally tied to an academic calendar. */
export type DisableStudentsInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};

export enum DiscountApplyToEnum {
  Bill = 'BILL',
  BillExcept = 'BILL_EXCEPT',
  Category = 'CATEGORY',
  Item = 'ITEM'
}

/** Whether a category, assigned to this student with this period scope, would pay off. */
export type DiscountAssignmentPreview = {
  applies: Scalars['Boolean']['output'];
  /** Bills considered after the period pin was applied. */
  considered_bills: Scalars['Int']['output'];
  /** What this student would save, using the same per-student share maths as the ledger. */
  estimated_relief: Scalars['Float']['output'];
  /** Lines of this student's bills the category's rules reach. */
  matched_lines: Scalars['Int']['output'];
  samples: Array<DiscountPreviewLine>;
  status: DiscountPreviewStatus;
};

export type DiscountAssignmentPreviewInput = {
  /** The period pin about to be set, so the preview reflects the pending choice. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  discount_category_id: Scalars['ID']['input'];
  effective_from?: InputMaybe<Scalars['Date']['input']>;
  effective_until?: InputMaybe<Scalars['Date']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DiscountCategory = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountRules: Array<DiscountRule>;
  entityDiscounts: Array<EntityDiscount>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DiscountCategoryTotal = {
  amount: Scalars['Float']['output'];
  /** Null for discounts recorded without a category, such as manual discounts. */
  discount_category_id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Distinct students relieved under this category in the period. */
  student_count: Scalars['Int']['output'];
};

/** A billed line a rule does or does not reach. */
export type DiscountPreviewLine = {
  amount: Scalars['Float']['output'];
  bill_detail_id: Scalars['ID']['output'];
  bill_id: Scalars['ID']['output'];
  bill_item_template_id?: Maybe<Scalars['ID']['output']>;
  item_name: Scalars['String']['output'];
};

/**
 * Why a discount configuration will or will not produce money for someone. Used by
 * the rule editor and the assign dialog so a silent no-op is visible BEFORE saving.
 */
export enum DiscountPreviewStatus {
  /** The configuration matches billed lines and will reduce them. */
  Applies = 'APPLIES',
  /** The category itself is switched off. */
  CategoryInactive = 'CATEGORY_INACTIVE',
  /** The category holds no active rule, so an assignment does nothing. */
  NoActiveRules = 'NO_ACTIVE_RULES',
  /** Rules are live but none of them target any line that is actually billed. */
  NoMatchingLines = 'NO_MATCHING_LINES',
  /** The period pin (term/session) excludes every bill this student has. */
  PeriodExcludesAllBills = 'PERIOD_EXCLUDES_ALL_BILLS',
  /** This student has no bills at all yet. */
  StudentHasNoBills = 'STUDENT_HAS_NO_BILLS'
}

export type DiscountRule = {
  apply_to: DiscountApplyToEnum;
  created_at: Scalars['DateTime']['output'];
  deactivated_reason?: Maybe<DiscountRuleIssueEnum>;
  discountCategory: DiscountCategory;
  discount_category_id: Scalars['ID']['output'];
  discount_type: DiscountTypeEnum;
  discount_value: Scalars['Float']['output'];
  exclude_template_ids?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_discount_amount?: Maybe<Scalars['Float']['output']>;
  priority: Scalars['Int']['output'];
  targetCategoryEntity?: Maybe<BillItemCategory>;
  targetTemplate?: Maybe<BillItemTemplate>;
  target_category_id?: Maybe<Scalars['ID']['output']>;
  target_template_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/**
 * What a rule configuration would reach across the school's current bills. Answers
 * "does this target anything?" before the rule is saved — an item rule pinned to a
 * template nothing is billed under reports matched_lines: 0.
 */
export type DiscountRuleImpact = {
  considered_amount: Scalars['Float']['output'];
  /** Every line considered, for the 'N of M' denominator. */
  considered_lines: Scalars['Int']['output'];
  /** Money this rule would take off those lines. */
  estimated_discount: Scalars['Float']['output'];
  /** Gross value of the matched lines. */
  matched_amount: Scalars['Float']['output'];
  /** Distinct bills touched. */
  matched_bills: Scalars['Int']['output'];
  /** Lines this rule matches. */
  matched_lines: Scalars['Int']['output'];
  /** A few matched lines, to confirm it hit what was intended. */
  samples: Array<DiscountPreviewLine>;
  status: DiscountPreviewStatus;
  /**
   * Billed lines in the SAME fee category that this rule does NOT reach — the
   * near-misses that reveal a rule pinned to the wrong one of several
   * similarly-named fee items.
   */
  unmatched_siblings: Array<DiscountPreviewLine>;
};

export type DiscountRuleImpactInput = {
  /** Defaults to the active academic calendar. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  apply_to: DiscountApplyToEnum;
  discount_type: DiscountTypeEnum;
  discount_value: Scalars['Float']['input'];
  exclude_template_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  max_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  target_category_id?: InputMaybe<Scalars['ID']['input']>;
  target_template_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Why a rule was auto-deactivated by the integrity repair; re-saving it with a valid target reactivates it. */
export enum DiscountRuleIssueEnum {
  MissingTargetCategory = 'MISSING_TARGET_CATEGORY',
  MissingTargetTemplate = 'MISSING_TARGET_TEMPLATE'
}

export enum DiscountTypeEnum {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

/** One-off explanations a staff member can switch off for good. */
export enum DismissibleNotice {
  /** The explanation of the grouped Billing tabs (2026-10-27). */
  BillingNavGroups = 'BILLING_NAV_GROUPS'
}

/** A referee the caller nominated on their own parked draft (pending only), shaped like ReferenceNominationInput so the form can resend it. */
export type DraftReferenceNomination = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  requirement_key: Scalars['String']['output'];
};

export type EditStudentAcademicCalendarInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  entry_level?: InputMaybe<Scalars['String']['input']>;
  initial_absent_days?: InputMaybe<Scalars['Int']['input']>;
  initial_late_days?: InputMaybe<Scalars['Int']['input']>;
  initial_present_days?: InputMaybe<Scalars['Int']['input']>;
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  min_graduation_units?: InputMaybe<Scalars['Int']['input']>;
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EditStudentInput = {
  campus_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  profile?: InputMaybe<EditStudentProfileInput>;
  student_academic_calendar?: InputMaybe<EditStudentAcademicCalendarInput>;
  student_id: Scalars['ID']['input'];
  subject_enrollment?: InputMaybe<EditStudentSubjectEnrollmentInput>;
};

export type EditStudentProfileInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  home_address?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  lga?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  other_name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  permanent_address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  state_of_origin?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type EditStudentSubjectEnrollmentInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  subjects: Array<Scalars['ID']['input']>;
};

export type EducationalResource = {
  accessLevel: EducationalResourceAccessLevel;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  resourceType: EducationalResourceType;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EducationalResourceAccessLevel {
  Parents = 'PARENTS',
  Students = 'STUDENTS',
  TeacherOnly = 'TEACHER_ONLY'
}

export enum EducationalResourceType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Link = 'LINK',
  PastPaper = 'PAST_PAPER',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Worksheet = 'WORKSHEET'
}

/** Input for re-enabling one or more previously disabled students. */
export type EnableStudentsInput = {
  reason: Scalars['String']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};

/** Input for manually enrolling students into a specific academic calendar. */
export type EnrollStudentsInCalendarInput = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_section_id: Scalars['ID']['input'];
  entry_level?: InputMaybe<Scalars['String']['input']>;
  min_graduation_units?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_ids: Array<Scalars['ID']['input']>;
};

export enum EnrollmentModel {
  ClassroomSection = 'CLASSROOM_SECTION',
  Student = 'STUDENT'
}

export type EnrollmentScoreResponse = {
  created: Scalars['Int']['output'];
  student_subject_enrollment_id: Scalars['ID']['output'];
  updated: Scalars['Int']['output'];
};

export enum EnrollmentStatusEnum {
  Enrolled = 'ENROLLED',
  Expelled = 'EXPELLED',
  Graduated = 'GRADUATED',
  Left = 'LEFT',
  Promoted = 'PROMOTED',
  Suspended = 'SUSPENDED',
  Transferred = 'TRANSFERRED',
  Withdrawn = 'WITHDRAWN'
}

export type EntityDiscount = {
  academicCalendar?: Maybe<AcademicCalendar>;
  /** Optional period scope: pinned to one term (wins over session/date window). */
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  assignedBy?: Maybe<User>;
  assigned_by?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  discountCategory: DiscountCategory;
  discount_category_id: Scalars['ID']['output'];
  effective_from?: Maybe<Scalars['Date']['output']>;
  effective_until?: Maybe<Scalars['Date']['output']>;
  /** The student/entity this discount is assigned to */
  entity?: Maybe<Student>;
  entity_id: Scalars['ID']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  session?: Maybe<Session>;
  /** Optional period scope: pinned to one session (wins over the date window). */
  session_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ErrorDetails = {
  line?: Maybe<Scalars['Int']['output']>;
  suggestion?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Exemption = {
  amount: Scalars['Float']['output'];
  /** What approval actually applied via the discount ledger (direct bills) — the raw `amount` is 0 for full exemptions. */
  applied_amount?: Maybe<Scalars['Float']['output']>;
  approvedBy?: Maybe<User>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approved_by?: Maybe<Scalars['ID']['output']>;
  bill?: Maybe<Bill>;
  billDetail?: Maybe<BillDetail>;
  bill_detail_id?: Maybe<Scalars['ID']['output']>;
  bill_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  entity?: Maybe<ExemptionEntity>;
  entity_id: Scalars['ID']['output'];
  entity_type: Scalars['String']['output'];
  exemption_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  requestedBy: User;
  requested_by: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  status: ExemptionStatusEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type ExemptionEntity = Student;

export enum ExemptionScopeType {
  Department = 'DEPARTMENT',
  Faculty = 'FACULTY',
  Programme = 'PROGRAMME'
}

export enum ExemptionStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

/** Input for exporting student data, with optional filters. All filters are nullable. */
export type ExportStudentsInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  /** Only students whose custom field values match every entry. */
  custom_fields?: InputMaybe<Array<CustomFieldFilterInput>>;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  faculty_id?: InputMaybe<Scalars['ID']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  /**
   * Case-insensitive exact match on the local government area of origin.
   * @deprecated Moved to the school's custom fields (#574): filters on the custom field with this key when the school has one, ignored otherwise. Use custom_fields.
   */
  lga?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive exact match on nationality. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Case-insensitive exact match on the student's state of origin.
   * @deprecated Moved to the school's custom fields (#574): filters on the custom field with this key when the school has one, ignored otherwise. Use custom_fields.
   */
  state_of_origin?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FacultyType = {
  createdAt: Scalars['DateTime']['output'];
  departments?: Maybe<Array<Maybe<DepartmentType>>>;
  faculty_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of FacultyType items. */
export type FacultyTypePaginator = {
  /** A list of FacultyType items. */
  data: Array<FacultyType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum FeatureSourceEnum {
  Default = 'DEFAULT',
  Override = 'OVERRIDE',
  Plan = 'PLAN'
}

export type FeatureToggle = {
  code: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  source: FeatureSourceEnum;
};

export type FeeSplitAssignment = {
  childSchool: School;
  child_school_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  fee_split_profile_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  overrides: Array<FeeSplitOverride>;
  profile: FeeSplitProfile;
  updated_at: Scalars['DateTime']['output'];
};

export type FeeSplitOverride = {
  assignment: FeeSplitAssignment;
  base_amount?: Maybe<Scalars['Float']['output']>;
  campus_amount?: Maybe<Scalars['Float']['output']>;
  campus_percentage?: Maybe<Scalars['Float']['output']>;
  campus_price?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  fee_split_assignment_id: Scalars['ID']['output'];
  fee_split_rule_id: Scalars['ID']['output'];
  hq_amount?: Maybe<Scalars['Float']['output']>;
  hq_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  rule: FeeSplitRule;
  updated_at: Scalars['DateTime']['output'];
};

export type FeeSplitProfile = {
  assignments: Array<FeeSplitAssignment>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  rules: Array<FeeSplitRule>;
  school_id: Scalars['ID']['output'];
  split_mode: SplitModeEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type FeeSplitRule = {
  base_amount?: Maybe<Scalars['Float']['output']>;
  billItemCategory?: Maybe<BillItemCategory>;
  billItemTemplate?: Maybe<BillItemTemplate>;
  bill_item_category_id?: Maybe<Scalars['ID']['output']>;
  bill_item_template_id?: Maybe<Scalars['ID']['output']>;
  billable_id?: Maybe<Scalars['ID']['output']>;
  billable_type?: Maybe<Scalars['String']['output']>;
  campus_amount?: Maybe<Scalars['Float']['output']>;
  campus_percentage?: Maybe<Scalars['Float']['output']>;
  campus_price?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  fee_split_profile_id: Scalars['ID']['output'];
  hq_amount?: Maybe<Scalars['Float']['output']>;
  hq_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  overrides: Array<FeeSplitOverride>;
  priority: Scalars['Int']['output'];
  profile: FeeSplitProfile;
  updated_at: Scalars['DateTime']['output'];
};

export type File = {
  created_at: Scalars['DateTime']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mime_type: Scalars['String']['output'];
  original_name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  uploaded_at: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FileExport = {
  created_at: Scalars['DateTime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  expires_at: Scalars['DateTime']['output'];
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Mixed']['output']>;
  progress: Scalars['Int']['output'];
  school_id: Scalars['ID']['output'];
  status: FileExportStatusEnum;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id: Scalars['ID']['output'];
};

/** A paginated list of FileExport items. */
export type FileExportPaginator = {
  /** A list of FileExport items. */
  data: Array<FileExport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum FileExportStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type FileFilterInput = {
  extensions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A paginated list of File items. */
export type FilePaginator = {
  /** A list of File items. */
  data: Array<File>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type FlutterwaveConfig = PaymentProviderConfig & {
  apiKey?: Maybe<Scalars['String']['output']>;
  encryptionKey?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  secretHash?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type FlutterwaveConfigInput = {
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  secretHash?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordInput = {
  broker?: InputMaybe<PasswordBroker>;
  email: Scalars['String']['input'];
};

/** Age-eligibility rule for a DATE (date-of-birth) field, enforced server-side (#323). */
export type FormAgeEligibility = {
  max_age?: Maybe<Scalars['Int']['output']>;
  /** Custom rejection message shown when the applicant is out of range. */
  message?: Maybe<Scalars['String']['output']>;
  min_age?: Maybe<Scalars['Int']['output']>;
  /** Date the age is measured at (YYYY-MM-DD). Defaults to the submission date when unset. */
  reference_date?: Maybe<Scalars['String']['output']>;
};

export type FormAgeEligibilityInput = {
  max_age?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min_age?: InputMaybe<Scalars['Int']['input']>;
  reference_date?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Per-form branding (#299 Wave 1). Every field is optional; an unset field falls
 * back to the school's SchoolBranding, then to GradeVerse defaults. custom_css is
 * intentionally NOT exposed yet — it is an injection vector that needs a server-side
 * allow-list sanitizer, tracked as a separate follow-up.
 */
export type FormBranding = {
  accent_color?: Maybe<Scalars['String']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  background_image_url?: Maybe<Scalars['String']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  font_family?: Maybe<FormFontFamily>;
  layout_preset?: Maybe<FormLayoutPreset>;
  logo_position?: Maybe<FormLogoPosition>;
  logo_url?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  theme_preset?: Maybe<FormThemePreset>;
};

export type FormBrandingInput = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  background_color?: InputMaybe<Scalars['String']['input']>;
  background_image_url?: InputMaybe<Scalars['String']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  font_family?: InputMaybe<FormFontFamily>;
  layout_preset?: InputMaybe<FormLayoutPreset>;
  logo_position?: InputMaybe<FormLogoPosition>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  theme_preset?: InputMaybe<FormThemePreset>;
};

export enum FormConditionOperator {
  Equals = 'EQUALS',
  In = 'IN',
  NotEquals = 'NOT_EQUALS'
}

export type FormExportResponse = {
  filename: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
  rows: Array<Array<Scalars['String']['output']>>;
};

/** One form's fee, rolled up across every submission billed for it. */
export type FormFeeBillGroup = {
  /** How many people have been billed for this fee. */
  bill_count: Scalars['Int']['output'];
  form_id: Scalars['ID']['output'];
  form_slug?: Maybe<Scalars['String']['output']>;
  form_title: Scalars['String']['output'];
  /** How many of them have settled it. */
  paid_count: Scalars['Int']['output'];
  payer_type: FormFeePayerType;
  total_billed: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

/** One person billed for a form fee, and where they stand on it. */
export type FormFeePayer = {
  amount: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  bill_id: Scalars['ID']['output'];
  bill_status?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_student: Scalars['Boolean']['output'];
  /** Null when the form declares no field holding the payer's name. */
  name?: Maybe<Scalars['String']['output']>;
  student_id?: Maybe<Scalars['ID']['output']>;
  submission_id: Scalars['ID']['output'];
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  tracking_code?: Maybe<Scalars['String']['output']>;
  waived: Scalars['Boolean']['output'];
};

/**
 * Who owes a form fee: people who applied and have no student record, or students
 * of the school filling a restricted form. Explicit so the UI never calls an
 * applicant a student.
 */
export enum FormFeePayerType {
  Applicant = 'APPLICANT',
  Student = 'STUDENT'
}

export type FormField = {
  /** Age-eligibility rule (DATE fields only). */
  age_eligibility?: Maybe<FormAgeEligibility>;
  allowed_extensions?: Maybe<Array<Scalars['String']['output']>>;
  /** Pull this field's options from a live school data source (SELECT/RADIO/CHECKBOX only). Mutually exclusive with `options`; the submitted value is the source row's id. */
  data_source?: Maybe<FormFieldDataSource>;
  default_value?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** Maps this (visible) field to a built-in student attribute at conversion. Supported targets: matric_no, photo (FILE fields only — the uploaded image becomes the student's profile picture), surname, first_name, other_name, gender, dob, email, phone, home_address (residential address), state (state of residence), city, religion, nationality — or custom:<key> for one of the school's active student custom fields (the answer is saved as that field's value). State of origin, LGA and the permanent address are custom fields (custom:state_of_origin, custom:lga, custom:permanent_address); the old names are still accepted and saved in that form. An explicit conversion-time field_mapping always wins; maps_to fills what it left empty. Optional per school. This is NOT the system's applicant↔student link — that is always recorded via FormSubmission.convertedStudent / Student.admissionSubmission. */
  maps_to?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  /** Max file size in KB */
  max_size?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Id of the section this field belongs to (null = unsectioned). References FormSection.id. */
  section_id?: Maybe<Scalars['String']['output']>;
  /** Show this field only when the condition holds (null = always shown). */
  show_if?: Maybe<FormFieldCondition>;
  /** Show this field's answer as a column on the admin submissions table. Per-form, school-level configuration authored in the form builder. */
  show_in_table?: Maybe<Scalars['Boolean']['output']>;
  type: FormFieldType;
};

/** A single-condition visibility rule for a field (#323 v1 — no nested AND/OR). */
export type FormFieldCondition = {
  /** Name of the controlling field whose value is tested. */
  field: Scalars['String']['output'];
  operator: FormConditionOperator;
  /** Values to test against. EQUALS/NOT_EQUALS use the first; IN matches any. */
  value: Array<Scalars['String']['output']>;
};

export type FormFieldConditionInput = {
  field: Scalars['String']['input'];
  operator: FormConditionOperator;
  value: Array<Scalars['String']['input']>;
};

/**
 * Live data sources a SELECT / RADIO / CHECKBOX field can pull its options from
 * instead of a manual `options` list. Options resolve at render time via
 * CustomForm.publicOptions, scoped to the form's school; the submitted value is
 * the chosen row's id and is validated server-side against the same source.
 */
export enum FormFieldDataSource {
  Campuses = 'CAMPUSES',
  /** Schools whose parent is the form's school */
  ChildSchools = 'CHILD_SCHOOLS',
  /** Class levels, without arms */
  Classrooms = 'CLASSROOMS',
  /** Class level × arm placements (same options CLASSROOM_SELECT shows) */
  ClassArms = 'CLASS_ARMS',
  Departments = 'DEPARTMENTS',
  Faculties = 'FACULTIES',
  /** Active tertiary programmes (same options PROGRAMME_SELECT shows) */
  Programmes = 'PROGRAMMES',
  /** Academic sessions */
  Sessions = 'SESSIONS',
  Subjects = 'SUBJECTS'
}

export type FormFieldInput = {
  age_eligibility?: InputMaybe<FormAgeEligibilityInput>;
  allowed_extensions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pull this field's options from a live school data source (SELECT/RADIO/CHECKBOX only). Mutually exclusive with `options`. */
  data_source?: InputMaybe<FormFieldDataSource>;
  default_value?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  /** Maps this visible field to a built-in student attribute at conversion. Supported targets: matric_no, photo (FILE fields only), surname, first_name, other_name, gender, dob, email, phone, home_address, state, city, religion. */
  maps_to?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  /** Max file size in KB */
  max_size?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the section this field belongs to (null = unsectioned). */
  section_id?: InputMaybe<Scalars['String']['input']>;
  show_if?: InputMaybe<FormFieldConditionInput>;
  /** Show this field's answer as a column on the admin submissions table. */
  show_in_table?: InputMaybe<Scalars['Boolean']['input']>;
  type: FormFieldType;
};

export enum FormFieldType {
  Checkbox = 'CHECKBOX',
  ClassroomSelect = 'CLASSROOM_SELECT',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  File = 'FILE',
  Number = 'NUMBER',
  ProgrammeSelect = 'PROGRAMME_SELECT',
  Radio = 'RADIO',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Time = 'TIME'
}

export enum FormFontFamily {
  Mono = 'MONO',
  Rounded = 'ROUNDED',
  Sans = 'SANS',
  Serif = 'SERIF',
  System = 'SYSTEM'
}

export enum FormLayoutPreset {
  Card = 'CARD',
  Compact = 'COMPACT',
  Spacious = 'SPACIOUS',
  Split = 'SPLIT',
  Standard = 'STANDARD'
}

export enum FormLogoPosition {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** One referee slot an admission form requires. */
export type FormReferenceRequirement = {
  count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reference_form_id: Scalars['ID']['output'];
  /** Stage whose submission triggers this requirement's invites. Null = the final stage. */
  stage_id?: Maybe<Scalars['String']['output']>;
};

export type FormReferenceRequirementInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  reference_form_id: Scalars['ID']['input'];
  stage_id?: InputMaybe<Scalars['String']['input']>;
};

export type FormReferenceSettings = {
  /** When true, applicants may read submitted responses on their status page. Default false — name + status only. */
  applicants_can_view_responses?: Maybe<Scalars['Boolean']['output']>;
  /** Days a referee link stays valid (default 60). */
  expires_days?: Maybe<Scalars['Int']['output']>;
};

export type FormReferenceSettingsInput = {
  applicants_can_view_responses?: InputMaybe<Scalars['Boolean']['input']>;
  expires_days?: InputMaybe<Scalars['Int']['input']>;
};

/** An ordered, titled group of fields on a form (#322). Optional — a form with no sections renders as a single unnamed section. */
export type FormSection = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type FormSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** One stage of a (possibly multi-stage) application. A single-stage form returns one synthesized stage covering all fields. */
export type FormStage = {
  description?: Maybe<Scalars['String']['output']>;
  /** Optional fee for this stage (a bill item template). */
  fee_bill_item_template_id?: Maybe<Scalars['ID']['output']>;
  /** Names of the form fields that belong to this stage. Empty = all fields. */
  field_names: Array<Scalars['String']['output']>;
  gate: FormStageGate;
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** How advancing past a stage is gated. */
export enum FormStageGate {
  Approval = 'APPROVAL',
  Both = 'BOTH',
  None = 'NONE',
  Payment = 'PAYMENT'
}

export type FormStageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fee_bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  field_names?: InputMaybe<Array<Scalars['String']['input']>>;
  gate?: InputMaybe<FormStageGate>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type FormSubmission = {
  activities: Array<FormSubmissionActivity>;
  admission_letter_generated_at?: Maybe<Scalars['DateTime']['output']>;
  /** The programme on the admission letter next to the one the applicant applied for and the one they were placed in. */
  admission_letter_programme_check?: Maybe<AdmissionLetterProgrammeCheck>;
  admission_letter_sent_at?: Maybe<Scalars['DateTime']['output']>;
  /** A short-lived signed URL to download the generated admission letter (#376). Null until a letter has been generated. */
  admission_letter_url?: Maybe<Scalars['String']['output']>;
  admission_letter_warnings: Array<Scalars['String']['output']>;
  /** Email extracted from submission data, used for applicant verification and notifications */
  applicant_email?: Maybe<Scalars['String']['output']>;
  /** Best-effort applicant display name: the student's own record for a restricted form, else the name fields the form's mapping declares. Null when the form declares no name field. */
  applicant_name?: Maybe<Scalars['String']['output']>;
  /** The programme the applicant chose, read the way conversion and the admission letter read it. Null when no answer names a programme. */
  applicant_programme?: Maybe<ApplicantProgrammeChoice>;
  /** What approving this application does with its admission letter, for the reviewer to see before confirming. */
  approval_letter_preview?: Maybe<ApprovalLetterPreview>;
  /** The reviewer this submission has been claimed by (or assigned to). Null = up for grabs. */
  assignedReviewer?: Maybe<User>;
  /** When the reviewer was assigned (used for SLA / staleness) */
  assigned_reviewer_at?: Maybe<Scalars['DateTime']['output']>;
  /** Payment gate (#249): true when this application is blocked from approval/conversion by an unmet, unwaived payment requirement. Derived live from the bill status + waiver, so paying auto-unblocks with no status change. */
  awaiting_payment: Scalars['Boolean']['output'];
  /** The bill generated for this submission (if any) */
  bill?: Maybe<Bill>;
  convertedStudent?: Maybe<Student>;
  converted_student_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  /** Which stage the applicant is currently on (1-indexed). */
  current_stage: Scalars['Int']['output'];
  data: Scalars['JSON']['output'];
  /** Pending referee nominations stored with the caller's OWN parked draft, for re-editing on reopen. Empty for anyone else's submission. */
  draft_nominations: Array<DraftReferenceNomination>;
  duplicateOf?: Maybe<FormSubmission>;
  /** Prior non-rejected submission with the same applicant email on this form (public admission path). Null = not a duplicate. Reviewer-facing signal — duplicates are allowed, but visible (#250). */
  duplicate_of_submission_id?: Maybe<Scalars['ID']['output']>;
  /** When the applicant's email was verified via OTP before submission. Null for unverified or non-admission submissions. */
  email_verified_at?: Maybe<Scalars['DateTime']['output']>;
  /** FILE-field values resolved to viewable attachments. data only carries their ids. */
  files: Array<SubmissionFile>;
  form: CustomForm;
  id: Scalars['ID']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  paymentWaivedBy?: Maybe<User>;
  /** When the payment requirement was waived for this application. Null = not waived. */
  payment_waived_at?: Maybe<Scalars['DateTime']['output']>;
  /** A short-lived signed URL to download this application as a branded PDF (#377). Any principal that can already see this submission can select it. */
  pdf_url?: Maybe<Scalars['String']['output']>;
  /** Reference requests bound to this application (reviewer surface). */
  referenceRequests: Array<ReferenceRequestRecord>;
  /** Live per-requirement reference progress. Null when the form has no reference requirements. Never blocks anything — informational. */
  reference_progress?: Maybe<ReferenceProgress>;
  /** Every answer resolved for display: picker ids become option labels (retired options included), FILE ids become the original filename. Use this instead of relabelling `data` on the client. */
  resolved_answers: Array<ResolvedFormAnswer>;
  review_note?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<User>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Per-stage lifecycle record, keyed by stage number. */
  stage_states?: Maybe<Scalars['JSON']['output']>;
  status: FormSubmissionStatus;
  /** When the current stage was submitted; null while it is still a draft. */
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  tracking_code?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_agent?: Maybe<Scalars['String']['output']>;
  /** The waiver code used on this submission, if any. */
  waiverCode?: Maybe<FormWaiverCode>;
};

export type FormSubmissionActivity = {
  /** Files attached to this activity (resolved from metadata.file_ids). Empty list when nothing is attached. */
  attachments: Array<File>;
  content: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  form_submission_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether the signed-in user may edit or delete this activity: a note they typed themselves (not one recorded by a workflow action), and not an action request the applicant has already answered. */
  is_editable: Scalars['Boolean']['output'];
  is_visible_to_applicant: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  new_status?: Maybe<Scalars['String']['output']>;
  old_status?: Maybe<Scalars['String']['output']>;
  /** When an action_required activity has been handled (auto-set when applicant replies, manually set by admins). Null = still open. */
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  type: SubmissionActivityType;
  user?: Maybe<User>;
};

/** A paginated list of FormSubmission items. */
export type FormSubmissionPaginator = {
  /** A list of FormSubmission items. */
  data: Array<FormSubmission>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum FormSubmissionStatus {
  Approved = 'APPROVED',
  Converted = 'CONVERTED',
  /** Applicant is still filling this stage — editable freely via saveDraft. */
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum FormThemePreset {
  Brand = 'BRAND',
  Dark = 'DARK',
  Default = 'DEFAULT',
  Light = 'LIGHT',
  Minimal = 'MINIMAL'
}

export enum FormType {
  Admission = 'ADMISSION',
  General = 'GENERAL',
  /** A referee-facing template: authored like any form, but hidden from listings and reachable only through a reference-request token. */
  Reference = 'REFERENCE'
}

export type FormWaiverCode = {
  academicCalendar: AcademicCalendar;
  academic_calendar_id: Scalars['ID']['output'];
  batch_label?: Maybe<Scalars['String']['output']>;
  /** Paid so far on the bill of the application that used this code. Above zero means money arrived although the fee was waived: review it for a refund. Null where not loaded. */
  bill_amount_paid?: Maybe<Scalars['Float']['output']>;
  campus?: Maybe<CampusType>;
  /** The campus this code was issued for. Null for codes issued without one. */
  campus_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  form?: Maybe<CustomForm>;
  form_id: Scalars['ID']['output'];
  generatedBy: User;
  id: Scalars['ID']['output'];
  revokedBy?: Maybe<User>;
  revoked_at?: Maybe<Scalars['DateTime']['output']>;
  status: FormWaiverCodeStatus;
  usedBySubmission?: Maybe<FormSubmission>;
  used_at?: Maybe<Scalars['DateTime']['output']>;
  used_by_email?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of FormWaiverCode items. */
export type FormWaiverCodePaginator = {
  /** A list of FormWaiverCode items. */
  data: Array<FormWaiverCode>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum FormWaiverCodeStatus {
  Available = 'AVAILABLE',
  Revoked = 'REVOKED',
  Used = 'USED'
}

/** Summary counts of waiver codes for a form. */
export type FormWaiverCodeSummary = {
  available: Scalars['Int']['output'];
  revoked: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type GatewaySettlementAccount = {
  account_name?: Maybe<Scalars['String']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  /** Secret fields (MAC key, API key) are masked to '' on read — see PaymentProviderConfigResolver's #239 contract. */
  config?: Maybe<Scalars['JSON']['output']>;
  created_at: Scalars['DateTime']['output'];
  gateway_identifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  paymentProvider: PaymentProvider;
  payment_provider_id: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum GatewaySplitStatusEnum {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type GenerateCertificateInput = {
  certificate_template_id: Scalars['ID']['input'];
  graduation_record_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};

export type GenerateLessonNoteWithAiInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['ID']['input'];
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  learningObjectives?: InputMaybe<Scalars['String']['input']>;
  modelOverride?: InputMaybe<Scalars['String']['input']>;
  schemeWeekId?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
  topic: Scalars['String']['input'];
};

/** Result of batch code generation. Codes are shown in plaintext exactly once. */
export type GenerateWaiverCodesResult = {
  /** The generated codes in plaintext (display to admin, then discard). */
  codes: Array<Scalars['String']['output']>;
  /** Total number of codes generated. */
  count: Scalars['Int']['output'];
};

export type GeneratedCertificate = {
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approver?: Maybe<User>;
  auditLogs: Array<CertificateAuditLog>;
  certificate_number: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  delivery_method?: Maybe<CertificateDeliveryEnum>;
  file_path?: Maybe<Scalars['String']['output']>;
  generated_at?: Maybe<Scalars['DateTime']['output']>;
  generator?: Maybe<User>;
  graduationRecord: GraduationRecord;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  reissue_reason?: Maybe<Scalars['String']['output']>;
  reissuedFrom?: Maybe<GeneratedCertificate>;
  reissues: Array<GeneratedCertificate>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  released_at?: Maybe<Scalars['DateTime']['output']>;
  releaser?: Maybe<User>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<User>;
  revocation_reason?: Maybe<Scalars['String']['output']>;
  revoked_at?: Maybe<Scalars['DateTime']['output']>;
  revoker?: Maybe<User>;
  snapshot_html?: Maybe<Scalars['String']['output']>;
  status: CertificateStatusEnum;
  student: Student;
  template: CertificateTemplate;
  updated_at: Scalars['DateTime']['output'];
  verification_code: Scalars['String']['output'];
  verification_hash?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type GeneratedCertificateFilterInput = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CertificateStatusEnum>;
};

/** A paginated list of GeneratedCertificate items. */
export type GeneratedCertificatePaginator = {
  /** A list of GeneratedCertificate items. */
  data: Array<GeneratedCertificate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GeneratedTranscript = {
  cover_letter?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  file_path?: Maybe<Scalars['String']['output']>;
  generatedBy?: Maybe<User>;
  generated_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  student: Student;
  student_id: Scalars['ID']['output'];
  summary: Scalars['JSON']['output'];
  transcriptRequest?: Maybe<TranscriptRequest>;
  transcriptTemplate?: Maybe<TranscriptTemplate>;
  transcript_request_id?: Maybe<Scalars['ID']['output']>;
  transcript_template_id?: Maybe<Scalars['ID']['output']>;
  version: Scalars['Int']['output'];
};

export type Grade = {
  grade?: Maybe<Scalars['String']['output']>;
  /** Name of the parent grade group. Batch-loads the group so a list of bands costs one query, not one per band. */
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Float']['output']>;
  school?: Maybe<School>;
};

export type GradeAndRemark = {
  /** This can be sometime A, B, C, D, E, `Thinking of having this customisable in the admin panel` */
  grade?: Maybe<Scalars['String']['output']>;
  /** This should be customizable in the admin panel based on grade level */
  remark?: Maybe<Scalars['String']['output']>;
};

export type GradeGroup = {
  description?: Maybe<Scalars['String']['output']>;
  gradeBands: Array<Grade>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GradeSummary = {
  average?: Maybe<Scalars['Int']['output']>;
  excellent?: Maybe<Scalars['Int']['output']>;
  fail?: Maybe<Scalars['Int']['output']>;
  fair?: Maybe<Scalars['Int']['output']>;
  first_class?: Maybe<Scalars['Int']['output']>;
  good?: Maybe<Scalars['Int']['output']>;
  other?: Maybe<Scalars['Int']['output']>;
  pass?: Maybe<Scalars['Int']['output']>;
  poor?: Maybe<Scalars['Int']['output']>;
  second_class_lower?: Maybe<Scalars['Int']['output']>;
  second_class_upper?: Maybe<Scalars['Int']['output']>;
  third_class?: Maybe<Scalars['Int']['output']>;
  very_good?: Maybe<Scalars['Int']['output']>;
};

export enum GradingModeEnum {
  Ai = 'AI',
  Manual = 'MANUAL'
}

export type GraduationCriteriaPreset = {
  criteria: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GraduationEligibilityCheckResult = {
  eligible_count: Scalars['Int']['output'];
  failed_count: Scalars['Int']['output'];
  failed_student_ids: Array<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  not_eligible_count: Scalars['Int']['output'];
  records: Array<GraduationRecord>;
  total_checked: Scalars['Int']['output'];
};

export type GraduationRecord = {
  academicCalendar?: Maybe<AcademicCalendar>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approver?: Maybe<User>;
  calculation_method: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  degree_classification: Scalars['String']['output'];
  final_result: Scalars['Float']['output'];
  graduated_at?: Maybe<Scalars['DateTime']['output']>;
  graduation_status: GraduationStatusEnum;
  has_outstanding_courses: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  outstanding_courses?: Maybe<Scalars['String']['output']>;
  programme?: Maybe<ProgrammeType>;
  student: Student;
  total_units_passed: Scalars['Int']['output'];
  total_units_registered: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GraduationRecordFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  created_from?: InputMaybe<Scalars['Date']['input']>;
  created_to?: InputMaybe<Scalars['Date']['input']>;
  graduation_status?: InputMaybe<GraduationStatusEnum>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated list of GraduationRecord items. */
export type GraduationRecordPaginator = {
  /** A list of GraduationRecord items. */
  data: Array<GraduationRecord>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum GraduationStatusEnum {
  Approved = 'APPROVED',
  Eligible = 'ELIGIBLE',
  NotEligible = 'NOT_ELIGIBLE',
  Revoked = 'REVOKED'
}

export type Guardian = {
  altPhoneNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The school's active guardian custom fields, in display order, with this guardian's values. */
  customFieldValues: Array<CustomFieldValue>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /** Staff-internal notes. Null unless the viewer has Guardians → View. */
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  preferredLanguage: Scalars['String']['output'];
  studentLinks: Array<GuardianStudent>;
  students: Array<Student>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  whatsappOptIn: Scalars['Boolean']['output'];
};

export type GuardianActivityItem = {
  description?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum GuardianBroadcastChannel {
  Email = 'EMAIL',
  Whatsapp = 'WHATSAPP'
}

export type GuardianBroadcastResult = {
  emailsSent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  whatsappSent: Scalars['Int']['output'];
};

export type GuardianCalendarOption = {
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  session?: Maybe<Session>;
};

export type GuardianChildOverview = {
  /** Current-term attendance rate (present + late over recorded days), 0-100. Null when nothing is recorded yet. */
  attendancePercentage?: Maybe<Scalars['Float']['output']>;
  currentClassroom?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  currentProgramme?: Maybe<Scalars['String']['output']>;
  /** The caller's own guardian-student link (pivot id + notification preferences). */
  link: GuardianStudent;
  outstandingBalance: Scalars['Float']['output'];
  relationshipType: Scalars['String']['output'];
  school: School;
  student: Student;
};

export type GuardianDashboardSummary = {
  recentActivity: Array<GuardianActivityItem>;
  totalChildren: Scalars['Int']['output'];
  totalOutstanding: Scalars['Float']['output'];
};

export type GuardianInvitation = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  guardian: Guardian;
  id: Scalars['ID']['output'];
  school: School;
  status: Scalars['String']['output'];
};

export enum GuardianRelationshipType {
  Father = 'FATHER',
  Grandparent = 'GRANDPARENT',
  Guardian = 'GUARDIAN',
  Mother = 'MOTHER',
  Other = 'OTHER',
  Sponsor = 'SPONSOR'
}

export type GuardianStudent = {
  canAuthorizePickup: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  guardian: Guardian;
  id: Scalars['ID']['output'];
  isPrimaryContact: Scalars['Boolean']['output'];
  receivesAttendanceNotifications: Scalars['Boolean']['output'];
  receivesFeeNotifications: Scalars['Boolean']['output'];
  receivesResultNotifications: Scalars['Boolean']['output'];
  relationshipType: GuardianRelationshipType;
  /** Null when the student was removed or is outside your access. */
  student?: Maybe<Student>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Used for both create (studentId + relationshipType required) and update (all optional).
 * The resolver enforces required-field context — avoids splitting into two identical inputs.
 */
export type GuardianStudentLinkInput = {
  canAuthorizePickup?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  receivesAttendanceNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivesFeeNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivesResultNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipType?: InputMaybe<GuardianRelationshipType>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type HeadingMapEntry = {
  csvColumn: Scalars['String']['input'];
  modelField: Scalars['String']['input'];
};

export type HierarchyStaffMember = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type HistoricalSourceMapInput = {
  academic_calendar_id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};

export type ImportError = {
  errors?: Maybe<Scalars['JSON']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
};

export type ImportResponse = {
  errors?: Maybe<Array<Maybe<ImportError>>>;
  failed?: Maybe<Scalars['Int']['output']>;
  /** True when the import was too large and was queued for background processing. */
  queued?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the StudentImport tracking row when queued. Null for synchronous imports. */
  student_import_id?: Maybe<Scalars['ID']['output']>;
  successful?: Maybe<Scalars['Int']['output']>;
  total_rows?: Maybe<Scalars['Int']['output']>;
};

export type InitiatePaymentInput = {
  amount: Scalars['Float']['input'];
  billDetailAndAmount?: InputMaybe<Array<BillDetailAndAmount>>;
  /** The settlement account to route this payment through. When set, overrides the provider-level PAY ITEM ID. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  processor?: InputMaybe<Scalars['String']['input']>;
  student_id: Scalars['ID']['input'];
};

export type InitiatePaymentType = {
  amountInKobo?: Maybe<Scalars['Int']['output']>;
  baseAmount?: Maybe<Scalars['Float']['output']>;
  convenienceFee?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  inlineCheckoutUrl?: Maybe<Scalars['String']['output']>;
  merchantCode?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  payItemId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentPageUrl?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  rrr?: Maybe<Scalars['String']['output']>;
  splitAccounts?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<Scalars['String']['output']>;
};

export type InterswitchCharges = {
  cardCharge: Scalars['Float']['output'];
  otherCharge: Scalars['Float']['output'];
};

export type InterswitchConfig = PaymentProviderConfig & {
  apiKey?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  macKey?: Maybe<Scalars['String']['output']>;
  merchantCode?: Maybe<Scalars['String']['output']>;
  payItemId?: Maybe<Scalars['String']['output']>;
};

export type InterswitchConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  macKey?: InputMaybe<Scalars['String']['input']>;
  merchantCode?: InputMaybe<Scalars['String']['input']>;
  payItemId?: InputMaybe<Scalars['String']['input']>;
};

export type LecturerAllocationSummary = {
  allocated_count: Scalars['Int']['output'];
  course_lecturer_id: Scalars['ID']['output'];
  lecturer_name: Scalars['String']['output'];
  school_staff_id: Scalars['ID']['output'];
  students: Array<CourseRegistered>;
};

export type LedgerEntry = {
  bill_due_date?: Maybe<Scalars['Date']['output']>;
  credit: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  debit: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  items?: Maybe<Array<LedgerEntryDetail>>;
  /**
   * Payment rows only: the portion of this payment allocated to bills OUTSIDE
   * this statement's bill set (e.g. bills of a programme the student has since
   * left). Money flagged here is NOT settling any bill shown above — check the
   * student's placement or re-point the allocation.
   */
  off_statement_amount?: Maybe<Scalars['Float']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  related_id: Scalars['ID']['output'];
  related_type: Scalars['String']['output'];
  running_balance: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: LedgerEntryType;
};

export type LedgerEntryDetail = {
  amount: Scalars['Float']['output'];
  item_name: Scalars['String']['output'];
};

export enum LedgerEntryType {
  Bill = 'BILL',
  Discount = 'DISCOUNT',
  Exemption = 'EXEMPTION',
  Payment = 'PAYMENT',
  Refund = 'REFUND'
}

export type LessonNote = {
  aiGenerated: Scalars['Boolean']['output'];
  aiGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  aiModel?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  classroom: Classroom;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  resources: Array<EducationalResource>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  schemeWeek?: Maybe<SchemeWeek>;
  school: School;
  status: LessonNoteStatus;
  subject: Subject;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<User>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<LessonNoteVersion>;
};

export enum LessonNoteApprovalMode {
  AiOnly = 'AI_ONLY',
  Disabled = 'DISABLED',
  Required = 'REQUIRED'
}

export enum LessonNoteStatus {
  Draft = 'DRAFT',
  PendingReview = 'PENDING_REVIEW',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type LessonNoteVersion = {
  aiGenerated: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  title: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type LoginResponse = {
  loginSchools?: Maybe<Array<LoginSchool>>;
  message?: Maybe<Scalars['String']['output']>;
  school_count?: Maybe<Scalars['Int']['output']>;
  schools?: Maybe<Array<Maybe<School>>>;
  status?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

/** A school in the login response, annotated with the portals available to the authenticated user. */
export type LoginSchool = {
  portals: Array<PortalType>;
  school: School;
};

export type ManualOutstandingCoursePaginator = {
  data: Array<ManualOutstandingCourseType>;
  paginatorInfo: PaginatorInfo;
};

export type ManualOutstandingCourseType = {
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUser?: Maybe<User>;
  curriculum_level?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MarkChannelReadInput = {
  chat_channel_id: Scalars['ID']['input'];
  last_read_message_id: Scalars['ID']['input'];
};

export type MarkStudentAttendanceInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  /** Marks against a named attendance event; event_type, course_id and session are then derived from the event. */
  attendance_event_id?: InputMaybe<Scalars['ID']['input']>;
  course_id?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['Date']['input'];
  /** Tertiary: what the attendance is for. Defaults to LECTURE (secondary schools' only value). */
  event_type?: InputMaybe<AttendanceEventType>;
  /** Tertiary: optional programme/course tags for a course register (#320). */
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
  status: AttendanceStatus;
  student_id: Scalars['ID']['input'];
};

export type MatricNoConfig = {
  enabled: Scalars['Boolean']['output'];
  next_sequence: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  template: Scalars['String']['output'];
};

export enum MatricNoOption {
  Custom = 'CUSTOM',
  GenerateNew = 'GENERATE_NEW',
  KeepExisting = 'KEEP_EXISTING'
}

export type MatricRetrievalAttempt = {
  admin_notes?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedStudent?: Maybe<Student>;
  matched_student_id?: Maybe<Scalars['ID']['output']>;
  other_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  programme?: Maybe<ProgrammeType>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  resolver?: Maybe<User>;
  result: Scalars['String']['output'];
  status: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  year_of_graduation?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of MatricRetrievalAttempt items. */
export type MatricRetrievalAttemptPaginator = {
  /** A list of MatricRetrievalAttempt items. */
  data: Array<MatricRetrievalAttempt>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MatricRetrievalResult = {
  found: Scalars['Boolean']['output'];
  matric_no?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  student_id?: Maybe<Scalars['ID']['output']>;
};

export enum MatricRetrievalResultEnum {
  Found = 'FOUND',
  MultipleMatches = 'MULTIPLE_MATCHES',
  NotFound = 'NOT_FOUND'
}

export enum MatricRetrievalStatusEnum {
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type MethodBreakdownEntry = {
  count: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type ModuleCloneAssignmentInput = {
  curriculum_ids: Array<Scalars['ID']['input']>;
  sequence: Scalars['Int']['input'];
};

export type ModuleCourseRegistrationInput = {
  courses: Array<CourseCurriculumInput>;
  programme_module_id: Scalars['ID']['input'];
};

/** A school-wide elective offered in a module for one semester calendar. */
export type ModuleElectiveOffering = {
  academicCalendar: AcademicCalendar;
  academic_calendar_id: Scalars['ID']['output'];
  course: Course;
  course_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  programme_module_id: Scalars['ID']['output'];
};

export type ModuleElectiveSearchResult = {
  courses: Array<Course>;
  module_id: Scalars['ID']['output'];
};

export type ModulePaymentLine = {
  amount: Scalars['Float']['output'];
  attempt_number: Scalars['Int']['output'];
  bill_id?: Maybe<Scalars['ID']['output']>;
  cleared: Scalars['Boolean']['output'];
  module_id: Scalars['ID']['output'];
  module_name: Scalars['String']['output'];
  outstanding: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
};

export type ModulePaymentSummary = {
  amount: Scalars['Float']['output'];
  cleared: Scalars['Boolean']['output'];
  modules: Array<ModulePaymentLine>;
  outstanding: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
};

/** How results are recorded for modular/residence programmes. */
export enum ModuleResultModeEnum {
  Rollup = 'ROLLUP',
  Separate = 'SEPARATE'
}

export type MonnifyConfig = PaymentProviderConfig & {
  apiKey?: Maybe<Scalars['String']['output']>;
  contractCode?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type MonnifyConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  contractCode?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  /**
   * Accept/transfer courses from another programme to a target programme.
   * Used when a student transfers programmes and some courses are recognized.
   */
  acceptCoursesForProgramme: Array<CourseRegistered>;
  acceptGuardianInvitation: LoginResponse;
  acceptSchoolInvitation: School;
  acknowledgeAnnouncement: Scalars['Boolean']['output'];
  /** The explicit acknowledgement that clears a must-read notice. Idempotent. */
  acknowledgeSchoolAnnouncement: SchoolAnnouncement;
  activateChildSchoolCalendar: MutationResponse;
  addChildByLinkingCode: GuardianStudent;
  addCourseMutation?: Maybe<StudentCourseRegistration>;
  addCourseOutstandingWaiver: MutationResponse;
  addManualOutstandingCourse: MutationResponse;
  addModuleElectiveOfferings: MutationResponse;
  /** Admin adds a referee to an application (e.g. replacing a dead end). Invited immediately. */
  addReferenceRequest: ReferenceRequestRecord;
  addSchemeWeek: SchemeWeek;
  addStudentCourseToExempt: MutationResponse;
  /** Add a note or message to a form submission */
  addSubmissionNote: FormSubmissionActivity;
  addTranscriptRequestNote: TranscriptRequestActivity;
  adjustWallet: WalletTransaction;
  adminGenerateTranscript: GeneratedTranscript;
  /**
   * Resets one student's password to the platform default (surname in lowercase).
   * Staff only: requires students.update in the current school; the resolver then
   * applies the caller's per-student permission scope.
   */
  adminResetStudentPassword: MutationResponse;
  adminSubmitCourseRegistration?: Maybe<StudentCourseRegistration>;
  allocateCoursesToLecturerInSemesterByHODOrAdmin: Array<CourseLecturer>;
  allocateStudentsToLecturerManually: StudentAllocationResult;
  allocateStudentsToLecturersRandomly: StudentAllocationResult;
  /** Applicant replies to an action-required activity, optionally attaching files uploaded via applicantUploadFile. */
  applicantReply: FormSubmissionActivity;
  /** Applicant updates a single field on their submission in response to an admin's action_required request. Validates the new value against the field's constraints, updates submission.data atomically, and auto-resolves the linked action_required activity. */
  applicantUpdateField: FormSubmissionActivity;
  /** Public-facing file upload for verified applicants. Authenticates via the OTP session token, scopes the file to the applicant's school. Files are tagged 'applicant_attachment'. */
  applicantUploadFile: File;
  /**
   * Adds a template's fields that the school does not have yet (matched by key),
   * after its existing fields. A retired field with the same key is reactivated;
   * an active one is left as it is. Returns the fields created or reactivated.
   * Needs Custom Fields → Create.
   */
  applyCustomFieldTemplate: Array<CustomField>;
  /** Apply a one-off manual discount to a single line of a direct student bill (append-only ledger row; survives rule re-syncs). */
  applyManualDiscount: BillDetail;
  approveCaScoresForCourse: MutationResponse;
  approveCertificate: GeneratedCertificate;
  approveExemption: Exemption;
  approveGraduation: GraduationRecord;
  approveLessonNote: LessonNote;
  approveOrDenyCourse: Array<CourseLecturer>;
  approveRefund: Refund;
  approveRoleRequests: Array<PermissionGrant>;
  approveStudentCourseRegistration: Array<StudentCourseRegistration>;
  approveTranscriptRequest: TranscriptRequest;
  assignAdmissionLetterTemplate: Scalars['Boolean']['output'];
  assignDiscount: EntityDiscount;
  assignFeeSplitProfile: Array<FeeSplitAssignment>;
  assignPermissionGroup: MutationResponse;
  assignResultTemplateToClassroom?: Maybe<Classroom>;
  assignResultTemplateToProgramme?: Maybe<ProgrammeType>;
  /**
   * Assign one result template to several programmes and several semesters in one
   * all-or-nothing write. Pairs already on this template are reported as unchanged.
   * Pairs on a different template are returned as conflicts and nothing is written
   * unless overwrite is true. Templates with historical columns accept one semester only.
   */
  assignResultTemplateToProgrammes: ProgrammeTemplateAssignmentResult;
  assignStaffDepartment: Staff;
  assignStaffToChildSchools: BulkStaffAssignmentResult;
  assignStudentsToCampus: MutationResponse;
  /** Claim a submission for review (or assign it to another reviewer). Pass user_id=null on the unassign mutation to release. */
  assignSubmissionReviewer: FormSubmission;
  assignTeacherToSubject: Array<SubjectTeacher>;
  attachLinkResourceToLessonNote: EducationalResource;
  attachResourceToLessonNote: EducationalResource;
  batchApproveFilteredGraduations: BatchApproveGraduationsResult;
  batchApproveGraduations: BatchApproveGraduationsResult;
  batchGenerateCertificates: CertificateBatchJob;
  broadcastMessage: Array<ChatMessageType>;
  broadcastToGuardians: GuardianBroadcastResult;
  /**
   * Broadcast a WhatsApp template to multiple guardians.
   * Only opted-in, verified, non-opted-out guardians receive the message.
   */
  broadcastWhatsappMessage: Scalars['Boolean']['output'];
  bulkAddCourseOutstandingWaiver: MutationResponse;
  bulkAddManualOutstandingByScope: MutationResponse;
  bulkAddManualOutstandingByStudents: MutationResponse;
  /** Bulk convert multiple approved submissions to students */
  bulkConvertSubmissions: BulkConvertResponse;
  bulkCourseRegistrationAction: BulkRegistrationActionResult;
  bulkDeleteCbtTests: BulkCbtActionResult;
  bulkDeleteCourseOutstandingWaiver: MutationResponse;
  bulkDeleteManualOutstandingCourse: MutationResponse;
  bulkDeleteStudentCourseExemption: MutationResponse;
  bulkExempt: MutationResponse;
  bulkExemptByStudents: MutationResponse;
  bulkExemptFromExcel: MutationResponse;
  bulkGenerateStudentLinkingCodes: BulkLinkingCodeResult;
  bulkInviteStaff: BulkInviteStaffResponse;
  bulkPublishResults: BulkPublishResponse;
  /**
   * Bulk replace assessment type on scores across multiple course_registered records.
   * Finds all scores with from_assessment_type_id and changes them to to_assessment_type_id.
   */
  bulkReplaceAssessmentType: MutationResponse;
  /**
   * Resets every selected student of the current school to the platform default
   * password (surname in lowercase) and reports the outcome per student. A
   * student that cannot be reset is listed as failed without aborting the rest.
   * Requires students.update in the current school.
   */
  bulkResetStudentPasswords: BulkResetStudentPasswordsResponse;
  /**
   * Bulk swap all student course registrations from one course to another within a programme,
   * optionally scoped to a specific academic calendar.
   */
  bulkSwapCourse: MutationResponse;
  bulkTransferStudents: BulkTransferResult;
  bulkUnPublishResults: MutationResponse;
  bulkUpdateCbtTests: BulkCbtActionResult;
  /** Bulk update course_status (C/E) for multiple course_registered records at once. */
  bulkUpdateCourseRegisteredStatus: MutationResponse;
  /** Bulk update unit or instance year for multiple courses at once. */
  bulkUpdateCourses: MutationResponse;
  /** Bulk update curriculum entries — change status, level, or semester for multiple entries at once. */
  bulkUpdateCurriculum: MutationResponse;
  /**
   * Bulk update the registration level for selected course registrations.
   * Also updates the student_academic_calendar placement to match.
   */
  bulkUpdateRegistrationLevel: BulkRegistrationActionResult;
  bulkUpdateStudentCourseExemption: MutationResponse;
  /**
   * Bulk-updates programme, classroom section, or campus for multiple students.
   * Authorization is handled at the resolver level due to array arguments.
   */
  bulkUpdateStudents: MutationResponse;
  cancelAiPendingAction: AiPendingAction;
  cancelMySubscription: SubscriptionState;
  /** Admin cancels a request; its link dies. */
  cancelReferenceRequest: ReferenceRequestRecord;
  changePassword: MutationResponse;
  checkAllProgrammesEligibility: FileExport;
  checkGraduationEligibility: GraduationEligibilityCheckResult;
  cleanupResolvedManualOutstanding: MutationResponse;
  clearStudentLecturerAllocations: MutationResponse;
  /**
   * Copy a programme's modules from one session into another (or into a sibling
   * programme). Dates shift by the gap between the two sessions' start dates,
   * calendar pins are re-mapped to the matching semester of the target session,
   * and a target sequence that already exists is skipped, so re-running is safe.
   */
  cloneProgrammeModules?: Maybe<CloneProgrammeModulesResult>;
  /** Stops collecting answers. Needs Students → Update. */
  closeStudentDataRequest: StudentDataRequest;
  /** The person pressing Confirm on the card. Refused through any MCP/assistant channel. */
  confirmAiPendingAction: AiPendingAction;
  confirmTranscriptPayment: TranscriptRequest;
  consolidatedExport: FileExport;
  /** Convert an approved admission form submission into a student record */
  convertSubmissionToStudent: Student;
  copyCbtScoresToAssessment?: Maybe<CopyCbtScoresToAssessmentResult>;
  copySchoolTemplates: CopySchoolTemplatesResult;
  /** Creates a new academic calendar entry for the current school. */
  createAcademicCalendar?: Maybe<AcademicCalendar>;
  createAssessmentType?: Maybe<SchoolAssessmentType>;
  createAssessmentTypesBulk?: Maybe<AssessmentTypeBulkResult>;
  createAttendanceEvent: AttendanceEvent;
  createBillItemCategory: BillItemCategory;
  createBillItemTemplate: BillItemTemplate;
  createBills: Array<Bill>;
  createBroadsheetTemplate: BroadsheetTemplate;
  createCBTTest?: Maybe<Array<Maybe<CbtTest>>>;
  createCampus?: Maybe<CampusType>;
  createCertificateTemplate: CertificateTemplate;
  createChildSchool: CreateChildSchoolResult;
  createChildSchoolBillItem: MutationResponse;
  createChildSchoolBills: MutationResponse;
  createChildSchoolCalendar: MutationResponse;
  createChildSchoolClassroom: MutationResponse;
  createChildSchoolCourse: MutationResponse;
  createChildSchoolSession: MutationResponse;
  createChildSchoolStudent: MutationResponse;
  createChildSchoolSubject: MutationResponse;
  createChildSchoolTermStructure: MutationResponse;
  createClassroom?: Maybe<Classroom>;
  createClassroomSection?: Maybe<ClassroomSection>;
  createCourse?: Maybe<Course>;
  createCurriculum?: Maybe<Scalars['Int']['output']>;
  createCustomField: CustomField;
  createDepartment?: Maybe<DepartmentType>;
  createDirectChannel: ChatChannel;
  createDiscountCategory: DiscountCategory;
  createDiscountRule: DiscountRule;
  createFaculty?: Maybe<FacultyType>;
  createFeeSplitOverride: FeeSplitOverride;
  createFeeSplitProfile: FeeSplitProfile;
  createFeeSplitRule: FeeSplitRule;
  createForm: CustomForm;
  createGatewaySettlementAccount: GatewaySettlementAccount;
  createGroupChannel: ChatChannel;
  createGuardian: Guardian;
  createLessonNote: LessonNote;
  createPermissionGroup: PermissionGroup;
  createProgramme?: Maybe<ProgrammeType>;
  createProgrammeModule?: Maybe<ProgrammeModuleType>;
  createQueryBank?: Maybe<QuestionBank>;
  createQuestion?: Maybe<Question>;
  createQuestions: Array<Question>;
  createResultTemplate: ResultTemplate;
  createRoom: Room;
  createSchemeOfWork: SchemeOfWork;
  createSchool?: Maybe<School>;
  createSchoolAnnouncement: SchoolAnnouncement;
  createSchoolGrade?: Maybe<Grade>;
  /**
   * Creates multiple school grades in a single transaction.
   * Returns the list of created grades.
   */
  createSchoolGradeBulk: Array<Grade>;
  createSchoolGrades: Array<Grade>;
  createSchoolSubject?: Maybe<MutationResponse>;
  createSection?: Maybe<Section>;
  /** Creates a new session for the current school. */
  createSession?: Maybe<Session>;
  /** Creates a new session structure for the current school. */
  createSessionStructure?: Maybe<SessionStructure>;
  createSettlementAccount: SettlementAccount;
  createStudent?: Maybe<Student>;
  /**
   * Sends a data request to the students in the audience the sender may update,
   * and notifies them. Errors are keyed "input.<field>". Needs Students → Update.
   */
  createStudentDataRequest: StudentDataRequest;
  createSubject: Subject;
  createSummaryTemplate: SummaryTemplate;
  /** Creates a new term structure within a session structure. */
  createTermStructure?: Maybe<TermStructure>;
  createTicket: Ticket;
  createTicketCategory: TicketCategory;
  createTimetable: Timetable;
  createTimetableTemplate: TimetableTemplate;
  createTimetableTimeSlot: TimetableTimeSlot;
  createTranscriptTemplate: TranscriptTemplate;
  createTranscriptType: TranscriptType;
  deallocateCourseFromLecturer: Array<CourseLecturer>;
  /** Referee declines to provide a reference; admissions is notified so the applicant can be asked for a replacement. */
  declineReference: Scalars['Boolean']['output'];
  /**
   * De-enrolls students from a specific academic calendar by removing their
   * student_academic_calendar record. Use when enrollment was a mistake.
   */
  deenrollStudents: MutationResponse;
  /** Deletes an academic calendar entry. */
  deleteAcademicCalendar?: Maybe<AcademicCalendar>;
  /** Soft-delete an admission letter template. Letters already issued keep their PDF. */
  deleteAdmissionLetterTemplate: Scalars['Boolean']['output'];
  deleteAssessmentType?: Maybe<AssessmentTypeDeleteResult>;
  deleteAssessmentTypesBulk?: Maybe<AssessmentTypeDeleteResult>;
  /** Deletes the event AND its register rows — a register is meaningless without its event. */
  deleteAttendanceEvent: MutationResponse;
  deleteBillItemCategory: Scalars['Boolean']['output'];
  deleteBillItemTemplate: Scalars['Boolean']['output'];
  deleteBroadsheetTemplate?: Maybe<BroadsheetTemplate>;
  deleteCBTTest?: Maybe<MutationResponse>;
  deleteCBTTestSession: MutationResponse;
  deleteCampus?: Maybe<MutationResponse>;
  deleteCertificateTemplate: Scalars['Boolean']['output'];
  deleteChildSchool: MutationResponse;
  deleteCourse?: Maybe<MutationResponse>;
  deleteCourseOutstandingWaiver: MutationResponse;
  /** Delete specific course registered scores by their IDs. */
  deleteCourseRegisteredScores: MutationResponse;
  deleteCourseRegistration: MutationResponse;
  /**
   * Delete several courses at once. Each course is checked independently:
   * courses carrying registrations, allocations, attendance or other
   * historical records are left untouched and reported back as blocked.
   */
  deleteCourses: BulkCourseDeleteResponse;
  deleteCurriculum?: Maybe<MutationResponse>;
  /** Deletes the field and every value saved for it. Set is_active false instead to keep the values. */
  deleteCustomField: Scalars['Boolean']['output'];
  deleteDepartment?: Maybe<MutationResponse>;
  deleteDiscountCategory: Scalars['Boolean']['output'];
  deleteDiscountRule: Scalars['Boolean']['output'];
  deleteExport: Scalars['Boolean']['output'];
  deleteFaculty?: Maybe<MutationResponse>;
  deleteFeeSplitOverride: Scalars['Boolean']['output'];
  deleteFeeSplitProfile: Scalars['Boolean']['output'];
  deleteFeeSplitRule: Scalars['Boolean']['output'];
  deleteFile: MutationResponse;
  /** Soft-delete a form */
  deleteForm: Scalars['Boolean']['output'];
  deleteGatewaySettlementAccount: Scalars['Boolean']['output'];
  deleteGuardian: Scalars['Boolean']['output'];
  deleteLessonNote: Scalars['Boolean']['output'];
  deleteManualOutstandingCourse: MutationResponse;
  deletePermissionGroup: Scalars['Boolean']['output'];
  deleteProgramme?: Maybe<MutationResponse>;
  deleteProgrammeModule?: Maybe<MutationResponse>;
  deleteQueryBank?: Maybe<MutationResponse>;
  deleteQuestion?: Maybe<MutationResponse>;
  /**
   * Delete a result template. Refused while the template is still in use —
   * i.e. assigned to any classroom/programme or referenced by a published
   * result — so a delete can never orphan a live assignment or result snapshot.
   */
  deleteResultTemplate: MutationResponse;
  deleteRoom: Scalars['Boolean']['output'];
  deleteSchemeOfWork: Scalars['Boolean']['output'];
  deleteSchemeWeek: Scalars['Boolean']['output'];
  deleteSchoolGrade?: Maybe<Grade>;
  deleteSchoolGradeGroup?: Maybe<GradeGroup>;
  deleteSchoolInvitation: MutationResponse;
  deleteSchoolSubject?: Maybe<MutationResponse>;
  /** Deletes a session. */
  deleteSession?: Maybe<Session>;
  /** Deletes a session structure. */
  deleteSessionStructure?: Maybe<SessionStructure>;
  deleteSettlementAccount: Scalars['Boolean']['output'];
  deleteStaff: Scalars['Boolean']['output'];
  deleteStudent?: Maybe<MutationResponse>;
  deleteStudentSubjectEnrollment: MutationResponse;
  deleteSubject: Scalars['Boolean']['output'];
  deleteSubjectEnrollment: MutationResponse;
  /** Delete a subject offering. Pass a null section_id to delete the classroom-wide offering. */
  deleteSubjectOffering: MutationResponse;
  /** Delete a note/message/action_required the caller typed themselves (see FormSubmissionActivity.is_editable). Workflow-recorded activities cannot be deleted. */
  deleteSubmissionNote: Scalars['Boolean']['output'];
  deleteSummaryTemplate?: Maybe<SummaryTemplate>;
  /** Deletes a term structure. */
  deleteTermStructure?: Maybe<TermStructure>;
  deleteTicketCategory: TicketCategory;
  deleteTimetable?: Maybe<Timetable>;
  deleteTimetableEntry?: Maybe<TimetableEntry>;
  deleteTimetableTemplate?: Maybe<TimetableTemplate>;
  deleteTimetableTimeSlot?: Maybe<TimetableTimeSlot>;
  deleteTranscriptTemplate: Scalars['Boolean']['output'];
  deleteTranscriptType: Scalars['Boolean']['output'];
  detachEducationalResource: Scalars['Boolean']['output'];
  /**
   * Disables one or more students, recording the reason and optional academic
   * calendar context. Authorization is handled at the resolver level.
   */
  disableStudents: MutationResponse;
  dismissAnnouncement: Scalars['Boolean']['output'];
  dismissMatricRetrievalAttempt: MatricRetrievalAttempt;
  /** "Don't show this again" on a one-off notice, for the signed-in staff account only. Returns every notice the account has dismissed. */
  dismissNotice: Array<Scalars['String']['output']>;
  /** Guided-tour intro: the authenticated user (staff or student) opts out of the automatic popover for good. No id argument — acts on the caller only. */
  dismissTourIntro: Scalars['Boolean']['output'];
  dropCourseMutation?: Maybe<StudentCourseRegistration>;
  editStudent: Student;
  /**
   * Re-enables one or more previously disabled students, recording the reason.
   * Authorization is handled at the resolver level.
   */
  enableStudents: MutationResponse;
  endCbtMonitoringSession?: Maybe<CbtMonitoringSession>;
  endorseCourseRegistrationByHOD: Array<StudentCourseRegistration>;
  enrollStudentSubject?: Maybe<StudentSubjectEnrollmentResponse>;
  /**
   * Manually enrolls students into a specific academic calendar. Students who
   * already have a record for the target calendar are skipped (idempotent).
   */
  enrollStudentsInCalendar: MutationResponse;
  exportAdmissionLetters: FileExport;
  /** Bulk-download selected applications as a ZIP of branded PDFs (#377). Returns a FileExport the DownloadManager surfaces when ready. */
  exportApplicationPdfs: FileExport;
  exportBillingReport: Array<FileExport>;
  exportDebtors: Array<FileExport>;
  /** Queue a full export of a report (every row) to the download manager. */
  exportReport: FileExport;
  /**
   * Queues a student data export job and returns a FileExport record that can be
   * polled or subscribed to for completion.
   */
  exportStudents: FileExport;
  /** Express release: skips review/approval steps, goes directly from GENERATED to RELEASED. */
  expressReleaseCertificate: GeneratedCertificate;
  flagCbtMonitoringSession?: Maybe<CbtMonitoringSession>;
  forgotPassword: MutationResponse;
  generateCertificate: GeneratedCertificate;
  /** Generate a batch of single-use waiver codes for a paid form. Returns plaintext codes (shown once). */
  generateFormWaiverCodes: GenerateWaiverCodesResult;
  generateLessonNoteWithAi: LessonNote;
  /**
   * Render one student's ID card (CR80, front only) and return the export row
   * the download manager polls. Requires `id_cards.generate`.
   */
  generateStudentIdCard: FileExport;
  generateStudentLinkingCode: Student;
  getCbtMonitoringSignalingToken?: Maybe<CbtMonitoringSignalingToken>;
  givePermission: MutationResponse;
  gradeTheoryAnswer: TheoryQuestionAnswer;
  /**
   * Bulk import scores from a multi-sheet Excel file (e.g. from Download Merged).
   * Each sheet is auto-matched to its course by reading the header row.
   */
  importBulkScoreSheet: MutationResponse;
  /**
   * Bulk create/update modules from rows parsed out of a CSV/XLSX sheet. Rows
   * match existing modules by programme + session + name (case-insensitive), so
   * re-submitting a corrected sheet updates rather than duplicates. Row problems
   * are reported per row in the result instead of failing the whole batch.
   */
  importProgrammeModules?: Maybe<ProgrammeModuleImportResult>;
  importScoreSheet?: Maybe<ScoreImportResult>;
  importStudents: ImportResponse;
  initiatePayment?: Maybe<InitiatePaymentType>;
  initiatePublicPayment?: Maybe<InitiatePaymentType>;
  initiateTranscriptPayment: InitiatePaymentType;
  inviteGuardian: GuardianInvitation;
  inviteTeacher: SchoolInvitation;
  /** Generate a 6-digit code that an Organization owner pastes into the Gradeverse Sites CMS to link this school. Caller needs cms_integration.manage on the current school. */
  issueCmsConnectionCode: CmsConnectionCode;
  lecturerSubmitCoursesInSemester: Array<CourseLecturer>;
  /**
   * Link courses into an equivalence group. All provided course_ids will
   * share the same equivalence number. If any already belong to a group,
   * they merge into one group.
   */
  linkCourseEquivalence: MutationResponse;
  linkGuardianToStudent: GuardianStudent;
  linkTranscriptApplicantToStudent: TranscriptRequest;
  login?: Maybe<LoginResponse>;
  logout: Scalars['Boolean']['output'];
  /** Mark all of the current user's notifications as read (#224). */
  markAllNotificationsRead: Scalars['Boolean']['output'];
  markChannelRead: ChatMessageReadType;
  /** Mark one of the current user's notifications as read (#224). */
  markNotificationRead: Scalars['Boolean']['output'];
  /** Record that the signed-in student opened a notice. Idempotent. */
  markSchoolAnnouncementRead: SchoolAnnouncement;
  markStudentAttendance?: Maybe<MutationResponse>;
  markTranscriptDispatched: TranscriptRequest;
  /** Fill a draft template on a preset from the pasted wording of the school's own admission letter. Applicant details become placeholders. Nothing is saved; needs the school's AI assistant. */
  matchAdmissionLetter: AdmissionLetterPreset;
  moveRegisteredCoursesToModule: MutationResponse;
  overrideCourseRegistrationApproval: Array<StudentCourseRegistration>;
  payFromWallet: Payment;
  permanentlyDeleteArchivedStudent: MutationResponse;
  permanentlyDeleteStudent: MutationResponse;
  pqCancelSubscription: PqSubscription;
  pqCreateSubscription: PqSubscription;
  pqForgotPassword: MutationResponse;
  /** Generate or regenerate an AI summary for a topic */
  pqGenerateTopicSummary: PqTopicSummary;
  pqLogin: PqAuthResponse;
  pqRegister: PqAuthResponse;
  pqRemoveSchoolSync: Scalars['Boolean']['output'];
  pqResetPassword: MutationResponse;
  pqStartPractice: PqPracticeSession;
  pqSubmitPractice: PqPracticeSession;
  pqSyncToSchool: Array<PqSchoolSync>;
  pqVerifyPayment: PqSubscription;
  prepareModuleRegistrationPayments: ModulePaymentSummary;
  /** letterhead: a banner chosen but not yet uploaded, printed on this preview only. */
  previewAdmissionLetterTemplate: Scalars['String']['output'];
  previewQuestionsFromFile: PreviewQuestions;
  previewStudentImport: ImportResponse;
  processExportNow: FileExport;
  processRefund: Refund;
  promoteStudents?: Maybe<MutationResponse>;
  publishBill: Bill;
  publishChildSchoolBill: MutationResponse;
  publishLessonNote: LessonNote;
  publishStudentResult?: Maybe<PublishedResult>;
  reallocateStudents: StudentAllocationResult;
  recordCbtMonitoringConsent?: Maybe<CbtMonitoringConsent>;
  recordCbtMonitoringEvent?: Maybe<CbtMonitoringEvent>;
  recordPayment: Payment;
  /** Validate a connection code + school_slug. Single-use. Public — the code is the auth, listed in EnsureSchoolContext::$except. */
  redeemCmsConnectionCode: CmsConnectionResult;
  /** Public: apply a waiver code on the payment page to an application already submitted and billed. The tracking code proves the application is the caller's. Voids the unpaid bill; never refused because a payment was started. */
  redeemWaiverCodeAtCheckout: CheckoutWaiverResult;
  /** Re-render an applicant's admission letter from the current default template, replacing the stored file. */
  regenerateAdmissionLetter: FormSubmission;
  regenerateTranscriptData: GeneratedTranscript;
  registerAsGuardian: LoginResponse;
  registerPushSubscription: Scalars['Boolean']['output'];
  registerUser: LoginResponse;
  reissueCertificate: GeneratedCertificate;
  rejectCertificate: GeneratedCertificate;
  rejectExemption: Exemption;
  rejectLessonNote: LessonNote;
  rejectRefund: Refund;
  rejectRoleRequests: Array<PermissionGrant>;
  rejectSchoolInvitation: Scalars['Boolean']['output'];
  rejectStudentCourseRegistration: Array<StudentCourseRegistration>;
  rejectTranscriptRequest: TranscriptRequest;
  releaseCertificate: GeneratedCertificate;
  /**
   * Reminds students who have not answered (all of them, or only these), at
   * most once a day each. Returns how many will be reminded. Errors are keyed
   * "student_ids". Needs Students → Update.
   */
  remindStudentDataRequest: Scalars['Int']['output'];
  removeAdmissionLetterLetterhead: AdmissionLetterTemplate;
  /**
   * Remove all scores of a specific assessment type from a course for all registered students
   * in a given academic calendar. Use this when an assessment type (e.g. CA) is no longer needed.
   */
  removeAssessmentScores: MutationResponse;
  /** Remove a single course prerequisite. */
  removeCoursePrerequisite: MutationResponse;
  removeEntityDiscount: Scalars['Boolean']['output'];
  removeManualOutstandingByScope: MutationResponse;
  removeModuleElectiveOffering: MutationResponse;
  removePermissionGroupFromUser: MutationResponse;
  removeSchoolAffiliateLogo: School;
  removeStudentsFromCampus: MutationResponse;
  removeTeacherFromSubject: MutationResponse;
  /** Collects answers again; a due date in the past needs a new one (error key "due_on"). Needs Students → Update. */
  reopenStudentDataRequest: StudentDataRequest;
  reorderAssessmentTypes?: Maybe<AssessmentTypeReorderResult>;
  /** Sets the display order: ids listed first come first. Fields not listed keep their relative order after them. */
  reorderCustomFields: Array<CustomField>;
  reorderLessonNoteResources: LessonNote;
  /** Applicant swaps an unresponsive/declined referee while the application is undecided. Old request is cancelled, the replacement is invited immediately. */
  replaceReferenceReferee: Scalars['Boolean']['output'];
  replyTicket: TicketMessage;
  replyToTranscriptRequest: TranscriptRequestActivity;
  replyToTranscriptRequestPublic: TranscriptRequestActivity;
  requeryPayment?: Maybe<Payment>;
  /** Request OTP for applicant email verification. Scope by school_slug OR by tracking_code (the school is derived from the submission) — applicants know their tracking code from every email we send, but rarely their school's slug. */
  requestApplicantOtp: Scalars['Boolean']['output'];
  /** Public: demo / sales enquiry from the landing page. Throttled per IP. */
  requestDemo: MutationResponse;
  requestExemption: Exemption;
  /** Request email verification OTP before submitting an admission form. Checks for duplicate applications — blocks if one already exists. */
  requestFormEmailVerification: Scalars['Boolean']['output'];
  requestRefund: Refund;
  /** Admin reopens the applicant's current (submitted) stage back to draft so they can revise and resubmit. Notifies the applicant with a link back into the form. */
  requestResubmission: FormSubmission;
  requestRole: PermissionGrant;
  resendGuardianInvitation: GuardianInvitation;
  /** Admin re-sends an invite. Rotates the token (old links die); does not restart the auto-reminder cycle. */
  resendReferenceInvite: ReferenceRequestRecord;
  resendSchoolInvitation: SchoolInvitation;
  resetPassword: MutationResponse;
  resolveMatricRetrievalAttempt: MatricRetrievalAttempt;
  resolvePublicPayment?: Maybe<Payment>;
  resolveSuccessfulPayment?: Maybe<Payment>;
  restoreArchivedStudent: MutationResponse;
  restoreLessonNoteVersion: LessonNote;
  restoreStudent: MutationResponse;
  resubmitCourseRegistration?: Maybe<StudentCourseRegistration>;
  retryExport: FileExport;
  retryFailedBatchCertificates: CertificateBatchJob;
  reverseTransfer: MutationResponse;
  /** Review (approve/reject) a form submission */
  reviewFormSubmission: FormSubmission;
  /** Revoke all unused waiver codes for a form (optionally filtered by batch label and/or academic calendar). */
  revokeAllFormWaiverCodes: Scalars['Int']['output'];
  revokeCaScoresForCourse: MutationResponse;
  revokeCertificate: GeneratedCertificate;
  revokeChildSchoolRole: MutationResponse;
  /** Revoke/undo course transfer acceptance. */
  revokeCoursesFromProgramme: Array<CourseRegistered>;
  revokeExemption: Exemption;
  /** Revoke a single unused waiver code. */
  revokeFormWaiverCode: FormWaiverCode;
  revokeGraduation: GraduationRecord;
  revokePermission: MutationResponse;
  revokePermissionGrant: MutationResponse;
  revokeRole: PermissionGrant;
  revokeStaffFromChildSchools: RevokeStaffResult;
  /** Create or update an admission letter template (#376). Omit id to create. */
  saveAdmissionLetterTemplate: AdmissionLetterTemplate;
  /** Create or update a DRAFT submission. Applicants edit freely (partial data allowed) until they submit a stage. First call (no tracking_code) creates the draft and emails a resume link; later calls require the applicant's OTP session token + tracking_code and only work while the stage is a draft. */
  saveDraft: FormSubmission;
  /** Referee parks partial answers ("Save & continue later"); reopening the same invite link brings them back. Only while the request is open for filling; no field validation. */
  saveReferenceDraft: Scalars['Boolean']['output'];
  /** Student dashboard "Save & continue later": upserts the caller's single DRAFT of this form (answers + referee nominations) with no field validation. submitForm later finalizes that same row. */
  saveStudentFormDraft: FormSubmission;
  saveStudentResultFeedback?: Maybe<StudentResultFeedback>;
  senateApproveStudentRegistration: Array<StudentCourseRegistration>;
  /** Generate (if needed) and email an approved applicant their admission letter. */
  sendAdmissionLetter: FormSubmission;
  sendChatMessage: ChatMessageType;
  /**
   * Dispatch a single-template WhatsApp message to one guardian.
   * Returns the queued WhatsappMessage row.
   */
  sendWhatsappMessage: WhatsappMessage;
  /** Sets an academic calendar entry as the active one for the current school. */
  setActiveAcademicCalendar?: Maybe<AcademicCalendar>;
  /**
   * Set (or clear, when result_template_id is null) a classroom's DEFAULT result
   * template. The default is used for any academic calendar that has no explicit
   * per-calendar assignment, so admins assign once instead of every term.
   */
  setClassroomResultTemplateDefault: Classroom;
  /**
   * Set the prerequisites for a course. Replaces any existing prerequisites.
   * Validates against self-reference and circular dependencies.
   */
  setCoursePrerequisites: Array<CoursePrerequisiteType>;
  setDefaultGatewaySettlementAccount: GatewaySettlementAccount;
  /** Sets a session structure as the default for the current school. */
  setDefaultSessionStructure?: Maybe<SessionStructure>;
  /**
   * Toggle fee splitting for the CURRENT school. Dual opt-in: splitting only
   * runs when a child school and its parent BOTH have it enabled — a parent
   * enables the feature for the organisation, each child consents for itself.
   */
  setFeeSplitOptIn: School;
  /**
   * Flip a guardian's WhatsApp opt-in flag.
   * Writes a WhatsappOptinAudit record with source = staff_dashboard.
   */
  setGuardianWhatsappOptIn: Guardian;
  setLessonNoteApprovalMode: LessonNoteApprovalMode;
  setPaymentProvider: PaymentProvider;
  setPendingApprovalNotificationSubscription: NotificationSubscriptionStatus;
  /**
   * Set (or clear, when result_template_id is null) a programme's DEFAULT result
   * template (tertiary). Used for any calendar without an explicit assignment.
   */
  setProgrammeResultTemplateDefault?: Maybe<ProgrammeType>;
  setProgrammeTranscriptTemplateDefault: ProgrammeType;
  /**
   * Set (or clear, when result_template_id is null) the default result template of
   * several programmes at once. The default applies to every semester without an
   * explicit assignment. Templates with historical columns cannot be defaults.
   */
  setProgrammesResultTemplateDefault: Array<ProgrammeType>;
  /** Upsert a single subject offering for a classroom (and optionally a section). */
  setSubjectOffering: SubjectOffering;
  /** Replace the full set of offerings for a subject. Offerings absent from the list are removed. */
  setSubjectOfferings: Array<SubjectOffering>;
  /** Tag waiver codes with a campus, or clear it with campus_id null (for codes issued before codes carried a campus). Returns how many codes changed. */
  setWaiverCodesCampus: Scalars['Int']['output'];
  startCBTTest?: Maybe<CbtTestSession>;
  startCbtMonitoringSession?: Maybe<CbtMonitoringSession>;
  studentLogin?: Maybe<LoginResponse>;
  studentResetPassword?: Maybe<MutationResponse>;
  /** Redeem an emailed onboarding/reset token and set the student's password (#252). Public: the expiring broker token is the credential. */
  studentSetPasswordWithToken?: Maybe<MutationResponse>;
  submitAnswers: Scalars['Boolean']['output'];
  submitCBTTest?: Maybe<CbtTestSession>;
  submitCertificateForReview: GeneratedCertificate;
  submitCourseRegistration?: Maybe<StudentCourseRegistration>;
  submitForm: FormSubmission;
  submitLessonNoteForReview: LessonNote;
  submitOfflineCbtSession?: Maybe<SubmitOfflineCbtSessionPayload>;
  /** Submit a public form */
  submitPublicForm: FormSubmission;
  submitPublicTranscriptRequest: TranscriptRequest;
  /** Referee submits their reference. Token dies with the submission. */
  submitReference: Scalars['Boolean']['output'];
  /** Submit (freeze) the applicant's current stage. Validates that stage's fields, then locks it for review. Requires the applicant's OTP session token + tracking_code. */
  submitStage: FormSubmission;
  submitTheoryAnswers?: Maybe<Scalars['Boolean']['output']>;
  submitTranscriptRequest: TranscriptRequest;
  togglePaymentProvider: PaymentProvider;
  /** Toggle a module's active state. Open = is_active AND dates in range. */
  toggleProgrammeModule?: Maybe<ProgrammeModuleType>;
  transferStudent: StudentTransferResult;
  triggerAiGrading?: Maybe<Scalars['Boolean']['output']>;
  unPublishStudentResult?: Maybe<PublishedResult>;
  unassignFeeSplitProfile: Scalars['Boolean']['output'];
  /**
   * Assign a result template to a programme (tertiary schools only).
   * This replaces classroom-based template assignment for tertiary institutions.
   */
  unassignResultTemplateFromProgramme: MutationResponse;
  /** Release a submission so any reviewer can pick it up again. */
  unassignSubmissionReviewer: FormSubmission;
  /** Remove a course from its equivalence group (sets equivalence=0). */
  unlinkCourseEquivalence: MutationResponse;
  unlinkGuardianFromStudent: Scalars['Boolean']['output'];
  unregisterPushSubscription: Scalars['Boolean']['output'];
  /** Updates an existing academic calendar entry. */
  updateAcademicCalendar?: Maybe<AcademicCalendar>;
  updateAdmissionLetterSettings: AdmissionLetterSettings;
  updateAssessmentType?: Maybe<SchoolAssessmentType>;
  updateAttendanceEvent: AttendanceEvent;
  /** Edit a draft bill in place (reconcile its line items) instead of creating a new one. */
  updateBill: Bill;
  updateBillItemCategory: BillItemCategory;
  updateBillItemTemplate: BillItemTemplate;
  updateBroadsheetTemplate: BroadsheetTemplate;
  updateCBTTest?: Maybe<CbtTest>;
  updateCampus?: Maybe<CampusType>;
  updateCertificateTemplate: CertificateTemplate;
  updateChildSchool: MutationResponse;
  updateChildSchoolSettings: MutationResponse;
  updateClassroom?: Maybe<Classroom>;
  updateClassroomSection?: Maybe<ClassroomSection>;
  updateCourse?: Maybe<Course>;
  updateCourseRegisteredFields?: Maybe<CourseRegistered>;
  updateCurriculum?: Maybe<CurriculumType>;
  updateCustomField: CustomField;
  updateDepartment?: Maybe<DepartmentType>;
  updateDiscountCategory: DiscountCategory;
  updateDiscountRule: DiscountRule;
  updateEducationalResource: EducationalResource;
  updateEntityDiscount: EntityDiscount;
  updateFaculty?: Maybe<FacultyType>;
  updateFeeSplitOverride: FeeSplitOverride;
  updateFeeSplitProfile: FeeSplitProfile;
  updateFeeSplitRule: FeeSplitRule;
  updateFile: File;
  updateForm: CustomForm;
  updateGatewaySettlementAccount: GatewaySettlementAccount;
  updateGuardian: Guardian;
  /** Saves a guardian's custom field values. Needs Guardians → Update. Only the listed fields change. */
  updateGuardianCustomFieldValues: Array<CustomFieldValue>;
  updateGuardianNotificationPreferences: GuardianStudent;
  updateGuardianStudentLink: GuardianStudent;
  updateLessonNote: LessonNote;
  updateMyProfile: Student;
  /**
   * Saves what the signed-in student filled in on their profile. Only fields
   * they may fill in are accepted, and only the listed fields change. Errors
   * are keyed "values.<field key>". Students only.
   */
  updateMyStudentProfileForm: StudentProfileForm;
  updatePdfResultConfig: PdfResultConfig;
  updatePdfTranscriptConfig: PdfTranscriptConfig;
  updatePermissionGrant: MutationResponse;
  updatePermissionGroup: PermissionGroup;
  updateProfile: User;
  updateProgramme?: Maybe<ProgrammeType>;
  updateProgrammeModule?: Maybe<ProgrammeModuleType>;
  updateQueryBank?: Maybe<QuestionBank>;
  updateQuestion?: Maybe<Question>;
  /** Admin fixes a referee's name/email. An email change on an already-invited request rotates the token and re-sends the invite. */
  updateReferenceRequest: ReferenceRequestRecord;
  updateRegistrationFields?: Maybe<StudentCourseRegistration>;
  updateRegistrationScores?: Maybe<UpdateScoreResponse>;
  updateResultTemplate: ResultTemplate;
  updateRoom: Room;
  updateSchemeOfWork: SchemeOfWork;
  updateSchemeWeek: SchemeWeek;
  updateSchool?: Maybe<School>;
  /** Toggle the school AI assistant (master switch + student access). School admins only. */
  updateSchoolAiSettings: School;
  updateSchoolAnnouncement: SchoolAnnouncement;
  updateSchoolGrade?: Maybe<Grade>;
  updateSchoolGradeGroup?: Maybe<GradeGroup>;
  updateSchoolSettings: School;
  updateSchoolSubject?: Maybe<MutationResponse>;
  /** Updates an existing session. */
  updateSession?: Maybe<Session>;
  /** Updates an existing session structure. */
  updateSessionStructure?: Maybe<SessionStructure>;
  updateSettlementAccount: SettlementAccount;
  /** Saves a staff member's custom field values. Needs Teachers → Update. Only the listed fields change. */
  updateStaffCustomFieldValues: Array<CustomFieldValue>;
  /** Deactivate (revokes every grant in this school, blocks the school context) or reactivate (restores entry, NOT grants) a staff membership. The optional reason lands in the audit row. */
  updateStaffStatus: Staff;
  updateStudentAttendanceSummary?: Maybe<MutationResponse>;
  updateStudentCourseExemption: MutationResponse;
  /** Saves a student's custom field values. Needs Students → Update. Only the listed fields change. */
  updateStudentCustomFieldValues: Array<CustomFieldValue>;
  /** Changes a request's wording, due date or options. Needs Students → Update. */
  updateStudentDataRequest: StudentDataRequest;
  /** Sets which built-in fields students may fill in. Fields not listed keep their setting. Needs Custom Fields → Update. */
  updateStudentProfileFieldSettings: Array<StudentProfileFieldSetting>;
  /**
   * Save secondary student assessment scores directly from the on-screen grid (no Excel round-trip).
   *
   * This is also the post-publish correction surface (#227): editing a score whose
   * result is already published requires a non-blank `reason` and records a signed,
   * immutable amendment entry (old→new value, reason, actor). Editing an unpublished
   * result ignores `reason` and writes no amendment entry.
   */
  updateStudentScores?: Maybe<UpdateStudentScoresResponse>;
  /**
   * Bulk-updates the enrollment status for multiple students within a given
   * academic calendar. Authorization is handled at the resolver level.
   */
  updateStudentStatus: MutationResponse;
  updateStudentSubjectEnrollment?: Maybe<StudentSubjectEnrollment>;
  updateSubject: Subject;
  /** Update the content or visibility of a note/message/action_required the caller typed themselves (see FormSubmissionActivity.is_editable). */
  updateSubmissionNote: FormSubmissionActivity;
  updateSummaryTemplate: SummaryTemplate;
  /** Updates an existing term structure. */
  updateTermStructure?: Maybe<TermStructure>;
  updateTicketCategory: TicketCategory;
  updateTicketStatus: Ticket;
  updateTimetable: Timetable;
  updateTimetableTemplate: TimetableTemplate;
  updateTimetableTimeSlot: TimetableTimeSlot;
  updateTranscriptCoverLetter: GeneratedTranscript;
  updateTranscriptTemplate: TranscriptTemplate;
  updateTranscriptType: TranscriptType;
  /**
   * Upsert the WhatsApp provider settings for the current school.
   * Requires whatsapp_messaging.configure permission.
   */
  updateWhatsappSettings: WhatsappSettings;
  /** Upload the template's letterhead banner (PNG or JPEG, up to 2 MB, 600 to 4000 pixels wide), replacing any earlier one. */
  uploadAdmissionLetterLetterhead: AdmissionLetterTemplate;
  /** Prepare a signature drawn on screen, or a picture of one (PNG or JPEG, up to 5 MB), for a signatory: the paper is made transparent and the picture cropped to the ink. Put the returned id on the signatory's image_id and save the template; an id no template uses is removed after a day. */
  uploadAdmissionLetterSignature: AdmissionLetterSignatureImage;
  uploadAdmissionLetterWatermark: AdmissionLetterTemplate;
  uploadCertificateBackground: CertificateTemplate;
  uploadCertificateSignature: CertificateTemplate;
  uploadFile: File;
  uploadMyPhoto: Student;
  /** Upload a file for a FILE field on a public form, before the applicant has any session. The school comes from the form, and the field's own allowed_extensions/max_size are enforced here so the applicant is told at upload time rather than at submit. Files are tagged 'public_form_upload'. */
  uploadPublicFormFile: File;
  /** Upload a file for a FILE field on a reference form. Authorised by the referee's reference token (referees are never authenticated). Files are tagged 'reference_upload'. */
  uploadReferenceFile: File;
  uploadRoleSignature: PermissionGrant;
  uploadSchoolAffiliateLogo: School;
  uploadSchoolLogo: School;
  uploadStudentPhoto: Student;
  upsertTimetableEntry: TimetableEntry;
  userLogin?: Maybe<LoginResponse>;
  /** Validate a waiver code for a form (public). Returns true if the code is valid and available. Does NOT consume the code. */
  validateFormWaiverCode: Scalars['Boolean']['output'];
  /** Verify OTP and return session token. Scope by school_slug OR tracking_code, matching the requestApplicantOtp call. */
  verifyApplicantOtp: ApplicantSession;
  /** Verify the email OTP sent to the applicant. Returns a session token valid for 2 hours. */
  verifyFormEmailOtp: ApplicantSession;
  voidBill: Bill;
  /** Void a manual discount: the ledger row is kept (voided_at/voided_by stamped) and the derived amounts are restored. */
  voidManualDiscount: BillDetail;
  voidPayment: Payment;
  /** Waive the payment gate for one application (#249): let an unpaid applicant proceed to review/conversion. Records the actor + reason in the audit trail. */
  waiveSubmissionPayment: FormSubmission;
  withdrawRoleRequest: PermissionGrant;
};


export type MutationAcceptCoursesForProgrammeArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
  target_programme_id: Scalars['ID']['input'];
};


export type MutationAcceptGuardianInvitationArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAcceptSchoolInvitationArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationAcknowledgeAnnouncementArgs = {
  announcement_id: Scalars['ID']['input'];
};


export type MutationAcknowledgeSchoolAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateChildSchoolCalendarArgs = {
  calendar_id: Scalars['ID']['input'];
  school_id: Scalars['ID']['input'];
};


export type MutationAddChildByLinkingCodeArgs = {
  linkingCode: Scalars['String']['input'];
  relationshipType: GuardianRelationshipType;
};


export type MutationAddCourseMutationArgs = {
  input?: InputMaybe<AddCourseToRegInput>;
};


export type MutationAddCourseOutstandingWaiverArgs = {
  input: AddCourseOutstandingWaiverInput;
};


export type MutationAddManualOutstandingCourseArgs = {
  input: AddManualOutstandingCourseInput;
};


export type MutationAddModuleElectiveOfferingsArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  course_ids: Array<Scalars['ID']['input']>;
  module_id: Scalars['ID']['input'];
};


export type MutationAddReferenceRequestArgs = {
  referee_email: Scalars['String']['input'];
  referee_name: Scalars['String']['input'];
  referee_phone?: InputMaybe<Scalars['String']['input']>;
  referee_relationship?: InputMaybe<Scalars['String']['input']>;
  requirement_key: Scalars['String']['input'];
  submission_id: Scalars['ID']['input'];
};


export type MutationAddSchemeWeekArgs = {
  input: SchemeWeekInput;
  schemeOfWorkId: Scalars['ID']['input'];
};


export type MutationAddStudentCourseToExemptArgs = {
  input: AddStudentCourseToExemptInput;
};


export type MutationAddSubmissionNoteArgs = {
  content: Scalars['String']['input'];
  is_visible_to_applicant?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  submission_id: Scalars['ID']['input'];
  type?: InputMaybe<SubmissionActivityType>;
};


export type MutationAddTranscriptRequestNoteArgs = {
  content: Scalars['String']['input'];
  is_visible_to_applicant?: InputMaybe<Scalars['Boolean']['input']>;
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationAdjustWalletArgs = {
  input: AdjustWalletInput;
};


export type MutationAdminGenerateTranscriptArgs = {
  input: AdminGenerateTranscriptInput;
};


export type MutationAdminResetStudentPasswordArgs = {
  input: AdminResetStudentPasswordInput;
};


export type MutationAdminSubmitCourseRegistrationArgs = {
  input?: InputMaybe<AdminCourseRegistrationInput>;
};


export type MutationAllocateCoursesToLecturerInSemesterByHodOrAdminArgs = {
  input: AllocateCoursesToLecturerInSemesterByHodOrAdminInput;
};


export type MutationAllocateStudentsToLecturerManuallyArgs = {
  course_lecturer_id: Scalars['ID']['input'];
  course_registered_ids: Array<Scalars['ID']['input']>;
};


export type MutationAllocateStudentsToLecturersRandomlyArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id: Scalars['ID']['input'];
  course_lecturer_ids: Array<Scalars['ID']['input']>;
  group_by?: InputMaybe<AllocationGroupBy>;
};


export type MutationApplicantReplyArgs = {
  activity_id?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  token: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


export type MutationApplicantUpdateFieldArgs = {
  activity_id: Scalars['ID']['input'];
  new_value?: InputMaybe<Scalars['JSON']['input']>;
  token: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


export type MutationApplicantUploadFileArgs = {
  file: Scalars['Upload']['input'];
  token: Scalars['String']['input'];
};


export type MutationApplyCustomFieldTemplateArgs = {
  entity: CustomFieldEntity;
  template: Scalars['String']['input'];
};


export type MutationApplyManualDiscountArgs = {
  input: ApplyManualDiscountInput;
};


export type MutationApproveCaScoresForCourseArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  course_id: Scalars['ID']['input'];
};


export type MutationApproveCertificateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveExemptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveGraduationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveLessonNoteArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveOrDenyCourseArgs = {
  input: ApproveOrDenyCourseInput;
};


export type MutationApproveRefundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveRoleRequestsArgs = {
  input: BatchRoleActionInput;
};


export type MutationApproveStudentCourseRegistrationArgs = {
  input: ApproveStudentRegistrationInput;
};


export type MutationApproveTranscriptRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignAdmissionLetterTemplateArgs = {
  form_id?: InputMaybe<Scalars['ID']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAssignDiscountArgs = {
  input: AssignDiscountInput;
};


export type MutationAssignFeeSplitProfileArgs = {
  input: AssignFeeSplitProfileInput;
};


export type MutationAssignPermissionGroupArgs = {
  input: AssignPermissionGroupInput;
  user_id: Scalars['ID']['input'];
};


export type MutationAssignResultTemplateToClassroomArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id: Scalars['ID']['input'];
  historical_source_map?: InputMaybe<Array<HistoricalSourceMapInput>>;
  result_template_id: Scalars['ID']['input'];
};


export type MutationAssignResultTemplateToProgrammeArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  historical_source_map?: InputMaybe<Array<HistoricalSourceMapInput>>;
  programme_id: Scalars['ID']['input'];
  result_template_id: Scalars['ID']['input'];
};


export type MutationAssignResultTemplateToProgrammesArgs = {
  input: AssignResultTemplateToProgrammesInput;
};


export type MutationAssignStaffDepartmentArgs = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
  staff_id: Scalars['ID']['input'];
};


export type MutationAssignStaffToChildSchoolsArgs = {
  input: AssignStaffToChildSchoolsInput;
};


export type MutationAssignStudentsToCampusArgs = {
  campus_id: Scalars['ID']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};


export type MutationAssignSubmissionReviewerArgs = {
  submission_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAssignTeacherToSubjectArgs = {
  classroomSectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectId: Scalars['ID']['input'];
  teacherId: Scalars['ID']['input'];
};


export type MutationAttachLinkResourceToLessonNoteArgs = {
  input: AttachLinkResourceToLessonNoteInput;
};


export type MutationAttachResourceToLessonNoteArgs = {
  input: AttachResourceToLessonNoteInput;
};


export type MutationBatchApproveFilteredGraduationsArgs = {
  filter?: InputMaybe<GraduationRecordFilterInput>;
};


export type MutationBatchApproveGraduationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchGenerateCertificatesArgs = {
  input: BatchGenerateCertificatesInput;
};


export type MutationBroadcastMessageArgs = {
  input: BroadcastMessageInput;
};


export type MutationBroadcastToGuardiansArgs = {
  channels: Array<GuardianBroadcastChannel>;
  guardianIds: Array<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBroadcastWhatsappMessageArgs = {
  input: BroadcastWhatsappMessageInput;
};


export type MutationBulkAddCourseOutstandingWaiverArgs = {
  input: BulkAddCourseOutstandingWaiverInput;
};


export type MutationBulkAddManualOutstandingByScopeArgs = {
  input: BulkManualOutstandingByScopeInput;
};


export type MutationBulkAddManualOutstandingByStudentsArgs = {
  input: BulkManualOutstandingByStudentsInput;
};


export type MutationBulkConvertSubmissionsArgs = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  field_mapping: Scalars['JSON']['input'];
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  submission_ids: Array<Scalars['ID']['input']>;
  target_school_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBulkCourseRegistrationActionArgs = {
  input: BulkCourseRegistrationActionInput;
};


export type MutationBulkDeleteCbtTestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteCourseOutstandingWaiverArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteManualOutstandingCourseArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteStudentCourseExemptionArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkExemptArgs = {
  input: BulkExemptInput;
};


export type MutationBulkExemptByStudentsArgs = {
  input: BulkExemptByStudentsInput;
};


export type MutationBulkExemptFromExcelArgs = {
  course_ids: Array<Scalars['ID']['input']>;
  matric_list: Scalars['Upload']['input'];
};


export type MutationBulkGenerateStudentLinkingCodesArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkInviteStaffArgs = {
  input: BulkInviteStaffInput;
};


export type MutationBulkPublishResultsArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_section_id: Scalars['ID']['input'];
};


export type MutationBulkReplaceAssessmentTypeArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
  from_assessment_type_id: Scalars['ID']['input'];
  to_assessment_type_id: Scalars['ID']['input'];
};


export type MutationBulkResetStudentPasswordsArgs = {
  input: BulkResetStudentPasswordsInput;
};


export type MutationBulkSwapCourseArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  new_course_id: Scalars['ID']['input'];
  old_course_id: Scalars['ID']['input'];
  programme_id: Scalars['ID']['input'];
};


export type MutationBulkTransferStudentsArgs = {
  input: BulkTransferStudentsInput;
};


export type MutationBulkUnPublishResultsArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_section_id: Scalars['ID']['input'];
};


export type MutationBulkUpdateCbtTestsArgs = {
  input: BulkUpdateCbtTestsInput;
};


export type MutationBulkUpdateCourseRegisteredStatusArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
  course_status: Scalars['String']['input'];
};


export type MutationBulkUpdateCoursesArgs = {
  course_instance_year?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBulkUpdateCurriculumArgs = {
  course_registration_level?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  programme_module_id?: InputMaybe<Scalars['ID']['input']>;
  remove_from_module?: InputMaybe<Scalars['Boolean']['input']>;
  semester?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkUpdateRegistrationLevelArgs = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  registration_ids: Array<Scalars['ID']['input']>;
  registration_level?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkUpdateStudentCourseExemptionArgs = {
  input: Array<BulkUpdateStudentCourseExemptionInput>;
};


export type MutationBulkUpdateStudentsArgs = {
  input: BulkUpdateStudentsInput;
};


export type MutationCancelAiPendingActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelMySubscriptionArgs = {
  mode: CancelMode;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelReferenceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCheckAllProgrammesEligibilityArgs = {
  academic_calendar_id: Scalars['ID']['input'];
};


export type MutationCheckGraduationEligibilityArgs = {
  input: CheckGraduationEligibilityInput;
};


export type MutationClearStudentLecturerAllocationsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id: Scalars['ID']['input'];
};


export type MutationCloneProgrammeModulesArgs = {
  input?: InputMaybe<CloneProgrammeModulesInput>;
};


export type MutationCloseStudentDataRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmAiPendingActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmTranscriptPaymentArgs = {
  payment_reference: Scalars['String']['input'];
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationConsolidatedExportArgs = {
  input: ConsolidatedExportInput;
};


export type MutationConvertSubmissionToStudentArgs = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  field_mapping: Scalars['JSON']['input'];
  matric_no?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  submission_id: Scalars['ID']['input'];
  target_school_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCopyCbtScoresToAssessmentArgs = {
  input: CopyCbtScoresToAssessmentInput;
};


export type MutationCopySchoolTemplatesArgs = {
  input: CopySchoolTemplatesInput;
};


export type MutationCreateAcademicCalendarArgs = {
  input: CreateAcademicCalendarInput;
};


export type MutationCreateAssessmentTypeArgs = {
  input: CreateAssessmentTypeInput;
};


export type MutationCreateAssessmentTypesBulkArgs = {
  assessments_data: Array<CreateAssessmentTypeInput>;
};


export type MutationCreateAttendanceEventArgs = {
  input: CreateAttendanceEventInput;
};


export type MutationCreateBillItemCategoryArgs = {
  input: CreateBillItemCategoryInput;
};


export type MutationCreateBillItemTemplateArgs = {
  input: CreateBillItemTemplateInput;
};


export type MutationCreateBillsArgs = {
  input: CreateBillsInput;
};


export type MutationCreateBroadsheetTemplateArgs = {
  input: CreateBroadsheetTemplateInput;
};


export type MutationCreateCbtTestArgs = {
  input: CreateCbtTestInput;
};


export type MutationCreateCampusArgs = {
  input?: InputMaybe<CampusInput>;
};


export type MutationCreateCertificateTemplateArgs = {
  input: CreateCertificateTemplateInput;
};


export type MutationCreateChildSchoolArgs = {
  input: CreateChildSchoolInput;
};


export type MutationCreateChildSchoolBillItemArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  default_amount: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
};


export type MutationCreateChildSchoolBillsArgs = {
  bills: Scalars['JSON']['input'];
  school_id: Scalars['ID']['input'];
};


export type MutationCreateChildSchoolCalendarArgs = {
  ended_at?: InputMaybe<Scalars['Date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  school_id: Scalars['ID']['input'];
  session_id: Scalars['ID']['input'];
  started_at?: InputMaybe<Scalars['Date']['input']>;
  term_structure_id: Scalars['ID']['input'];
  total_school_days?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateChildSchoolClassroomArgs = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  create_section?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateChildSchoolCourseArgs = {
  course_code: Scalars['String']['input'];
  course_instance_year?: InputMaybe<Scalars['String']['input']>;
  course_title: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
  unit: Scalars['Int']['input'];
};


export type MutationCreateChildSchoolSessionArgs = {
  ended_at?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
  started_at?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateChildSchoolStudentArgs = {
  school_id: Scalars['ID']['input'];
  student: Scalars['JSON']['input'];
};


export type MutationCreateChildSchoolSubjectArgs = {
  name: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
};


export type MutationCreateChildSchoolTermStructureArgs = {
  name: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};


export type MutationCreateClassroomArgs = {
  input?: InputMaybe<CreateClassroomInput>;
};


export type MutationCreateClassroomSectionArgs = {
  input: CreateClassroomSectionInput;
};


export type MutationCreateCourseArgs = {
  input?: InputMaybe<CourseCreateInput>;
};


export type MutationCreateCurriculumArgs = {
  input?: InputMaybe<CreateCurriculumInput>;
};


export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};


export type MutationCreateDepartmentArgs = {
  input?: InputMaybe<DepartmentInput>;
};


export type MutationCreateDirectChannelArgs = {
  input: CreateDirectChannelInput;
};


export type MutationCreateDiscountCategoryArgs = {
  input: CreateDiscountCategoryInput;
};


export type MutationCreateDiscountRuleArgs = {
  input: CreateDiscountRuleInput;
};


export type MutationCreateFacultyArgs = {
  input?: InputMaybe<FacultyInput>;
};


export type MutationCreateFeeSplitOverrideArgs = {
  input: CreateFeeSplitOverrideInput;
};


export type MutationCreateFeeSplitProfileArgs = {
  input: CreateFeeSplitProfileInput;
};


export type MutationCreateFeeSplitRuleArgs = {
  input: CreateFeeSplitRuleInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateGatewaySettlementAccountArgs = {
  input: CreateGatewaySettlementAccountInput;
};


export type MutationCreateGroupChannelArgs = {
  input: CreateGroupChannelInput;
};


export type MutationCreateGuardianArgs = {
  input: CreateGuardianInput;
};


export type MutationCreateLessonNoteArgs = {
  input: CreateLessonNoteInput;
};


export type MutationCreatePermissionGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<PermissionInput>>;
};


export type MutationCreateProgrammeArgs = {
  input?: InputMaybe<ProgrammeInput>;
};


export type MutationCreateProgrammeModuleArgs = {
  input?: InputMaybe<CreateProgrammeModuleInput>;
};


export type MutationCreateQueryBankArgs = {
  input: CreateQuestionBankInput;
};


export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateQuestionsArgs = {
  input: CreateQuestionsInput;
};


export type MutationCreateResultTemplateArgs = {
  input: CreateResultTemplateInput;
};


export type MutationCreateRoomArgs = {
  input: CreateRoomInput;
};


export type MutationCreateSchemeOfWorkArgs = {
  input: CreateSchemeOfWorkInput;
};


export type MutationCreateSchoolArgs = {
  createSchoolInput?: InputMaybe<CreateSchoolInput>;
  userRegisterInput?: InputMaybe<UserRegisterInput>;
};


export type MutationCreateSchoolAnnouncementArgs = {
  input: CreateSchoolAnnouncementInput;
};


export type MutationCreateSchoolGradeArgs = {
  createGradeInput?: InputMaybe<SchoolGradeInput>;
};


export type MutationCreateSchoolGradeBulkArgs = {
  inputs: Array<CreateSchoolGradeBulkInput>;
};


export type MutationCreateSchoolGradesArgs = {
  input: Array<CreateSchoolGradeBulkInput>;
};


export type MutationCreateSchoolSubjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSectionArgs = {
  input?: InputMaybe<CreateSectionInput>;
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationCreateSessionStructureArgs = {
  input: CreateSessionStructureInput;
};


export type MutationCreateSettlementAccountArgs = {
  input: CreateSettlementAccountInput;
};


export type MutationCreateStudentArgs = {
  createStudentInput?: InputMaybe<CreateStudentInput>;
};


export type MutationCreateStudentDataRequestArgs = {
  input: CreateStudentDataRequestInput;
};


export type MutationCreateSubjectArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateSummaryTemplateArgs = {
  input: CreateSummaryTemplateInput;
};


export type MutationCreateTermStructureArgs = {
  input: CreateTermStructureInput;
};


export type MutationCreateTicketArgs = {
  input: CreateTicketInput;
};


export type MutationCreateTicketCategoryArgs = {
  input: CreateTicketCategoryInput;
};


export type MutationCreateTimetableArgs = {
  input: CreateTimetableInput;
};


export type MutationCreateTimetableTemplateArgs = {
  input: CreateTimetableTemplateInput;
};


export type MutationCreateTimetableTimeSlotArgs = {
  input: CreateTimetableTimeSlotInput;
};


export type MutationCreateTranscriptTemplateArgs = {
  input: CreateTranscriptTemplateInput;
};


export type MutationCreateTranscriptTypeArgs = {
  input: CreateTranscriptTypeInput;
};


export type MutationDeallocateCourseFromLecturerArgs = {
  input: AllocateCoursesToLecturerInSemesterByHodOrAdminInput;
};


export type MutationDeclineReferenceArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationDeenrollStudentsArgs = {
  input: DeenrollStudentsInput;
};


export type MutationDeleteAcademicCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdmissionLetterTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentTypesBulkArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAttendanceEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBillItemCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBillItemTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBroadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCbtTestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCbtTestSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampusArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCertificateTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChildSchoolArgs = {
  school_id: Scalars['ID']['input'];
};


export type MutationDeleteCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCourseOutstandingWaiverArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCourseRegisteredScoresArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCourseRegistrationArgs = {
  course_registration_id: Scalars['Int']['input'];
};


export type MutationDeleteCoursesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCurriculumArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacultyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeeSplitOverrideArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeeSplitProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeeSplitRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGatewaySettlementAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGuardianArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLessonNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManualOutstandingCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeModuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQueryBankArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResultTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoomArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchemeOfWorkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchemeWeekArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchoolGradeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchoolGradeGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchoolInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchoolSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSessionStructureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSettlementAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaffArgs = {
  staffId: Scalars['ID']['input'];
};


export type MutationDeleteStudentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStudentSubjectEnrollmentArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  subject_ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubjectEnrollmentArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  modelIds: Array<Scalars['ID']['input']>;
  modelType: DeletableModelType;
  subject_id: Scalars['ID']['input'];
};


export type MutationDeleteSubjectOfferingArgs = {
  classroom_id: Scalars['ID']['input'];
  section_id?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
};


export type MutationDeleteSubmissionNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSummaryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTermStructureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTicketCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimetableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimetableEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimetableTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimetableTimeSlotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTranscriptTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTranscriptTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetachEducationalResourceArgs = {
  deleteUnderlyingFile?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDisableStudentsArgs = {
  input: DisableStudentsInput;
};


export type MutationDismissAnnouncementArgs = {
  announcement_id: Scalars['ID']['input'];
};


export type MutationDismissMatricRetrievalAttemptArgs = {
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDismissNoticeArgs = {
  notice: DismissibleNotice;
};


export type MutationDropCourseMutationArgs = {
  input?: InputMaybe<DropCourseFromRegInput>;
};


export type MutationEditStudentArgs = {
  input: EditStudentInput;
};


export type MutationEnableStudentsArgs = {
  input: EnableStudentsInput;
};


export type MutationEndCbtMonitoringSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEndorseCourseRegistrationByHodArgs = {
  input: ApproveStudentRegistrationInput;
};


export type MutationEnrollStudentSubjectArgs = {
  academicCalendarId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
  model: EnrollmentModel;
  subjectIds: Array<Scalars['ID']['input']>;
};


export type MutationEnrollStudentsInCalendarArgs = {
  input: EnrollStudentsInCalendarInput;
};


export type MutationExportAdmissionLettersArgs = {
  generate_missing?: InputMaybe<Scalars['Boolean']['input']>;
  submission_ids: Array<Scalars['ID']['input']>;
};


export type MutationExportApplicationPdfsArgs = {
  submission_ids: Array<Scalars['ID']['input']>;
};


export type MutationExportBillingReportArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  report_formats: Array<Scalars['String']['input']>;
  report_type: Scalars['String']['input'];
  session_id?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationExportDebtorsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  min_outstanding?: InputMaybe<Scalars['Float']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  report_formats: Array<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExportReportArgs = {
  filters?: InputMaybe<Array<ReportFilterValueInput>>;
  format: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type MutationExportStudentsArgs = {
  input: ExportStudentsInput;
};


export type MutationExpressReleaseCertificateArgs = {
  delivery_method: CertificateDeliveryEnum;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationFlagCbtMonitoringSessionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateCertificateArgs = {
  input: GenerateCertificateInput;
};


export type MutationGenerateFormWaiverCodesArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  batch_label?: InputMaybe<Scalars['String']['input']>;
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationGenerateLessonNoteWithAiArgs = {
  input: GenerateLessonNoteWithAiInput;
};


export type MutationGenerateStudentIdCardArgs = {
  student_id: Scalars['ID']['input'];
};


export type MutationGenerateStudentLinkingCodeArgs = {
  studentId: Scalars['ID']['input'];
};


export type MutationGetCbtMonitoringSignalingTokenArgs = {
  monitoring_session_id: Scalars['ID']['input'];
  role: CbtMonitoringSignalingRoleEnum;
};


export type MutationGivePermissionArgs = {
  input: PermissionInput;
  user_id: Scalars['ID']['input'];
};


export type MutationGradeTheoryAnswerArgs = {
  attestation: Scalars['Boolean']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationImportBulkScoreSheetArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationImportProgrammeModulesArgs = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  rows: Array<ProgrammeModuleImportRowInput>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationImportScoreSheetArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  dry_run?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['Upload']['input'];
  subject_id: Scalars['ID']['input'];
};


export type MutationImportStudentsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  campus_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_section_id: Scalars['Int']['input'];
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  students: Array<StudentImportRecordInput>;
};


export type MutationInitiatePaymentArgs = {
  input?: InputMaybe<InitiatePaymentInput>;
};


export type MutationInitiatePublicPaymentArgs = {
  bill_id: Scalars['ID']['input'];
  payment_method?: InputMaybe<Scalars['String']['input']>;
  processor: Scalars['String']['input'];
};


export type MutationInitiateTranscriptPaymentArgs = {
  applicant_email: Scalars['String']['input'];
  processor?: InputMaybe<Scalars['String']['input']>;
  tracking_code: Scalars['String']['input'];
};


export type MutationInviteGuardianArgs = {
  email: Scalars['String']['input'];
  guardianId: Scalars['ID']['input'];
};


export type MutationInviteTeacherArgs = {
  email: Scalars['String']['input'];
  school_permission_group_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLecturerSubmitCoursesInSemesterArgs = {
  input: LecturerSubmitCoursesInSemesterInput;
};


export type MutationLinkCourseEquivalenceArgs = {
  course_ids: Array<Scalars['ID']['input']>;
};


export type MutationLinkGuardianToStudentArgs = {
  guardianId: Scalars['ID']['input'];
  input: GuardianStudentLinkInput;
};


export type MutationLinkTranscriptApplicantToStudentArgs = {
  student_id: Scalars['ID']['input'];
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkChannelReadArgs = {
  input: MarkChannelReadInput;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkSchoolAnnouncementReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkStudentAttendanceArgs = {
  input: Array<MarkStudentAttendanceInput>;
};


export type MutationMarkTranscriptDispatchedArgs = {
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationMatchAdmissionLetterArgs = {
  preset_id?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


export type MutationMoveRegisteredCoursesToModuleArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
  course_registration_id: Scalars['ID']['input'];
  ignore_unit_check?: InputMaybe<Scalars['Boolean']['input']>;
  programme_module_id: Scalars['ID']['input'];
};


export type MutationOverrideCourseRegistrationApprovalArgs = {
  input: OverrideRegistrationApprovalInput;
};


export type MutationPayFromWalletArgs = {
  input: PayFromWalletInput;
};


export type MutationPermanentlyDeleteArchivedStudentArgs = {
  school_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationPermanentlyDeleteStudentArgs = {
  student_id: Scalars['ID']['input'];
};


export type MutationPqCreateSubscriptionArgs = {
  input: PqCreateSubscriptionInput;
};


export type MutationPqForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationPqGenerateTopicSummaryArgs = {
  input: PqGenerateTopicSummaryInput;
};


export type MutationPqLoginArgs = {
  input: PqLoginInput;
};


export type MutationPqRegisterArgs = {
  input: PqRegisterInput;
};


export type MutationPqRemoveSchoolSyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPqResetPasswordArgs = {
  input: PqResetPasswordInput;
};


export type MutationPqStartPracticeArgs = {
  input: PqStartPracticeInput;
};


export type MutationPqSubmitPracticeArgs = {
  input: PqSubmitPracticeInput;
};


export type MutationPqSyncToSchoolArgs = {
  input: PqSyncToSchoolInput;
};


export type MutationPqVerifyPaymentArgs = {
  reference: Scalars['String']['input'];
};


export type MutationPrepareModuleRegistrationPaymentsArgs = {
  initiate_retake?: InputMaybe<Scalars['Boolean']['input']>;
  module_ids: Array<Scalars['ID']['input']>;
};


export type MutationPreviewAdmissionLetterTemplateArgs = {
  input: AdmissionLetterPreviewInput;
  letterhead?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationPreviewQuestionsFromFileArgs = {
  cbt_question_bank_id: Scalars['Int']['input'];
  question_file: Scalars['Upload']['input'];
  question_type: Scalars['String']['input'];
};


export type MutationPreviewStudentImportArgs = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  campus_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_section_id: Scalars['Int']['input'];
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  students: Array<StudentImportRecordInput>;
};


export type MutationProcessExportNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProcessRefundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPromoteStudentsArgs = {
  input: PromoteStudentsInput;
};


export type MutationPublishBillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishChildSchoolBillArgs = {
  bill_id: Scalars['ID']['input'];
  school_id: Scalars['ID']['input'];
};


export type MutationPublishLessonNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishStudentResultArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationReallocateStudentsArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
  target_course_lecturer_id: Scalars['ID']['input'];
};


export type MutationRecordCbtMonitoringConsentArgs = {
  cbt_test_session_id: Scalars['ID']['input'];
};


export type MutationRecordCbtMonitoringEventArgs = {
  input: RecordCbtMonitoringEventInput;
};


export type MutationRecordPaymentArgs = {
  input: RecordPaymentInput;
};


export type MutationRedeemCmsConnectionCodeArgs = {
  code: Scalars['String']['input'];
  redeemed_by_origin?: InputMaybe<Scalars['String']['input']>;
  school_slug: Scalars['String']['input'];
};


export type MutationRedeemWaiverCodeAtCheckoutArgs = {
  bill_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


export type MutationRegenerateAdmissionLetterArgs = {
  submission_id: Scalars['ID']['input'];
};


export type MutationRegenerateTranscriptDataArgs = {
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationRegisterAsGuardianArgs = {
  input: RegisterGuardianInput;
};


export type MutationRegisterPushSubscriptionArgs = {
  input: RegisterPushSubscriptionInput;
};


export type MutationRegisterUserArgs = {
  input: UserRegisterInput;
};


export type MutationReissueCertificateArgs = {
  input: ReissueCertificateInput;
};


export type MutationRejectCertificateArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectExemptionArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectLessonNoteArgs = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationRejectRefundArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectRoleRequestsArgs = {
  input: RejectRoleInput;
};


export type MutationRejectSchoolInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationRejectStudentCourseRegistrationArgs = {
  input: RejectStudentRegistrationInput;
};


export type MutationRejectTranscriptRequestArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReleaseCertificateArgs = {
  delivery_method: CertificateDeliveryEnum;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRemindStudentDataRequestArgs = {
  id: Scalars['ID']['input'];
  student_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRemoveAdmissionLetterLetterheadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAssessmentScoresArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  course_id: Scalars['ID']['input'];
  school_assessment_type_id: Scalars['ID']['input'];
};


export type MutationRemoveCoursePrerequisiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveEntityDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveManualOutstandingByScopeArgs = {
  input: RemoveManualOutstandingByScopeInput;
};


export type MutationRemoveModuleElectiveOfferingArgs = {
  module_id: Scalars['ID']['input'];
  offering_id: Scalars['ID']['input'];
};


export type MutationRemovePermissionGroupFromUserArgs = {
  group_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationRemoveStudentsFromCampusArgs = {
  campus_id: Scalars['ID']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveTeacherFromSubjectArgs = {
  classroomSectionId?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
  teacherId: Scalars['ID']['input'];
};


export type MutationReopenStudentDataRequestArgs = {
  due_on?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationReorderAssessmentTypesArgs = {
  order_data: Array<AssessmentTypeOrderInput>;
};


export type MutationReorderCustomFieldsArgs = {
  entity: CustomFieldEntity;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationReorderLessonNoteResourcesArgs = {
  lessonNoteId: Scalars['ID']['input'];
  resourceIds: Array<Scalars['ID']['input']>;
};


export type MutationReplaceReferenceRefereeArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  request_id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


export type MutationReplyTicketArgs = {
  input: ReplyTicketInput;
};


export type MutationReplyToTranscriptRequestArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  content: Scalars['String']['input'];
  transcript_request_id: Scalars['ID']['input'];
};


export type MutationReplyToTranscriptRequestPublicArgs = {
  applicant_email: Scalars['String']['input'];
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  content: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


export type MutationRequeryPaymentArgs = {
  input?: InputMaybe<RequeryPaymentInput>;
};


export type MutationRequestApplicantOtpArgs = {
  email: Scalars['String']['input'];
  school_slug?: InputMaybe<Scalars['String']['input']>;
  tracking_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestDemoArgs = {
  input: RequestDemoInput;
};


export type MutationRequestExemptionArgs = {
  input: RequestExemptionInput;
};


export type MutationRequestFormEmailVerificationArgs = {
  email: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationRequestRefundArgs = {
  input: RequestRefundInput;
};


export type MutationRequestResubmissionArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  submission_id: Scalars['ID']['input'];
};


export type MutationRequestRoleArgs = {
  input: RequestRoleInput;
};


export type MutationResendGuardianInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendReferenceInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendSchoolInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResolveMatricRetrievalAttemptArgs = {
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationResolvePublicPaymentArgs = {
  order_id: Scalars['String']['input'];
  processor?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveSuccessfulPaymentArgs = {
  input?: InputMaybe<ResolveSuccessfulPaymentInput>;
};


export type MutationRestoreArchivedStudentArgs = {
  school_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationRestoreLessonNoteVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationRestoreStudentArgs = {
  student_id: Scalars['ID']['input'];
};


export type MutationResubmitCourseRegistrationArgs = {
  input?: InputMaybe<CourseRegistrationInput>;
};


export type MutationRetryExportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryFailedBatchCertificatesArgs = {
  batch_job_id: Scalars['ID']['input'];
};


export type MutationReverseTransferArgs = {
  transfer_id: Scalars['ID']['input'];
};


export type MutationReviewFormSubmissionArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  status: FormSubmissionStatus;
  submission_id: Scalars['ID']['input'];
};


export type MutationRevokeAllFormWaiverCodesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  batch_label?: InputMaybe<Scalars['String']['input']>;
  form_id: Scalars['ID']['input'];
};


export type MutationRevokeCaScoresForCourseArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  course_id: Scalars['ID']['input'];
};


export type MutationRevokeCertificateArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRevokeChildSchoolRoleArgs = {
  role: Scalars['String']['input'];
  school_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationRevokeCoursesFromProgrammeArgs = {
  course_registered_ids: Array<Scalars['ID']['input']>;
};


export type MutationRevokeExemptionArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeFormWaiverCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeGraduationArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRevokePermissionArgs = {
  input: PermissionInput;
  user_id: Scalars['ID']['input'];
};


export type MutationRevokePermissionGrantArgs = {
  grant_id: Scalars['ID']['input'];
};


export type MutationRevokeRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeStaffFromChildSchoolsArgs = {
  input: RevokeStaffFromChildSchoolsInput;
};


export type MutationSaveAdmissionLetterTemplateArgs = {
  body: Scalars['String']['input'];
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  design?: InputMaybe<AdmissionLetterDesignInput>;
  details?: InputMaybe<Array<AdmissionLetterDetailInput>>;
  footer_text?: InputMaybe<Scalars['String']['input']>;
  header_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<AdmissionLetterLayout>;
  letter_title?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resumption_date?: InputMaybe<Scalars['Date']['input']>;
  sections?: InputMaybe<Array<AdmissionLetterSectionInput>>;
  show_logo?: InputMaybe<Scalars['Boolean']['input']>;
  show_qr_code?: InputMaybe<Scalars['Boolean']['input']>;
  signatures?: InputMaybe<Array<AdmissionLetterSignatureInput>>;
};


export type MutationSaveDraftArgs = {
  applicant_email?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['JSON']['input'];
  references?: InputMaybe<Array<ReferenceNominationInput>>;
  slug: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  tracking_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveReferenceDraftArgs = {
  data: Scalars['JSON']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveStudentFormDraftArgs = {
  data: Scalars['JSON']['input'];
  form_id: Scalars['ID']['input'];
  references?: InputMaybe<Array<ReferenceNominationInput>>;
};


export type MutationSaveStudentResultFeedbackArgs = {
  input: SaveStudentResultFeedbackInput;
};


export type MutationSenateApproveStudentRegistrationArgs = {
  input: ApproveStudentRegistrationInput;
};


export type MutationSendAdmissionLetterArgs = {
  submission_id: Scalars['ID']['input'];
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendWhatsappMessageArgs = {
  guardianId: Scalars['ID']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  templateName: Scalars['String']['input'];
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSetActiveAcademicCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetClassroomResultTemplateDefaultArgs = {
  classroom_id: Scalars['ID']['input'];
  result_template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetCoursePrerequisitesArgs = {
  course_id: Scalars['ID']['input'];
  prerequisite_course_ids: Array<Scalars['ID']['input']>;
};


export type MutationSetDefaultGatewaySettlementAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultSessionStructureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetFeeSplitOptInArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetGuardianWhatsappOptInArgs = {
  guardianId: Scalars['ID']['input'];
  optIn: Scalars['Boolean']['input'];
};


export type MutationSetLessonNoteApprovalModeArgs = {
  mode: LessonNoteApprovalMode;
};


export type MutationSetPaymentProviderArgs = {
  input?: InputMaybe<PaymentProviderInput>;
};


export type MutationSetPendingApprovalNotificationSubscriptionArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  programmeId?: InputMaybe<Scalars['ID']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type MutationSetProgrammeResultTemplateDefaultArgs = {
  programme_id: Scalars['ID']['input'];
  result_template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetProgrammeTranscriptTemplateDefaultArgs = {
  programme_id: Scalars['ID']['input'];
  transcript_template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetProgrammesResultTemplateDefaultArgs = {
  programme_ids: Array<Scalars['ID']['input']>;
  result_template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetSubjectOfferingArgs = {
  input: SubjectOfferingInput;
  subjectId: Scalars['ID']['input'];
};


export type MutationSetSubjectOfferingsArgs = {
  offerings: Array<SubjectOfferingInput>;
  subjectId: Scalars['ID']['input'];
};


export type MutationSetWaiverCodesCampusArgs = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationStartCbtTestArgs = {
  testId: Scalars['ID']['input'];
};


export type MutationStartCbtMonitoringSessionArgs = {
  cbt_test_session_id: Scalars['ID']['input'];
};


export type MutationStudentLoginArgs = {
  matricNumber: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationStudentResetPasswordArgs = {
  matricNumber: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationStudentSetPasswordWithTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitAnswersArgs = {
  answers: Array<StudentAnswerInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationSubmitCbtTestArgs = {
  input: SubmitCbtTestInput;
};


export type MutationSubmitCertificateForReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitCourseRegistrationArgs = {
  input?: InputMaybe<CourseRegistrationInput>;
};


export type MutationSubmitFormArgs = {
  data: Scalars['JSON']['input'];
  form_id: Scalars['ID']['input'];
  references?: InputMaybe<Array<ReferenceNominationInput>>;
  waiver_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitLessonNoteForReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitOfflineCbtSessionArgs = {
  input: OfflineCbtSessionInput;
};


export type MutationSubmitPublicFormArgs = {
  data: Scalars['JSON']['input'];
  email_verification_token?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<Array<ReferenceNominationInput>>;
  slug: Scalars['String']['input'];
  waiver_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitPublicTranscriptRequestArgs = {
  applicant_category: ApplicantCategoryEnum;
  applicant_email: Scalars['String']['input'];
  applicant_name: Scalars['String']['input'];
  applicant_phone?: InputMaybe<Scalars['String']['input']>;
  complaint_note?: InputMaybe<Scalars['String']['input']>;
  courier_address?: InputMaybe<Scalars['String']['input']>;
  courier_name?: InputMaybe<Scalars['String']['input']>;
  courier_phone?: InputMaybe<Scalars['String']['input']>;
  destination_address?: InputMaybe<Scalars['String']['input']>;
  destination_institution?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  number_of_copies?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  platform_name?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  programme_name?: InputMaybe<Scalars['String']['input']>;
  recipient_email?: InputMaybe<Scalars['String']['input']>;
  school_slug: Scalars['String']['input'];
  student_status: StudentAcademicStatusEnum;
  supporting_document?: InputMaybe<Scalars['Upload']['input']>;
  transcript_type_id: Scalars['ID']['input'];
  year_of_admission?: InputMaybe<Scalars['String']['input']>;
  year_of_graduation?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitReferenceArgs = {
  data: Scalars['JSON']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitStageArgs = {
  email_verification_token?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
  waiver_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitTheoryAnswersArgs = {
  input: Array<StudentTheoryAnswerInput>;
};


export type MutationSubmitTranscriptRequestArgs = {
  input: SubmitTranscriptRequestInput;
};


export type MutationTogglePaymentProviderArgs = {
  id: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
};


export type MutationToggleProgrammeModuleArgs = {
  id: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
};


export type MutationTransferStudentArgs = {
  input: TransferStudentInput;
};


export type MutationTriggerAiGradingArgs = {
  cbt_test_session_id: Scalars['ID']['input'];
};


export type MutationUnPublishStudentResultArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationUnassignFeeSplitProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnassignResultTemplateFromProgrammeArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  programme_id: Scalars['ID']['input'];
};


export type MutationUnassignSubmissionReviewerArgs = {
  submission_id: Scalars['ID']['input'];
};


export type MutationUnlinkCourseEquivalenceArgs = {
  course_id: Scalars['ID']['input'];
};


export type MutationUnlinkGuardianFromStudentArgs = {
  guardianId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type MutationUnregisterPushSubscriptionArgs = {
  endpoint: Scalars['String']['input'];
};


export type MutationUpdateAcademicCalendarArgs = {
  input: UpdateAcademicCalendarInput;
};


export type MutationUpdateAdmissionLetterSettingsArgs = {
  auto_revoke: Scalars['Boolean']['input'];
  auto_send: Scalars['Boolean']['input'];
};


export type MutationUpdateAssessmentTypeArgs = {
  input: UpdateAssessmentTypeInput;
};


export type MutationUpdateAttendanceEventArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAttendanceEventInput;
};


export type MutationUpdateBillArgs = {
  input: UpdateBillInput;
};


export type MutationUpdateBillItemCategoryArgs = {
  input: UpdateBillItemCategoryInput;
};


export type MutationUpdateBillItemTemplateArgs = {
  input: UpdateBillItemTemplateInput;
};


export type MutationUpdateBroadsheetTemplateArgs = {
  input: UpdateBroadsheetTemplateInput;
};


export type MutationUpdateCbtTestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCbtTestInput;
};


export type MutationUpdateCampusArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CampusInput>;
};


export type MutationUpdateCertificateTemplateArgs = {
  input: UpdateCertificateTemplateInput;
};


export type MutationUpdateChildSchoolArgs = {
  input: UpdateChildSchoolInput;
};


export type MutationUpdateChildSchoolSettingsArgs = {
  school_id: Scalars['ID']['input'];
  settings: Scalars['JSON']['input'];
};


export type MutationUpdateClassroomArgs = {
  id: Scalars['ID']['input'];
  input: CreateClassroomInput;
};


export type MutationUpdateClassroomSectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClassroomSectionInput;
};


export type MutationUpdateCourseArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CourseUpdateInput>;
};


export type MutationUpdateCourseRegisteredFieldsArgs = {
  input?: InputMaybe<UpdateCourseRegisteredFieldsInput>;
};


export type MutationUpdateCurriculumArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateCurriculumInput>;
};


export type MutationUpdateCustomFieldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomFieldInput;
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DepartmentUpdateInput>;
};


export type MutationUpdateDiscountCategoryArgs = {
  input: UpdateDiscountCategoryInput;
};


export type MutationUpdateDiscountRuleArgs = {
  input: UpdateDiscountRuleInput;
};


export type MutationUpdateEducationalResourceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEducationalResourceInput;
};


export type MutationUpdateEntityDiscountArgs = {
  input: UpdateEntityDiscountInput;
};


export type MutationUpdateFacultyArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<FacultyInput>;
};


export type MutationUpdateFeeSplitOverrideArgs = {
  input: UpdateFeeSplitOverrideInput;
};


export type MutationUpdateFeeSplitProfileArgs = {
  input: UpdateFeeSplitProfileInput;
};


export type MutationUpdateFeeSplitRuleArgs = {
  input: UpdateFeeSplitRuleInput;
};


export type MutationUpdateFileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFileInput;
};


export type MutationUpdateFormArgs = {
  input: UpdateFormInput;
};


export type MutationUpdateGatewaySettlementAccountArgs = {
  input: UpdateGatewaySettlementAccountInput;
};


export type MutationUpdateGuardianArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGuardianInput;
};


export type MutationUpdateGuardianCustomFieldValuesArgs = {
  guardian_id: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};


export type MutationUpdateGuardianNotificationPreferencesArgs = {
  guardianStudentId: Scalars['ID']['input'];
  receivesAttendanceNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivesFeeNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivesResultNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateGuardianStudentLinkArgs = {
  id: Scalars['ID']['input'];
  input: GuardianStudentLinkInput;
};


export type MutationUpdateLessonNoteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLessonNoteInput;
};


export type MutationUpdateMyProfileArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMyStudentProfileFormArgs = {
  values: Array<StudentProfileValueInput>;
};


export type MutationUpdatePdfResultConfigArgs = {
  input: PdfResultConfigInput;
};


export type MutationUpdatePdfTranscriptConfigArgs = {
  input: PdfTranscriptConfigInput;
};


export type MutationUpdatePermissionGrantArgs = {
  grant_id: Scalars['ID']['input'];
  input: UpdatePermissionGrantInput;
};


export type MutationUpdatePermissionGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<PermissionInput>>;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateProgrammeArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ProgrammeUpdateInput>;
};


export type MutationUpdateProgrammeModuleArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateProgrammeModuleInput>;
};


export type MutationUpdateQueryBankArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQuestionBankInput;
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQuestionInput;
};


export type MutationUpdateReferenceRequestArgs = {
  id: Scalars['ID']['input'];
  referee_email?: InputMaybe<Scalars['String']['input']>;
  referee_name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRegistrationFieldsArgs = {
  input?: InputMaybe<UpdateCourseRegistrationFieldsInput>;
};


export type MutationUpdateRegistrationScoresArgs = {
  courseScores: Array<CourseScoreInput>;
};


export type MutationUpdateResultTemplateArgs = {
  input: UpdateResultTemplateInput;
};


export type MutationUpdateRoomArgs = {
  input: UpdateRoomInput;
};


export type MutationUpdateSchemeOfWorkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSchemeOfWorkInput;
};


export type MutationUpdateSchemeWeekArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSchemeWeekInput;
};


export type MutationUpdateSchoolArgs = {
  id: Scalars['ID']['input'];
  updateSchoolInput?: InputMaybe<UpdateSchoolInput>;
};


export type MutationUpdateSchoolAiSettingsArgs = {
  aiAssistantEnabled: Scalars['Boolean']['input'];
  aiStudentAccess: Scalars['Boolean']['input'];
};


export type MutationUpdateSchoolAnnouncementArgs = {
  input: UpdateSchoolAnnouncementInput;
};


export type MutationUpdateSchoolGradeArgs = {
  id: Scalars['ID']['input'];
  updateGradeInput?: InputMaybe<SchoolGradeInput>;
};


export type MutationUpdateSchoolGradeGroupArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSchoolSettingsArgs = {
  settings: Scalars['JSON']['input'];
};


export type MutationUpdateSchoolSubjectArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateSessionStructureArgs = {
  input: UpdateSessionStructureInput;
};


export type MutationUpdateSettlementAccountArgs = {
  input: UpdateSettlementAccountInput;
};


export type MutationUpdateStaffCustomFieldValuesArgs = {
  staff_id: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};


export type MutationUpdateStaffStatusArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  staffId: Scalars['ID']['input'];
  status: StaffStatus;
};


export type MutationUpdateStudentAttendanceSummaryArgs = {
  input: UpdateStudentAttendanceSummaryInput;
};


export type MutationUpdateStudentCourseExemptionArgs = {
  fields: UpdateStudentCourseExemptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateStudentCustomFieldValuesArgs = {
  student_id: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};


export type MutationUpdateStudentDataRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStudentDataRequestInput;
};


export type MutationUpdateStudentProfileFieldSettingsArgs = {
  fields: Array<StudentProfileFieldSettingInput>;
};


export type MutationUpdateStudentScoresArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  studentScores: Array<StudentScoresInput>;
};


export type MutationUpdateStudentStatusArgs = {
  input: UpdateStudentStatusInput;
};


export type MutationUpdateStudentSubjectEnrollmentArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
  subject_id: Scalars['ID']['input'];
};


export type MutationUpdateSubjectArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSubmissionNoteArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_visible_to_applicant?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSummaryTemplateArgs = {
  input: UpdateSummaryTemplateInput;
};


export type MutationUpdateTermStructureArgs = {
  input: UpdateTermStructureInput;
};


export type MutationUpdateTicketCategoryArgs = {
  auto_response?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TicketPriority>;
};


export type MutationUpdateTicketStatusArgs = {
  input: UpdateTicketStatusInput;
};


export type MutationUpdateTimetableArgs = {
  input: UpdateTimetableInput;
};


export type MutationUpdateTimetableTemplateArgs = {
  input: UpdateTimetableTemplateInput;
};


export type MutationUpdateTimetableTimeSlotArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTimetableTimeSlotInput;
};


export type MutationUpdateTranscriptCoverLetterArgs = {
  cover_letter: Scalars['String']['input'];
  generated_transcript_id: Scalars['ID']['input'];
};


export type MutationUpdateTranscriptTemplateArgs = {
  input: UpdateTranscriptTemplateInput;
};


export type MutationUpdateTranscriptTypeArgs = {
  input: UpdateTranscriptTypeInput;
};


export type MutationUpdateWhatsappSettingsArgs = {
  input: UpdateWhatsappSettingsInput;
};


export type MutationUploadAdmissionLetterLetterheadArgs = {
  id: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUploadAdmissionLetterSignatureArgs = {
  image: Scalars['Upload']['input'];
  source: AdmissionLetterSignatureSource;
};


export type MutationUploadAdmissionLetterWatermarkArgs = {
  id: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUploadCertificateBackgroundArgs = {
  certificate_template_id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadCertificateSignatureArgs = {
  certificate_template_id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  signature_id: Scalars['String']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUploadMyPhotoArgs = {
  photo: Scalars['Upload']['input'];
};


export type MutationUploadPublicFormFileArgs = {
  field_name: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUploadReferenceFileArgs = {
  field_name: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  token: Scalars['String']['input'];
};


export type MutationUploadRoleSignatureArgs = {
  grant_id: Scalars['ID']['input'];
  signature: Scalars['Upload']['input'];
};


export type MutationUploadSchoolAffiliateLogoArgs = {
  logo: Scalars['Upload']['input'];
};


export type MutationUploadSchoolLogoArgs = {
  logo: Scalars['Upload']['input'];
};


export type MutationUploadStudentPhotoArgs = {
  photo: Scalars['Upload']['input'];
  student_id: Scalars['ID']['input'];
};


export type MutationUpsertTimetableEntryArgs = {
  input: UpsertTimetableEntryInput;
};


export type MutationUserLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationValidateFormWaiverCodeArgs = {
  code: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationVerifyApplicantOtpArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  school_slug?: InputMaybe<Scalars['String']['input']>;
  tracking_code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyFormEmailOtpArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationVoidBillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVoidManualDiscountArgs = {
  bill_discount_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationVoidPaymentArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWaiveSubmissionPaymentArgs = {
  reason: Scalars['String']['input'];
  submission_id: Scalars['ID']['input'];
};


export type MutationWithdrawRoleRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResponse = Response & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A data request as the student it was sent to sees it. */
export type MyStudentDataRequest = {
  blocks_portal: Scalars['Boolean']['output'];
  /** Every required field is filled in. */
  completed: Scalars['Boolean']['output'];
  due_on: Scalars['Date']['output'];
  fields: Array<MyStudentDataRequestField>;
  id: Scalars['ID']['output'];
  is_overdue: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MyStudentDataRequestField = {
  /** The student can fill it in on their profile now (false: the school changed the field since). */
  fillable: Scalars['Boolean']['output'];
  filled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

/** A Nigerian state (or the FCT) with its local government areas. */
export type NigerianState = {
  lgas: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type NotificationSubscriptionScope = {
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  programmeId?: Maybe<Scalars['ID']['output']>;
  programmeName?: Maybe<Scalars['String']['output']>;
  schoolWide: Scalars['Boolean']['output'];
};

export type NotificationSubscriptionStatus = {
  scopes: Array<NotificationSubscriptionScope>;
  subscribed: Scalars['Boolean']['output'];
  topic: Scalars['String']['output'];
};

export type OfflineCbtSessionInput = {
  answers: Array<StudentAnswerInput>;
  cbt_test_id: Scalars['ID']['input'];
  end_time: Scalars['DateTime']['input'];
  local_session_id: Scalars['String']['input'];
  start_time: Scalars['DateTime']['input'];
  student_id: Scalars['ID']['input'];
  theory_answers?: InputMaybe<Array<OfflineStudentTheoryAnswerInput>>;
};

export type OfflineCbtTest = {
  allowed_student_ids: Array<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  questions: Array<OfflineQuestion>;
  title: Scalars['String']['output'];
  track_progress: Scalars['Boolean']['output'];
};

export type OfflineQuestion = {
  id: Scalars['ID']['output'];
  images?: Maybe<Array<File>>;
  marks: Scalars['Int']['output'];
  options: Array<OfflineQuestionOption>;
  question: Scalars['String']['output'];
  question_type: QuestionTypeEnum;
  test_id: Scalars['ID']['output'];
};

export type OfflineQuestionOption = {
  id: Scalars['ID']['output'];
  images?: Maybe<Array<File>>;
  option: Scalars['String']['output'];
};

export type OfflineStudent = {
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matric_no: Scalars['String']['output'];
  offline_password_hash: Scalars['String']['output'];
};

export type OfflineStudentTheoryAnswerInput = {
  answer: Scalars['Mixed']['input'];
  question_id: Scalars['ID']['input'];
};

export type OfflineSyncPayload = {
  students: Array<OfflineStudent>;
  tests: Array<OfflineCbtTest>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OutstandingCourseItem = {
  category: Scalars['String']['output'];
  course: Course;
  course_id: Scalars['ID']['output'];
  curriculum_level: Scalars['String']['output'];
  is_locked: Scalars['Boolean']['output'];
  programme_module_ids: Array<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  unit: Scalars['Int']['output'];
};

export type OutstandingCoursesResult = {
  compulsory: Array<OutstandingCourseItem>;
  compulsory_mode: Scalars['String']['output'];
  compulsory_total_units: Scalars['Int']['output'];
  elective: Array<OutstandingCourseItem>;
  elective_total_units: Scalars['Int']['output'];
  enforce_prerequisites: Scalars['Boolean']['output'];
  passed_course_ids: Array<Scalars['ID']['output']>;
};

/** When outstanding courses appear for registration. */
export enum OutstandingModeEnum {
  AllInclusive = 'ALL_INCLUSIVE',
  AllSemesters = 'ALL_SEMESTERS',
  SemesterMatch = 'SEMESTER_MATCH'
}

export type OutstandingReport = {
  record_count: Scalars['Int']['output'];
  records: Array<OutstandingReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: OutstandingReportSummary;
  type: Scalars['String']['output'];
};

export type OutstandingReportRecord = {
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  billable_name: Scalars['String']['output'];
  billable_type: Scalars['String']['output'];
  /** Readable kind of record the bill was raised on (Student, Class, Application fee…), for display. */
  billable_type_label: Scalars['String']['output'];
  due_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  net_amount: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type OutstandingReportSummary = {
  by_status: Array<StatusBreakdownEntry>;
  total_bills: Scalars['Int']['output'];
  total_outstanding: Scalars['Float']['output'];
};

export type OverrideRegistrationApprovalInput = {
  academic_calendar_id: Scalars['ID']['input'];
  action: ApprovalActionEnum;
  reason?: InputMaybe<Scalars['String']['input']>;
  student_id: Scalars['ID']['input'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export enum ParentDataCopyOption {
  AcademicCalendars = 'ACADEMIC_CALENDARS',
  AssessmentTypes = 'ASSESSMENT_TYPES',
  Billing = 'BILLING',
  BroadsheetTemplates = 'BROADSHEET_TEMPLATES',
  CertificateTemplates = 'CERTIFICATE_TEMPLATES',
  Classrooms = 'CLASSROOMS',
  Courses = 'COURSES',
  CoursePrerequisites = 'COURSE_PREREQUISITES',
  Curriculum = 'CURRICULUM',
  CustomFields = 'CUSTOM_FIELDS',
  CustomForms = 'CUSTOM_FORMS',
  Departments = 'DEPARTMENTS',
  Discounts = 'DISCOUNTS',
  Faculties = 'FACULTIES',
  GradeSystem = 'GRADE_SYSTEM',
  PaymentProviders = 'PAYMENT_PROVIDERS',
  Programmes = 'PROGRAMMES',
  ResultTemplates = 'RESULT_TEMPLATES',
  SchemeOfWork = 'SCHEME_OF_WORK',
  Semesters = 'SEMESTERS',
  Sessions = 'SESSIONS',
  Subjects = 'SUBJECTS',
  SubjectOfferings = 'SUBJECT_OFFERINGS',
  SummaryTemplates = 'SUMMARY_TEMPLATES',
  TimetableTemplates = 'TIMETABLE_TEMPLATES',
  TranscriptTemplates = 'TRANSCRIPT_TEMPLATES'
}

export type ParseError = {
  block_index?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<ErrorDetails>;
  end_line?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  raw_lines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  start_line?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum PasswordBroker {
  Students = 'STUDENTS',
  Users = 'USERS'
}

export type PayFromWalletInput = {
  allocations: Array<PaymentAllocationInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  student_id: Scalars['ID']['input'];
};

export type Payment = {
  amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  currency_code: Scalars['String']['output'];
  /**
   * Which application this payment is settling, when it is an application fee.
   * Null for every ordinary student payment. Resolved in one batched pass by
   * PaymentQuery, never per row — the ledger is not paginated.
   */
  form_context?: Maybe<PaymentFormContext>;
  /** The settlement account this payment was routed through. */
  gatewaySettlementAccount?: Maybe<GatewaySettlementAccount>;
  gateway_settlement_account_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<User>;
  payer_id?: Maybe<Scalars['ID']['output']>;
  paymentAllocations: Array<PaymentAllocation>;
  payment_channel?: Maybe<Scalars['String']['output']>;
  payment_date: Scalars['DateTime']['output'];
  payment_method: Scalars['String']['output'];
  processor_reference?: Maybe<Scalars['String']['output']>;
  recordedBy?: Maybe<User>;
  recorded_by_id?: Maybe<Scalars['ID']['output']>;
  refunds: Array<Refund>;
  school: School;
  school_id: Scalars['ID']['output'];
  status: PaymentStatusEnum;
  student?: Maybe<Student>;
  student_id?: Maybe<Scalars['ID']['output']>;
  transaction_reference?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  void_reason?: Maybe<Scalars['String']['output']>;
  voided_at?: Maybe<Scalars['DateTime']['output']>;
  voided_by?: Maybe<Scalars['ID']['output']>;
};

export type PaymentAllocation = {
  amount: Scalars['Float']['output'];
  billDetail: BillDetail;
  bill_detail_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payment: Payment;
  payment_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PaymentAllocationInput = {
  amount: Scalars['Float']['input'];
  bill_detail_id: Scalars['ID']['input'];
};

export type PaymentEnrollmentCheck = {
  enrolled: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * The application behind an application-fee payment.
 *
 * A public payer has no student record, so these payments carry student_id = null
 * and showed up on the ledger with no owner and no sign they belonged to a form.
 */
export type PaymentFormContext = {
  applicant_email?: Maybe<Scalars['String']['output']>;
  /** Null when the form declares no field holding the applicant's name. */
  applicant_name?: Maybe<Scalars['String']['output']>;
  form_slug?: Maybe<Scalars['String']['output']>;
  form_title?: Maybe<Scalars['String']['output']>;
  submission_id?: Maybe<Scalars['ID']['output']>;
  tracking_code?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodBreakdown = {
  count: Scalars['Int']['output'];
  payment_method: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type PaymentMethodReport = {
  record_count: Scalars['Int']['output'];
  records: Array<PaymentMethodReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: PaymentMethodReportSummary;
  type: Scalars['String']['output'];
};

export type PaymentMethodReportRecord = {
  count: Scalars['Int']['output'];
  payment_method: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type PaymentMethodReportSummary = {
  total_amount: Scalars['Float']['output'];
  total_count: Scalars['Int']['output'];
};

/** What a session or term filter on payments means. */
export enum PaymentPeriodBasis {
  /** Money paid toward that period's bills, through allocations: what a student's statement counts. */
  Billed = 'BILLED',
  /** Money received during the period, by payment date. The payments ledger's default. */
  Received = 'RECEIVED'
}

export type PaymentProvider = {
  config?: Maybe<PaymentProviderConfigUnion>;
  /** Settlement accounts configured for this provider (PAY ITEM IDs for Interswitch, subaccount codes for Paystack, etc.). */
  gatewaySettlementAccounts: Array<GatewaySettlementAccount>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<PaymentProviderType>;
  school_id?: Maybe<Scalars['Int']['output']>;
};

export type PaymentProviderConfig = {
  apiKey?: Maybe<Scalars['String']['output']>;
};

export type PaymentProviderConfigUnion = FlutterwaveConfig | InterswitchConfig | MonnifyConfig | PaystackConfig | RemitaConfig;

export type PaymentProviderFieldStatus = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  present: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  secret: Scalars['Boolean']['output'];
};

export type PaymentProviderInput = {
  flutterwave?: InputMaybe<FlutterwaveConfigInput>;
  interswitch?: InputMaybe<InterswitchConfigInput>;
  monnify?: InputMaybe<MonnifyConfigInput>;
  name: PaymentProviderType;
  paystack?: InputMaybe<PaystackConfigInput>;
  remita?: InputMaybe<RemitaConfigInput>;
};

export type PaymentProviderStatus = {
  fields: Array<PaymentProviderFieldStatus>;
  isConfigured: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  name: PaymentProviderType;
};

export enum PaymentProviderType {
  Flutterwave = 'FLUTTERWAVE',
  Interswitch = 'INTERSWITCH',
  Monnify = 'MONNIFY',
  Paystack = 'PAYSTACK',
  Remita = 'REMITA'
}

export type PaymentProviderV2 = {
  config?: Maybe<PaymentProviderConfigUnion>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PaymentSplitRecord = {
  campusSchool: School;
  campus_amount: Scalars['Float']['output'];
  campus_school_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  feeSplitOverride?: Maybe<FeeSplitOverride>;
  feeSplitRule?: Maybe<FeeSplitRule>;
  fee_split_override_id?: Maybe<Scalars['ID']['output']>;
  fee_split_rule_id?: Maybe<Scalars['ID']['output']>;
  gateway_split_response?: Maybe<Scalars['JSON']['output']>;
  gateway_split_status?: Maybe<GatewaySplitStatusEnum>;
  hqSchool: School;
  hq_amount: Scalars['Float']['output'];
  hq_school_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  payment?: Maybe<Payment>;
  paymentAllocation?: Maybe<PaymentAllocation>;
  payment_allocation_id?: Maybe<Scalars['ID']['output']>;
  payment_id: Scalars['ID']['output'];
  payment_reference?: Maybe<Scalars['String']['output']>;
  split_details?: Maybe<Scalars['JSON']['output']>;
  split_mode: SplitModeEnum;
  student_matric_no?: Maybe<Scalars['String']['output']>;
  student_name?: Maybe<Scalars['String']['output']>;
  total_amount: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PaymentSplitRecordPaginated = {
  current_page: Scalars['Int']['output'];
  data: Array<PaymentSplitRecord>;
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaymentStatusDetail = {
  amount_paid: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  payment_status: BillPaymentStatus;
  total_amount: Scalars['Float']['output'];
};

export enum PaymentStatusEnum {
  Failed = 'FAILED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Successful = 'SUCCESSFUL',
  Voided = 'VOIDED'
}

export type PaystackConfig = PaymentProviderConfig & {
  apiKey?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type PaystackConfigInput = {
  publicKey?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
};

export type PdfDocument = {
  base64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type PdfResultConfig = {
  alternate_row_color?: Maybe<Scalars['String']['output']>;
  font_size?: Maybe<Scalars['Int']['output']>;
  footer_text?: Maybe<Scalars['String']['output']>;
  header_font_size?: Maybe<Scalars['Int']['output']>;
  logo_height?: Maybe<Scalars['Int']['output']>;
  logo_position?: Maybe<Scalars['String']['output']>;
  page_margin?: Maybe<Scalars['Int']['output']>;
  page_orientation?: Maybe<Scalars['String']['output']>;
  page_size?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  row_padding?: Maybe<Scalars['Int']['output']>;
  show_attendance?: Maybe<Scalars['Boolean']['output']>;
  show_borders?: Maybe<Scalars['Boolean']['output']>;
  show_footer?: Maybe<Scalars['Boolean']['output']>;
  show_grading_key?: Maybe<Scalars['Boolean']['output']>;
  show_next_term_date?: Maybe<Scalars['Boolean']['output']>;
  show_remarks?: Maybe<Scalars['Boolean']['output']>;
  show_report_title?: Maybe<Scalars['Boolean']['output']>;
  show_school_address?: Maybe<Scalars['Boolean']['output']>;
  show_school_name?: Maybe<Scalars['Boolean']['output']>;
  show_signature_lines?: Maybe<Scalars['Boolean']['output']>;
  show_student_info?: Maybe<Scalars['Boolean']['output']>;
  show_summary?: Maybe<Scalars['Boolean']['output']>;
  show_watermark?: Maybe<Scalars['Boolean']['output']>;
  signature_labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  striped_rows?: Maybe<Scalars['Boolean']['output']>;
  /** Extra student fields printed under the name/class rows (keys from studentDocumentFields). */
  student_info_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject_column_width?: Maybe<Scalars['Int']['output']>;
  watermark_text?: Maybe<Scalars['String']['output']>;
};

export type PdfResultConfigInput = {
  alternate_row_color?: InputMaybe<Scalars['String']['input']>;
  font_size?: InputMaybe<Scalars['Int']['input']>;
  footer_text?: InputMaybe<Scalars['String']['input']>;
  header_font_size?: InputMaybe<Scalars['Int']['input']>;
  logo_height?: InputMaybe<Scalars['Int']['input']>;
  logo_position?: InputMaybe<Scalars['String']['input']>;
  page_margin?: InputMaybe<Scalars['Int']['input']>;
  page_orientation?: InputMaybe<Scalars['String']['input']>;
  page_size?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<Scalars['String']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  row_padding?: InputMaybe<Scalars['Int']['input']>;
  show_attendance?: InputMaybe<Scalars['Boolean']['input']>;
  show_borders?: InputMaybe<Scalars['Boolean']['input']>;
  show_footer?: InputMaybe<Scalars['Boolean']['input']>;
  show_grading_key?: InputMaybe<Scalars['Boolean']['input']>;
  show_next_term_date?: InputMaybe<Scalars['Boolean']['input']>;
  show_remarks?: InputMaybe<Scalars['Boolean']['input']>;
  show_report_title?: InputMaybe<Scalars['Boolean']['input']>;
  show_school_address?: InputMaybe<Scalars['Boolean']['input']>;
  show_school_name?: InputMaybe<Scalars['Boolean']['input']>;
  show_signature_lines?: InputMaybe<Scalars['Boolean']['input']>;
  show_student_info?: InputMaybe<Scalars['Boolean']['input']>;
  show_summary?: InputMaybe<Scalars['Boolean']['input']>;
  show_watermark?: InputMaybe<Scalars['Boolean']['input']>;
  signature_labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  striped_rows?: InputMaybe<Scalars['Boolean']['input']>;
  /** Keys from studentDocumentFields. Send [] to show only the standard rows. Checked per school on save. */
  student_info_fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject_column_width?: InputMaybe<Scalars['Int']['input']>;
  watermark_text?: InputMaybe<Scalars['String']['input']>;
};

export type PdfResultPreset = {
  config: PdfResultConfig;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PdfTranscriptConfig = {
  alternate_row_color?: Maybe<Scalars['String']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  font_size?: Maybe<Scalars['Int']['output']>;
  footer_text?: Maybe<Scalars['String']['output']>;
  header_font_size?: Maybe<Scalars['Int']['output']>;
  logo_height?: Maybe<Scalars['Int']['output']>;
  logo_position?: Maybe<Scalars['String']['output']>;
  page_margin?: Maybe<Scalars['Int']['output']>;
  page_orientation?: Maybe<Scalars['String']['output']>;
  page_size?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  report_subtitle?: Maybe<Scalars['String']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  row_padding?: Maybe<Scalars['Int']['output']>;
  show_borders?: Maybe<Scalars['Boolean']['output']>;
  show_cover_letter?: Maybe<Scalars['Boolean']['output']>;
  show_cumulative?: Maybe<Scalars['Boolean']['output']>;
  show_estamp?: Maybe<Scalars['Boolean']['output']>;
  show_footer?: Maybe<Scalars['Boolean']['output']>;
  show_partial_footnote?: Maybe<Scalars['Boolean']['output']>;
  show_report_title?: Maybe<Scalars['Boolean']['output']>;
  show_school_address?: Maybe<Scalars['Boolean']['output']>;
  show_school_name?: Maybe<Scalars['Boolean']['output']>;
  show_semester_summary?: Maybe<Scalars['Boolean']['output']>;
  show_signature_lines?: Maybe<Scalars['Boolean']['output']>;
  show_student_info?: Maybe<Scalars['Boolean']['output']>;
  show_watermark?: Maybe<Scalars['Boolean']['output']>;
  signature_labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  striped_rows?: Maybe<Scalars['Boolean']['output']>;
  student_info_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  student_info_layout?: Maybe<Scalars['String']['output']>;
  table_header_font_size?: Maybe<Scalars['Int']['output']>;
  watermark_text?: Maybe<Scalars['String']['output']>;
};

export type PdfTranscriptConfigInput = {
  alternate_row_color?: InputMaybe<Scalars['String']['input']>;
  /** One of the keys from transcriptFontFamilies. */
  font_family?: InputMaybe<Scalars['String']['input']>;
  font_size?: InputMaybe<Scalars['Int']['input']>;
  /** Send null or an empty string to go back to the default footer. */
  footer_text?: InputMaybe<Scalars['String']['input']>;
  header_font_size?: InputMaybe<Scalars['Int']['input']>;
  logo_height?: InputMaybe<Scalars['Int']['input']>;
  logo_position?: InputMaybe<Scalars['String']['input']>;
  page_margin?: InputMaybe<Scalars['Int']['input']>;
  page_orientation?: InputMaybe<Scalars['String']['input']>;
  page_size?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<Scalars['String']['input']>;
  report_subtitle?: InputMaybe<Scalars['String']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  row_padding?: InputMaybe<Scalars['Int']['input']>;
  show_borders?: InputMaybe<Scalars['Boolean']['input']>;
  show_cover_letter?: InputMaybe<Scalars['Boolean']['input']>;
  show_cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  show_estamp?: InputMaybe<Scalars['Boolean']['input']>;
  show_footer?: InputMaybe<Scalars['Boolean']['input']>;
  show_partial_footnote?: InputMaybe<Scalars['Boolean']['input']>;
  show_report_title?: InputMaybe<Scalars['Boolean']['input']>;
  show_school_address?: InputMaybe<Scalars['Boolean']['input']>;
  show_school_name?: InputMaybe<Scalars['Boolean']['input']>;
  show_semester_summary?: InputMaybe<Scalars['Boolean']['input']>;
  show_signature_lines?: InputMaybe<Scalars['Boolean']['input']>;
  show_student_info?: InputMaybe<Scalars['Boolean']['input']>;
  show_watermark?: InputMaybe<Scalars['Boolean']['input']>;
  signature_labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  striped_rows?: InputMaybe<Scalars['Boolean']['input']>;
  /** Keys from transcriptStudentInfoFields, including custom:<key> for the school's student custom fields. Checked per school on save. */
  student_info_fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  student_info_layout?: InputMaybe<Scalars['String']['input']>;
  table_header_font_size?: InputMaybe<Scalars['Int']['input']>;
  watermark_text?: InputMaybe<Scalars['String']['input']>;
};

export type PdfTranscriptPreset = {
  config: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PendingScoreEntry = {
  /** Classroom section name (secondary) or null (tertiary) */
  classroomSection?: Maybe<Scalars['String']['output']>;
  /** classroom_section_id (secondary) or null (tertiary) */
  classroomSectionId?: Maybe<Scalars['ID']['output']>;
  /** Subject ID (secondary) or Course ID (tertiary) */
  entityId: Scalars['ID']['output'];
  /** Subject name (secondary) or Course code + title (tertiary) */
  name: Scalars['String']['output'];
  /** Students who have at least one score entered */
  studentsWithScores: Scalars['Int']['output'];
  /** Total students enrolled/registered */
  totalStudents: Scalars['Int']['output'];
};

export type Permission = {
  action: PermissionActionEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: PermissionResourceEnum;
  resource: Scalars['String']['output'];
};

/** A single action on a permission resource, described for the person granting it. */
export type PermissionActionDetail = {
  action: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

export enum PermissionActionEnum {
  AllocateStudents = 'ALLOCATE_STUDENTS',
  Approve = 'APPROVE',
  ApproveGraduation = 'APPROVE_GRADUATION',
  AssignStaff = 'ASSIGN_STAFF',
  AssignStudent = 'ASSIGN_STUDENT',
  AssignTeacher = 'ASSIGN_TEACHER',
  BatchGenerate = 'BATCH_GENERATE',
  BillingCreateBills = 'BILLING_CREATE_BILLS',
  BillingCreateBillItems = 'BILLING_CREATE_BILL_ITEMS',
  BillingDeleteBillItems = 'BILLING_DELETE_BILL_ITEMS',
  BillingManageDiscounts = 'BILLING_MANAGE_DISCOUNTS',
  BillingManageExemptions = 'BILLING_MANAGE_EXEMPTIONS',
  BillingManageFeeSplits = 'BILLING_MANAGE_FEE_SPLITS',
  BillingManageGatewaySettlementAccounts = 'BILLING_MANAGE_GATEWAY_SETTLEMENT_ACCOUNTS',
  BillingManageRefunds = 'BILLING_MANAGE_REFUNDS',
  BillingManageStudentWallets = 'BILLING_MANAGE_STUDENT_WALLETS',
  BillingPublishBills = 'BILLING_PUBLISH_BILLS',
  BillingRecordManualPayments = 'BILLING_RECORD_MANUAL_PAYMENTS',
  BillingUpdateBillItems = 'BILLING_UPDATE_BILL_ITEMS',
  BillingViewBillDetails = 'BILLING_VIEW_BILL_DETAILS',
  BillingViewBillItems = 'BILLING_VIEW_BILL_ITEMS',
  BillingViewFeeSplits = 'BILLING_VIEW_FEE_SPLITS',
  BillingViewGatewaySettlementAccounts = 'BILLING_VIEW_GATEWAY_SETTLEMENT_ACCOUNTS',
  BillingViewPaymentsAny = 'BILLING_VIEW_PAYMENTS_ANY',
  BillingViewPaymentsOwn = 'BILLING_VIEW_PAYMENTS_OWN',
  BillingViewPaymentReceiptsAny = 'BILLING_VIEW_PAYMENT_RECEIPTS_ANY',
  BillingViewPaymentReceiptsOwn = 'BILLING_VIEW_PAYMENT_RECEIPTS_OWN',
  BillingViewReports = 'BILLING_VIEW_REPORTS',
  BillingViewSplitReports = 'BILLING_VIEW_SPLIT_REPORTS',
  BillingViewStudentWallets = 'BILLING_VIEW_STUDENT_WALLETS',
  BillingVoidPayments = 'BILLING_VOID_PAYMENTS',
  Broadcast = 'BROADCAST',
  BulkDownloadCbt = 'BULK_DOWNLOAD_CBT',
  BulkDownloadScores = 'BULK_DOWNLOAD_SCORES',
  ChangeStatus = 'CHANGE_STATUS',
  CheckEligibility = 'CHECK_ELIGIBILITY',
  Configure = 'CONFIGURE',
  Convert = 'CONVERT',
  CopyTemplates = 'COPY_TEMPLATES',
  Create = 'CREATE',
  CreateBroadsheet = 'CREATE_BROADSHEET',
  CreateCategory = 'CREATE_CATEGORY',
  Delete = 'DELETE',
  DeleteBroadsheet = 'DELETE_BROADSHEET',
  DownloadSheets = 'DOWNLOAD_SHEETS',
  Endorse = 'ENDORSE',
  Export = 'EXPORT',
  Flag = 'FLAG',
  Generate = 'GENERATE',
  GenerateAi = 'GENERATE_AI',
  Manage = 'MANAGE',
  /** Guardians → Message (broadcastToGuardians). */
  Message = 'MESSAGE',
  MessageParent = 'MESSAGE_PARENT',
  Override = 'OVERRIDE',
  Reissue = 'REISSUE',
  Reject = 'REJECT',
  Release = 'RELEASE',
  Reply = 'REPLY',
  Review = 'REVIEW',
  Revoke = 'REVOKE',
  RevokeGraduation = 'REVOKE_GRADUATION',
  SenateApprove = 'SENATE_APPROVE',
  Send = 'SEND',
  TemplateManage = 'TEMPLATE_MANAGE',
  TransferStudent = 'TRANSFER_STUDENT',
  Update = 'UPDATE',
  UpdateBroadsheet = 'UPDATE_BROADSHEET',
  UpdateCourseRegistrationScore = 'UPDATE_COURSE_REGISTRATION_SCORE',
  UploadScores = 'UPLOAD_SCORES',
  Verify = 'VERIFY',
  View = 'VIEW',
  ViewAll = 'VIEW_ALL',
  ViewBroadsheet = 'VIEW_BROADSHEET'
}

/**
 * The permission/role changes written to the audit trail, as the exact `event`
 * string stored on the AuditLog row. Filter with these instead of hand-typed
 * strings so the client cannot silently miss rows after a rename (#226).
 */
export enum PermissionAuditEvent {
  PermissionGroupCreated = 'PERMISSION_GROUP_CREATED',
  PermissionGroupDeleted = 'PERMISSION_GROUP_DELETED',
  PermissionGroupUpdated = 'PERMISSION_GROUP_UPDATED',
  RoleGrantRevoked = 'ROLE_GRANT_REVOKED',
  RoleRequestApproved = 'ROLE_REQUEST_APPROVED',
  RoleRequestCreated = 'ROLE_REQUEST_CREATED',
  RoleRequestRejected = 'ROLE_REQUEST_REJECTED',
  RoleRequestWithdrawn = 'ROLE_REQUEST_WITHDRAWN',
  UserPermissionGranted = 'USER_PERMISSION_GRANTED',
  UserPermissionGrantRevoked = 'USER_PERMISSION_GRANT_REVOKED',
  UserPermissionGrantUpdated = 'USER_PERMISSION_GRANT_UPDATED',
  UserPermissionGroupAssigned = 'USER_PERMISSION_GROUP_ASSIGNED',
  UserPermissionGroupRemoved = 'USER_PERMISSION_GROUP_REMOVED',
  UserPermissionRevoked = 'USER_PERMISSION_REVOKED'
}

export type PermissionDefinition = {
  /** One entry per action, in catalog order, each with its plain-language description. */
  action_details: Array<PermissionActionDetail>;
  actions: Array<Scalars['String']['output']>;
  /** Which school types ever see this resource, e.g. "All schools", "Tertiary only". */
  audience?: Maybe<Scalars['String']['output']>;
  available_scopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PermissionGrant = {
  category?: Maybe<Scalars['String']['output']>;
  ends_at?: Maybe<Scalars['Date']['output']>;
  grant_type: Scalars['String']['output'];
  granted_by?: Maybe<User>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_primary: Scalars['Boolean']['output'];
  permission?: Maybe<Permission>;
  permissionGroup?: Maybe<PermissionGroup>;
  requested_at?: Maybe<Scalars['DateTime']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewed_by?: Maybe<User>;
  scope_description?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<PermissionGrantScope>>;
  starts_at?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** A paginated list of PermissionGrant items. */
export type PermissionGrantPaginator = {
  /** A list of PermissionGrant items. */
  data: Array<PermissionGrant>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PermissionGrantScope = {
  id: Scalars['ID']['output'];
  scope_id?: Maybe<Scalars['ID']['output']>;
  scope_type: PermissionScopeTypeEnum;
  scope_value?: Maybe<Scalars['String']['output']>;
};

export type PermissionGroup = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  /**
   * The scope type the frontend must prompt for when assigning this group
   * (e.g. FACULTY for a Dean, DEPARTMENT for an HOD). Null = no scope required (#325).
   * Feed it to `permissionScopeOptions(scope_types: [...])` to list the selectable values.
   */
  required_scope_type?: Maybe<PermissionScopeTypeEnum>;
  /** Whether this group is a teaching or non-teaching role. */
  teaching_type?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
};

/** A paginated list of PermissionGroup items. */
export type PermissionGroupPaginator = {
  /** A list of PermissionGroup items. */
  data: Array<PermissionGroup>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PermissionInput = {
  action: PermissionActionEnum;
  resource: PermissionResourceEnum;
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export enum PermissionResourceEnum {
  AiAssistant = 'AI_ASSISTANT',
  Attendance = 'ATTENDANCE',
  AttendanceEvents = 'ATTENDANCE_EVENTS',
  Billing = 'BILLING',
  Cafeteria = 'CAFETERIA',
  Campus = 'CAMPUS',
  Cbt = 'CBT',
  CbtMonitoring = 'CBT_MONITORING',
  Certificates = 'CERTIFICATES',
  Chat = 'CHAT',
  ChildSchools = 'CHILD_SCHOOLS',
  Classes = 'CLASSES',
  CmsIntegration = 'CMS_INTEGRATION',
  CourseEquivalence = 'COURSE_EQUIVALENCE',
  CourseExemptions = 'COURSE_EXEMPTIONS',
  CourseRegistrationApproval = 'COURSE_REGISTRATION_APPROVAL',
  CustomFields = 'CUSTOM_FIELDS',
  EducationalResources = 'EDUCATIONAL_RESOURCES',
  FinancialRecords = 'FINANCIAL_RECORDS',
  Forms = 'FORMS',
  GradeSystem = 'GRADE_SYSTEM',
  Guardians = 'GUARDIANS',
  IdCards = 'ID_CARDS',
  LecturerCourseAllocation = 'LECTURER_COURSE_ALLOCATION',
  LessonNotes = 'LESSON_NOTES',
  Permissions = 'PERMISSIONS',
  Registrations = 'REGISTRATIONS',
  Results = 'RESULTS',
  ResultTemplates = 'RESULT_TEMPLATES',
  Rooms = 'ROOMS',
  SchemeOfWork = 'SCHEME_OF_WORK',
  SchoolAnnouncements = 'SCHOOL_ANNOUNCEMENTS',
  SchoolAssets = 'SCHOOL_ASSETS',
  SchoolProfile = 'SCHOOL_PROFILE',
  StaffRoles = 'STAFF_ROLES',
  Students = 'STUDENTS',
  Subjects = 'SUBJECTS',
  SubjectAssignment = 'SUBJECT_ASSIGNMENT',
  Teachers = 'TEACHERS',
  Tickets = 'TICKETS',
  Timetable = 'TIMETABLE',
  Transcripts = 'TRANSCRIPTS',
  Transportation = 'TRANSPORTATION',
  WaiverCodes = 'WAIVER_CODES',
  WhatsappMessaging = 'WHATSAPP_MESSAGING'
}

/** A selectable value for one permission-scope dimension. */
export type PermissionScopeOption = {
  label: Scalars['String']['output'];
  /**
   * What gets persisted as `ScopeInput.scope_value`: a model id for
   * PROGRAMME/DEPARTMENT/FACULTY/CLASSROOM_SECTION, and the level name itself
   * (e.g. "100") for LEVEL, which is the shape `registration_level` stores.
   */
  value: Scalars['String']['output'];
};

export type PermissionScopeOptionGroup = {
  options: Array<PermissionScopeOption>;
  scope_type: PermissionScopeTypeEnum;
};

export enum PermissionScopeTypeEnum {
  ClassroomSection = 'CLASSROOM_SECTION',
  Department = 'DEPARTMENT',
  Faculty = 'FACULTY',
  Level = 'LEVEL',
  Programme = 'PROGRAMME'
}

export type Plan = {
  billing_intervals: Array<BillingIntervalEnum>;
  code: Scalars['String']['output'];
  default_currency_code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<PlanFeature>;
  id: Scalars['ID']['output'];
  is_public: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prices: Array<PlanPrice>;
  sort_order: Scalars['Int']['output'];
  trial_days: Scalars['Int']['output'];
  type_applicability: TypeApplicabilityEnum;
};

export type PlanFeature = {
  feature_code: Scalars['String']['output'];
  is_included: Scalars['Boolean']['output'];
  limit_value?: Maybe<Scalars['Int']['output']>;
};

export type PlanPrice = {
  base_price: Scalars['String']['output'];
  billing_interval: BillingIntervalEnum;
  currency_code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_custom_quote: Scalars['Boolean']['output'];
  setup_fee: Scalars['String']['output'];
  size_tier_max?: Maybe<Scalars['Int']['output']>;
  size_tier_min: Scalars['Int']['output'];
  type_applicability: TypeApplicabilityEnum;
};

export enum PortalType {
  Guardian = 'GUARDIAN',
  Staff = 'STAFF'
}

export type PqAnswerInput = {
  pq_question_id: Scalars['ID']['input'];
  pq_question_option_id: Scalars['ID']['input'];
  time_spent_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type PqAuthResponse = {
  message: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<PqUser>;
};

export type PqBadge = {
  created_at: Scalars['DateTime']['output'];
  criteria_type: Scalars['String']['output'];
  criteria_value: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  xp_reward: Scalars['Int']['output'];
};

export type PqCreateSubscriptionInput = {
  payment_provider: Scalars['String']['input'];
  payment_reference: Scalars['String']['input'];
  tier: PqSubscriptionTier;
};

export type PqExamBody = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questionBanks: Array<PqQuestionBank>;
  slug: Scalars['String']['output'];
  subjects: Array<PqSubject>;
  updated_at: Scalars['DateTime']['output'];
};

export type PqGenerateTopicSummaryInput = {
  pq_exam_body_id?: InputMaybe<Scalars['ID']['input']>;
  pq_topic_id: Scalars['ID']['input'];
};

export type PqLeaderboardEntry = {
  rank: Scalars['Int']['output'];
  user: PqUser;
  xp_total: Scalars['Int']['output'];
};

export enum PqLeaderboardType {
  Global = 'GLOBAL',
  Subject = 'SUBJECT',
  Weekly = 'WEEKLY'
}

export type PqLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type PqPracticeAnswer = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_correct: Scalars['Boolean']['output'];
  question: PqQuestion;
  selectedOption?: Maybe<PqQuestionOption>;
  time_spent_seconds?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PqPracticeSession = {
  answers: Array<PqPracticeAnswer>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  correct_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  questionBank: PqQuestionBank;
  question_count: Scalars['Int']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  started_at: Scalars['DateTime']['output'];
  status: PqPracticeSessionStatus;
  time_spent_seconds?: Maybe<Scalars['Int']['output']>;
  total_marks: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum PqPracticeSessionStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  Started = 'STARTED'
}

export type PqQuestion = {
  created_at: Scalars['DateTime']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marks: Scalars['Int']['output'];
  options: Array<PqQuestionOption>;
  position?: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  questionBank: PqQuestionBank;
  question_type: QuestionTypeEnum;
  topic?: Maybe<PqTopic>;
  updated_at: Scalars['DateTime']['output'];
};

export type PqQuestionBank = {
  created_at: Scalars['DateTime']['output'];
  examBody: PqExamBody;
  id: Scalars['ID']['output'];
  is_published: Scalars['Boolean']['output'];
  question_count: Scalars['Int']['output'];
  subject: PqSubject;
  updated_at: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

/** A paginated list of PqQuestionBank items. */
export type PqQuestionBankPaginator = {
  /** A list of PqQuestionBank items. */
  data: Array<PqQuestionBank>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PqQuestionOption = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_correct: Scalars['Boolean']['output'];
  option: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  question: PqQuestion;
  updated_at: Scalars['DateTime']['output'];
};

export type PqRegisterInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  target_exam?: InputMaybe<Scalars['String']['input']>;
};

export type PqResetPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type PqSchoolSync = {
  cbt_question_bank_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  questionBank: PqQuestionBank;
  school: School;
  synced_at: Scalars['DateTime']['output'];
  synced_question_count: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PqStartPracticeInput = {
  pq_question_bank_id: Scalars['ID']['input'];
  question_count?: InputMaybe<Scalars['Int']['input']>;
};

export type PqSubject = {
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  examBodies: Array<PqExamBody>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  topics: Array<PqTopic>;
  updated_at: Scalars['DateTime']['output'];
};

export enum PqSubjectCategory {
  Arts = 'ARTS',
  Commercial = 'COMMERCIAL',
  General = 'GENERAL',
  Science = 'SCIENCE'
}

export type PqSubmitPracticeInput = {
  answers: Array<PqAnswerInput>;
  pq_practice_session_id: Scalars['ID']['input'];
  time_spent_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type PqSubscription = {
  amount?: Maybe<Scalars['Float']['output']>;
  auto_renew: Scalars['Boolean']['output'];
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payment_provider?: Maybe<Scalars['String']['output']>;
  payment_reference?: Maybe<Scalars['String']['output']>;
  starts_at: Scalars['DateTime']['output'];
  status: PqSubscriptionStatus;
  tier: PqSubscriptionTier;
  updated_at: Scalars['DateTime']['output'];
};

export enum PqSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Trial = 'TRIAL'
}

export enum PqSubscriptionTier {
  Basic = 'BASIC',
  Free = 'FREE',
  Premium = 'PREMIUM'
}

export type PqSyncToSchoolInput = {
  pq_question_bank_ids: Array<Scalars['ID']['input']>;
  school_id: Scalars['ID']['input'];
};

export type PqTopic = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  questions: Array<PqQuestion>;
  slug: Scalars['String']['output'];
  subject: PqSubject;
  summaries: Array<PqTopicSummary>;
  updated_at: Scalars['DateTime']['output'];
};

export type PqTopicSummary = {
  ai_model?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  examBody?: Maybe<PqExamBody>;
  generated_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key_points?: Maybe<Array<Scalars['String']['output']>>;
  summary: Scalars['String']['output'];
  topic: PqTopic;
  updated_at: Scalars['DateTime']['output'];
};

export type PqTopicWithCount = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question_count: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type PqUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  badges: Array<PqBadge>;
  created_at: Scalars['DateTime']['output'];
  current_streak: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
  last_practice_date?: Maybe<Scalars['Date']['output']>;
  longest_streak: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<PqSubscription>;
  target_exam?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  xp_total: Scalars['Int']['output'];
};

export type PqUserStats = {
  average_score: Scalars['Float']['output'];
  badges_earned: Scalars['Int']['output'];
  best_score: Scalars['Float']['output'];
  current_streak: Scalars['Int']['output'];
  longest_streak: Scalars['Int']['output'];
  subjects_practiced: Scalars['Int']['output'];
  total_practices: Scalars['Int']['output'];
  total_questions_answered: Scalars['Int']['output'];
  xp_total: Scalars['Int']['output'];
};

export type PreviewOption = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  optionImages?: Maybe<Array<File>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PreviewQuestions = {
  created_questions?: Maybe<Array<Question>>;
  errors?: Maybe<Array<ParseError>>;
  preview?: Maybe<Array<QuestionPreview>>;
  status: Scalars['String']['output'];
};

export type ProcessedResult = {
  academic_calendar: AcademicCalendar;
  classroom: Classroom;
  data?: Maybe<Scalars['Mixed']['output']>;
  headers: Array<ResultHeader>;
  programme?: Maybe<ProgrammeType>;
  result_feedbacks?: Maybe<Array<StudentResultFeedback>>;
  result_mode?: Maybe<ResultMode>;
  status?: Maybe<ResultStatus>;
  student: Student;
  summary?: Maybe<Scalars['Mixed']['output']>;
  template: ResultTemplate;
};

/** How a programme's courses are delivered across the calendar. */
export enum ProgrammeDeliveryModeEnum {
  Modular = 'MODULAR',
  Regular = 'REGULAR',
  Residence = 'RESIDENCE'
}

export type ProgrammeModuleImportResult = {
  created: Scalars['Int']['output'];
  errors: Array<ImportError>;
  /** Rows rejected; see errors for the row number and field messages. */
  failed: Scalars['Int']['output'];
  /** Modules created or updated, in row order. */
  modules: Array<ProgrammeModuleType>;
  total_rows: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

/** One sheet row. Dates are strings (YYYY-MM-DD) so a bad cell is reported for its row instead of rejecting the whole batch. */
export type ProgrammeModuleImportRowInput = {
  /** Direct calendar pin; must belong to the row's session. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  ended_at: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Programme code (prog_code). Takes precedence over the mutation-level programme_id default. */
  programme_code?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  /** Semester/term position within the session (1 = first semester). Pins the module to that semester's calendar. */
  semester?: InputMaybe<Scalars['Int']['input']>;
  /** Optional — defaults to the next sequence within the programme and session. */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  /** Session name as configured for the school, e.g. "2025/2026". Takes precedence over the mutation-level session_id default. */
  session?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  started_at: Scalars['String']['input'];
};

export type ProgrammeModuleType = {
  academicCalendar?: Maybe<AcademicCalendar>;
  /** Optional pin to a calendar (semester/term) within the session. */
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ended_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Admin toggle: true = activated, false = deactivated. Module is open when is_active AND dates are in range. */
  is_active: Scalars['Boolean']['output'];
  /** Computed: whether this module is currently open for registration (is_active AND within date range). */
  is_open: Scalars['Boolean']['output'];
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: Maybe<Scalars['Int']['output']>;
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: Maybe<Scalars['Int']['output']>;
  /** School-controlled display label, e.g. "Module 1 (January)". */
  name: Scalars['String']['output'];
  offeredCurriculums: Array<CurriculumType>;
  programme?: Maybe<ProgrammeType>;
  programme_id: Scalars['ID']['output'];
  registrationFeeItemTemplate?: Maybe<BillItemTemplate>;
  /** Optional fee charged once per student for this module. Existing invoices retain their amount. */
  registration_fee?: Maybe<Scalars['Float']['output']>;
  /** Fee Item Template used to bill the first attempt. When set, the invoice inherits the template's amount, GL account and category. */
  registration_fee_item_template_id?: Maybe<Scalars['ID']['output']>;
  retakeFeeItemTemplate?: Maybe<BillItemTemplate>;
  /** Optional fee charged on the 2nd and later attempts. Null falls back to registration_fee. */
  retake_fee?: Maybe<Scalars['Float']['output']>;
  /** Fee Item Template used to bill retake attempts. When null, no retake fee is charged. */
  retake_fee_item_template_id?: Maybe<Scalars['ID']['output']>;
  school_id: Scalars['ID']['output'];
  sequence: Scalars['Int']['output'];
  session?: Maybe<Session>;
  /** The session (academic year) the module runs within. */
  session_id: Scalars['ID']['output'];
  started_at: Scalars['Date']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An existing (programme, semester) assignment that uses a different template. */
export type ProgrammeTemplateAssignmentConflict = {
  academic_calendar_id: Scalars['ID']['output'];
  calendar_name: Scalars['String']['output'];
  current_template_id: Scalars['ID']['output'];
  current_template_name: Scalars['String']['output'];
  programme_id: Scalars['ID']['output'];
  programme_name: Scalars['String']['output'];
};

export type ProgrammeTemplateAssignmentResult = {
  /** False when conflicts were found and overwrite was not set — nothing was written. */
  applied: Scalars['Boolean']['output'];
  assigned: Scalars['Int']['output'];
  conflicts: Array<ProgrammeTemplateAssignmentConflict>;
  overwritten: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
};

export type ProgrammeType = {
  calculation_method: Scalars['String']['output'];
  compulsory_mode: CompulsoryModeEnum;
  createdAt: Scalars['DateTime']['output'];
  default_result_template?: Maybe<ResultTemplate>;
  /** Default result template used for any calendar without an explicit assignment. */
  default_result_template_id?: Maybe<Scalars['ID']['output']>;
  default_transcript_template?: Maybe<TranscriptTemplate>;
  /** Default transcript template used when generating transcripts for this programme. */
  default_transcript_template_id?: Maybe<Scalars['ID']['output']>;
  degree: Scalars['String']['output'];
  delivery_mode: ProgrammeDeliveryModeEnum;
  department_id: Scalars['ID']['output'];
  duration: Scalars['Int']['output'];
  enforce_prerequisites: Scalars['Boolean']['output'];
  graduation_criteria?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['String']['output']>;
  is_active_programme?: Maybe<Scalars['Boolean']['output']>;
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: Maybe<Scalars['Int']['output']>;
  min_units: Scalars['Int']['output'];
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: Maybe<Scalars['Int']['output']>;
  module_result_mode: ModuleResultModeEnum;
  /** Modules configured for this programme, ordered by sequence. */
  modules: Array<ProgrammeModuleType>;
  outstanding_mode: OutstandingModeEnum;
  prog_code: Scalars['String']['output'];
  program_name: Scalars['String']['output'];
  progression_type: ProgressionTypeEnum;
  promotion_criteria?: Maybe<Scalars['JSON']['output']>;
  /** Result templates assigned to this programme (for tertiary schools) */
  resultTemplates: Array<ResultTemplate>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of ProgrammeType items. */
export type ProgrammeTypePaginator = {
  /** A list of ProgrammeType items. */
  data: Array<ProgrammeType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** How students progress through the programme. */
export enum ProgressionTypeEnum {
  Level = 'LEVEL',
  Year = 'YEAR'
}

export type PromoteStudentsInput = {
  classroom_section_id: Scalars['ID']['input'];
  from_academic_calendar_id: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
  to_academic_calendar_id: Scalars['ID']['input'];
};

/** Promotion eligibility dry-run for one programme + source calendar. */
export type PromotionEligibilityReport = {
  /** The merged promotion_criteria the rows were evaluated against. */
  criteria: Scalars['JSON']['output'];
  eligible_count: Scalars['Int']['output'];
  failed_count: Scalars['Int']['output'];
  failed_student_ids: Array<Scalars['ID']['output']>;
  from_academic_calendar_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  not_eligible_count: Scalars['Int']['output'];
  programme_id: Scalars['ID']['output'];
  rows: Array<PromotionEligibilityRow>;
  total_checked: Scalars['Int']['output'];
};

/** One student's promotion-eligibility evaluation. Dry run: nothing is persisted. */
export type PromotionEligibilityRow = {
  calculation_method: Scalars['String']['output'];
  /** Per-check detail keyed by check name (unit_validation, cgpa_validation, outstanding_courses, level_cap). */
  checks: Scalars['JSON']['output'];
  /** Level the student sits in for the source calendar (0 when it could not be read). */
  current_level: Scalars['Int']['output'];
  failed_checks: Array<Scalars['String']['output']>;
  full_name: Scalars['String']['output'];
  is_eligible: Scalars['Boolean']['output'];
  matric_no?: Maybe<Scalars['String']['output']>;
  /** Level the student would move to; null when current_level is unknown. */
  next_level?: Maybe<Scalars['Int']['output']>;
  outstanding_count: Scalars['Int']['output'];
  outstanding_courses: Array<Scalars['String']['output']>;
  /** Cumulative CGPA or weighted average on the programme. */
  result: Scalars['Float']['output'];
  skipped_checks: Array<Scalars['String']['output']>;
  student_id: Scalars['ID']['output'];
  units_passed: Scalars['Float']['output'];
  /** Units registered / passed in the source calendar's session. */
  units_registered: Scalars['Float']['output'];
};

export type PublicClassroomOption = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type PublicDataSourceOptions = {
  options: Array<PublicOption>;
  source: FormFieldDataSource;
};

/** Options for picker fields on public forms. Empty arrays when the form doesn't include the corresponding field type or data source. */
export type PublicFormOptions = {
  classroomSections: Array<PublicClassroomOption>;
  /** One entry per data_source used by the form's fields, with id/label option pairs scoped to the form's school. */
  dataSources: Array<PublicDataSourceOptions>;
  programmes: Array<PublicProgrammeOption>;
};

export type PublicOption = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type PublicPaymentProvider = {
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<PaymentProviderType>;
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type PublicProgramme = {
  id: Scalars['ID']['output'];
  prog_code: Scalars['String']['output'];
  program_name: Scalars['String']['output'];
};

export type PublicProgrammeOption = {
  id: Scalars['ID']['output'];
  program_name: Scalars['String']['output'];
};

/** What a referee sees when opening their invite link. */
export type PublicReferenceRequest = {
  /** Whether this school lets the applicant read the response — a referee must know before writing. */
  applicant_can_view: Scalars['Boolean']['output'];
  applicant_name: Scalars['String']['output'];
  /** Answers the referee parked with "Save & continue later". Only the token holder ever sees them; null once submitted or declined. */
  draft_data?: Maybe<Scalars['JSON']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  /** The admission form's title — the programme context the paper form's cover conveyed. */
  form_title: Scalars['String']['output'];
  referee_name: Scalars['String']['output'];
  /** The REFERENCE template to render (fields, sections, branding, publicOptions). */
  referenceForm: CustomForm;
  school_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PublishedResult = {
  academic_calendar: AcademicCalendar;
  classroom: Classroom;
  created_at: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Mixed']['output']>;
  feedbacks?: Maybe<Scalars['Mixed']['output']>;
  headers?: Maybe<Scalars['Mixed']['output']>;
  id: Scalars['ID']['output'];
  school: School;
  status: ResultStatus;
  student: Student;
  template: ResultTemplate;
};

/** Indicates what fields are available at the top level of a query operation. */
export type Query = {
  /** Retrieves a specific academic calendar entry by ID. */
  academicCalendar?: Maybe<AcademicCalendar>;
  /** Retrieves all academic calendar entries for a given session. */
  academicCalendarsForSession: Array<AcademicCalendar>;
  /** Retrieves the currently active academic calendar entry for the current school. Requires authentication. */
  activeAcademicCalendar?: Maybe<AcademicCalendar>;
  activeAnnouncements: Array<Announcement>;
  activeCbtMonitoringSessions: CbtMonitoringSessionPaginator;
  activePaymentProvider?: Maybe<PaymentProvider>;
  activePaymentProviders: Array<PaymentProvider>;
  /** Retrieves the currently active session for the current school. Requires authentication. */
  activeSession?: Maybe<Session>;
  activeSetting?: Maybe<Setting>;
  admissionLetterAssignments: AdmissionLetterAssignments;
  admissionLetterExportPreview: Array<AdmissionLetterExportCandidate>;
  admissionLetterHistory: Array<AdmissionLetterRevision>;
  admissionLetterPresets: Array<AdmissionLetterPreset>;
  admissionLetterSettings: AdmissionLetterSettings;
  /** The school's signatures with these ids (at most 50), for the template editor: staff who may edit templates only. Ids of other schools, or of signatures that are gone, are left out. */
  admissionLetterSignatureImages: Array<AdmissionLetterSignatureImage>;
  /** The current school's admission letter templates (#376), default first. */
  admissionLetterTemplates: Array<AdmissionLetterTemplate>;
  aiActionRun?: Maybe<AiActionRun>;
  aiPendingAction?: Maybe<AiPendingAction>;
  aiSelection?: Maybe<AiSelection>;
  allChildSchoolClassrooms: Array<ChildSchoolClassroomOption>;
  allChildSchoolProgrammes: Array<ChildSchoolProgrammeOption>;
  allChildSchools: Array<School>;
  /** Retrieves all session structures for the current school. Requires authentication. */
  allSessionStructures: Array<SessionStructure>;
  /** Public query: check application status by tracking code */
  applicantStatus: ApplicantStatusResponse;
  /** Get all submissions for a verified applicant session */
  applicantSubmissions: Array<ApplicantSubmissionSummary>;
  archivedStudents: ArchivedStudentsResponse;
  attendanceEvent: AttendanceEvent;
  /** The school's attendance events for a calendar (defaults to the active one). */
  attendanceEvents: Array<AttendanceEvent>;
  availablePlans: Array<Plan>;
  /** Reports the signed-in staff member may run in this school. */
  availableReports: Array<ReportSummary>;
  bill?: Maybe<Bill>;
  billInvoicePdf: PdfDocument;
  billItemCategories: Array<BillItemCategory>;
  billItemTemplates: Array<BillItemTemplate>;
  billStudents: Array<Student>;
  billStudentsWithStatus: BillStudentsWithStatusResult;
  billingKpis: BillingKpis;
  bills: Array<Bill>;
  broadsheetExcelUrl: FileExport;
  broadsheetPdfUrl: FileExport;
  broadsheetReport: BroadsheetReport;
  broadsheetTemplate?: Maybe<BroadsheetTemplate>;
  broadsheetTemplates: BroadsheetTemplatePaginator;
  cbtMonitoringSession?: Maybe<CbtMonitoringSession>;
  cbtRecordingDownloadUrl?: Maybe<CbtRecordingDownload>;
  cbtRecordingThumbnailUrl?: Maybe<CbtRecordingDownload>;
  certificateAuditLogs: Array<CertificateAuditLog>;
  certificateBatchJob: CertificateBatchJob;
  certificateBatchJobs: CertificateBatchJobPaginator;
  certificateDesigns: Array<CertificateDesignInfo>;
  certificateFieldTypes: Array<CertificateFieldTypeInfo>;
  certificateTemplate: CertificateTemplate;
  certificateTemplates: Array<CertificateTemplate>;
  chatChannels: ChatChannelListResponse;
  /**
   * Active staff of the current school, for the new-DM / new-group pickers.
   * Gated on the chat create ability, NOT the staff directory permission —
   * a user allowed to start chats needs recipients even without teachers.view.
   */
  chatContacts: Array<ChatContact>;
  chatMessages: ChatMessageConnection;
  /**
   * Resolves records attached to chat messages for the CURRENT viewer. Returns
   * one card per requested ref, in the same order, each carrying only what this
   * viewer is allowed to see.
   */
  chatShareCards: Array<ChatShareCard>;
  chatUnreadSummary: ChatUnreadSummary;
  /** Preflight: likely-duplicate warnings for proposed bill items, without creating anything. */
  checkBillDuplicates: Array<BillDuplicateWarning>;
  checkCaApprovalStatus: Scalars['Boolean']['output'];
  checkPaymentEnrollment: PaymentEnrollmentCheck;
  /**
   * Checks whether the currently authenticated student is disabled.
   * Uses auth()->user() — no arguments required.
   */
  checkStudentAccess: StudentAccessCheck;
  /** Preview checkout grouping for a bill (used during bill creation/editing). */
  checkoutGroupPreview: CheckoutGroupPreview;
  /** Resolve the checkout groups for a bill. Returns how line items will be grouped by settlement account at payment time. */
  checkoutGroups: Array<CheckoutGroup>;
  childSchoolAcademicCalendars: Array<ChildSchoolCalendarOption>;
  childSchoolArchivedStudents: ArchivedStudentsResponse;
  childSchoolBillItems: Array<ChildSchoolBillItem>;
  childSchoolChannels: Array<ChatChannel>;
  childSchoolClassroomSections: Array<ChildSchoolClassroomSection>;
  childSchoolClassrooms: Array<ChildSchoolClassroomSection>;
  /** Fetch classroom sections, programmes and campuses for a child school — used by the conversion dialog when admin targets a child school. */
  childSchoolConversionOptions: ConversionOptions;
  childSchoolFinancials: ChildSchoolFinancialsResponse;
  childSchoolProgrammes: Array<ChildSchoolProgramme>;
  childSchoolSessionsAndTerms: ChildSchoolSessionsAndTermsResponse;
  childSchoolStaff: Array<ChildSchoolStaffMember>;
  childSchoolStudentBreakdown: ChildSchoolStudentBreakdownResponse;
  childSchoolStudentProfile: ChildSchoolStudentProfile;
  childSchoolStudents: ChildSchoolStudentsResponse;
  childSchoolTransfers: StudentTransfersResponse;
  childSchools: Array<School>;
  childSchoolsAttendance: ChildSchoolsAttendanceResponse;
  childSchoolsResults: ChildSchoolsResultsResponse;
  childSchoolsSummary: ChildSchoolsSummaryResponse;
  /** Offerings effective for a classroom. When section_id is given, classroom-wide (all-section) offerings are included too. */
  classroomOfferings: Array<SubjectOffering>;
  classroomStudentAttendance: ClassroomStudentAttendanceResult;
  /**
   * List all course equivalence groups for the school.
   * Returns groups of courses that are considered equivalent.
   */
  courseEquivalenceGroups: Array<CourseEquivalenceGroup>;
  /**
   * The register for one course (#320): the students with an approved
   * registration for it this semester, not the whole level cohort. Refused
   * unless the course is allocated-and-approved to the caller, or the caller
   * holds course_registration.view_all. Tertiary schools.
   */
  courseStudentAttendance: ClassroomStudentAttendanceResult;
  /** Templates a school can add for a record type. Needs Custom Fields → View. */
  customFieldTemplates: Array<CustomFieldTemplate>;
  /** Custom field definitions for a record type. include_inactive needs Custom Fields → View. */
  customFields: Array<CustomField>;
  dashboardOverview: DashboardStats;
  debtors: DebtorPaginated;
  /** Retrieves the default session structure for the current school. Requires authentication. */
  defaultSessionStructure?: Maybe<SessionStructure>;
  /**
   * Whether assigning a category to one student would actually reduce anything,
   * and when it would not, which link in the chain is broken.
   */
  discountAssignmentPreview: DiscountAssignmentPreview;
  discountCategories: Array<DiscountCategory>;
  discountCategory?: Maybe<DiscountCategory>;
  /**
   * What a rule configuration would reach right now, before it is saved. The
   * preview runs the SAME matcher the billing engine uses, so it cannot disagree
   * with what happens after saving.
   */
  discountRuleImpact: DiscountRuleImpact;
  downloadAllCBTTestResults: FileExport;
  /**
   * Bulk export all CBT scores for a semester, grouped by course/subject
   * (one sheet per course). Optionally filter by programme and/or level.
   */
  downloadBulkCbtScores: FileExport;
  /**
   * Bulk download score sheets for all courses/subjects in a semester.
   * Returns one Excel file with one sheet per course/subject.
   * Tertiary: filter by programme_id and/or level.
   * Non-tertiary: filter by classroom_id and/or classroom_section_id.
   */
  downloadBulkScoreSheet: FileExport;
  /**
   * Download score sheets with CBT scores pre-filled. Same format as bulk score
   * sheets, but assessment columns linked to CBT tests are auto-populated with
   * scaled scores. Unlinked CBT scores appear in an extra column.
   */
  downloadBulkScoreSheetWithCbt: FileExport;
  downloadCBTResult?: Maybe<Scalars['String']['output']>;
  downloadPublicTranscriptPdf: FileExport;
  downloadScoreSheet: FileExport;
  downloadStudentAllSemestersResult: FileExport;
  /**
   * Generate a PDF report of one student's CBT sessions. Optional
   * cbt_test_ids narrows the report to specific tests; otherwise every
   * completed session for the student is included.
   */
  downloadStudentCbtReport: FileExport;
  downloadStudentResult: FileExport;
  downloadTheoryAnswers: FileExport;
  downloadTranscriptPdf: FileExport;
  entityDiscounts: Array<EntityDiscount>;
  /** The register for one event: its resolved participants with per-event attendance counts. */
  eventStudentAttendance: ClassroomStudentAttendanceResult;
  exemption?: Maybe<Exemption>;
  exemptions: Array<Exemption>;
  /** Export form submissions as structured data for CSV download */
  exportFormSubmissions: FormExportResponse;
  exportGraduationRecords: FileExport;
  exportStudentLinkingCodes: Array<StudentLinkingCodeExportRow>;
  feeSplitProfile?: Maybe<FeeSplitProfile>;
  feeSplitProfiles: Array<FeeSplitProfile>;
  fileExports: FileExportPaginator;
  files: FilePaginator;
  form?: Maybe<CustomForm>;
  formFeeBills: Array<FormFeeBillGroup>;
  formFeePayers: Array<FormFeePayer>;
  /** Fetch a single form submission with full activity history and bill (admin view) */
  formSubmission?: Maybe<FormSubmission>;
  /** List submissions for a form. Supports server-side filtering by status, assignment, and free-text search. */
  formSubmissions: FormSubmissionPaginator;
  /** List waiver codes for a form (admin). Supports filtering by status and academic calendar. */
  formWaiverCodes: FormWaiverCodePaginator;
  forms: Array<CustomForm>;
  gatewaySettlementAccount?: Maybe<GatewaySettlementAccount>;
  gatewaySettlementAccounts: Array<GatewaySettlementAccount>;
  generateBillingReport: BillingReportResult;
  generatedCertificate: GeneratedCertificate;
  generatedCertificates: GeneratedCertificatePaginator;
  generatedTranscript: GeneratedTranscript;
  getAvailableRoles: Array<PermissionGroup>;
  getCBTTest?: Maybe<CbtTest>;
  getCBTTestSessionResult?: Maybe<CbtTestSession>;
  getCampus?: Maybe<CampusType>;
  getCourse?: Maybe<Course>;
  getCourseLecturersInSemester: Array<CourseLecturer>;
  getCourseOutstandingExemption?: Maybe<CourseOutstandingExemptionType>;
  getCourseRegistration?: Maybe<StudentCourseRegistration>;
  /** Financial-clearance state for the authenticated student's course registration (per-school opt-in gate). */
  getCourseRegistrationFinancialClearance: CourseRegistrationFinancialClearance;
  getCourseRegistrationsForStudent?: Maybe<Array<StudentCourseRegistration>>;
  getCurriculum?: Maybe<CurriculumType>;
  getCurriculumsGivenProgramLevelAndSemester?: Maybe<Array<CurriculumType>>;
  getDepartment?: Maybe<DepartmentType>;
  getFaculty?: Maybe<FacultyType>;
  getLecturerCoursesInSemesterByAdmin: Array<CourseLecturer>;
  getLecturerStudentAllocations: Array<LecturerAllocationSummary>;
  getOfflineSyncData?: Maybe<OfflineSyncPayload>;
  getProgramme?: Maybe<ProgrammeType>;
  getQueryBank?: Maybe<QuestionBank>;
  getQuestion?: Maybe<Question>;
  getRegistrationsForCourseInCurrentCalendar?: Maybe<Array<StudentCourseRegistration>>;
  getRoleRequestDetails?: Maybe<PermissionGrant>;
  getSchool?: Maybe<School>;
  getSchoolGradeGroups: Array<GradeGroup>;
  getSchoolSubjectById?: Maybe<Subject>;
  getStaff: StaffPaginator;
  getStaffRoles: PermissionGrantPaginator;
  getStudentCourseRegistrationForCurrentSemester?: Maybe<StudentCourseRegistration>;
  getStudentCurriculumsGivenProgramLevelAndSemester?: Maybe<Array<CurriculumType>>;
  getStudentRegistrationApprovalDetails?: Maybe<CourseRegistrationApprovalDetails>;
  getSubjectEnrollments: StudentSubjectEnrollmentPaginator;
  getTertiaryResultSummarySheet?: Maybe<ResultSummarySheetReport>;
  getTestResults: CbtTestResultPaginator;
  getUnallocatedStudents: Array<CourseRegistered>;
  graduationCriteriaPresets: Array<GraduationCriteriaPreset>;
  graduationRecord: GraduationRecord;
  graduationRecords: GraduationRecordPaginator;
  /** One guardian. Needs Guardians → View (GuardianPolicy::view); their custom field values are school-internal data. */
  guardian?: Maybe<Guardian>;
  guardianChildAnnouncements: Array<SchoolAnnouncement>;
  guardianChildAttendance?: Maybe<StudentAttendanceResponse>;
  /** One bill of a linked child, with that child's own balance. Null when the bill is not one of the child's visible bills. */
  guardianChildBill?: Maybe<Bill>;
  guardianChildBills: Array<Bill>;
  guardianChildCalendars: Array<GuardianCalendarOption>;
  guardianChildCourseRegistration?: Maybe<StudentCourseRegistration>;
  guardianChildResults?: Maybe<ProcessedResult>;
  guardianChildTimetable?: Maybe<Timetable>;
  guardianChildTranscriptRequests: Array<TranscriptRequest>;
  guardianChildren: Array<GuardianChildOverview>;
  guardianDashboardSummary: GuardianDashboardSummary;
  guardians: Array<Guardian>;
  guardiansByStudent: Array<Guardian>;
  hierarchySchools: Array<School>;
  hierarchyStaff: Array<HierarchyStaffMember>;
  interswitchCharges: InterswitchCharges;
  lessonNote?: Maybe<LessonNote>;
  lessonNoteApprovalMode: LessonNoteApprovalMode;
  lessonNoteResources: Array<EducationalResource>;
  lessonNotes: Array<LessonNote>;
  listCBTTests: CbtTestPaginator;
  listCbtMonitoringSessions: CbtMonitoringSessionPaginator;
  listCourseOutstandingExemptions: Array<CourseOutstandingExemptionType>;
  listCourseOutstandingWaivers: CourseOutstandingWaiverPaginator;
  listCurriculumsByProgram?: Maybe<Array<CurriculumType>>;
  listCurriculumsByProgramAndLevel?: Maybe<Array<CurriculumType>>;
  listManualOutstandingCourses: ManualOutstandingCoursePaginator;
  /** Modules of a programme, ordered by sequence. Optionally filtered by session and/or calendar. */
  listProgrammeModules?: Maybe<Array<ProgrammeModuleType>>;
  listQuestionBanks: QuestionBankPaginator;
  listQuestions: Array<Question>;
  listSchoolCampuses: CampusTypePaginator;
  listSchoolCourses: CoursePaginator;
  listSchoolCurriculums: CurriculumTypePaginator;
  listSchoolDepartments: DepartmentTypePaginator;
  listSchoolFaculties: FacultyTypePaginator;
  listSchoolProgrammes: ProgrammeTypePaginator;
  listSchoolSubjects?: Maybe<Array<Maybe<Subject>>>;
  listStudentCBTTestSessions: CbtTestSessionPaginator;
  listStudentCourseRegistrationsByLevel: CourseRegistrationForApprovalPaginator;
  listStudentCurriculumsByProgram?: Maybe<Array<CurriculumType>>;
  /** Find one of the school's waiver codes by its text (codes are stored hashed, so this is the only way to look one up). Null when the school has no such code. */
  lookupWaiverCode?: Maybe<FormWaiverCode>;
  matricNoConfig: MatricNoConfig;
  matricRetrievalAttempts: MatricRetrievalAttemptPaginator;
  me?: Maybe<UserType>;
  moduleElectiveCandidates: Array<Course>;
  moduleElectiveOfferings: Array<ModuleElectiveOffering>;
  moduleRegistrationPayments: ModulePaymentSummary;
  myActiveRoles: Array<PermissionGrant>;
  myAttendance: StudentAttendanceResponse;
  /**
   * Courses the caller may take a register for: their own approved allocations
   * for the active semester, or the whole catalogue for holders of
   * course_registration.view_all. Empty for anyone else.
   */
  myAttendanceCourses: Array<Course>;
  /** The current user's persisted in-app notifications, newest first (#224). */
  myNotifications: UserNotificationPaginator;
  myPendingScoreEntries: Array<PendingScoreEntry>;
  myRoleRequests: Array<PermissionGrant>;
  /** Paginated list of schools the authenticated user belongs to, with optional search. */
  mySchools: SchoolPaginator;
  /** The signed-in student's open data requests, unanswered first. Students only. */
  myStudentDataRequests: Array<MyStudentDataRequest>;
  /** The signed-in student's own profile form. Students only. */
  myStudentProfileForm: StudentProfileForm;
  mySubscription: SubscriptionState;
  myTranscriptRequests: Array<TranscriptRequest>;
  /** Unread total for the bell badge — myNotifications only counts its own page (#224). */
  myUnreadNotificationCount: Scalars['Int']['output'];
  /** The 36 Nigerian states and the FCT with their 774 local government areas, for state-of-origin / LGA dropdowns. */
  nigerianStates: Array<NigerianState>;
  pagedSchoolInvitations: SchoolInvitationPaginator;
  /**
   * The parent school's General channel, for child-school staff holding
   * chat.message_parent. Null when the school has no parent or the user lacks
   * the permission — frontends hide the "Message parent school" entry on null.
   */
  parentSchoolGeneralChannel?: Maybe<ChatChannel>;
  payment?: Maybe<Payment>;
  paymentMethodBreakdown: Array<PaymentMethodBreakdown>;
  paymentProviderStatus: Array<PaymentProviderStatus>;
  paymentReceiptPdf: PdfDocument;
  paymentSplitRecords: PaymentSplitRecordPaginated;
  payments: Array<Payment>;
  pdfResultConfig: PdfResultConfig;
  pdfResultPresets: Array<PdfResultPreset>;
  pdfTranscriptConfig: PdfTranscriptConfig;
  pdfTranscriptPresets: Array<PdfTranscriptPreset>;
  /**
   * The must-read notices this student has not acknowledged yet. The portal
   * blocks on a non-empty result; an empty list means nothing is owed.
   */
  pendingAnnouncementAcknowledgements: Array<SchoolAnnouncement>;
  pendingApprovalNotificationSubscription: NotificationSubscriptionStatus;
  pendingCourseRegistrationsForApproval: CourseRegistrationForApprovalPaginator;
  pendingCourseRegistrationsForEndorsement: CourseRegistrationForApprovalPaginator;
  pendingRoleApprovals: Array<PermissionGrant>;
  /** Permission/role change history for the current school, newest first (#226). */
  permissionAuditLogs: AuditLogPaginator;
  permissionDefinitions: Array<PermissionDefinition>;
  permissionGroup?: Maybe<PermissionGroup>;
  permissionGroups: PermissionGroupPaginator;
  /**
   * Selectable values for the permission-scope dimensions, for the scope picker
   * on the role-request and grant-assignment screens.
   *
   * Deliberately NOT permission-scoped: staff request a scoped role BEFORE they
   * hold any grant, and the management list queries (listSchoolProgrammes and
   * friends) resolve a grant-less user to zero rows, which left the picker
   * empty and made a scoped role impossible to request. School tenancy still
   * applies; only value + label are ever returned.
   */
  permissionScopeOptions: Array<PermissionScopeOptionGroup>;
  permissions: Array<Permission>;
  pqBadges: Array<PqBadge>;
  pqExamBodies: Array<PqExamBody>;
  pqExamBodySubjects: Array<PqSubject>;
  pqLeaderboard: Array<PqLeaderboardEntry>;
  pqMyBadges: Array<PqBadge>;
  pqMySubscription?: Maybe<PqSubscription>;
  pqPracticeQuestions: Array<PqQuestion>;
  pqPracticeSession?: Maybe<PqPracticeSession>;
  pqPracticeSessions: Array<PqPracticeSession>;
  pqProfile: PqUser;
  pqQuestionBank?: Maybe<PqQuestionBank>;
  pqQuestionBanks: PqQuestionBankPaginator;
  /** Search questions by topic, optionally filtered by exam body and year */
  pqQuestionsByTopic: Array<PqQuestion>;
  pqSchoolSyncs: Array<PqSchoolSync>;
  /** Get topics for a specific subject with per-topic question counts */
  pqSubjectTopics: Array<PqTopicWithCount>;
  pqSubjects: Array<PqSubject>;
  /** Get a single topic by ID */
  pqTopic?: Maybe<PqTopic>;
  /** Get AI-generated summary for a topic, optionally scoped to an exam body */
  pqTopicSummary?: Maybe<PqTopicSummary>;
  /** List topics, optionally filtered by subject and/or active status */
  pqTopics: Array<PqTopic>;
  pqUserStats: PqUserStats;
  /**
   * Preview what will be exported by downloadBulkCbtScores, without generating any file.
   * Returns a summary of tests grouped by course/subject with session counts.
   */
  previewBulkCbtScores: BulkCbtScoresPreview;
  /**
   * Preview what will be exported by downloadBulkScoreSheet, without generating any file.
   * Returns a summary of courses/subjects and their student counts.
   */
  previewBulkScoreSheet: BulkScoreSheetPreview;
  /**
   * Dry-run promotion eligibility for every active student enrolled on the
   * programme in the source calendar, evaluated against the programme's
   * promotion_criteria. Nothing is persisted; use promoteStudents to act on it.
   */
  promotionEligibilityReport: PromotionEligibilityReport;
  /** Fetch a public form by slug without authentication */
  publicForm?: Maybe<CustomForm>;
  publicPaymentProvider?: Maybe<PublicPaymentProvider>;
  publicPaymentProviders: Array<PublicPaymentProvider>;
  publicProgrammes: Array<PublicProgramme>;
  publicTranscriptPaymentProvider?: Maybe<PublicPaymentProvider>;
  publicTranscriptTypes: Array<TranscriptType>;
  /** Referee opens their invite link. Invalid, expired and foreign tokens are indistinguishable (null). */
  referenceRequest?: Maybe<PublicReferenceRequest>;
  refund?: Maybe<Refund>;
  refunds: Array<Refund>;
  /** One report with its filters and their options, for the report runner. */
  reportDefinition: ReportDefinitionDetail;
  /** Student search for a report's Student filter. */
  reportStudentOptions: Array<ReportFilterOption>;
  resolveSchool?: Maybe<SchoolBranding>;
  /**
   * Post-publish amendment history for a single result, identified by student +
   * academic calendar (#227). Returns every corrected score for that result,
   * newest first, from the signed, immutable audit trail. Gated on the same
   * permission as editing scores and scoped to the acting school.
   */
  resultAmendmentHistory: Array<ResultAmendment>;
  resultTemplates: ResultTemplatePaginator;
  retrieveMatricNo: MatricRetrievalResult;
  revenueByMonth: Array<RevenueByMonth>;
  /** Rooms for the current (tertiary) school. Empty for non-tertiary schools. */
  rooms: Array<Room>;
  /** On-screen preview, capped at 200 rows. */
  runReport: ReportRunResult;
  saasInvoices: SaasInvoicePaginator;
  schemeOfWork?: Maybe<SchemeOfWork>;
  schemeOfWorkForContext?: Maybe<SchemeOfWork>;
  schemesOfWork: Array<SchemeOfWork>;
  /** Admin list of the school's announcements, newest first. */
  schoolAnnouncements: Array<SchoolAnnouncement>;
  schoolAssessmentTypes: Array<SchoolAssessmentType>;
  schoolClassrooms?: Maybe<Classroom>;
  schoolCourseRegistration: StudentCourseRegistrationPaginator;
  schoolFeatures: Array<FeatureToggle>;
  /** Retrieves all sessions for the current school. Requires authentication. */
  schoolSessions: Array<Session>;
  searchCampusByName?: Maybe<Array<CampusType>>;
  searchModuleElectiveCourses: ModuleElectiveSearchResult;
  /** Search courses by code or title. Available to both students and staff. */
  searchSchoolCourses: Array<Course>;
  /** Retrieves a specific session by ID. */
  session?: Maybe<Session>;
  /** Retrieves a specific session structure by its ID. */
  sessionStructure?: Maybe<SessionStructure>;
  settlementAccounts: Array<SettlementAccount>;
  splitSummary: SplitSummary;
  staff?: Maybe<Staff>;
  student?: Maybe<Student>;
  studentAllSemesterResults: AllSemesterResults;
  /** The signed-in student's notice board — every notice they can see, read or not. */
  studentAnnouncements: Array<SchoolAnnouncement>;
  studentAttendance: StudentAttendanceResponse;
  /**
   * Bills that apply to a student. Class (Classroom/ClassroomSection) bills match
   * only for sessions/terms the student was actually enrolled in that class;
   * direct student bills always match. With no session/academic_calendar filter,
   * results span every session the student was enrolled in — not just the active one.
   */
  studentBills: Array<Bill>;
  /** One data request. Needs Students → View. */
  studentDataRequest?: Maybe<StudentDataRequest>;
  /** How many students an audience would reach now. Needs Students → Update. */
  studentDataRequestAudienceCount: Scalars['Int']['output'];
  /** The fields a data request may ask for. Needs Students → Update. */
  studentDataRequestFieldChoices: Array<StudentDataRequestFieldChoice>;
  /** The students a request reached, limited to the students the viewer may see. Needs Students → View. */
  studentDataRequestRecipients: StudentDataRequestRecipientPaginator;
  /** The school's data requests, newest first. Needs Students → View. */
  studentDataRequests: Array<StudentDataRequest>;
  /** Retrieves the full disablement history for a given student. */
  studentDisablementHistory: Array<StudentDisablement>;
  /** Student fields a school can add to its result PDF and ID card, beyond name and matric number. */
  studentDocumentFields: Array<StudentDocumentField>;
  studentEnrolledProgrammes: Array<ProgrammeType>;
  studentFinancialSummary: StudentFinancialSummary;
  studentFinancials: StudentFinancialPaginated;
  /** Fetch forms available to the authenticated student */
  studentForms: CustomFormPaginator;
  studentImport?: Maybe<StudentImport>;
  studentImports: StudentImportPaginator;
  studentLedger: StudentLedgerResult;
  /** The built-in fields students may fill in on their profile. Needs Custom Fields → View. */
  studentProfileFieldSettings: Array<StudentProfileFieldSetting>;
  studentRegisteredCalendars: Array<AcademicCalendar>;
  studentResult?: Maybe<ProcessedResult>;
  studentSubjects?: Maybe<Array<Subject>>;
  studentWallet: StudentWallet;
  students: StudentPaginator;
  subject?: Maybe<Subject>;
  /** All offerings configured for a subject. */
  subjectOfferings: Array<SubjectOffering>;
  subjectTeachers: Array<Staff>;
  subjects: Array<Subject>;
  suggestPaymentAllocation: Array<SuggestedAllocation>;
  summaryExcelUrl: FileExport;
  summaryPdfUrl: FileExport;
  summaryReport: SummaryReport;
  summaryTemplates: SummaryTemplatePaginator;
  /** Retrieves a specific term structure by ID. */
  termStructure?: Maybe<TermStructure>;
  /** Retrieves all terms for a given session structure (scoped to the current school). */
  termStructuresForStructure: Array<TermStructure>;
  ticket?: Maybe<Ticket>;
  ticketCategories: Array<TicketCategory>;
  tickets: TicketPaginator;
  timetable?: Maybe<Timetable>;
  timetableTemplate?: Maybe<TimetableTemplate>;
  timetableTemplates: Array<TimetableTemplate>;
  timetables: TimetablePaginator;
  transcriptDesignOptions: Array<TranscriptDesignOption>;
  transcriptFontFamilies: Array<TranscriptFontFamily>;
  transcriptPresetOptions: Array<TranscriptPresetOption>;
  transcriptRequest: TranscriptRequest;
  transcriptRequestStatus: TranscriptRequestStatusResponse;
  transcriptRequests: TranscriptRequestPaginator;
  transcriptStudentInfoFields: Array<TranscriptStudentInfoField>;
  transcriptTemplate: TranscriptTemplate;
  transcriptTemplates: Array<TranscriptTemplate>;
  transcriptTypes: Array<TranscriptType>;
  /** List courses that are not assigned to any curriculum entry. */
  unfloatedCourses: UnfloatedCoursePaginator;
  /** List multiple users. */
  users: UserPaginator;
  usersWithCourseLecturers: UserPaginator;
  verifyCertificate: CertificateVerificationResult;
  /** Public: the landing page uses this to tailor currency, pricing and copy. */
  visitorCountry: VisitorCountry;
  /** Waiver code counts by status and per campus. Needs waiver_codes.view. */
  waiverCodeStats: WaiverCodeStats;
  /** Every waiver code in the school across forms (the Bursar's view). Needs waiver_codes.view. */
  waiverCodes: FormWaiverCodePaginator;
  /** What's new for the signed-in staff member, newest first: only changes they can reach in this school. The AI assistant reads the same list (get_whats_new). */
  whatsNew: Array<WhatsNewEntry>;
  /** Return the WhatsApp conversation for a specific guardian. */
  whatsappConversation?: Maybe<WhatsappConversation>;
  /**
   * Paginated list of WhatsApp messages for the current school.
   * Optionally filter by guardianId and/or direction.
   */
  whatsappMessages: WhatsappMessagePaginator;
  /** Return the current school's WhatsApp settings (sensitive fields masked). */
  whatsappSettings?: Maybe<WhatsappSettings>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAcademicCalendarArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAcademicCalendarsForSessionArgs = {
  session_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryActiveCbtMonitoringSessionsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  testId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAdmissionLetterExportPreviewArgs = {
  submission_ids: Array<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAdmissionLetterHistoryArgs = {
  submission_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAdmissionLetterSignatureImagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAiActionRunArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAiPendingActionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAiSelectionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryApplicantStatusArgs = {
  tracking_code: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryApplicantSubmissionsArgs = {
  token: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryArchivedStudentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAttendanceEventArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAttendanceEventsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<AttendanceEventCategory>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAvailablePlansArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  school_type?: InputMaybe<TypeApplicabilityEnum>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillInvoicePdfArgs = {
  bill_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillItemCategoriesArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillItemTemplatesArgs = {
  filters?: InputMaybe<BillItemTemplateFilterInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillStudentsArgs = {
  bill_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillStudentsWithStatusArgs = {
  bill_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort_field?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillingKpisArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBillsArgs = {
  filters?: InputMaybe<BillsFilterInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBroadsheetExcelUrlArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  broadsheet_template_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
  student_status?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBroadsheetPdfUrlArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  broadsheet_template_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
  student_status?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBroadsheetReportArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  broadsheet_template_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
  student_status?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBroadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBroadsheetTemplatesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCbtMonitoringSessionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCbtRecordingDownloadUrlArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCbtRecordingThumbnailUrlArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCertificateAuditLogsArgs = {
  filter: CertificateAuditLogFilterInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCertificateBatchJobArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCertificateBatchJobsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCertificateTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChatMessagesArgs = {
  chat_channel_id: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChatShareCardsArgs = {
  refs: Array<ChatShareRefInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCheckBillDuplicatesArgs = {
  input: CheckBillDuplicatesInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCheckCaApprovalStatusArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  course_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCheckPaymentEnrollmentArgs = {
  bill_detail_ids: Array<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCheckoutGroupPreviewArgs = {
  bill_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCheckoutGroupsArgs = {
  bill_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolAcademicCalendarsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolArchivedStudentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  school_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolBillItemsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolClassroomSectionsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolClassroomsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolConversionOptionsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolProgrammesArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolSessionsAndTermsArgs = {
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolStudentBreakdownArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  school_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolStudentProfileArgs = {
  school_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolStudentsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  school_id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnrollmentStatusEnum>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolTransfersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  school_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryChildSchoolsAttendanceArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryClassroomOfferingsArgs = {
  classroom_id: Scalars['ID']['input'];
  section_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryClassroomStudentAttendanceArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id: Scalars['ID']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCourseStudentAttendanceArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id: Scalars['ID']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCustomFieldTemplatesArgs = {
  entity: CustomFieldEntity;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCustomFieldsArgs = {
  entity: CustomFieldEntity;
  include_inactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDebtorsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  min_outstanding?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  sort_field?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDiscountAssignmentPreviewArgs = {
  input: DiscountAssignmentPreviewInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDiscountCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDiscountRuleImpactArgs = {
  input: DiscountRuleImpactInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadAllCbtTestResultsArgs = {
  cbt_test_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadBulkCbtScoresArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadBulkScoreSheetArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadBulkScoreSheetWithCbtArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadCbtResultArgs = {
  cbt_test_session_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadPublicTranscriptPdfArgs = {
  applicant_email: Scalars['String']['input'];
  tracking_code: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadScoreSheetArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  subject_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadStudentAllSemestersResultArgs = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadStudentCbtReportArgs = {
  cbt_test_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadStudentResultArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadTheoryAnswersArgs = {
  cbt_test_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDownloadTranscriptPdfArgs = {
  category?: InputMaybe<TranscriptTypeCategoryEnum>;
  generated_transcript_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryEntityDiscountsArgs = {
  discount_category_id?: InputMaybe<Scalars['ID']['input']>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryEventStudentAttendanceArgs = {
  attendance_event_id: Scalars['ID']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryExemptionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryExemptionsArgs = {
  bill_id?: InputMaybe<Scalars['ID']['input']>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ExemptionStatusEnum>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryExportFormSubmissionsArgs = {
  filter?: InputMaybe<SubmissionFilterInput>;
  form_id: Scalars['ID']['input'];
  status?: InputMaybe<FormSubmissionStatus>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryExportGraduationRecordsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  created_from?: InputMaybe<Scalars['Date']['input']>;
  created_to?: InputMaybe<Scalars['Date']['input']>;
  graduation_status?: InputMaybe<GraduationStatusEnum>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFeeSplitProfileArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFeeSplitProfilesArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFileExportsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFilesArgs = {
  filter?: InputMaybe<FileFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormFeeBillsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormFeePayersArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormSubmissionsArgs = {
  assigned_to_me?: InputMaybe<Scalars['Boolean']['input']>;
  assignment?: InputMaybe<SubmissionAssignmentFilter>;
  filter?: InputMaybe<SubmissionFilterInput>;
  first?: Scalars['Int']['input'];
  form_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FormSubmissionStatus>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFormWaiverCodesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  form_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<FormWaiverCodeStatus>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGatewaySettlementAccountArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGatewaySettlementAccountsArgs = {
  payment_provider_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGenerateBillingReportArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  report_type: Scalars['String']['input'];
  session_id?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGeneratedCertificateArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGeneratedCertificatesArgs = {
  filter?: InputMaybe<GeneratedCertificateFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGeneratedTranscriptArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCbtTestArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCbtTestSessionResultArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCampusArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCourseArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCourseLecturersInSemesterArgs = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  course_id: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCourseOutstandingExemptionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCourseRegistrationArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCourseRegistrationsForStudentArgs = {
  student_id: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCurriculumArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetCurriculumsGivenProgramLevelAndSemesterArgs = {
  level: Scalars['String']['input'];
  prog_id: Scalars['Int']['input'];
  semester: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetDepartmentArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetFacultyArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetLecturerCoursesInSemesterByAdminArgs = {
  input: LecturerGetCoursesInSemesterInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetLecturerStudentAllocationsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetOfflineSyncDataArgs = {
  academicCalendarId?: InputMaybe<Scalars['ID']['input']>;
  testIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetProgrammeArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetQueryBankArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetQuestionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetRegistrationsForCourseInCurrentCalendarArgs = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  course_id: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetRoleRequestDetailsArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetSchoolSubjectByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetStaffArgs = {
  filter?: InputMaybe<StaffFilter>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetStaffRolesArgs = {
  filter?: InputMaybe<RoleGrantFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetStudentRegistrationApprovalDetailsArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetSubjectEnrollmentsArgs = {
  academicCalendarId?: InputMaybe<Scalars['ID']['input']>;
  classroomId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetTertiaryResultSummarySheetArgs = {
  input: ResultSummarySheetInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetTestResultsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  testId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetUnallocatedStudentsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGraduationRecordArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGraduationRecordsArgs = {
  filter?: InputMaybe<GraduationRecordFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildAnnouncementsArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildAttendanceArgs = {
  academicCalendarId?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildBillArgs = {
  billId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildBillsArgs = {
  academicCalendarId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildCalendarsArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildCourseRegistrationArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildResultsArgs = {
  academicCalendarId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildTimetableArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardianChildTranscriptRequestsArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardiansArgs = {
  classroomId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  facultyId?: InputMaybe<Scalars['ID']['input']>;
  hasStudentLinks?: InputMaybe<Scalars['Boolean']['input']>;
  programmeId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGuardiansByStudentArgs = {
  studentId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryLessonNoteArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryLessonNoteResourcesArgs = {
  lessonNoteId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryLessonNotesArgs = {
  classroomId?: InputMaybe<Scalars['ID']['input']>;
  schemeOfWorkId?: InputMaybe<Scalars['ID']['input']>;
  schemeWeekId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LessonNoteStatus>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCbtTestsArgs = {
  filter?: InputMaybe<CbtTestFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCbtMonitoringSessionsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CbtMonitoringSessionStatusEnum>;
  testId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCourseOutstandingExemptionsArgs = {
  filter?: InputMaybe<CourseOutstandingExemptionFilterInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCourseOutstandingWaiversArgs = {
  filter?: InputMaybe<WaiverFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCurriculumsByProgramArgs = {
  prog_id: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListCurriculumsByProgramAndLevelArgs = {
  level: Scalars['String']['input'];
  prog_id: Scalars['Int']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListManualOutstandingCoursesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListProgrammeModulesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  programme_id: Scalars['ID']['input'];
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListQuestionBanksArgs = {
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListQuestionsArgs = {
  bankId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolCampusesArgs = {
  filter?: InputMaybe<CampusFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolCoursesArgs = {
  filter?: InputMaybe<CourseFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolCurriculumsArgs = {
  filter?: InputMaybe<CurriculumFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolDepartmentsArgs = {
  filter?: InputMaybe<DepartmentFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolFacultiesArgs = {
  filter?: InputMaybe<FacultyFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListSchoolProgrammesArgs = {
  filter?: InputMaybe<ProgrammeFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListStudentCbtTestSessionsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryListStudentCourseRegistrationsByLevelArgs = {
  input?: InputMaybe<CourseRegistrationLevelInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryLookupWaiverCodeArgs = {
  code: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryMatricRetrievalAttemptsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<MatricRetrievalResultEnum>;
  status?: InputMaybe<MatricRetrievalStatusEnum>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryModuleElectiveCandidatesArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  module_id: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryModuleElectiveOfferingsArgs = {
  module_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryModuleRegistrationPaymentsArgs = {
  module_ids: Array<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryMyAttendanceArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryMyNotificationsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  unread_only?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryMySchoolsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPagedSchoolInvitationsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPaymentMethodBreakdownArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPaymentReceiptPdfArgs = {
  payment_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPaymentSplitRecordsArgs = {
  child_school_id?: InputMaybe<Scalars['ID']['input']>;
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPaymentsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  period_basis?: InputMaybe<PaymentPeriodBasis>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PaymentStatusEnum>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPendingCourseRegistrationsForApprovalArgs = {
  filter?: InputMaybe<CourseRegistrationApprovalFilterInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPendingCourseRegistrationsForEndorsementArgs = {
  filter?: InputMaybe<CourseRegistrationApprovalFilterInput>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPermissionAuditLogsArgs = {
  actor_id?: InputMaybe<Scalars['ID']['input']>;
  events?: InputMaybe<Array<PermissionAuditEvent>>;
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  target_user_id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPermissionGroupsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPermissionScopeOptionsArgs = {
  scope_types?: InputMaybe<Array<PermissionScopeTypeEnum>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqExamBodiesArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqExamBodySubjectsArgs = {
  pq_exam_body_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
  type: PqLeaderboardType;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqPracticeQuestionsArgs = {
  pq_practice_session_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqPracticeSessionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqPracticeSessionsArgs = {
  pq_question_bank_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PqPracticeSessionStatus>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqQuestionBankArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqQuestionBanksArgs = {
  first?: Scalars['Int']['input'];
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pq_exam_body_id?: InputMaybe<Scalars['ID']['input']>;
  pq_subject_id?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqQuestionsByTopicArgs = {
  pq_exam_body_id?: InputMaybe<Scalars['ID']['input']>;
  pq_topic_id: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqSchoolSyncsArgs = {
  school_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqSubjectTopicsArgs = {
  pq_subject_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqSubjectsArgs = {
  category?: InputMaybe<PqSubjectCategory>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqTopicArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqTopicSummaryArgs = {
  pq_exam_body_id?: InputMaybe<Scalars['ID']['input']>;
  pq_topic_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPqTopicsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  pq_subject_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPreviewBulkCbtScoresArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPreviewBulkScoreSheetArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPromotionEligibilityReportArgs = {
  from_academic_calendar_id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicFormArgs = {
  slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicPaymentProviderArgs = {
  form_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicPaymentProvidersArgs = {
  form_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicProgrammesArgs = {
  school_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicTranscriptPaymentProviderArgs = {
  school_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPublicTranscriptTypesArgs = {
  school_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryReferenceRequestArgs = {
  token: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRefundArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRefundsArgs = {
  payment_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RefundStatusEnum>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryReportDefinitionArgs = {
  key: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryReportStudentOptionsArgs = {
  key: Scalars['String']['input'];
  search: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryResolveSchoolArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryResultAmendmentHistoryArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryResultTemplatesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRetrieveMatricNoArgs = {
  input: RetrieveMatricNoInput;
  school_slug: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRevenueByMonthArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRoomsArgs = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  only_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRunReportArgs = {
  filters?: InputMaybe<Array<ReportFilterValueInput>>;
  key: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySaasInvoicesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchemeOfWorkArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchemeOfWorkForContextArgs = {
  classroomId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
  termStructureId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchemesOfWorkArgs = {
  classroomId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  termStructureId?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchoolAnnouncementsArgs = {
  include_inactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchoolAssessmentTypesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  include_reusable?: InputMaybe<Scalars['Boolean']['input']>;
  is_ca?: InputMaybe<Scalars['Boolean']['input']>;
  is_exam?: InputMaybe<Scalars['Boolean']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySchoolCourseRegistrationArgs = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CourseRegistrationFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySearchCampusByNameArgs = {
  name: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySearchModuleElectiveCoursesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  module_id: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySearchSchoolCoursesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySessionArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySessionStructureArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySettlementAccountsArgs = {
  provider_name?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySplitSummaryArgs = {
  child_school_id?: InputMaybe<Scalars['ID']['input']>;
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStaffArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentAllSemesterResultsArgs = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentAttendanceArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentBillsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BillStatusEnum>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentDataRequestArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentDataRequestAudienceCountArgs = {
  audience: StudentDataRequestAudienceInput;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentDataRequestRecipientsArgs = {
  filter?: InputMaybe<StudentDataRequestRecipientFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  request_id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentDataRequestsArgs = {
  status?: InputMaybe<StudentDataRequestStatus>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentDisablementHistoryArgs = {
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentEnrolledProgrammesArgs = {
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentFinancialSummaryArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentFinancialsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentFormsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentImportArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentImportsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentLedgerArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentRegisteredCalendarsArgs = {
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentResultArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentSubjectsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentWalletArgs = {
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryStudentsArgs = {
  filter?: InputMaybe<StudentFilter>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySubjectArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySubjectOfferingsArgs = {
  subjectId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySubjectTeachersArgs = {
  subjectId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySuggestPaymentAllocationArgs = {
  amount: Scalars['Float']['input'];
  student_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySummaryExcelUrlArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  calculation_method?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id: Scalars['ID']['input'];
  retake_method?: InputMaybe<Scalars['String']['input']>;
  summary_template_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySummaryPdfUrlArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  calculation_method?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id: Scalars['ID']['input'];
  retake_method?: InputMaybe<Scalars['String']['input']>;
  summary_template_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySummaryReportArgs = {
  academic_calendar_id: Scalars['ID']['input'];
  calculation_method?: InputMaybe<Scalars['String']['input']>;
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  retake_method?: InputMaybe<Scalars['String']['input']>;
  student_status?: InputMaybe<Scalars['String']['input']>;
  summary_template_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QuerySummaryTemplatesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTermStructureArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTermStructuresForStructureArgs = {
  session_structure_id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTicketsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<TicketPriority>;
  status?: InputMaybe<TicketStatus>;
  ticket_category_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTimetableArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTimetableTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTimetablesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  timeable_id?: InputMaybe<Scalars['ID']['input']>;
  timeable_type?: InputMaybe<TimetableTimeableType>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTranscriptRequestArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTranscriptRequestStatusArgs = {
  tracking_code: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTranscriptRequestsArgs = {
  filter?: InputMaybe<TranscriptRequestFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTranscriptTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUnfloatedCoursesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUsersArgs = {
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  school_id?: InputMaybe<Scalars['ID']['input']>;
  school_permission_group_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUsersWithCourseLecturersArgs = {
  filter?: InputMaybe<LecturerCourseFilterInput>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryVerifyCertificateArgs = {
  verification_code: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryWaiverCodeStatsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  form_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryWaiverCodesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  batch_label?: InputMaybe<Scalars['String']['input']>;
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  form_id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paid_after_waiver?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FormWaiverCodeStatus>;
  without_campus?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryWhatsappConversationArgs = {
  guardianId: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryWhatsappMessagesArgs = {
  direction?: InputMaybe<WhatsappDirection>;
  first?: Scalars['Int']['input'];
  guardianId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Question = {
  correct_answer_guidelines?: Maybe<Scalars['String']['output']>;
  correct_answer_prose?: Maybe<Scalars['Mixed']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Array<File>;
  marks: Scalars['Int']['output'];
  options: Array<QuestionOption>;
  question: Scalars['String']['output'];
  questionBank: QuestionBank;
  question_type: QuestionTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionAnswer = {
  identifier: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type QuestionBank = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: Array<Question>;
  school: School;
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of QuestionBank items. */
export type QuestionBankPaginator = {
  /** A list of QuestionBank items. */
  data: Array<QuestionBank>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type QuestionInput = {
  correct_answer_guidelines?: InputMaybe<Scalars['String']['input']>;
  correct_answer_prose?: InputMaybe<Scalars['Mixed']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marks?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<CreateQuestionOptionInput>>;
  question: Scalars['String']['input'];
  question_type: QuestionTypeEnum;
};

export type QuestionOption = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Array<File>;
  is_correct: Scalars['Boolean']['output'];
  option: Scalars['String']['output'];
  question: Question;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionPreview = {
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  blanks_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  has_images?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<PreviewOption>>>;
  questionImages?: Maybe<Array<File>>;
  questionText: Scalars['String']['output'];
  question_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  validation?: Maybe<QuestionValidation>;
};

export enum QuestionTypeEnum {
  FillInTheBlanks = 'FILL_IN_THE_BLANKS',
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Theory = 'THEORY',
  TrueFalse = 'TRUE_FALSE'
}

export type QuestionValidation = {
  expected_answers: Scalars['Int']['output'];
  has_sufficient_answers: Scalars['Boolean']['output'];
  provided_answers: Scalars['Int']['output'];
};

/** Entities that can be associated with questions or assessments. */
export type Questionable = Classroom | ClassroomSection | Course | Student | Subject;

export type QuestionableInput = {
  ids: Array<Scalars['ID']['input']>;
  type: QuestionableTypeEnum;
};

export enum QuestionableTypeEnum {
  Classroom = 'Classroom',
  ClassroomSection = 'ClassroomSection',
  Course = 'Course',
  CustomForm = 'CustomForm',
  Student = 'Student',
  Subject = 'Subject'
}

export type RecordCbtMonitoringEventInput = {
  event_type: CbtMonitoringEventTypeEnum;
  monitoring_session_id: Scalars['ID']['input'];
  occurred_at?: InputMaybe<Scalars['DateTime']['input']>;
  payload?: InputMaybe<Scalars['Mixed']['input']>;
  severity?: InputMaybe<CbtMonitoringEventSeverityEnum>;
};

export type RecordPaymentInput = {
  allocations: Array<PaymentAllocationInput>;
  amount: Scalars['Float']['input'];
  /** When true, any amount beyond the allocations is credited to the student's wallet. */
  credit_overpayment?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_date: Scalars['DateTime']['input'];
  payment_method: Scalars['String']['input'];
  student_id: Scalars['ID']['input'];
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
};

/** A referee answer rendered against the template — the only sanctioned reading of response_data. */
export type ReferenceAnswer = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Validated in ReferenceRequestService: strictly at submission, leniently on draft saves (half-typed rows are skipped, not rejected). */
export type ReferenceNominationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  requirement_key: Scalars['String']['input'];
};

export type ReferenceProgress = {
  complete: Scalars['Boolean']['output'];
  requirements: Array<ReferenceRequirementProgress>;
  total_received: Scalars['Int']['output'];
  total_required: Scalars['Int']['output'];
};

/** Admin/reviewer view of one reference request. */
export type ReferenceRequestRecord = {
  /** Referee answers (label → value). Empty until submitted. */
  answers: Array<ReferenceAnswer>;
  created_at: Scalars['DateTime']['output'];
  declined_reason?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invited_at?: Maybe<Scalars['DateTime']['output']>;
  last_reminded_at?: Maybe<Scalars['DateTime']['output']>;
  /** Short-lived signed URL to this reference as a PDF (reviewers with forms.review only). Null until submitted. */
  pdf_url?: Maybe<Scalars['String']['output']>;
  referee_email: Scalars['String']['output'];
  referee_name: Scalars['String']['output'];
  referee_phone?: Maybe<Scalars['String']['output']>;
  referee_relationship?: Maybe<Scalars['String']['output']>;
  reminder_count: Scalars['Int']['output'];
  requirement_key: Scalars['String']['output'];
  status: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferenceRequirementProgress = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  received: Scalars['Int']['output'];
  required: Scalars['Int']['output'];
};

export type Refund = {
  amount: Scalars['Float']['output'];
  approvedBy?: Maybe<User>;
  approved_by?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  payment_id: Scalars['ID']['output'];
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  processor_reference?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  refund_method?: Maybe<Scalars['String']['output']>;
  requestedBy: User;
  requested_by: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  status: RefundStatusEnum;
  updated_at: Scalars['DateTime']['output'];
};

export enum RefundDestinationEnum {
  Cash = 'CASH',
  Wallet = 'WALLET'
}

export enum RefundStatusEnum {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED'
}

export type RefundsReport = {
  record_count: Scalars['Int']['output'];
  records: Array<RefundsReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: RefundsReportSummary;
  type: Scalars['String']['output'];
};

export type RefundsReportRecord = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  processed_at?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  refund_method?: Maybe<Scalars['String']['output']>;
  requested_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  student_name: Scalars['String']['output'];
};

export type RefundsReportSummary = {
  by_status: Array<StatusBreakdownEntry>;
  pending_count: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_refunded: Scalars['Float']['output'];
};

export type RegisterGuardianInput = {
  email: Scalars['String']['input'];
  linking_code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  relationship_type: GuardianRelationshipType;
};

export type RegisterPushSubscriptionInput = {
  auth_token?: InputMaybe<Scalars['String']['input']>;
  content_encoding?: InputMaybe<Scalars['String']['input']>;
  endpoint: Scalars['String']['input'];
  public_key?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationUpdateFieldsInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  academic_session?: InputMaybe<Scalars['String']['input']>;
  approval_status?: InputMaybe<Scalars['String']['input']>;
  authorization_status?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['Int']['input']>;
  registration_level?: InputMaybe<Scalars['String']['input']>;
  semester?: InputMaybe<Scalars['Int']['input']>;
  senate_approval_status?: InputMaybe<Scalars['String']['input']>;
};

export type ReissueCertificateInput = {
  corrections?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RejectRoleInput = {
  ids: Array<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
};

export type RejectStudentRegistrationInput = {
  academic_calendar_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  student_id: Scalars['ID']['input'];
};

export type ReliefGrantedReport = {
  record_count: Scalars['Int']['output'];
  records: Array<ReliefGrantedReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: ReliefGrantedReportSummary;
  type: Scalars['String']['output'];
};

export type ReliefGrantedReportRecord = {
  billable_name: Scalars['String']['output'];
  billable_type: Scalars['String']['output'];
  /** Readable kind of record the bill was raised on (Student, Class, Application fee…), for display. */
  billable_type_label: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  total_billed: Scalars['Float']['output'];
  total_discounted: Scalars['Float']['output'];
  total_exempted: Scalars['Float']['output'];
  total_relief: Scalars['Float']['output'];
};

export type ReliefGrantedReportSummary = {
  bill_count: Scalars['Int']['output'];
  total_discounted: Scalars['Float']['output'];
  total_exempted: Scalars['Float']['output'];
  total_relief: Scalars['Float']['output'];
};

export type RemitaConfig = PaymentProviderConfig & {
  apiKey?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  serviceTypeId: Scalars['String']['output'];
};

export type RemitaConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  serviceTypeId: Scalars['String']['input'];
};

export type RemoveManualOutstandingByScopeInput = {
  course_ids: Array<Scalars['ID']['input']>;
  levels: Array<Scalars['String']['input']>;
  scope_id: Scalars['ID']['input'];
  scope_type: ExemptionScopeType;
};

export type ReplyTicketInput = {
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  scheduled_at?: InputMaybe<Scalars['DateTime']['input']>;
  ticket_id: Scalars['ID']['input'];
};

export type ReportDefinition = {
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['ID']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  is_favorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  report_type: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ReportDefinitionDetail = {
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  filters: Array<ReportFilterDefinition>;
  formats: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportFilterDefinition = {
  default_value?: Maybe<Scalars['String']['output']>;
  help?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<ReportFilterOption>;
  required: Scalars['Boolean']['output'];
  /** select, student (search box backed by reportStudentOptions), date or number. */
  type: Scalars['String']['output'];
};

export type ReportFilterOption = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportFilterValueInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ReportLabelValue = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportRunResult = {
  generated_at: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  notes: Array<Scalars['String']['output']>;
  /** The filters the report ran with, as labels. */
  parameters: Array<ReportLabelValue>;
  sections: Array<ReportSectionResult>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** True when the preview was cut short; the export always has every row. */
  truncated: Scalars['Boolean']['output'];
};

export type ReportSectionColumn = {
  /** left, right or center. */
  align: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ReportSectionResult = {
  columns: Array<ReportSectionColumn>;
  heading?: Maybe<Scalars['String']['output']>;
  /** Display strings in column order. */
  rows: Array<Array<Maybe<Scalars['String']['output']>>>;
  subheading?: Maybe<Scalars['String']['output']>;
  summary: Array<ReportLabelValue>;
  /** Rows in this section before the preview cap. */
  total_rows: Scalars['Int']['output'];
};

/**
 * Reports Center (#645): school-wide reports that preview on screen and export
 * to Excel, PDF or Word through the download manager.
 */
export type ReportSummary = {
  /** Students, Academic, Lecturers, Attendance or Billing. */
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** Export formats: xlsx, pdf, doc. */
  formats: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RequeryPaymentInput = {
  order_id: Scalars['String']['input'];
  processor?: InputMaybe<Scalars['String']['input']>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RequestDemoInput = {
  /** ISO 3166-1 alpha-2 country code. Falls back to the CDN-detected country when omitted. */
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_source?: InputMaybe<DemoCountrySource>;
  email: Scalars['String']['input'];
  institution_name: Scalars['String']['input'];
  institution_type?: InputMaybe<DemoInstitutionType>;
  kind?: InputMaybe<DemoRequestKind>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  student_count?: InputMaybe<DemoStudentCount>;
  /** Honeypot: hidden from people, so any value means a bot. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RequestExemptionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bill_detail_id?: InputMaybe<Scalars['ID']['input']>;
  bill_id?: InputMaybe<Scalars['ID']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: Scalars['String']['input'];
  exemption_type: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type RequestRefundInput = {
  amount: Scalars['Float']['input'];
  /** Where a processed refund sends the money — cash (default) or the student's wallet. */
  destination?: InputMaybe<RefundDestinationEnum>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  refund_method?: InputMaybe<Scalars['String']['input']>;
};

export type RequestRoleInput = {
  ends_at?: InputMaybe<Scalars['Date']['input']>;
  school_permission_group_id: Scalars['ID']['input'];
  scopes?: InputMaybe<Array<ScopeInput>>;
  starts_at?: InputMaybe<Scalars['Date']['input']>;
};

export type ResetPasswordInput = {
  broker?: InputMaybe<PasswordBroker>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResolveSuccessfulPaymentInput = {
  order_id: Scalars['String']['input'];
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

/** One submission answer as a person should read it (FormSubmission.resolved_answers). Fields the applicant skipped are present with an empty display. */
export type ResolvedFormAnswer = {
  /** Option label(s), original filename(s), or the scalar as text; lists are comma-joined. Empty when unanswered. */
  display: Scalars['String']['output'];
  field_label: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
  /** The builder field type (TEXT, SELECT, PROGRAMME_SELECT, FILE, ...). */
  field_type: Scalars['String']['output'];
  /** The stored value, for clients that still need the id. */
  raw?: Maybe<Scalars['JSON']['output']>;
};

export type Response = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * A single audited post-publish score correction (#227), projected from the
 * generic signed audit trail. Immutable: there is no mutation to edit or delete it.
 */
export type ResultAmendment = {
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  /** The staff member who made the correction. */
  actor?: Maybe<User>;
  /** Human-readable assessment name captured at correction time (e.g. CA1). */
  assessment_name?: Maybe<Scalars['String']['output']>;
  /** When the correction was made. */
  created_at: Scalars['DateTime']['output'];
  /** Underlying audit log id. */
  id: Scalars['ID']['output'];
  /** Score after the correction. */
  new_score?: Maybe<Scalars['Float']['output']>;
  /** Score before the correction; null when the score was newly added. */
  old_score?: Maybe<Scalars['Float']['output']>;
  /** Reason supplied for the correction (always present for an amendment). */
  reason: Scalars['String']['output'];
  school_assessment_type_id?: Maybe<Scalars['ID']['output']>;
  student_id?: Maybe<Scalars['ID']['output']>;
  subject_id?: Maybe<Scalars['ID']['output']>;
};

/** How a report-card feedback item is answered (#574 phase 4). */
export enum ResultFeedbackInputType {
  /** A level on the item's rating scale, e.g. 1-5 for a psychomotor trait. */
  Rating = 'RATING',
  /** Free-text comment (the default; every pre-existing item). */
  Text = 'TEXT'
}

export type ResultHeader = {
  is_visible: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum ResultMode {
  Full = 'FULL',
  ProvisionalCa = 'PROVISIONAL_CA'
}

export enum ResultStatus {
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED'
}

export type ResultSummaryHeader = {
  department_name: Scalars['String']['output'];
  faculty_name: Scalars['String']['output'];
  level: Scalars['String']['output'];
  program_name: Scalars['String']['output'];
  semester: Scalars['String']['output'];
  session: Scalars['String']['output'];
};

export type ResultSummarySheetInput = {
  academic_calendar_id: Scalars['Int']['input'];
  cgpa_or_weighted: Scalars['String']['input'];
  level: Scalars['String']['input'];
  programme_id: Scalars['Int']['input'];
  student_status?: InputMaybe<Scalars['String']['input']>;
};

export type ResultSummarySheetReport = {
  header: ResultSummaryHeader;
  students: Array<StudentResultSummary>;
  summary: GradeSummary;
};

export type ResultTemplate = {
  classrooms: Array<Classroom>;
  code?: Maybe<Scalars['String']['output']>;
  columns: Array<ResultTemplateColumn>;
  created_at: Scalars['DateTime']['output'];
  /** Programmes using this template as their default for every semester without an explicit assignment (tertiary). */
  default_for_programmes: Array<ProgrammeType>;
  feedbacks: Array<ResultTemplateFeedback>;
  grade_group?: Maybe<GradeGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  programmes: Array<ProgrammeType>;
  properties?: Maybe<Scalars['Mixed']['output']>;
  school: School;
  style_code?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};


export type ResultTemplateClassroomsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
};


export type ResultTemplateProgrammesArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ResultTemplateColumn = {
  calculation_arguments?: Maybe<Scalars['Mixed']['output']>;
  calculation_function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_visible: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  result_template: ResultTemplate;
  school_assessment_type?: Maybe<SchoolAssessmentType>;
  sequence: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ResultTemplateFeedback = {
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input_type: ResultFeedbackInputType;
  label: Scalars['String']['output'];
  /** Labels the school set per level, lowest first; null means the defaults. */
  rating_labels?: Maybe<Array<Scalars['String']['output']>>;
  /** Highest level of the scale (2-10) for a RATING item; null for TEXT. */
  rating_max?: Maybe<Scalars['Int']['output']>;
  /** Effective label per level, lowest first (school labels, else defaults); empty for TEXT. */
  rating_scale_labels: Array<Scalars['String']['output']>;
  result_template: ResultTemplate;
  sequence: Scalars['Int']['output'];
};

/** A paginated list of ResultTemplate items. */
export type ResultTemplatePaginator = {
  /** A list of ResultTemplate items. */
  data: Array<ResultTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RetrieveMatricNoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  other_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programme_id: Scalars['ID']['input'];
  surname: Scalars['String']['input'];
  year_of_graduation?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueByMonth = {
  count: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type RevenueReport = {
  record_count: Scalars['Int']['output'];
  records: Array<RevenueReportRecord>;
  records_truncated: Scalars['Boolean']['output'];
  summary: RevenueReportSummary;
  type: Scalars['String']['output'];
};

export type RevenueReportRecord = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  payment_date: Scalars['String']['output'];
  payment_method: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  student_name: Scalars['String']['output'];
};

export type RevenueReportSummary = {
  by_method: Array<MethodBreakdownEntry>;
  total_amount: Scalars['Float']['output'];
  total_count: Scalars['Int']['output'];
};

export type RevokeStaffFromChildSchoolsInput = {
  school_ids: Array<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type RevokeStaffResult = {
  message: Scalars['String']['output'];
  revoked_count: Scalars['Int']['output'];
  skipped_schools: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RoleGrantFilterInput = {
  category?: InputMaybe<StaffRoleCategoryEnum>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  school_permission_group_id?: InputMaybe<Scalars['ID']['input']>;
  scope_id?: InputMaybe<Scalars['ID']['input']>;
  scope_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StaffRoleStatusEnum>;
};

/** A physical room used for scheduling timetable entries (tertiary, #292). */
export type Room = {
  campus_id?: Maybe<Scalars['ID']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type SaasInvoice = {
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  lines: Array<SaasInvoiceLine>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SaasInvoiceLine = {
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  lineType: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};

/** A paginated list of SaasInvoice items. */
export type SaasInvoicePaginator = {
  /** A list of SaasInvoice items. */
  data: Array<SaasInvoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SampleOption = {
  identifier?: Maybe<Scalars['String']['output']>;
  optionText?: Maybe<Scalars['String']['output']>;
};

export type SampleQuestion = {
  questionText?: Maybe<Scalars['String']['output']>;
};

export type SaveStudentResultFeedbackInput = {
  academic_calendar_id: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  /** RATING items only: 1..rating_max, or null to clear. */
  rating?: InputMaybe<Scalars['Int']['input']>;
  result_template_feedback_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
};

export type SchemeOfWork = {
  classroom: Classroom;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  school: School;
  subject: Subject;
  termStructure: TermStructure;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weeks: Array<SchemeWeek>;
};

export type SchemeWeek = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  keyConcepts?: Maybe<Scalars['String']['output']>;
  learningObjectives?: Maybe<Scalars['String']['output']>;
  schemeOfWork: SchemeOfWork;
  suggestedActivities?: Maybe<Scalars['String']['output']>;
  suggestedResources?: Maybe<Scalars['String']['output']>;
  topic: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weekNumber: Scalars['Int']['output'];
};

export type SchemeWeekInput = {
  keyConcepts?: InputMaybe<Scalars['String']['input']>;
  learningObjectives?: InputMaybe<Scalars['String']['input']>;
  suggestedActivities?: InputMaybe<Scalars['String']['input']>;
  suggestedResources?: InputMaybe<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
  weekNumber: Scalars['Int']['input'];
};

export type School = {
  academicCalendars?: Maybe<Array<Maybe<AcademicCalendar>>>;
  address?: Maybe<Scalars['String']['output']>;
  affiliate_logo?: Maybe<Scalars['String']['output']>;
  affiliate_name?: Maybe<Scalars['String']['output']>;
  /** Master switch for the school AI assistant (chat). Default off; set by school admins via updateSchoolAiSettings. */
  aiAssistantEnabled: Scalars['Boolean']['output'];
  /** Whether students may use the AI assistant. Only meaningful while aiAssistantEnabled is on. Default off. */
  aiStudentAccess: Scalars['Boolean']['output'];
  /** AI spend this month/today against the school's cap. School admins only (null for anyone else) and read-only for them — caps are platform-controlled. */
  aiUsage?: Maybe<SchoolAiUsage>;
  attendance_type?: Maybe<Scalars['String']['output']>;
  billItems?: Maybe<Array<Maybe<BillItemTemplate>>>;
  /** Tenant white-label branding (app_name, colours, logo, favicon, login bg, hide-GradeVerse flag). Same values as the public resolveSchool query, for authenticated pages that already know their school. */
  branding?: Maybe<SchoolBranding>;
  childSchools: Array<School>;
  classroomSections?: Maybe<Array<Maybe<ClassroomSection>>>;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  custom_domain?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Fee splitting runs only when a child school AND its parent both enabled it. */
  fee_split_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Public base URL of this school's SPA, no trailing slash: custom domain, else slug subdomain of the platform host, else the platform FRONTEND_URL. Build shareable links from this, not from the browser origin. */
  frontend_url: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  is_child?: Maybe<Scalars['Boolean']['output']>;
  is_parent?: Maybe<Scalars['Boolean']['output']>;
  is_standalone?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentSchool?: Maybe<School>;
  /** Platform-granted entitlement to create/manage child schools. Set only from the platform admin dashboard. */
  parent_features_enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentProviders?: Maybe<Array<Maybe<PaymentProvider>>>;
  school_type?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<Section>>>;
  settings?: Maybe<Scalars['JSON']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** Student portal surface: FULL portal (default) or CBT_ONLY. Set per school by a platform admin. */
  student_portal_mode: StudentPortalMode;
  ticket_auto_response?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/**
 * Where a school stands against its AI assistant spend cap, for the current
 * calendar month and the current day. Amounts are in `currency` — the currency the
 * platform's configured token rates are quoted in.
 *
 * READ ONLY for schools: the caps are set by the GradeVerse platform team (school
 * record in the admin panel, or `php artisan ai:set-spend-cap`), never by the
 * school itself, and there is no mutation that writes them.
 */
export type SchoolAiUsage = {
  /** True when a ceiling is exhausted — the assistant refuses new chats until the window rolls over. */
  capReached: Scalars['Boolean']['output'];
  /** Currency code the amounts below are expressed in, e.g. USD or NGN. */
  currency: Scalars['String']['output'];
  /** Optional ceiling for today. Null means no daily ceiling. */
  dailyCap?: Maybe<Scalars['Float']['output']>;
  /** dailyCap - dailySpend, floored at 0. Null when there is no daily ceiling. */
  dailyRemaining?: Maybe<Scalars['Float']['output']>;
  /** Spent so far today. */
  dailySpend: Scalars['Float']['output'];
  /** Tokens consumed today. */
  dailyTokens: Scalars['Int']['output'];
  /** True when some recorded usage ran on a model with no configured price, so the spend above is a floor rather than the full picture. */
  hasUnpricedUsage: Scalars['Boolean']['output'];
  /** Ceiling for this calendar month. Null means no monthly ceiling. */
  monthlyCap?: Maybe<Scalars['Float']['output']>;
  /** monthlyCap - monthlySpend, floored at 0. Null when there is no ceiling. */
  monthlyRemaining?: Maybe<Scalars['Float']['output']>;
  /** Spent so far this calendar month. */
  monthlySpend: Scalars['Float']['output'];
  /** Tokens consumed this calendar month (input + output + thinking). */
  monthlyTokens: Scalars['Int']['output'];
  /** End of the current monthly window. */
  periodEnd: Scalars['DateTime']['output'];
  /** Start of the current monthly window. */
  periodStart: Scalars['DateTime']['output'];
};

export type SchoolAnnouncement = {
  /** When the signed-in student acknowledged it. Null = not acknowledged. */
  acknowledged_at?: Maybe<Scalars['DateTime']['output']>;
  /** How many have acknowledged it. Only meaningful when requires_acknowledgement. */
  acknowledged_count: Scalars['Int']['output'];
  /** Human-readable audience, e.g. "All students" or "JSS 2, JSS 3 Gold". */
  audience_label: Scalars['String']['output'];
  audience_type: SchoolAnnouncementAudienceType;
  audiences: Array<SchoolAnnouncementAudience>;
  body: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  /** Pinned notices sort above the rest on the board. */
  pinned: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the signed-in student opened this notice. Null = unread. */
  read_at?: Maybe<Scalars['DateTime']['output']>;
  /** How many have opened it. */
  read_count: Scalars['Int']['output'];
  /** How many students this notice currently addresses. */
  recipient_count: Scalars['Int']['output'];
  /** When true the student portal blocks until this notice is acknowledged. */
  requires_acknowledgement: Scalars['Boolean']['output'];
  severity: SchoolAnnouncementSeverity;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type SchoolAnnouncementAudience = {
  audience_id: Scalars['ID']['output'];
  /** classroom (a whole level) or section (one arm). */
  audience_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The level's or arm's display name. */
  name?: Maybe<Scalars['String']['output']>;
};

export type SchoolAnnouncementAudienceInput = {
  audience_id: Scalars['ID']['input'];
  /** classroom or section. */
  audience_type: Scalars['String']['input'];
};

export enum SchoolAnnouncementAudienceType {
  /** Every student in the school. */
  AllStudents = 'ALL_STUDENTS',
  /** Named class levels — every arm of each. */
  Classrooms = 'CLASSROOMS',
  /** Named class arms only. */
  Sections = 'SECTIONS'
}

export enum SchoolAnnouncementSeverity {
  Important = 'IMPORTANT',
  Info = 'INFO',
  Urgent = 'URGENT'
}

export type SchoolAssessmentType = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  cbt_id?: Maybe<Scalars['ID']['output']>;
  classroom?: Maybe<Classroom>;
  classroom_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_ca: Scalars['Boolean']['output'];
  is_exam: Scalars['Boolean']['output'];
  max_score: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  school?: Maybe<School>;
  school_id: Scalars['ID']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  studentScores?: Maybe<Array<Maybe<StudentScore>>>;
  subject?: Maybe<Subject>;
  subject_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SchoolBranding = {
  accent_color?: Maybe<Scalars['String']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  favicon_url?: Maybe<Scalars['String']['output']>;
  /** Public base URL of the school's SPA (see School.frontend_url). */
  frontend_url?: Maybe<Scalars['String']['output']>;
  hide_gradeverse_branding?: Maybe<Scalars['Boolean']['output']>;
  login_bg_url?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  school_name: Scalars['String']['output'];
};

export type SchoolGradeInput = {
  grade?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Scalars['Float']['input']>;
};

export type SchoolInvitation = {
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissionGroup?: Maybe<PermissionGroup>;
  school: School;
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of SchoolInvitation items. */
export type SchoolInvitationPaginator = {
  /** A list of SchoolInvitation items. */
  data: Array<SchoolInvitation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of School items. */
export type SchoolPaginator = {
  /** A list of School items. */
  data: Array<School>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SchoolWideEligibilityCheckResult = {
  eligible_count: Scalars['Int']['output'];
  not_eligible_count: Scalars['Int']['output'];
  programmes_checked: Scalars['Int']['output'];
  total_checked: Scalars['Int']['output'];
};

export type ScopeInput = {
  scope_type: PermissionScopeTypeEnum;
  scope_value?: InputMaybe<Scalars['String']['input']>;
};

export type ScoreImportResult = {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** Null only when the import engine did not run at all. */
  summary?: Maybe<ScoreImportSummary>;
};

/** One problem row from a score sheet import/preview, in user-readable terms. */
export type ScoreImportRowIssue = {
  reason: Scalars['String']['output'];
  /** 1-based spreadsheet row number (data starts at row 4). */
  row: Scalars['Int']['output'];
  /** Matric number, else the sheet's Student Name, else the hidden Student ID cell, when the row carried one. */
  student_ref?: Maybe<Scalars['String']['output']>;
};

export type ScoreImportSummary = {
  dry_run: Scalars['Boolean']['output'];
  /** Per-row detail for everything skipped/ignored (capped at 100 rows). */
  issues: Array<ScoreImportRowIssue>;
  missing_student_id: Scalars['Int']['output'];
  non_numeric: Scalars['Int']['output'];
  /** Score cells skipped because they are below zero or above the assessment's max_score. */
  out_of_range: Scalars['Int']['output'];
  /** Data rows found in the sheet. */
  rows: Scalars['Int']['output'];
  /** Score cells imported (or, for a dry run, that WOULD be imported). */
  saved: Scalars['Int']['output'];
  /** Distinct students those cells belong to. */
  students: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
};

export type ScoreInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  school_assessment_type_id: Scalars['Int']['input'];
  score: Scalars['Float']['input'];
};

export type ScoreResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  school_assessment_type_id: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type Section = {
  classroom_section?: Maybe<ClassroomSection>;
  classrooms?: Maybe<Array<Classroom>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of the section. */
  name: Scalars['String']['output'];
  school_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SemesterResult = {
  academic_calendar: AcademicCalendar;
  cumulative_cgpa?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Mixed']['output']>;
  gpa?: Maybe<Scalars['Float']['output']>;
  headers: Array<ResultHeader>;
  programme?: Maybe<ProgrammeType>;
  status: ResultStatus;
  summary?: Maybe<Scalars['Mixed']['output']>;
  template?: Maybe<ResultTemplate>;
};

export type SendChatMessageInput = {
  body: Scalars['String']['input'];
  chat_channel_id: Scalars['ID']['input'];
  mention_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  shared_refs?: InputMaybe<Array<ChatShareRefInput>>;
};

/** Represents a specific school session (e.g., 2024/2025 Session). */
export type Session = {
  academicCalendars?: Maybe<Array<AcademicCalendar>>;
  created_at: Scalars['DateTime']['output'];
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  sessionStructure: SessionStructure;
  session_structure_id: Scalars['ID']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** Represents the structure of a school session (e.g., Semesters, Terms). */
export type SessionStructure = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  sessions?: Maybe<Array<Session>>;
  termsStructure?: Maybe<Array<TermStructure>>;
  updated_at: Scalars['DateTime']['output'];
};

export type Setting = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  nextTermBeginsAt?: Maybe<Scalars['DateTime']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  termId?: Maybe<Scalars['ID']['output']>;
  termName?: Maybe<Scalars['String']['output']>;
  totalSchoolDay?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SettlementAccount = {
  account_name?: Maybe<Scalars['String']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  provider_name: Scalars['String']['output'];
  school_id: Scalars['ID']['output'];
  sub_account_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum SplitModeEnum {
  BaseMarkup = 'BASE_MARKUP',
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type SplitSummary = {
  by_school: Array<SplitSummaryBySchool>;
  record_count: Scalars['Int']['output'];
  total_amount: Scalars['Float']['output'];
  total_campus_amount: Scalars['Float']['output'];
  total_hq_amount: Scalars['Float']['output'];
};

export type SplitSummaryBySchool = {
  campus_amount: Scalars['Float']['output'];
  hq_amount: Scalars['Float']['output'];
  record_count: Scalars['Int']['output'];
  school_id: Scalars['ID']['output'];
  school_name: Scalars['String']['output'];
  total_amount: Scalars['Float']['output'];
};

export type Staff = {
  createdAt: Scalars['DateTime']['output'];
  /** The school's active staff custom fields, in display order, with this staff member's values. */
  customFieldValues: Array<CustomFieldValue>;
  department?: Maybe<DepartmentType>;
  department_id?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  email_verified_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lecturer_courses_in_semester: Array<CourseLecturer>;
  name: Scalars['String']['output'];
  roles: Array<PermissionGrant>;
  school: School;
  status?: Maybe<Scalars['String']['output']>;
  subjects: Array<StaffSubjectGroup>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type StaffFilter = {
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  faculty_id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  /** Only memberships in this status; omit for all. */
  status?: InputMaybe<StaffStatus>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of Staff items. */
export type StaffPaginator = {
  /** A list of Staff items. */
  data: Array<Staff>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum StaffRoleCategoryEnum {
  NonTeaching = 'NON_TEACHING',
  Teaching = 'TEACHING'
}

export enum StaffRoleStatusEnum {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

/** Lifecycle of a staff membership in ONE school. Inactive revokes grants here and blocks this school's context; the same person may stay active elsewhere. */
export enum StaffStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type StaffSubjectGroup = {
  classroomSections: Array<ClassroomSection>;
  subject: Subject;
};

export type Status = {
  message: Scalars['String']['output'];
};

export type StatusBreakdownEntry = {
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type Student = Billable & {
  academicCalendars?: Maybe<Array<Maybe<AcademicCalendar>>>;
  /** The admission application this student was converted from, if any. The system link is always recorded on conversion (converted_student_id), independent of whether the school collects a registration number. */
  admissionSubmission?: Maybe<FormSubmission>;
  /** City of the residential address. */
  city?: Maybe<Scalars['String']['output']>;
  currentClassroomSection?: Maybe<ClassroomSection>;
  /** The school's active student custom fields, in display order, with this student's values. */
  customFieldValues: Array<CustomFieldValue>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  /** Where the student currently lives (residential address). */
  home_address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  lastAcademicRecord?: Maybe<StudentAcademicCalendar>;
  /**
   * Local government area of origin.
   * @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key.
   */
  lga?: Maybe<Scalars['String']['output']>;
  /** Guardian linking code. A bearer credential for this student's records, so only users who may create guardians can read it; everyone else sees null. */
  linking_code?: Maybe<Scalars['String']['output']>;
  matric_no: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  openProgrammeModules: Array<ProgrammeModuleType>;
  other_name?: Maybe<Scalars['String']['output']>;
  /**
   * The permanent family home address, which can differ from the residential address.
   * @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key.
   */
  permanent_address?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  school?: Maybe<School>;
  /** State of the residential address. */
  state?: Maybe<Scalars['String']['output']>;
  /**
   * State of origin (Nigeria: one of the 36 states or FCT).
   * @deprecated Moved to the school's custom fields (#574): read customFieldValues. Null when the school has no field with this key.
   */
  state_of_origin?: Maybe<Scalars['String']['output']>;
  studentAcademicCalendar?: Maybe<StudentAcademicCalendar>;
  studentAcademicCalendars: Array<StudentAcademicCalendar>;
  studentActiveCurriculum?: Maybe<Array<Maybe<CurriculumType>>>;
  studentBills: Array<Bill>;
  studentCourseRegistration?: Maybe<Array<Maybe<StudentCourseRegistration>>>;
  studentOutstandingCourses?: Maybe<OutstandingCoursesResult>;
  studentRegistrationForCurrentSemester?: Maybe<StudentCourseRegistration>;
  subjects?: Maybe<Array<Subject>>;
  surname?: Maybe<Scalars['String']['output']>;
  timetable?: Maybe<Timetable>;
  /** When this student chose "Don't show again" on the guided-tour intro (#571); null = still shows once per device. */
  tour_intro_dismissed_at?: Maybe<Scalars['DateTime']['output']>;
};


export type StudentStudentAcademicCalendarArgs = {
  academicCalendarId?: InputMaybe<Scalars['Int']['input']>;
};


export type StudentStudentBillsArgs = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAcademicCalendar = {
  academicCalendar: AcademicCalendar;
  academic_calendar_id: Scalars['ID']['output'];
  classroomSection?: Maybe<ClassroomSection>;
  created_at: Scalars['DateTime']['output'];
  entry_level?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initial_absent_days?: Maybe<Scalars['Int']['output']>;
  initial_late_days?: Maybe<Scalars['Int']['output']>;
  initial_present_days?: Maybe<Scalars['Int']['output']>;
  is_active: Scalars['Boolean']['output'];
  max_units_per_registration?: Maybe<Scalars['Int']['output']>;
  min_graduation_units?: Maybe<Scalars['Int']['output']>;
  min_units_per_registration?: Maybe<Scalars['Int']['output']>;
  programme?: Maybe<ProgrammeType>;
  programme_id: Scalars['ID']['output'];
  session_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  student: Student;
  student_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum StudentAcademicStatusEnum {
  Active = 'ACTIVE',
  Expelled = 'EXPELLED',
  Graduated = 'GRADUATED',
  Rusticated = 'RUSTICATED',
  Transferred = 'TRANSFERRED',
  Withdrew = 'WITHDREW'
}

/**
 * Represents the result of a student access check, indicating whether the
 * authenticated student is currently disabled.
 */
export type StudentAccessCheck = {
  disabled_at?: Maybe<Scalars['DateTime']['output']>;
  is_disabled: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/** Which effect produced a derived per-student adjustment line on an indirect (class/section/programme) bill. */
export enum StudentAdjustmentSourceEnum {
  Discount = 'DISCOUNT',
  Exemption = 'EXEMPTION'
}

export type StudentAllocationResult = {
  allocations: Array<LecturerAllocationSummary>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  total_allocated: Scalars['Int']['output'];
  unallocated_count: Scalars['Int']['output'];
};

export type StudentAnswer = {
  id: Scalars['ID']['output'];
  is_correct: Scalars['Boolean']['output'];
  question: Question;
  school: School;
  selectedOption: QuestionOption;
  testSession: CbtTestSession;
};

export type StudentAnswerInput = {
  question_id: Scalars['ID']['input'];
  selected_option_id: Scalars['ID']['input'];
};

export type StudentAttendance = {
  academicCalendar: AcademicCalendar;
  created_at: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  school: School;
  session: Scalars['String']['output'];
  status: AttendanceStatus;
  student: Student;
  updated_at: Scalars['DateTime']['output'];
};

export type StudentAttendancePeriodSummary = {
  student: Student;
  summary: StudentAttendanceSummary;
};

export type StudentAttendanceResponse = {
  records: Array<StudentAttendance>;
  summary: StudentAttendanceSummary;
};

export type StudentAttendanceSummary = {
  absent: Scalars['Int']['output'];
  excused: Scalars['Int']['output'];
  late: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  present: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/**
 * A DERIVED per-student adjustment line on an INDIRECT bill (derive-on-read:
 * never a bill_discounts row, never voidable — it disappears when its source
 * assignment/exemption is revoked). `label` is display-safe for the student
 * portal; discount_* attribution is set for discount lines, exemption_id for
 * exemption lines.
 */
export type StudentBillAdjustment = {
  amount: Scalars['Float']['output'];
  bill_detail_id: Scalars['ID']['output'];
  discount_category_id?: Maybe<Scalars['ID']['output']>;
  discount_rule_id?: Maybe<Scalars['ID']['output']>;
  discount_type?: Maybe<DiscountTypeEnum>;
  discount_value?: Maybe<Scalars['Float']['output']>;
  exemption_id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  source: StudentAdjustmentSourceEnum;
};

export type StudentCourseRegistration = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id: Scalars['ID']['output'];
  academic_session: Scalars['String']['output'];
  approval_status?: Maybe<Scalars['String']['output']>;
  authorization_status: Scalars['String']['output'];
  coursesRegistered: Array<CourseRegistered>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  programme?: Maybe<ProgrammeType>;
  programme_id: Scalars['ID']['output'];
  registration_level: Scalars['String']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  school_id: Scalars['ID']['output'];
  semester: Scalars['Int']['output'];
  senate_approval_status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A paginated list of StudentCourseRegistration items. */
export type StudentCourseRegistrationPaginator = {
  /** A list of StudentCourseRegistration items. */
  data: Array<StudentCourseRegistration>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type StudentDataRequest = {
  audience: StudentDataRequestAudience;
  /** Students who have not answered see a prompt over the portal until they do. */
  blocks_portal: Scalars['Boolean']['output'];
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  completed_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by_name?: Maybe<Scalars['String']['output']>;
  due_on: Scalars['Date']['output'];
  fields: Array<StudentDataRequestField>;
  id: Scalars['ID']['output'];
  /** Students who join the audience while the request is open are added to it. */
  include_late_joiners: Scalars['Boolean']['output'];
  /** Past its due date and still open. */
  is_overdue: Scalars['Boolean']['output'];
  /** Closing the request makes the answers read-only for students. */
  lock_on_close: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** Every student the request reached (not limited to the viewer's scope). */
  recipients_count: Scalars['Int']['output'];
  status: StudentDataRequestStatus;
  title: Scalars['String']['output'];
  /** The viewer may edit, close and reopen it: they sent it, or may update every student. */
  viewer_can_manage: Scalars['Boolean']['output'];
};

export type StudentDataRequestAudience = {
  all_students: Scalars['Boolean']['output'];
  classroom_ids: Array<Scalars['ID']['output']>;
  /** Who it went to, for a person: "All students", "JSS 1, JSS 2 A", ... */
  label: Scalars['String']['output'];
  programme_ids: Array<Scalars['ID']['output']>;
  section_ids: Array<Scalars['ID']['output']>;
  student_ids: Array<Scalars['ID']['output']>;
};

export type StudentDataRequestAudienceInput = {
  all_students?: InputMaybe<Scalars['Boolean']['input']>;
  /** Class levels: every arm of each. */
  classroom_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  programme_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Single class arms. */
  section_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Students picked by name, on top of the classes and programmes. */
  student_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** One field a request asks for, as it was when the request was sent. */
export type StudentDataRequestField = {
  /** A StudentProfileField key: "custom:<key>" or a built-in column. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

/** A field a data request may ask for: one students of this school may fill in. */
export type StudentDataRequestFieldChoice = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type StudentDataRequestFieldInput = {
  key: Scalars['String']['input'];
  /** Defaults to true. At least one field must be required. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentDataRequestRecipient = {
  class_name?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  last_reminded_at?: Maybe<Scalars['DateTime']['output']>;
  matric_no?: Maybe<Scalars['String']['output']>;
  /** Labels of the required fields the student has not filled in. */
  missing: Array<Scalars['String']['output']>;
  reminder_count: Scalars['Int']['output'];
  student_id: Scalars['ID']['output'];
  student_name: Scalars['String']['output'];
};

export enum StudentDataRequestRecipientFilter {
  All = 'ALL',
  Completed = 'COMPLETED',
  /** Has not filled in every required field yet. */
  Pending = 'PENDING'
}

export type StudentDataRequestRecipientPaginator = {
  data: Array<StudentDataRequestRecipient>;
  paginatorInfo: PaginatorInfo;
};

export enum StudentDataRequestStatus {
  /** No longer collecting answers; locked when the request says so. */
  Closed = 'CLOSED',
  /** Students can answer. */
  Open = 'OPEN'
}

/**
 * Represents a student disablement record, tracking when and why a student was
 * disabled or re-enabled within the school.
 */
export type StudentDisablement = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  disabledByUser?: Maybe<User>;
  disabled_at: Scalars['DateTime']['output'];
  disabled_by?: Maybe<Scalars['ID']['output']>;
  disabled_reason: Scalars['String']['output'];
  enabledByUser?: Maybe<User>;
  enabled_at?: Maybe<Scalars['DateTime']['output']>;
  enabled_by?: Maybe<Scalars['ID']['output']>;
  enabled_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_current: Scalars['Boolean']['output'];
  school_id: Scalars['ID']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A student fact a generated document can print: a built-in profile field or custom:<key> for a school custom field (#574). */
export type StudentDocumentField = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type StudentFilter = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  classroom_section_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Only students whose custom field values match every entry (#574). Text
   * fields match a case-insensitive substring; other types an exact value.
   * Custom values are filterable here but are not part of free-text search.
   */
  custom_fields?: InputMaybe<Array<CustomFieldFilterInput>>;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  faculty_id?: InputMaybe<Scalars['ID']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  /**
   * Case-insensitive exact match on the local government area of origin.
   * @deprecated Moved to the school's custom fields (#574): filters on the custom field with this key when the school has one, ignored otherwise. Use custom_fields.
   */
  lga?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive exact match on nationality. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Case-insensitive exact match on the student's state of origin.
   * @deprecated Moved to the school's custom fields (#574): filters on the custom field with this key when the school has one, ignored otherwise. Use custom_fields.
   */
  state_of_origin?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnrollmentStatusEnum>;
};

export type StudentFinancial = {
  last_payment_at?: Maybe<Scalars['DateTime']['output']>;
  outstanding_balance: Scalars['Float']['output'];
  standing: StudentFinancialStanding;
  student: Student;
  /**
   * Sum of the student's bill net_amounts. Direct bills' net is ALREADY
   * reduced by their discount/exemption ledger rows; only DERIVED class-bill
   * relief still has to be subtracted. So the identity
   * total_billed - derived relief - total_paid = outstanding_balance holds,
   * where derived relief is the class-bill share of total_discounted /
   * total_exempted — those two fields also count direct-bill ledger relief as
   * a reporting dimension, so subtracting them wholesale over-subtracts for
   * students with direct-bill discounts. NB BillingKpis.total_billed is net of
   * ALL relief — a bill-level figure there, a student statement here.
   */
  total_billed: Scalars['Float']['output'];
  /** All discount relief: direct-bill ledger rows (already inside net billed) + derived class-bill effects (not yet subtracted). */
  total_discounted: Scalars['Float']['output'];
  /** All exemption relief, same two components as total_discounted. */
  total_exempted: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
  wallet_balance: Scalars['Float']['output'];
};

export type StudentFinancialPaginated = {
  data: Array<StudentFinancial>;
  page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum StudentFinancialStanding {
  InCredit = 'IN_CREDIT',
  NotBilled = 'NOT_BILLED',
  Owing = 'OWING',
  Settled = 'SETTLED'
}

export type StudentFinancialSummary = {
  bill_count: Scalars['Int']['output'];
  paid_bill_count: Scalars['Int']['output'];
  total_billed: Scalars['Float']['output'];
  /** Reporting dimension: direct rule/manual discount rows + derived class-bill discount effects. */
  total_discounted: Scalars['Float']['output'];
  total_exempted: Scalars['Float']['output'];
  total_outstanding: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
  total_refunded: Scalars['Float']['output'];
  wallet_balance: Scalars['Float']['output'];
};

export type StudentImport = {
  academic_calendar_id: Scalars['ID']['output'];
  campus_id?: Maybe<Scalars['ID']['output']>;
  classroom_section_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  failed_rows: Scalars['Int']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  programme_id?: Maybe<Scalars['ID']['output']>;
  progress: Scalars['Int']['output'];
  school_id: Scalars['ID']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  successful_rows: Scalars['Int']['output'];
  total_rows: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id: Scalars['ID']['output'];
  user_type: Scalars['String']['output'];
};

/** A paginated list of StudentImport items. */
export type StudentImportPaginator = {
  /** A list of StudentImport items. */
  data: Array<StudentImport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type StudentImportRecordInput = {
  /** City of the residential address. */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * Student custom field values keyed by field key, e.g.
   * {"blood_group": "O+", "has_allergies": "yes"}. Each value is validated
   * like the profile form; a bad value fails the row with an error keyed
   * custom_fields.<key>. Required custom fields are not enforced on import.
   */
  custom_fields?: InputMaybe<Scalars['JSON']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Where the student currently lives. */
  home_address?: InputMaybe<Scalars['String']['input']>;
  /**
   * Local government area of origin.
   * @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues.
   */
  lga?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  other_name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Permanent family home address.
   * @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues.
   */
  permanent_address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** State of the residential address. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  state_of_origin?: InputMaybe<Scalars['String']['input']>;
  /**
   * Subject names (secondary) or course codes/titles (tertiary) the student
   * should be enrolled in. Unknown values are silently skipped.
   */
  subjects?: InputMaybe<Array<Scalars['String']['input']>>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type StudentInfo = {
  department?: Maybe<Scalars['String']['output']>;
  faculty?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  matric_number?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programme?: Maybe<Scalars['String']['output']>;
};

export type StudentLedgerResult = {
  entries: Array<LedgerEntry>;
  page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StudentLinkingCodeExportRow = {
  className?: Maybe<Scalars['String']['output']>;
  linkingCode: Scalars['String']['output'];
  matricNo?: Maybe<Scalars['String']['output']>;
  programmeName?: Maybe<Scalars['String']['output']>;
  studentName: Scalars['String']['output'];
};

/** A paginated list of Student items. */
export type StudentPaginator = {
  /** A list of Student items. */
  data: Array<Student>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Outcome of resetting one student inside a bulk password reset. */
export type StudentPasswordResetResult = {
  message: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  /** Full name of the student, null when the id did not resolve to a student. */
  student_name?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentPerformanceSummary = {
  average_score: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  subjects_count: Scalars['Int']['output'];
  total_possible: Scalars['Float']['output'];
  total_score: Scalars['Float']['output'];
  total_scores: Scalars['Int']['output'];
};

/** Which surface the student portal exposes for a school. CBT_ONLY collapses it to just CBT/exams. */
export enum StudentPortalMode {
  CbtOnly = 'CBT_ONLY',
  Full = 'FULL'
}

/** One field on the student's own profile form, with their value. */
export type StudentProfileField = {
  /** Key of the field this one follows, in the same "custom:<key>" form. */
  depends_on?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** False for a field the school shows to students read-only, or locked. */
  editable: Scalars['Boolean']['output'];
  /** The custom field's id; null for a built-in field. */
  field_id?: Maybe<Scalars['ID']['output']>;
  filled_at?: Maybe<Scalars['DateTime']['output']>;
  /** Who last filled in the value (custom fields only). */
  filled_by?: Maybe<CustomFieldValueSource>;
  is_required: Scalars['Boolean']['output'];
  /** "custom:<key>" for a custom field; the column name (home_address, state, city, religion) for a built-in field. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** A closed data request locked the answer; the student asks the school to change it. */
  locked: Scalars['Boolean']['output'];
  /** The longest value accepted, for a built-in text field; null otherwise. */
  max_length?: Maybe<Scalars['Int']['output']>;
  /** Choices for a SELECT with its own list; empty otherwise. */
  options: Array<CustomFieldOption>;
  options_source?: Maybe<CustomFieldOptionsSource>;
  /** An open data request sent to the student asks for this field. */
  requested: Scalars['Boolean']['output'];
  type: CustomFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

/** How a built-in student field is offered to students on their own profile. */
export enum StudentProfileFieldAccess {
  /** Not shown to students. */
  Off = 'OFF',
  /** Students may fill it in. */
  Optional = 'OPTIONAL',
  /** Students may fill it in and are asked to until they do. */
  Required = 'REQUIRED'
}

/** A built-in student field and how the school offers it to students. */
export type StudentProfileFieldSetting = {
  access: StudentProfileFieldAccess;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: CustomFieldType;
  /** How many students have a value in this field, like a custom field's values_count. */
  values_count: Scalars['Int']['output'];
};

export type StudentProfileFieldSettingInput = {
  access: StudentProfileFieldAccess;
  key: Scalars['String']['input'];
};

export type StudentProfileForm = {
  /** Built-in fields first, then custom fields in the school's order. */
  fields: Array<StudentProfileField>;
  /** How many required fields the student can fill in are still empty. */
  missing_required: Scalars['Int']['output'];
};

export type StudentProfileValueInput = {
  /** A StudentProfileField key. */
  key: Scalars['String']['input'];
  /** Blank or null clears the value. CHECKBOX accepts true/false; DATE expects YYYY-MM-DD. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StudentResultFeedback = {
  academic_calendar: AcademicCalendar;
  author?: Maybe<User>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Chosen level for a RATING item (1..rating_max); null for TEXT or when unset. */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Label of the chosen level, e.g. "Very Good". */
  rating_label?: Maybe<Scalars['String']['output']>;
  result_template_feedback: ResultTemplateFeedback;
  student: Student;
  updated_at: Scalars['DateTime']['output'];
};

export type StudentResultSummary = {
  cum_cgpa?: Maybe<Scalars['String']['output']>;
  cum_tcp?: Maybe<Scalars['Float']['output']>;
  cum_tnup?: Maybe<Scalars['Float']['output']>;
  cum_tnur?: Maybe<Scalars['Float']['output']>;
  curr_gpa?: Maybe<Scalars['String']['output']>;
  curr_tcp?: Maybe<Scalars['Float']['output']>;
  curr_tnup?: Maybe<Scalars['Float']['output']>;
  curr_tnur?: Maybe<Scalars['Float']['output']>;
  degree_class?: Maybe<Scalars['String']['output']>;
  failed_compulsory_courses_list?: Maybe<Scalars['String']['output']>;
  matric_number: Scalars['String']['output'];
  names: Scalars['String']['output'];
  prev_cgpa?: Maybe<Scalars['String']['output']>;
  prev_tcp?: Maybe<Scalars['Float']['output']>;
  prev_tnup?: Maybe<Scalars['Float']['output']>;
  prev_tnur?: Maybe<Scalars['Float']['output']>;
  sn: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student_id: Scalars['ID']['output'];
};

export type StudentScore = {
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordedBy?: Maybe<User>;
  recorded_at: Scalars['DateTime']['output'];
  recorded_by_user_id?: Maybe<Scalars['ID']['output']>;
  schoolAssessmentType?: Maybe<SchoolAssessmentType>;
  school_assessment_type_id: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  studentSubjectEnrollment?: Maybe<StudentSubjectEnrollment>;
  student_subject_enrollment_id: Scalars['ID']['output'];
};

export type StudentScoreBulkResult = {
  created_scores?: Maybe<Array<Maybe<StudentScore>>>;
  error_count: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success_count: Scalars['Int']['output'];
};

export type StudentScoreCountResult = {
  count: Scalars['Int']['output'];
};

export type StudentScoreDeleteResult = {
  deleted_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StudentScoreExistsResult = {
  exists: Scalars['Boolean']['output'];
};

export type StudentScoreFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  max_score?: InputMaybe<Scalars['Float']['input']>;
  min_score?: InputMaybe<Scalars['Float']['input']>;
  recorded_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  school_assessment_type_id?: InputMaybe<Scalars['ID']['input']>;
  school_id?: InputMaybe<Scalars['ID']['input']>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
  student_subject_enrollment_id?: InputMaybe<Scalars['ID']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentScoreInput = {
  school_assessment_type_id: Scalars['Int']['input'];
  score: Scalars['Float']['input'];
};

export type StudentScoresInput = {
  scores: Array<StudentScoreInput>;
  student_subject_enrollment_id: Scalars['ID']['input'];
};

export type StudentSubject = {
  approve?: Maybe<Scalars['Boolean']['output']>;
  classroomId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  cumulative?: Maybe<Scalars['Int']['output']>;
  edit?: Maybe<Scalars['Boolean']['output']>;
  exam?: Maybe<Scalars['Int']['output']>;
  gradeAndRemark?: Maybe<GradeAndRemark>;
  id: Scalars['ID']['output'];
  isResultApproved?: Maybe<Scalars['Boolean']['output']>;
  lastTermCumulative?: Maybe<Scalars['Int']['output']>;
  sectionId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
  subject: Subject;
  termId: Scalars['ID']['output'];
  testOne?: Maybe<Scalars['Int']['output']>;
  testThree?: Maybe<Scalars['Int']['output']>;
  testTwo?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StudentSubjectEnrollment = {
  academicCalendar?: Maybe<AcademicCalendar>;
  academic_calendar_id: Scalars['ID']['output'];
  classroomSection?: Maybe<ClassroomSection>;
  enrollment_date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  student?: Maybe<Student>;
  studentScores?: Maybe<Array<Maybe<StudentScore>>>;
  student_id: Scalars['ID']['output'];
  subject?: Maybe<Subject>;
  subject_id: Scalars['ID']['output'];
};

/** A paginated list of StudentSubjectEnrollment items. */
export type StudentSubjectEnrollmentPaginator = {
  /** A list of StudentSubjectEnrollment items. */
  data: Array<StudentSubjectEnrollment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type StudentSubjectEnrollmentResponse = {
  enrolledCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentTheoryAnswerInput = {
  answer: Scalars['Mixed']['input'];
  cbt_test_session_id: Scalars['ID']['input'];
  question_id: Scalars['ID']['input'];
};

export type StudentTransferRecord = {
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  source_matric_no?: Maybe<Scalars['String']['output']>;
  source_school: School;
  status: Scalars['String']['output'];
  student_name: Scalars['String']['output'];
  target_matric_no?: Maybe<Scalars['String']['output']>;
  target_school: School;
  transferred_at: Scalars['DateTime']['output'];
};

export type StudentTransferResult = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  transfer?: Maybe<StudentTransferRecord>;
};

export type StudentTransfersResponse = {
  current_page: Scalars['Int']['output'];
  data: Array<StudentTransferRecord>;
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum StudentUpdateScope {
  AllCalendars = 'ALL_CALENDARS',
  CurrentOnly = 'CURRENT_ONLY'
}

export type StudentWallet = {
  balance: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  currency_code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  student?: Maybe<Student>;
  student_id: Scalars['ID']['output'];
  transactions: Array<WalletTransaction>;
  updated_at: Scalars['DateTime']['output'];
};

export type Subject = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  teachers?: Maybe<Array<Staff>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A rule declaring that a subject is offered to a classroom (optionally a single section). */
export type SubjectOffering = {
  classroom: Classroom;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Null when the offering applies to every section of the classroom. */
  section?: Maybe<Section>;
  status: SubjectOfferingStatus;
  subject: Subject;
  updatedAt: Scalars['DateTime']['output'];
};

export type SubjectOfferingInput = {
  classroom_id: Scalars['ID']['input'];
  /** Omit (or pass null) to offer the subject to ALL sections of the classroom. */
  section_id?: InputMaybe<Scalars['ID']['input']>;
  status: SubjectOfferingStatus;
};

/** Whether a subject is compulsory or optional for the classroom it is offered to. */
export enum SubjectOfferingStatus {
  Compulsory = 'COMPULSORY',
  Optional = 'OPTIONAL'
}

export type SubjectTeacher = {
  classroomSection?: Maybe<ClassroomSection>;
  id: Scalars['ID']['output'];
  staff: Staff;
  subject: Subject;
};

export enum SubmissionActivityType {
  ActionRequired = 'ACTION_REQUIRED',
  Assignment = 'ASSIGNMENT',
  Message = 'MESSAGE',
  Note = 'NOTE',
  StatusChange = 'STATUS_CHANGE'
}

/** One condition on an applicant's answer. Picker questions (programme, class, data-source lists) match the option's label. */
export type SubmissionAnswerFilterInput = {
  /** The question's label as shown on the form, or its field name. */
  field: Scalars['String']['input'];
  op: SubmissionAnswerOperator;
  /** The value to compare with (EQ, CONTAINS, GT, LT). */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Several values, any of which matches (IN). */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SubmissionAnswerOperator {
  Contains = 'CONTAINS',
  Empty = 'EMPTY',
  Eq = 'EQ',
  /** Greater than — number and date questions only. */
  Gt = 'GT',
  In = 'IN',
  /** Less than — number and date questions only. */
  Lt = 'LT',
  NotEmpty = 'NOT_EMPTY'
}

export enum SubmissionAssignmentFilter {
  Any = 'ANY',
  Claimed = 'CLAIMED',
  Unclaimed = 'UNCLAIMED'
}

/** Aggregate counts of submissions for a form, grouped by status */
export type SubmissionCounts = {
  approved: Scalars['Int']['output'];
  converted: Scalars['Int']['output'];
  /** Parked, never-submitted applications. Hidden from the default list; shown under an explicit DRAFT filter. */
  draft: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  /** Every received submission. Drafts are the applicant's unfinished work and are not counted here. */
  total: Scalars['Int']['output'];
};

/** A file uploaded against a FILE field on a submission, resolved for review. The url is a short-lived signed link. */
export type SubmissionFile = {
  /** Short-lived signed link that forces a download. */
  download_url: Scalars['String']['output'];
  field_label: Scalars['String']['output'];
  /** The form field this file was uploaded for. */
  field_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mime_type?: Maybe<Scalars['String']['output']>;
  original_name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  /** Short-lived signed link that renders the file inline (preview / new tab). */
  url: Scalars['String']['output'];
};

/** Server-side narrowing of a form's submissions — the same engine as the AI workspace's submission queries. Every condition is optional and they combine with AND. */
export type SubmissionFilterInput = {
  /** Conditions on answers; all must hold. */
  answers?: InputMaybe<Array<SubmissionAnswerFilterInput>>;
  /** Every word must appear in the applicant's name answers. */
  applicant_name?: InputMaybe<Scalars['String']['input']>;
  /** Only applications claimed by this reviewer. */
  assigned_reviewer_id?: InputMaybe<Scalars['ID']['input']>;
  /** The programme or class the applicant chose, by its label. */
  choice?: InputMaybe<Scalars['String']['input']>;
  /** true = only applications already converted to students; false = not yet converted. */
  converted?: InputMaybe<Scalars['Boolean']['input']>;
  /** true = only applications flagged as duplicates; false = none of them. */
  duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  letter_state?: InputMaybe<SubmissionLetterFilter>;
  /** Application-fee state (any of). */
  payment_states?: InputMaybe<Array<SubmissionPaymentFilter>>;
  references?: InputMaybe<SubmissionReferenceFilter>;
  /** Only applications currently on this stage (1-based). */
  stage?: InputMaybe<Scalars['Int']['input']>;
  /** Only these statuses. When set, it replaces the default of hiding drafts. */
  statuses?: InputMaybe<Array<FormSubmissionStatus>>;
  /** Submitted on or after this date. */
  submitted_from?: InputMaybe<Scalars['Date']['input']>;
  /** Submitted on or before this date. */
  submitted_to?: InputMaybe<Scalars['Date']['input']>;
};

export enum SubmissionLetterFilter {
  /** A letter exists but has not been emailed. */
  Generated = 'GENERATED',
  /** No admission letter has been generated. */
  None = 'NONE',
  /** The letter has been emailed to the applicant. */
  Sent = 'SENT'
}

/** Application-fee state of a submission, for SubmissionFilterInput. */
export enum SubmissionPaymentFilter {
  /** No fee bill was raised for this application. */
  NotRequired = 'NOT_REQUIRED',
  /** The fee bill is settled. */
  Paid = 'PAID',
  /** A fee bill is outstanding (not paid, not voided) and the fee was not waived. */
  Unpaid = 'UNPAID',
  /** An admin waived the fee. */
  Waived = 'WAIVED'
}

export enum SubmissionReferenceFilter {
  /** Every reference the form asks for has been received. */
  Complete = 'COMPLETE',
  /** At least one required reference is still outstanding. */
  Incomplete = 'INCOMPLETE',
  /** The form asks for no references. */
  NotRequired = 'NOT_REQUIRED'
}

export type SubmitCbtTestInput = {
  answers: Array<StudentAnswerInput>;
  cbt_test_session_id: Scalars['ID']['input'];
};

export type SubmitOfflineCbtSessionPayload = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  synced_session_id?: Maybe<Scalars['ID']['output']>;
};

export type SubmitTranscriptRequestInput = {
  applicant_email: Scalars['String']['input'];
  applicant_name?: InputMaybe<Scalars['String']['input']>;
  applicant_phone?: InputMaybe<Scalars['String']['input']>;
  courier_address?: InputMaybe<Scalars['String']['input']>;
  courier_name?: InputMaybe<Scalars['String']['input']>;
  courier_phone?: InputMaybe<Scalars['String']['input']>;
  destination_address?: InputMaybe<Scalars['String']['input']>;
  destination_institution?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  number_of_copies?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  platform_name?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  recipient_email?: InputMaybe<Scalars['String']['input']>;
  student_status: StudentAcademicStatusEnum;
  supporting_document?: InputMaybe<Scalars['Upload']['input']>;
  transcript_type_id: Scalars['ID']['input'];
};

export type Subscription = {
  chatMessageSent?: Maybe<ChatMessageType>;
  exportStatusUpdated?: Maybe<FileExport>;
  ticketMessageSent?: Maybe<TicketMessage>;
  userNotification?: Maybe<UserNotification>;
};


export type SubscriptionChatMessageSentArgs = {
  chat_channel_id: Scalars['ID']['input'];
};


export type SubscriptionExportStatusUpdatedArgs = {
  user_id: Scalars['ID']['input'];
};


export type SubscriptionTicketMessageSentArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type SubscriptionUserNotificationArgs = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type SubscriptionState = {
  amountDue: Scalars['Float']['output'];
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  graceUntil?: Maybe<Scalars['DateTime']['output']>;
  resolveUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SuggestedAllocation = {
  amount_due: Scalars['Float']['output'];
  bill_detail_id: Scalars['ID']['output'];
  bill_due_date?: Maybe<Scalars['Date']['output']>;
  bill_id: Scalars['ID']['output'];
  bill_item_name: Scalars['String']['output'];
  suggested_allocation: Scalars['Float']['output'];
};

export type SummaryReport = {
  course_headers?: Maybe<Array<Maybe<Scalars['Mixed']['output']>>>;
  course_legend?: Maybe<Array<Maybe<Scalars['Mixed']['output']>>>;
  data: Array<Maybe<Scalars['Mixed']['output']>>;
  failed_courses?: Maybe<Array<Maybe<Scalars['Mixed']['output']>>>;
  headers: Array<Maybe<Scalars['Mixed']['output']>>;
  meta?: Maybe<Scalars['Mixed']['output']>;
  summary?: Maybe<Scalars['Mixed']['output']>;
};

export type SummaryTemplate = {
  columns: Array<SummaryTemplateColumn>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade_group?: Maybe<GradeGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['Mixed']['output']>;
  school?: Maybe<School>;
  updated_at: Scalars['DateTime']['output'];
};

export type SummaryTemplateColumn = {
  calculation_arguments?: Maybe<Scalars['Mixed']['output']>;
  calculation_function?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_visible: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  summary_template: SummaryTemplate;
  type: Scalars['String']['output'];
};

/** A paginated list of SummaryTemplate items. */
export type SummaryTemplatePaginator = {
  /** A list of SummaryTemplate items. */
  data: Array<SummaryTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Teachable = Course | Subject;

export enum TeachableType {
  Course = 'Course',
  Subject = 'Subject'
}

export type Teacher = {
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  userName: Scalars['String']['output'];
};

/** Represents a term within a session structure (e.g., First Term, Second Term). */
export type TermStructure = {
  academicCalendars?: Maybe<Array<AcademicCalendar>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  sessionStructure: SessionStructure;
  session_structure_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TheoryQuestionAnswer = {
  ai_grade?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  grading_mode: GradingModeEnum;
  id: Scalars['ID']['output'];
  instructor_attestation: Scalars['Boolean']['output'];
  instructor_grade?: Maybe<Scalars['Int']['output']>;
  question: Question;
  student_answer: Scalars['Mixed']['output'];
};

export type Ticket = {
  attachments: Array<TicketAttachment>;
  category?: Maybe<TicketCategory>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages: Array<TicketMessage>;
  priority: TicketPriority;
  school_id: Scalars['ID']['output'];
  sender: UserOrStudent;
  status: TicketStatus;
  subject: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TicketAttachment = {
  file: File;
  id: Scalars['ID']['output'];
};

export type TicketCategory = {
  auto_response?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: TicketPriority;
  school_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TicketMessage = {
  attachments: Array<TicketAttachment>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  scheduled_at?: Maybe<Scalars['DateTime']['output']>;
  sender: UserOrStudent;
  status?: Maybe<Scalars['String']['output']>;
  ticket_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Ticket items. */
export type TicketPaginator = {
  /** A list of Ticket items. */
  data: Array<Ticket>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export enum TicketStatus {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type TicketingSummary = {
  all: Scalars['Int']['output'];
  highPriorityOpen: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

export type Timetable = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entries: Array<TimetableEntry>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  school: School;
  template?: Maybe<TimetableTemplate>;
  timeable: TimetableTimeable;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TimetableEntry = {
  created_at: Scalars['DateTime']['output'];
  custom_title?: Maybe<Scalars['String']['output']>;
  day_of_week: DayOfWeek;
  id: Scalars['ID']['output'];
  room_name?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Staff>;
  teachable?: Maybe<Teachable>;
  timeSlot: TimetableTimeSlot;
  timetable: Timetable;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Timetable items. */
export type TimetablePaginator = {
  /** A list of Timetable items. */
  data: Array<Timetable>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TimetableTemplate = {
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  school: School;
  timeSlots: Array<TimetableTimeSlot>;
  updated_at: Scalars['DateTime']['output'];
};

export type TimetableTimeSlot = {
  color?: Maybe<Scalars['String']['output']>;
  end_time: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order_index: Scalars['Int']['output'];
  start_time: Scalars['String']['output'];
  template: TimetableTemplate;
  type: Scalars['String']['output'];
};

export type TimetableTimeable = Classroom | ClassroomSection;

export enum TimetableTimeableType {
  Classroom = 'Classroom',
  ClassroomSection = 'ClassroomSection'
}

export enum TranscriptActivityTypeEnum {
  Message = 'MESSAGE',
  Note = 'NOTE',
  StatusChange = 'STATUS_CHANGE'
}

export type TranscriptBillDetailSummary = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
};

/** Bill data exposed to applicants for transcript payment — minimal fields, no school internals. */
export type TranscriptBillSummary = {
  amount: Scalars['Float']['output'];
  billable_id: Scalars['ID']['output'];
  billable_type: Scalars['String']['output'];
  details: Array<TranscriptBillDetailSummary>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type TranscriptDesignOption = {
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TranscriptFontFamily = {
  /** The exact value to send as font_family. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TranscriptPresetOption = {
  config: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TranscriptRequest = {
  activities: Array<TranscriptRequestActivity>;
  admin_notes?: Maybe<Scalars['String']['output']>;
  applicant_category: ApplicantCategoryEnum;
  applicant_email: Scalars['String']['output'];
  applicant_name: Scalars['String']['output'];
  applicant_phone?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<User>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  bill?: Maybe<Bill>;
  collected_at?: Maybe<Scalars['DateTime']['output']>;
  complaint_note?: Maybe<Scalars['String']['output']>;
  courier_address?: Maybe<Scalars['String']['output']>;
  courier_name?: Maybe<Scalars['String']['output']>;
  courier_phone?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  destination_address?: Maybe<Scalars['String']['output']>;
  destination_institution?: Maybe<Scalars['String']['output']>;
  generatedTranscript?: Maybe<GeneratedTranscript>;
  id: Scalars['ID']['output'];
  matric_no?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  number_of_copies: Scalars['Int']['output'];
  platform_code?: Maybe<Scalars['String']['output']>;
  platform_name?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  programme_id?: Maybe<Scalars['ID']['output']>;
  programme_name?: Maybe<Scalars['String']['output']>;
  recipient_email?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  status: TranscriptRequestStatusEnum;
  student?: Maybe<Student>;
  student_id?: Maybe<Scalars['ID']['output']>;
  student_status?: Maybe<StudentAcademicStatusEnum>;
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  /** The uploaded file's original name, for display instead of the storage key. */
  supporting_document_name?: Maybe<Scalars['String']['output']>;
  supporting_document_path?: Maybe<Scalars['String']['output']>;
  /** Short-lived signed URL that downloads the supporting document. Null when none was uploaded. */
  supporting_document_url?: Maybe<Scalars['String']['output']>;
  tracking_code: Scalars['String']['output'];
  transcriptType: TranscriptType;
  transcript_type_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  year_of_admission?: Maybe<Scalars['String']['output']>;
  year_of_graduation?: Maybe<Scalars['String']['output']>;
};

export type TranscriptRequestActivity = {
  content: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_visible_to_applicant: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  new_status?: Maybe<Scalars['String']['output']>;
  old_status?: Maybe<Scalars['String']['output']>;
  transcript_request_id: Scalars['ID']['output'];
  type: TranscriptActivityTypeEnum;
  user?: Maybe<User>;
};

export type TranscriptRequestFilterInput = {
  applicant_category?: InputMaybe<ApplicantCategoryEnum>;
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TranscriptRequestStatusEnum>;
  transcript_type_id?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of TranscriptRequest items. */
export type TranscriptRequestPaginator = {
  /** A list of TranscriptRequest items. */
  data: Array<TranscriptRequest>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TranscriptRequestStatusEnum {
  Approved = 'APPROVED',
  Collected = 'COLLECTED',
  PendingPayment = 'PENDING_PAYMENT',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type TranscriptRequestStatusResponse = {
  activities: Array<TranscriptRequestActivity>;
  applicant_name: Scalars['String']['output'];
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  bill?: Maybe<TranscriptBillSummary>;
  can_download: Scalars['Boolean']['output'];
  has_bill: Scalars['Boolean']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  status: TranscriptRequestStatusEnum;
  submitted_at?: Maybe<Scalars['DateTime']['output']>;
  tracking_code: Scalars['String']['output'];
  transcript_type: Scalars['String']['output'];
};

export type TranscriptStudentInfoField = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TranscriptTemplate = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  programmes: Array<ProgrammeType>;
  properties?: Maybe<Scalars['JSON']['output']>;
  style_code: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TranscriptType = {
  billItemTemplate?: Maybe<BillItemTemplate>;
  category: TranscriptTypeCategoryEnum;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum TranscriptTypeCategoryEnum {
  OfficialHardCopy = 'OFFICIAL_HARD_COPY',
  OfficialSoftCopy = 'OFFICIAL_SOFT_COPY',
  StudentCopy = 'STUDENT_COPY'
}

export enum TransferCarryOver {
  Attendance = 'ATTENDANCE',
  CourseRegistrations = 'COURSE_REGISTRATIONS',
  Results = 'RESULTS',
  SubjectEnrollments = 'SUBJECT_ENROLLMENTS'
}

export type TransferStudentInput = {
  carry_over?: InputMaybe<Array<TransferCarryOver>>;
  custom_matric_no?: InputMaybe<Scalars['String']['input']>;
  matric_no_option?: InputMaybe<MatricNoOption>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source_school_id: Scalars['ID']['input'];
  student_id: Scalars['ID']['input'];
  target_classroom_section_id: Scalars['ID']['input'];
  target_programme_id?: InputMaybe<Scalars['ID']['input']>;
  target_school_id: Scalars['ID']['input'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export enum TypeApplicabilityEnum {
  Any = 'ANY',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type UnfloatedCoursePaginator = {
  data: Array<Course>;
  paginatorInfo: PaginatorInfo;
};

export type UpdateAcademicCalendarInput = {
  ended_at?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
  next_calender_starts_at?: InputMaybe<Scalars['DateTime']['input']>;
  started_at?: InputMaybe<Scalars['DateTime']['input']>;
  total_school_days?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssessmentTypeInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  cbt_id?: InputMaybe<Scalars['Int']['input']>;
  classroom_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  is_ca?: InputMaybe<Scalars['Boolean']['input']>;
  is_exam?: InputMaybe<Scalars['Boolean']['input']>;
  max_score?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAttendanceEventInput = {
  category?: InputMaybe<AttendanceEventCategory>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycle?: InputMaybe<AttendanceEventLifecycle>;
  name?: InputMaybe<Scalars['String']['input']>;
  recurrence_days?: InputMaybe<Array<DayOfWeek>>;
  scheduled_date?: InputMaybe<Scalars['Date']['input']>;
  scope_id?: InputMaybe<Scalars['ID']['input']>;
  scope_type?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillInput = {
  /** Proceed even when items look like duplicates of the entity's other charges. */
  acknowledge_duplicates?: InputMaybe<Scalars['Boolean']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  /** Bill-level settlement account override. Set to null to remove the override and use per-item routing. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  items: Array<UpdateBillItemInput>;
};

export type UpdateBillItemCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Category for a custom item; ignored when bill_item_template_id is set (the template's category wins). */
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Override the settlement account for this line item. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Existing bill_detail id to update in place; omit to add a new line item. */
  id?: InputMaybe<Scalars['ID']['input']>;
  item_description?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  /** Save this custom item as a reusable template and link the line to it. Only applies to NEW lines (ignored when id is set). */
  save_as_template?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBillItemTemplateInput = {
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  default_amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Default settlement account for this fee item. */
  gateway_settlement_account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBroadsheetTemplateInput = {
  columns?: InputMaybe<Array<CreateBroadsheetTemplateColumnInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UpdateCbtTestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  linked_assessment_type_id?: InputMaybe<Scalars['Int']['input']>;
  narrow_classroom_id?: InputMaybe<Scalars['ID']['input']>;
  narrow_classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  question_bank_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  question_count?: InputMaybe<Scalars['Int']['input']>;
  question_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionable?: InputMaybe<QuestionableInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  subject_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  track_progress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCertificateTemplateInput = {
  color_scheme?: InputMaybe<Scalars['JSON']['input']>;
  custom_height_mm?: InputMaybe<Scalars['Int']['input']>;
  custom_width_mm?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<CertificateDesignEnum>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  paper_size?: InputMaybe<Scalars['String']['input']>;
  programme_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  signatures?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateChildSchoolInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  school_id: Scalars['ID']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClassroomSectionInput = {
  classroom_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomFieldInput = {
  depends_on?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  /** Changing the list is refused once any record holds a value, like a type change. */
  options_source?: InputMaybe<CustomFieldOptionsSource>;
  /** Student fields only: whether students see the field on their profile and may fill it in. */
  student_access?: InputMaybe<CustomFieldStudentAccess>;
  /** Changing the type is refused once any record holds a value. */
  type?: InputMaybe<CustomFieldType>;
};

export type UpdateDiscountCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscountRuleInput = {
  apply_to?: InputMaybe<DiscountApplyToEnum>;
  discount_type?: InputMaybe<DiscountTypeEnum>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  exclude_template_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  max_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  target_category_id?: InputMaybe<Scalars['ID']['input']>;
  target_template_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEducationalResourceInput = {
  accessLevel?: InputMaybe<EducationalResourceAccessLevel>;
  description?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntityDiscountInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  effective_from?: InputMaybe<Scalars['Date']['input']>;
  effective_until?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFeeSplitOverrideInput = {
  base_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_percentage?: InputMaybe<Scalars['Float']['input']>;
  campus_price?: InputMaybe<Scalars['Float']['input']>;
  hq_amount?: InputMaybe<Scalars['Float']['input']>;
  hq_percentage?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateFeeSplitProfileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  split_mode?: InputMaybe<SplitModeEnum>;
};

export type UpdateFeeSplitRuleInput = {
  base_amount?: InputMaybe<Scalars['Float']['input']>;
  bill_item_category_id?: InputMaybe<Scalars['ID']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  billable_id?: InputMaybe<Scalars['ID']['input']>;
  billable_type?: InputMaybe<Scalars['String']['input']>;
  campus_amount?: InputMaybe<Scalars['Float']['input']>;
  campus_percentage?: InputMaybe<Scalars['Float']['input']>;
  campus_price?: InputMaybe<Scalars['Float']['input']>;
  hq_amount?: InputMaybe<Scalars['Float']['input']>;
  hq_percentage?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFileInput = {
  original_name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateFormInput = {
  admission_field_mapping?: InputMaybe<Scalars['JSON']['input']>;
  application_deadline?: InputMaybe<Scalars['DateTime']['input']>;
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  branding?: InputMaybe<FormBrandingInput>;
  declaration_text?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FormFieldInput>>;
  form_type?: InputMaybe<FormType>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  payment_gates_review?: InputMaybe<Scalars['Boolean']['input']>;
  reference_requirements?: InputMaybe<Array<FormReferenceRequirementInput>>;
  reference_settings?: InputMaybe<FormReferenceSettingsInput>;
  restrict_to_students?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<FormSectionInput>>;
  /** Optional ordered stages. Omit to leave a form single-stage. */
  stages?: InputMaybe<Array<FormStageInput>>;
  target_classroom_section_id?: InputMaybe<Scalars['ID']['input']>;
  target_programme_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGatewaySettlementAccountInput = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  gateway_identifier?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuardianInput = {
  altPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * BCP-47 language tag for guardian communication preference.
   * Allowed values: en (English), fr (French), yo (Yoruba), ha (Hausa), ig (Igbo).
   */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  whatsappOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLessonNoteInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** Link the note to a scheme week of the same subject and class. Pass null to unlink. */
  schemeWeekId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LessonNoteStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionGrantInput = {
  /** New scopes for the grant. Pass empty array to make it unscoped. */
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type UpdateProfileInput = {
  /** Required when email changes. */
  current_password?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionBankInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionInput = {
  correct_answer_guidelines?: InputMaybe<Scalars['String']['input']>;
  correct_answer_prose?: InputMaybe<Scalars['Mixed']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marks?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<UpdateQuestionOptionInput>>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_type?: InputMaybe<QuestionTypeEnum>;
};

export type UpdateQuestionOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  option: Scalars['String']['input'];
};

export type UpdateResultTemplateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<CreateResultTemplateColumnInput>>;
  feedbacks?: InputMaybe<Array<CreateResultTemplateFeedbackInput>>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['Mixed']['input']>;
  style_code?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoomInput = {
  campus_id?: InputMaybe<Scalars['ID']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemeOfWorkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemeWeekInput = {
  keyConcepts?: InputMaybe<Scalars['String']['input']>;
  learningObjectives?: InputMaybe<Scalars['String']['input']>;
  suggestedActivities?: InputMaybe<Scalars['String']['input']>;
  suggestedResources?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSchoolAnnouncementInput = {
  audience_type?: InputMaybe<SchoolAnnouncementAudienceType>;
  audiences?: InputMaybe<Array<SchoolAnnouncementAudienceInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  requires_acknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<SchoolAnnouncementSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchoolInput = {
  affiliateName?: InputMaybe<Scalars['String']['input']>;
  attendance_type?: InputMaybe<Scalars['String']['input']>;
  custom_domain?: InputMaybe<Scalars['String']['input']>;
  schoolAddress?: InputMaybe<Scalars['String']['input']>;
  schoolEmail?: InputMaybe<Scalars['String']['input']>;
  schoolMobile?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  ticket_auto_response?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScoreResponse = {
  courses?: Maybe<Array<CourseScoreResponse>>;
  created_count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updated_count?: Maybe<Scalars['Int']['output']>;
};

export type UpdateSessionInput = {
  ended_at?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  started_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSessionStructureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_default: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSettlementAccountInput = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  provider_name?: InputMaybe<Scalars['String']['input']>;
  sub_account_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentAttendanceSummaryInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  initial_absent_days?: InputMaybe<Scalars['Int']['input']>;
  initial_late_days?: InputMaybe<Scalars['Int']['input']>;
  initial_present_days?: InputMaybe<Scalars['Int']['input']>;
  student_id: Scalars['ID']['input'];
};

export type UpdateStudentCourseExemptionInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStudentDataRequestInput = {
  blocks_portal?: InputMaybe<Scalars['Boolean']['input']>;
  due_on?: InputMaybe<Scalars['Date']['input']>;
  include_late_joiners?: InputMaybe<Scalars['Boolean']['input']>;
  lock_on_close?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentScoreInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recorded_at?: InputMaybe<Scalars['DateTime']['input']>;
  recorded_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentScoresResponse = {
  created_count?: Maybe<Scalars['Int']['output']>;
  enrollments?: Maybe<Array<EnrollmentScoreResponse>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updated_count?: Maybe<Scalars['Int']['output']>;
};

/**
 * Input for bulk-updating the enrollment status of multiple students within a
 * specific academic calendar.
 */
export type UpdateStudentStatusInput = {
  academic_calendar_id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  student_ids: Array<Scalars['ID']['input']>;
};

export type UpdateSummaryTemplateInput = {
  columns?: InputMaybe<Array<CreateSummaryTemplateColumnInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade_group_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UpdateTermStructureInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
};

export type UpdateTicketStatusInput = {
  id: Scalars['ID']['input'];
  status: TicketStatus;
};

export type UpdateTimetableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimetableTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimetableTimeSlotInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranscriptTemplateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  style_code?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranscriptTypeInput = {
  bill_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<TranscriptTypeCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWhatsappSettingsInput = {
  displayPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberId?: InputMaybe<Scalars['String']['input']>;
  wabaId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertTimetableEntryInput = {
  custom_title?: InputMaybe<Scalars['String']['input']>;
  day_of_week: DayOfWeek;
  id?: InputMaybe<Scalars['ID']['input']>;
  room_name?: InputMaybe<Scalars['String']['input']>;
  staff_id?: InputMaybe<Scalars['ID']['input']>;
  teachable_id?: InputMaybe<Scalars['ID']['input']>;
  teachable_type?: InputMaybe<TeachableType>;
  timetable_id?: InputMaybe<Scalars['ID']['input']>;
  timetable_time_slot_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Account of a person who utilizes this application. */
export type User = {
  /** Active permission grants for the user in the current school context. */
  activeGrants: Array<PermissionGrant>;
  /** Portals available to this user in the current school context (STAFF, GUARDIAN, or both). */
  availablePortals: Array<PortalType>;
  /** When the account was created. */
  created_at: Scalars['DateTime']['output'];
  /** One-off notices this user switched off with "Don't show this again" (keys of DismissibleNotice, lowercase). */
  dismissed_notices: Array<Scalars['String']['output']>;
  /** Unique email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** When the email was verified. */
  email_verified_at?: Maybe<Scalars['DateTime']['output']>;
  /** The guardian profile for the current school context, if the user is a guardian here. */
  guardianProfile?: Maybe<Guardian>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Non-unique name. */
  name: Scalars['String']['output'];
  /** The permission group assigned to the user in a school. */
  permissionGroup?: Maybe<PermissionGroup>;
  /** List of permissions for the user in a school. */
  permissions: Array<Permission>;
  /** Schools the user belongs to. */
  schools: Array<School>;
  /** The staff profile for the current school context, if the user is a staff member. */
  staffProfile?: Maybe<Staff>;
  /** When this user chose "Don't show again" on the guided-tour intro (#571); null = still shows once per device. */
  tour_intro_dismissed_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the account was last updated. */
  updated_at: Scalars['DateTime']['output'];
};


/** Account of a person who utilizes this application. */
export type UserPermissionGroupArgs = {
  school_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserPermissionsArgs = {
  school_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserNotification = {
  created_at: Scalars['DateTime']['output'];
  /** Present on persisted notifications (null on the live broadcast payload). */
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  /** Optional payload for client-side routing/dedupe (e.g. {form_id, submission_id}) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** When the recipient read it; null = unread. Null on the live broadcast payload. */
  read_at?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** A paginated list of UserNotification items. */
export type UserNotificationPaginator = {
  /** A list of UserNotification items. */
  data: Array<UserNotification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserOrStudent = Student | User;

/** A paginated list of User items. */
export type UserPaginator = {
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserRegisterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  isAcceptingTokens?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  password_confirmation?: InputMaybe<Scalars['String']['input']>;
};

/** A union type representing the various categories of users within the system. */
export type UserType = Staff | Student | Teacher | User;

/** The visitor's country as seen by the CDN, or null when unknown. */
export type VisitorCountry = {
  country_code?: Maybe<Scalars['String']['output']>;
};

/** Waiver code counts for one campus (campus_id null = codes issued without a campus). */
export type WaiverCodeCampusStats = {
  available: Scalars['Int']['output'];
  campus_id?: Maybe<Scalars['ID']['output']>;
  campus_name?: Maybe<Scalars['String']['output']>;
  revoked: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

/** Waiver code counts for one form. */
export type WaiverCodeFormStats = {
  available: Scalars['Int']['output'];
  form_id: Scalars['ID']['output'];
  form_title?: Maybe<Scalars['String']['output']>;
  revoked: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

/** Waiver code counts across the school's forms, with the same split per campus and per form. */
export type WaiverCodeStats = {
  available: Scalars['Int']['output'];
  /** Every campus of the school (zeros included), then codes without a campus (campus_id null) when there are any. */
  campuses: Array<WaiverCodeCampusStats>;
  /** Every form that has codes. Not narrowed by form_id, so it can drive a form picker. */
  forms: Array<WaiverCodeFormStats>;
  /** Used codes whose application's bill has money on it anyway (paid before or while the code was entered). */
  paid_after_waiver: Scalars['Int']['output'];
  revoked: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type WaiverFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  course_id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTransaction = {
  amount: Scalars['Float']['output'];
  balance_after: Scalars['Float']['output'];
  createdBy?: Maybe<User>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  school_id: Scalars['ID']['output'];
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type?: Maybe<Scalars['String']['output']>;
  student_wallet_id: Scalars['ID']['output'];
  type: WalletTransactionTypeEnum;
  updated_at: Scalars['DateTime']['output'];
};

export enum WalletTransactionTypeEnum {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type WhatsNewAction = {
  label: Scalars['String']['output'];
  /** Admin portal path, e.g. /admin/reports. */
  path: Scalars['String']['output'];
};

/** One change in the platform changelog (config/whats-new.php). */
export type WhatsNewEntry = {
  /** Where to try it, when the change has a page. */
  action?: Maybe<WhatsNewAction>;
  /** Release date, YYYY-MM-DD. */
  date: Scalars['String']['output'];
  /** Stable slug; the app remembers the newest one a user has seen. */
  id: Scalars['ID']['output'];
  sections: Array<WhatsNewSection>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WhatsNewSection = {
  bullets: Array<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  paragraphs: Array<Scalars['String']['output']>;
};

export type WhatsappConversation = {
  createdAt: Scalars['DateTime']['output'];
  guardian: Guardian;
  id: Scalars['ID']['output'];
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  optedOutAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum WhatsappDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type WhatsappMessage = {
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: WhatsappDirection;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fromPhone?: Maybe<Scalars['String']['output']>;
  guardian?: Maybe<Guardian>;
  id: Scalars['ID']['output'];
  messageType: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  status: WhatsappMessageStatus;
  templateName?: Maybe<Scalars['String']['output']>;
  toPhone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  waMessageId?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of WhatsappMessage items. */
export type WhatsappMessagePaginator = {
  /** A list of WhatsappMessage items. */
  data: Array<WhatsappMessage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WhatsappMessageStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Read = 'READ',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

/** WhatsApp settings for the current school. Sensitive IDs are masked. */
export type WhatsappSettings = {
  createdAt: Scalars['DateTime']['output'];
  displayPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wabaId?: Maybe<Scalars['String']['output']>;
};

export type AddCourseToRegInput = {
  course_registration_id: Scalars['Int']['input'];
  courses: Array<CourseCurriculumInput>;
  /** Skip module availability check. Staff only — rejected for student callers. */
  ignore_module_check?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip the max-units check when adding. Staff only — rejected for student callers. */
  ignore_unit_check?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminCourseRegistrationInput = {
  academic_calendar_id: Scalars['Int']['input'];
  auto_pick_from_curriculum?: InputMaybe<Scalars['Boolean']['input']>;
  courses?: InputMaybe<Array<CourseCurriculumInput>>;
  /** Skip module availability check. Staff only — rejected for student callers. */
  ignore_module_check?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip min/max unit validation. Staff only — rejected for student callers. */
  ignore_unit_check?: InputMaybe<Scalars['Boolean']['input']>;
  student_id: Scalars['Int']['input'];
};

export type AllocateCoursesToLecturerInSemesterByHodOrAdminInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  course_ids: Array<Scalars['Int']['input']>;
  lecturer_id: Scalars['Int']['input'];
};

export type ApproveOrDenyCourseInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  approve: Scalars['Boolean']['input'];
  course_ids: Array<Scalars['Int']['input']>;
  lecturer_id: Scalars['Int']['input'];
};

export type BillDetailAndAmount = {
  amount: Scalars['Float']['input'];
  bill_detail_id: Scalars['ID']['input'];
};

export type CampusFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CampusInput = {
  name: Scalars['String']['input'];
};

export type CloneProgrammeModulesInput = {
  /** Create the copies already activated. Defaults to false so a cloned timetable never opens registration by accident. */
  activate?: InputMaybe<Scalars['Boolean']['input']>;
  assignments?: InputMaybe<Array<ModuleCloneAssignmentInput>>;
  /** Copy registration and retake fee templates and legacy amounts. Defaults to false. */
  copy_fee_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Session the modules are copied from. */
  from_session_id: Scalars['ID']['input'];
  /** Programme whose modules are copied. */
  programme_id: Scalars['ID']['input'];
  /** Optional: move module dates by this many days. Defaults to the gap between the two sessions' start dates, or +1 year when either session has no start date. */
  shift_days?: InputMaybe<Scalars['Int']['input']>;
  /** Optional: create the copies under a different programme (defaults to programme_id). */
  to_programme_id?: InputMaybe<Scalars['ID']['input']>;
  /** Session the copies are created in. */
  to_session_id: Scalars['ID']['input'];
};

export type CourseCurriculumInput = {
  course_id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CourseRegistrationFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  academic_session?: InputMaybe<Scalars['String']['input']>;
  approval_status?: InputMaybe<Scalars['String']['input']>;
  authorization_status?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  registration_level?: InputMaybe<Scalars['String']['input']>;
  semester?: InputMaybe<Scalars['Int']['input']>;
  student_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseRegistrationInput = {
  courses: Array<CourseCurriculumInput>;
  modules?: InputMaybe<Array<ModuleCourseRegistrationInput>>;
  programme_module_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCurriculumInput = {
  course: Array<CourseCurriculumInput>;
  course_registration_level: Scalars['String']['input'];
  programme_id: Scalars['ID']['input'];
  /** Assigns the courses to a module (modular/residence programmes only). */
  programme_module_id?: InputMaybe<Scalars['ID']['input']>;
  semester: Scalars['Int']['input'];
};

export type CreateProgrammeModuleInput = {
  /** Optionally pin the module to a calendar (semester/term) within the session. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  ended_at: Scalars['Date']['input'];
  /** Set to true to activate the module. Defaults to false. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  programme_id: Scalars['ID']['input'];
  registration_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee Item Template for first-attempt billing. Preferred over the numeric registration_fee. */
  registration_fee_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional retake fee (2nd and later attempts). Null inherits registration_fee. */
  retake_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee Item Template for retake billing. Null means retakes are free. */
  retake_fee_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional — defaults to the next sequence within the programme and session. */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  session_id: Scalars['ID']['input'];
  started_at: Scalars['Date']['input'];
};

export type CurriculumFilterInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  course_registration_level?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  semester?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentFilterInput = {
  department_name?: InputMaybe<Scalars['String']['input']>;
  faculty_id?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentInput = {
  department_name: Scalars['String']['input'];
  faculty_id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DropCourseFromRegInput = {
  course_ids: Array<Scalars['Int']['input']>;
  course_registration_id: Scalars['Int']['input'];
};

export type FacultyFilterInput = {
  faculty_name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FacultyInput = {
  faculty_name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LecturerCourseFilterInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  course_id?: InputMaybe<Scalars['Int']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  school_staff_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LecturerGetCoursesInSemesterInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  lecturer_id: Scalars['Int']['input'];
};

export type LecturerSubmitCoursesInSemesterInput = {
  academic_calendar_id?: InputMaybe<Scalars['Int']['input']>;
  course_ids: Array<Scalars['Int']['input']>;
};

export type ProgrammeFilterInput = {
  degree?: InputMaybe<Scalars['String']['input']>;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  min_units?: InputMaybe<Scalars['Int']['input']>;
  prog_code?: InputMaybe<Scalars['String']['input']>;
  program_name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProgrammeInput = {
  calculation_method?: InputMaybe<Scalars['String']['input']>;
  /** Controls whether compulsory courses are enforced. Defaults to ENFORCED. */
  compulsory_mode?: InputMaybe<CompulsoryModeEnum>;
  degree: Scalars['String']['input'];
  /** Defaults to REGULAR (standard semester-based delivery). */
  delivery_mode?: InputMaybe<ProgrammeDeliveryModeEnum>;
  department_id: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  /** Whether to validate course prerequisites during registration. */
  enforce_prerequisites?: InputMaybe<Scalars['Boolean']['input']>;
  graduation_criteria?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  min_units: Scalars['Int']['input'];
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  /** Defaults to ROLLUP. Only relevant for modular/residence programmes. */
  module_result_mode?: InputMaybe<ModuleResultModeEnum>;
  /** Controls when outstanding courses appear. Defaults to SEMESTER_MATCH. */
  outstanding_mode?: InputMaybe<OutstandingModeEnum>;
  prog_code: Scalars['String']['input'];
  program_name: Scalars['String']['input'];
  /** Defaults to LEVEL. Use YEAR for postgrad programmes where level stays fixed. */
  progression_type?: InputMaybe<ProgressionTypeEnum>;
  promotion_criteria?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
};

export type ProgrammeUpdateInput = {
  calculation_method?: InputMaybe<Scalars['String']['input']>;
  compulsory_mode?: InputMaybe<CompulsoryModeEnum>;
  degree?: InputMaybe<Scalars['String']['input']>;
  delivery_mode?: InputMaybe<ProgrammeDeliveryModeEnum>;
  department_id?: InputMaybe<Scalars['ID']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  enforce_prerequisites?: InputMaybe<Scalars['Boolean']['input']>;
  graduation_criteria?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  min_units?: InputMaybe<Scalars['Int']['input']>;
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  module_result_mode?: InputMaybe<ModuleResultModeEnum>;
  outstanding_mode?: InputMaybe<OutstandingModeEnum>;
  prog_code?: InputMaybe<Scalars['String']['input']>;
  program_name?: InputMaybe<Scalars['String']['input']>;
  progression_type?: InputMaybe<ProgressionTypeEnum>;
  promotion_criteria?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  home_address?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  lga?: InputMaybe<Scalars['String']['input']>;
  matric_no?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  other_name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  permanent_address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Moved to the school's custom fields (#574): saved to the custom field with this key when the school has one, ignored otherwise. Use updateStudentCustomFieldValues. */
  state_of_origin?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseRegisteredFieldsInput = {
  course_registered_id: Scalars['ID']['input'];
  fields: CourseRegisteredUpdateFieldsInput;
};

export type UpdateCourseRegistrationFieldsInput = {
  course_registration_id: Scalars['ID']['input'];
  fields: RegistrationUpdateFieldsInput;
};

export type UpdateCurriculumInput = {
  acknowledgeImpact?: InputMaybe<Scalars['Boolean']['input']>;
  course_id?: InputMaybe<Scalars['ID']['input']>;
  course_registration_level?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  programme_id?: InputMaybe<Scalars['ID']['input']>;
  /** Change or clear the primary module and its offering. Other offerings remain; remove them explicitly with bulkUpdateCurriculum(remove_from_module: true). */
  programme_module_id?: InputMaybe<Scalars['ID']['input']>;
  semester?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgrammeModuleInput = {
  /** Set to a calendar ID to pin the module to a semester, or null to unpin. */
  academic_calendar_id?: InputMaybe<Scalars['ID']['input']>;
  ended_at?: InputMaybe<Scalars['Date']['input']>;
  /** Set to true to activate, false to deactivate. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional registration maximum. Null inherits the next configured limit. */
  max_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  /** Optional registration minimum. Null inherits the next configured limit. */
  min_units_per_registration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registration_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee Item Template for first-attempt billing. Preferred over the numeric registration_fee. */
  registration_fee_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional retake fee (2nd and later attempts). Null inherits registration_fee. */
  retake_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee Item Template for retake billing. Null means retakes are free. */
  retake_fee_item_template_id?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  started_at?: InputMaybe<Scalars['Date']['input']>;
};
